const airportList = [
  { id: 1, code: "APH", name: "A.P. Hill Army Airfield" },
  { id: 2, code: "AAL", name: "Aalborg Airport" },
  { id: 3, code: "AAR", name: "Aarhus Airport" },
  { id: 4, code: "ABD", name: "Abadan International Airport" },
  { id: 5, code: "ABF", name: "Abaiang Atoll Airport" },
  { id: 6, code: "ABA", name: "Abakan International Airport" },
  { id: 7, code: "ABW", name: "Abau Airport" },
  { id: 8, code: "AEH", name: "Abéché Airport" },
  { id: 9, code: "AEA", name: "Abemama Atoll Airport" },
  { id: 10, code: "ABZ", name: "Aberdeen Airport" },
  { id: 11, code: "ABR", name: "Aberdeen Regional Airport" },
  { id: 12, code: "AHB", name: "Abha Regional Airport" },
  { id: 13, code: "ABI", name: "Abilene Regional Airport" },
  { id: 14, code: "ABG", name: "Abingdon Airport" },
  { id: 15, code: "ABO", name: "Aboisso Airport" },
  { id: 16, code: "AOD", name: "Abou-Deïa Airport" },
  { id: 17, code: "AUH", name: "Abu Dhabi International Airport" },
  { id: 18, code: "AEU", name: "Abu Musa Airport[1]" },
  { id: 19, code: "AUE", name: "Abu Rudeis Airport" },
  { id: 20, code: "ABS", name: "Abu Simbel Airport" },
  { id: 21, code: "ARA", name: "Acadiana Regional Airport" },
  { id: 22, code: "ACA", name: "Acapulco International Airport" },
  { id: 23, code: "ARF", name: "Acaricuara Airport" },
  { id: 24, code: "ACS", name: "Achinsk Airport" },
  { id: 25, code: "ACU", name: "Achutupo Airport" },
  { id: 26, code: "ADT", name: "Ada Municipal Airport (FAA: ADH)" },
  { id: 27, code: "AAD", name: "Adado Airport" },
  { id: 28, code: "ADK", name: "Adak Airport" },
  { id: 29, code: "AOM", name: "Adam Airport[1]" },
  { id: 30, code: "AIP", name: "Adampur Airport" },
  { id: 31, code: "ADA", name: "Adana Şakirpaşa Airport" },
  { id: 32, code: "AEE", name: "Adareil Airport[1]" },
  { id: 33, code: "ADS", name: "Addison Airport" },
  { id: 34, code: "ADL", name: "Adelaide Airport" },
  { id: 35, code: "ADE", name: "Aden International Airport" },
  { id: 36, code: "ADF", name: "Adıyaman Airport" },
  { id: 37, code: "ADB", name: "Adnan Menderes Airport" },
  { id: 38, code: "AEG", name: "Aek Godang Airport" },
  { id: 39, code: "AFR", name: "Afore Airstrip" },
  { id: 40, code: "AFO", name: "Afton Municipal Airport" },
  { id: 41, code: "AFT", name: "Afutara Airport" },
  { id: 42, code: "AFY", name: "Afyon Airport" },
  { id: 43, code: "AGA", name: "Agadir–Al Massira Airport" },
  { id: 44, code: "AGX", name: "Agatti Aerodrome" },
  { id: 45, code: "AUP", name: "Agaun Airport" },
  { id: 46, code: "AGF", name: "Agen La Garenne Airport" },
  { id: 47, code: "AGZ", name: "Aggeneys Airport" },
  { id: 48, code: "AKW", name: "Aghajari Airport[1]" },
  { id: 49, code: "AGW", name: "Agnew Airport" },
  { id: 50, code: "AGR", name: "Agra Airport" },
  { id: 51, code: "AGQ", name: "Agrinion Airport" },
  { id: 52, code: "AJI", name: "Ağrı Airport" },
  { id: 53, code: "ACL", name: "Aguaclara Airport" },
  { id: 54, code: "AGJ", name: "Aguni Airport" },
  { id: 55, code: "AHE", name: "Ahe Airport" },
  { id: 56, code: "AHS", name: "Ahuas Airport" },
  { id: 57, code: "AWZ", name: "Ahvaz International Airport" },
  { id: 58, code: "AIW", name: "Ai-Ais Airport" },
  { id: 59, code: "AIH", name: "Aiambak Airport" },
  { id: 60, code: "AIK", name: "Aiken Municipal Airport" },
  { id: 61, code: "AIL", name: "Ailigandí Airport" },
  { id: 62, code: "AIC", name: "Ailinglaplap Airok Airport" },
  { id: 63, code: "AIM", name: "Ailuk Airport" },
  { id: 64, code: "ANW", name: "Ainsworth Regional Airport" },
  { id: 65, code: "AIE", name: "Aiome Airport" },
  { id: 66, code: "AEO", name: "Aioun el Atrouss Airport" },
  { id: 67, code: "AHL", name: "Aishalton Airport" },
  { id: 68, code: "ATP", name: "Aitape Airstrip" },
  { id: 69, code: "AIT", name: "Aitutaki Airport" },
  { id: 70, code: "AYU", name: "Aiyura Airport" },
  { id: 71, code: "AJA", name: "Ajaccio Napoleon Bonaparte Airport" },
  { id: 72, code: "AAP", name: "Aji Pangeran Tumenggung Pranoto International Airport" },
  { id: 73, code: "AKK", name: "Akhiok Airport" },
  { id: 74, code: "AKI", name: "Akiak Airport" },
  { id: 75, code: "AKE", name: "Akieni Airport" },
  { id: 76, code: "AXT", name: "Akita Airport" },
  { id: 77, code: "AJJ", name: "Akjoujt Airport" },
  { id: 78, code: "AKD", name: "Akola Airport" },
  { id: 79, code: "AKC", name: "Akron Fulton International Airport (FAA: AKR)" },
  { id: 80, code: "AKU", name: "Aksu Airport" },
  { id: 81, code: "AKX", name: "Aktobe Airport" },
  { id: 82, code: "AKV", name: "Akulivik Airport" },
  { id: 83, code: "AKR", name: "Akure Airport" },
  { id: 84, code: "AEY", name: "Akureyri Airport" },
  { id: 85, code: "AAN", name: "Al Ain International Airport" },
  { id: 86, code: "AZI", name: "Al Bateen Executive Airport" },
  { id: 87, code: "AAY", name: "Al Ghaydah Airport" },
  { id: 88, code: "AQI", name: "Al Qaisumah/Hafr Al Batin Airport" },
  { id: 89, code: "ABT", name: "Al-Baha Domestic Airport" },
  { id: 90, code: "AJF", name: "Al-Jawf Domestic Airport" },
  { id: 91, code: "AUK", name: "Alakanuk Airport" },
  { id: 92, code: "ALM", name: "Alamogordo–White Sands Regional Airport" },
  { id: 93, code: "ABC", name: "Albacete Airport" },
  { id: 94, code: "ALH", name: "Albany Airport" },
  { id: 95, code: "ALB", name: "Albany International Airport" },
  { id: 96, code: "ALL", name: "Albenga Airport" },
  { id: 97, code: "AEL", name: "Albert Lea Municipal Airport" },
  { id: 98, code: "ABN", name: "Albina Airstrip" },
  { id: 99, code: "ABQ", name: "Albuquerque International Sunport" },
  { id: 100, code: "ABX", name: "Albury Airport" },
  { id: 101, code: "ACD", name: "Alcides Fernández Airport" },
  { id: 102, code: "ADH", name: "Aldan Airport" },
  { id: 103, code: "ACI", name: "Alderney Airport" },
  { id: 104, code: "ALQ", name: "Alegrete Airport" },
  { id: 105, code: "ALT", name: "Alenquer Airport" },
  { id: 106, code: "ALP", name: "Aleppo International Airport" },
  { id: 107, code: "ALD", name: "Alerta Airport" },
  { id: 108, code: "AES", name: "Ålesund Airport, Vigra" },
  { id: 109, code: "ALJ", name: "Alexander Bay Airport" },
  { id: 110, code: "ALR", name: "Alexandra Aerodrome" },
  { id: 111, code: "AXL", name: "Alexandria Airport" },
  { id: 112, code: "AEX", name: "Alexandria International Airport" },
  { id: 113, code: "AXN", name: "Alexandria Municipal Airport (Chandler Field)" },
  { id: 114, code: "AXD", name: "Alexandroupoli Airport (Dimokritos Airport)" },
  { id: 115, code: "AOP", name: "Alférez FAP Alfredo Vladimir Sara Bauer Airport" },
  { id: 116, code: "AHO", name: "Alghero-Fertilia Airport" },
  { id: 117, code: "AXG", name: "Algona Municipal Airport (FAA: AXA)" },
  { id: 118, code: "AII", name: "Ali-Sabieh Airport" },
  { id: 119, code: "ALC", name: "Alicante–Elche Airport" },
  { id: 120, code: "ALI", name: "Alice International Airport" },
  { id: 121, code: "ASP", name: "Alice Springs Airport" },
  { id: 122, code: "ALZ", name: "Alitak Seaplane Base" },
  { id: 123, code: "AAV", name: "Allah Valley Airport" },
  { id: 124, code: "AET", name: "Allakaket Airport (FAA: 6A8)" },
  { id: 125, code: "ADY", name: "Alldays Airport" },
  { id: 126, code: "AGC", name: "Allegheny County Airport" },
  { id: 127, code: "AIA", name: "Alliance Municipal Airport" },
  { id: 128, code: "ALA", name: "Almaty International Airport" },
  { id: 129, code: "AMJ", name: "Almenara Airport" },
  { id: 130, code: "ARD", name: "Alor Island Airport" },
  { id: 131, code: "AWE", name: "Alowe Airport" },
  { id: 132, code: "AHZ", name: "Alpe d'Huez Airport" },
  { id: 133, code: "APN", name: "Alpena County Regional Airport" },
  { id: 134, code: "ABH", name: "Alpha Airport" },
  { id: 135, code: "ALE", name: "Alpine–Casparis Municipal Airport (FAA: E38)" },
  { id: 136, code: "AYD", name: "Alroy Downs Airport" },
  { id: 137, code: "ALF", name: "Alta Airport" },
  { id: 138, code: "AFL", name: "Alta Floresta Airport" },
  { id: 139, code: "ATM", name: "Altamira Airport" },
  { id: 140, code: "AAT", name: "Altay Airport" },
  { id: 141, code: "AME", name: "Alto Molocue Airport" },
  { id: 142, code: "APY", name: "Alto Parnaíba Airport" },
  { id: 143, code: "ARR", name: "Alto Río Senguer Airport" },
  { id: 144, code: "AWN", name: "Alton Downs Airport" },
  { id: 145, code: "AOO", name: "Altoona–Blair County Airport" },
  { id: 146, code: "AXS", name: "Altus/Quartz Mountain Regional Airport" },
  { id: 147, code: "ALU", name: "Alula Airport" },
  { id: 148, code: "AXF", name: "Alxa Left Banner Bayanhot Airport" },
  { id: 149, code: "AMC", name: "Am Timan Airport" },
  { id: 150, code: "AMF", name: "Ama Airport" },
  { id: 151, code: "AHI", name: "Amahai Airport" },
  { id: 152, code: "AXJ", name: "Amakusa Airfield[1]" },
  { id: 153, code: "AFI", name: "Amalfi Airport" },
  { id: 154, code: "ASJ", name: "Amami Airport" },
  { id: 155, code: "AMU", name: "Amanab Airport" },
  { id: 156, code: "AMT", name: "Amata Airport" },
  { id: 157, code: "AZB", name: "Amazon Bay Airport" },
  { id: 158, code: "AHY", name: "Ambatolahy Airport" },
  { id: 159, code: "AMY", name: "Ambatomainty Airport" },
  { id: 160, code: "AMB", name: "Ambilobe Airport" },
  { id: 161, code: "ABL", name: "Ambler Airport (FAA: AFM)" },
  { id: 162, code: "AMG", name: "Amboin Airport" },
  { id: 163, code: "ASV", name: "Amboseli Airport" },
  { id: 164, code: "AZZ", name: "Ambriz Airport" },
  { id: 165, code: "AUJ", name: "Ambunti Airport" },
  { id: 166, code: "AMV", name: "Amderma Airport" },
  { id: 167, code: "AHC", name: "Amedee Army Airfield" },
  { id: 168, code: "AHH", name: "Amery Municipal Airport" },
  { id: 169, code: "AMW", name: "Ames Municipal Airport" },
  { id: 170, code: "AEM", name: "Amgu Airport" },
  { id: 171, code: "ADJ", name: "Amman Civil Airport (Marka International Airport)" },
  { id: 172, code: "AMX", name: "Ammaroo Airport" },
  { id: 173, code: "AOS", name: "Amook Bay Seaplane Base (FAA: AK81)" },
  { id: 174, code: "AMP", name: "Ampanihy Airport" },
  { id: 175, code: "ADP", name: "Ampara Airport" },
  { id: 176, code: "AMS", name: "Amsterdam Airport Schiphol" },
  { id: 177, code: "AAA", name: "Anaa Airport" },
  { id: 178, code: "AAO", name: "Anaco Airport" },
  { id: 179, code: "AOE", name: "Anadolu Airport" },
  { id: 180, code: "AKP", name: "Anaktuvuk Pass Airport" },
  { id: 181, code: "AAQ", name: "Anapa Airport" },
  { id: 182, code: "APS", name: "Anápolis Airport" },
  { id: 183, code: "AUY", name: "Anatom Airport" },
  { id: 184, code: "AOI", name: "Ancona Falconara Airport" },
  { id: 185, code: "ANS", name: "Andahuaylas Airport" },
  { id: 186, code: "ADC", name: "Andakombe Airport" },
  { id: 187, code: "ADO", name: "Andamooka Airport" },
  { id: 188, code: "AID", name: "Anderson Municipal Airport (Darlington Field)" },
  { id: 189, code: "AND", name: "Anderson Regional Airport" },
  { id: 190, code: "ADN", name: "Andes Airport" },
  { id: 191, code: "AZN", name: "Andizhan Airport" },
  { id: 192, code: "ANX", name: "Andøya Airport, Andenes" },
  { id: 193, code: "ADW", name: "Andrews Field (Andrews Air Force Base)" },
  { id: 194, code: "ASD", name: "Andros Town International Airport" },
  { id: 195, code: "ANL", name: "Andulo Airport" },
  { id: 196, code: "ANA", name: "Angama Mara Airport" },
  { id: 197, code: "AXX", name: "Angel Fire Airport" },
  { id: 198, code: "AGH", name: "Ängelholm–Helsingborg Airport (former ICAO: ESDB)" },
  { id: 199, code: "ANE", name: "Angers – Loire Airport" },
  { id: 200, code: "AGD", name: "Anggi Airport" },
  { id: 201, code: "ANO", name: "Angoche Airport" },
  { id: 202, code: "AGN", name: "Angoon Seaplane Base" },
  { id: 203, code: "AGG", name: "Angoram Airport" },
  { id: 204, code: "ANG", name: "Angoulême – Cognac International Airport" },
  { id: 205, code: "AKG", name: "Anguganak Airport" },
  { id: 206, code: "ANZ", name: "Angus Downs Airport" },
  { id: 207, code: "ANI", name: "Aniak Airport" },
  { id: 208, code: "AMK", name: "Animas Air Park (FAA: 00C)" },
  { id: 209, code: "AWD", name: "Aniwa Airport" },
  { id: 210, code: "AKA", name: "Ankang Wulipu Airport" },
  { id: 211, code: "ARB", name: "Ann Arbor Municipal Airport" },
  { id: 212, code: "AOB", name: "Annanberg Airport" },
  { id: 213, code: "ANN", name: "Annette Island Airport" },
  { id: 214, code: "ANB", name: "Anniston Regional Airport" },
  { id: 215, code: "AQG", name: "Anqing Tianzhushan Airport" },
  { id: 216, code: "AOG", name: "Anshan Teng'ao Airport" },
  { id: 217, code: "AVA", name: "Anshun Huangguoshu Airport" },
  { id: 218, code: "AYT", name: "Antalya Airport" },
  { id: 219, code: "AYL", name: "Anthony Lagoon Airport" },
  { id: 220, code: "ANY", name: "Anthony Municipal Airport" },
  { id: 221, code: "ATE", name: "Antlers Municipal Airport (FAA: 80F)" },
  { id: 222, code: "ARE", name: "Antonio (Nery) Juarbe Pol Airport (FAA: ABO)" },
  { id: 223, code: "APO", name: "Antonio Roldán Betancourt Airport" },
  { id: 224, code: "ACB", name: "Antrim County Airport" },
  { id: 225, code: "ANM", name: "Antsirabato Airport" },
  { id: 226, code: "ATJ", name: "Antsirabe Airport" },
  { id: 227, code: "ANR", name: "Antwerp International Airport" },
  { id: 228, code: "ACJ", name: "Anuradhapura Airport" },
  { id: 229, code: "ANV", name: "Anvik Airport" },
  { id: 230, code: "AYN", name: "Anyang Airport" },
  { id: 231, code: "AOJ", name: "Aomori Airport" },
  { id: 232, code: "AOT", name: "Aosta Valley Airport" },
  { id: 233, code: "AAF", name: "Apalachicola Regional Airport" },
  { id: 234, code: "AAS", name: "Apalapsili Airport" },
  { id: 235, code: "APK", name: "Apataki Airport" },
  { id: 236, code: "APB", name: "Apolo Airport" },
  { id: 237, code: "APV", name: "Apple Valley Airport" },
  { id: 238, code: "ATW", name: "Appleton International Airport" },
  { id: 239, code: "APR", name: "April River Airport" },
  { id: 240, code: "APU", name: "Apucarana Airport" },
  { id: 241, code: "AEQ", name: "Ar Horqin Airport" },
  { id: 242, code: "ARX", name: "Aracati Airport" },
  { id: 243, code: "ARU", name: "Araçatuba Airport" },
  { id: 244, code: "AIY", name: "Araçuai Airport" },
  { id: 245, code: "ARW", name: "Arad International Airport" },
  { id: 246, code: "ARS", name: "Aragarças Airport" },
  { id: 247, code: "ARP", name: "Aragip Airport" },
  { id: 248, code: "AUX", name: "Araguaína Airport" },
  { id: 249, code: "AJK", name: "Arak Airport[1]" },
  { id: 250, code: "ACF", name: "Aral Talim Airport" },
  { id: 251, code: "AXC", name: "Aramac Airport" },
  { id: 252, code: "ADI", name: "Arandis Airport" },
  { id: 253, code: "AAK", name: "Aranuka Airport" },
  { id: 254, code: "AHF", name: "Arapahoe Municipal Airport (FAA: 37V)" },
  { id: 255, code: "APQ", name: "Arapiraca Airport" },
  { id: 256, code: "APX", name: "Arapongas Airport" },
  { id: 257, code: "AAG", name: "Arapoti Airport" },
  { id: 258, code: "ACR", name: "Araracuara Airport" },
  { id: 259, code: "AQA", name: "Araraquara Airport" },
  { id: 260, code: "ARY", name: "Ararat Airport" },
  { id: 261, code: "AAX", name: "Araxá Airport" },
  { id: 262, code: "AMH", name: "Arba Minch Airport" },
  { id: 263, code: "ARO", name: "Arboletes Airport" },
  { id: 264, code: "ACV", name: "Arcata-Eureka Airport" },
  { id: 265, code: "ARC", name: "Arctic Village Airport" },
  { id: 266, code: "ADU", name: "Ardabil Airport" },
  { id: 267, code: "AMZ", name: "Ardmore Airport" },
  { id: 268, code: "AHD", name: "Ardmore Downtown Executive Airport (FAA: 1F0)" },
  { id: 269, code: "ADM", name: "Ardmore Municipal Airport" },
  { id: 270, code: "ACM", name: "Arica Airport" },
  { id: 271, code: "AIR", name: "Aripuanã Airport" },
  { id: 272, code: "AQM", name: "Ariquemes Airport" },
  { id: 273, code: "AYK", name: "Arkalyk Airport" },
  { id: 274, code: "ARL", name: "Arly Airport" },
  { id: 275, code: "ARM", name: "Armidale Airport" },
  { id: 276, code: "AOA", name: "Aroa Airport" },
  { id: 277, code: "AON", name: "Arona Airport" },
  { id: 278, code: "AIS", name: "Arorae Island Airport" },
  { id: 279, code: "AAB", name: "Arrabury Airport" },
  { id: 280, code: "AAI", name: "Arraias Airport" },
  { id: 281, code: "ARJ", name: "Arso Airport" },
  { id: 282, code: "ATS", name: "Artesia Municipal Airport" },
  { id: 283, code: "ATC", name: "Arthur's Town Airport" },
  { id: 284, code: "ATI", name: "Artigas International Airport" },
  { id: 285, code: "AYY", name: "Arugam Bay Seaplane Base[1]" },
  { id: 286, code: "ARK", name: "Arusha Airport" },
  { id: 287, code: "AXR", name: "Arutua Airport" },
  { id: 288, code: "AVK", name: "Arvaikheer Airport" },
  { id: 289, code: "AJR", name: "Arvidsjaur Airport" },
  { id: 290, code: "ABB", name: "Asaba International Airport" },
  { id: 291, code: "AKJ", name: "Asahikawa Airport" },
  { id: 292, code: "APP", name: "Asapa Airport" },
  { id: 293, code: "AAU", name: "Asau Airport" },
  { id: 294, code: "ASC", name: "Ascención de Guarayos Airport" },
  { id: 295, code: "AEK", name: "Aseki Airport" },
  { id: 296, code: "ALK", name: "Asella Airport" },
  { id: 297, code: "ASG", name: "Ashburton Aerodrome" },
  { id: 298, code: "AVL", name: "Asheville Regional Airport" },
  { id: 299, code: "ASB", name: "Ashgabat International Airport" },
  { id: 300, code: "AHM", name: "Ashland Municipal Airport[1] (FAA: S03)" },
  { id: 301, code: "ASY", name: "Ashley Municipal Airport" },
  { id: 302, code: "ASZ", name: "Asirim Airport" },
  { id: 303, code: "ASM", name: "Asmara International Airport" },
  { id: 304, code: "ASO", name: "Asosa Airport" },
  { id: 305, code: "ASE", name: "Aspen–Pitkin County Airport (Sardy Field)" },
  { id: 306, code: "ASA", name: "Assab International Airport" },
  { id: 307, code: "AIF", name: "Assis Airport (former ICAO: SBAS)" },
  { id: 308, code: "ATZ", name: "Assiut Airport" },
  { id: 309, code: "AST", name: "Astoria Regional Airport" },
  { id: 310, code: "ASW", name: "Aswan International Airport" },
  { id: 311, code: "AXK", name: "Ataq Airport" },
  { id: 312, code: "ATR", name: "Atar International Airport" },
  { id: 313, code: "AUT", name: "Atauro Airport" },
  { id: 314, code: "ATB", name: "Atbara Airport" },
  { id: 315, code: "ATX", name: "Atbasar Airport" },
  { id: 316, code: "AHN", name: "Athens Ben Epps Airport" },
  { id: 317, code: "ATH", name: "Athens International Airport (Eleftherios Venizelos Airport)" },
  { id: 318, code: "ATV", name: "Ati Airport" },
  { id: 319, code: "AKB", name: "Atka Airport (FAA: AKA)" },
  { id: 320, code: "ABP", name: "Atkamba Airport" },
  { id: 321, code: "ACY", name: "Atlantic City International Airport" },
  { id: 322, code: "AIO", name: "Atlantic Municipal Airport" },
  { id: 323, code: "ATT", name: "Atmautluak Airport (FAA: 4A2)" },
  { id: 324, code: "ATK", name: "Atqasuk Edward Burnell Sr. Memorial Airport" },
  { id: 325, code: "AOU", name: "Attapeu International Airport" },
  { id: 326, code: "AUQ", name: "Atuona Airport" },
  { id: 327, code: "AUI", name: "Aua Island Airport" },
  { id: 328, code: "AUN", name: "Auburn Municipal Airport" },
  { id: 329, code: "AUO", name: "Auburn University Regional Airport" },
  { id: 330, code: "AKL", name: "Auckland Airport" },
  { id: 331, code: "AGB", name: "Augsburg Airport" },
  { id: 332, code: "AGS", name: "Augusta Regional Airport at Bush Field" },
  { id: 333, code: "AUG", name: "Augusta State Airport" },
  { id: 334, code: "AUD", name: "Augustus Downs Airport" },
  { id: 335, code: "AKS", name: "Auki Gwaunaru'u Airport" },
  { id: 336, code: "AUV", name: "Aumo Airport" },
  { id: 337, code: "AUL", name: "Aur Airport" },
  { id: 338, code: "AUR", name: "Aurillac – Tronquières Airport" },
  { id: 339, code: "AUZ", name: "Aurora Municipal Airport (FAA: ARR)" },
  { id: 340, code: "AUU", name: "Aurukun Airport" },
  { id: 341, code: "ASQ", name: "Austin Airport (FAA: 9U3)" },
  { id: 342, code: "AUM", name: "Austin Municipal Airport" },
  { id: 343, code: "AUS", name: "Austin–Bergstrom International Airport" },
  { id: 344, code: "AWP", name: "Austral Downs Airport" },
  { id: 345, code: "AVG", name: "Auvergne Airport" },
  { id: 346, code: "AUF", name: "Auxerre – Branches Aerodrome" },
  { id: 347, code: "AVV", name: "Avalon Airport" },
  { id: 348, code: "AVB", name: "Aviano Air Base" },
  { id: 349, code: "AVN", name: "Avignon – Provence Airport" },
  { id: 350, code: "AVO", name: "Avon Park Executive Airport" },
  { id: 351, code: "AVU", name: "Avu Avu Airport" },
  { id: 352, code: "AWB", name: "Awaba Airport" },
  { id: 353, code: "AWR", name: "Awar Airport" },
  { id: 354, code: "AWA", name: "Awasa Airport" },
  { id: 355, code: "AXU", name: "Axum Airport" },
  { id: 356, code: "AYC", name: "Ayacucho Airport" },
  { id: 357, code: "AYA", name: "Ayapel Airport" },
  { id: 358, code: "AYW", name: "Ayawasi Airport" },
  { id: 359, code: "AYQ", name: "Ayers Rock Airport" },
  { id: 360, code: "AYR", name: "Ayr Airport" },
  { id: 361, code: "AEB", name: "Baise Bama Airport" },
  { id: 362, code: "ADD", name: "Bole International Airport" },
  { id: 363, code: "API", name: "Captain Luis F. Gómez Niño Air Base" },
  { id: 364, code: "ATU", name: "Casco Cove Coast Guard Station" },
  { id: 365, code: "AVX", name: "Catalina Airport" },
  { id: 366, code: "AAJ", name: "Cayana Airstrip" },
  { id: 367, code: "APA", name: "Centennial Airport" },
  { id: 368, code: "ANF", name: "Cerro Moreno International Airport" },
  { id: 369, code: "ARI", name: "Chacalluta International Airport" },
  { id: 370, code: "ATF", name: "Chachoan Airport" },
  { id: 371, code: "AHU", name: "Cherif Al Idrissi Airport" },
  { id: 372, code: "ACN", name: "Ciudad Acuña International Airport" },
  { id: 373, code: "AXA", name: "Clayton J. Lloyd International Airport" },
  { id: 374, code: "ACO", name: "Cobano Airport" },
  { id: 375, code: "AKO", name: "Colorado Plains Regional Airport" },
  { id: 376, code: "ATA", name: "Comandante FAP Germán Arias Graziani Airport" },
  { id: 377, code: "AYP", name: "Coronel FAP Alfredo Mendívil Duarte Airport" },
  { id: 378, code: "ADV", name: "Ed Daein Airport" },
  { id: 379, code: "AAC", name: "El Arish International Airport" },
  { id: 380, code: "AXM", name: "El Edén International Airport" },
  { id: 381, code: "ALY", name: "El Nouzha Airport" },
  { id: 382, code: "ARQ", name: "El Troncal Airport" },
  { id: 383, code: "AIU", name: "Enua Airport" },
  { id: 384, code: "ASR", name: "Erkilet International Airport" },
  { id: 385, code: "ANK", name: "Etimesgut Air Base" },
  { id: 386, code: "APW", name: "Faleolo International Airport" },
  { id: 387, code: "AZL", name: "Fazenda Tucunaré Airport[1]" },
  { id: 388, code: "AFW", name: "Fort Worth Alliance Airport" },
  { id: 389, code: "AIV", name: "George Downer Airport" },
  { id: 390, code: "AQY", name: "Girdwood Airport[1]" },
  { id: 391, code: "AMN", name: "Gratiot Community Airport" },
  { id: 392, code: "AGT", name: "Guaraní International Airport" },
  { id: 393, code: "AKQ", name: "Gunung Batin Airport" },
  { id: 394, code: "ADZ", name: "Gustavo Rojas Pinilla International Airport" },
  { id: 395, code: "ABU", name: "Haliwen Airport" },
  { id: 396, code: "ASL", name: "Harrison County Airport" },
  { id: 397, code: "ATL", name: "Hartsfield–Jackson Atlanta International Airport" },
  { id: 398, code: "AHJ", name: "Hongyuan Airport" },
  { id: 399, code: "ALG", name: "Houari Boumediene Airport" },
  { id: 400, code: "AFN", name: "Jaffrey Airport–Silver Ranch" },
  { id: 401, code: "ASX", name: "John F. Kennedy Memorial Airport" },
  { id: 402, code: "AZP", name: "Jorge Jiménez Cantú National Airport" },
  { id: 403, code: "AEP", name: "Jorge Newbery Airpark" },
  { id: 404, code: "AYO", name: "Juan de Ayolas Airport" },
  { id: 405, code: "ABK", name: "Kabri Dar Airport" },
  { id: 406, code: "AGK", name: "Kagua Airport" },
  { id: 407, code: "AZO", name: "Kalamazoo/Battle Creek International Airport" },
  { id: 408, code: "AOK", name: "Karpathos Island National Airport" },
  { id: 409, code: "AQJ", name: "King Hussein International Airport" },
  { id: 410, code: "AKN", name: "King Salmon Airport" },
  { id: 411, code: "ADQ", name: "Kodiak Airport" },
  { id: 412, code: "AFK", name: "Kondavattavan Tank Seaplane Base[1]" },
  { id: 413, code: "ACC", name: "Kotoka International Airport" },
  { id: 414, code: "AKF", name: "Kufra Airport" },
  { id: 415, code: "ARV", name: "Lakeland Airport (Noble F. Lee Memorial Field)" },
  { id: 416, code: "ACE", name: "Lanzarote Airport" },
  { id: 417, code: "ANP", name: "Lee Airport" },
  { id: 418, code: "AIZ", name: "Lee C. Fine Memorial Airport" },
  { id: 419, code: "ABE", name: "Lehigh Valley International Airport" },
  { id: 420, code: "AOC", name: "Leipzig–Altenburg Airport" },
  { id: 421, code: "ADG", name: "Lenawee County Airport" },
  { id: 422, code: "AJL", name: "Lengpui Airport" },
  { id: 423, code: "ADX", name: "Leuchars Station (formerly RAF Leuchars)" },
  { id: 424, code: "AGU", name: "Lic. Jesús Terán Peredo International Airport" },
  { id: 425, code: "AOH", name: "Lima Allen County Airport" },
  { id: 426, code: "AGO", name: "Magnolia Municipal Airport" },
  { id: 427, code: "AAM", name: "Mala Mala Airport" },
  { id: 428, code: "AGP", name: "Málaga Airport" },
  { id: 429, code: "AJY", name: "Mano Dayak International Airport" },
  { id: 430, code: "AMO", name: "Mao Airport" },
  { id: 431, code: "AVW", name: "Marana Regional Airport (FAA: AVQ)" },
  { id: 432, code: "APT", name: "Marion County Airport (Brown Field)" },
  { id: 433, code: "AVI", name: "Máximo Gómez Airport" },
  { id: 434, code: "AXB", name: "Maxson Airfield (FAA: 89N)" },
  { id: 435, code: "AAH", name: "Merzbrück Airport" },
  { id: 436, code: "ARZ", name: "N'zeto Airport" },
  { id: 437, code: "ATN", name: "Namatanai Airport" },
  { id: 438, code: "APL", name: "Nampula Airport" },
  { id: 439, code: "ACK", name: "Nantucket Memorial Airport" },
  { id: 440, code: "APC", name: "Napa County Airport" },
  { id: 441, code: "APF", name: "Naples Municipal Airport" },
  { id: 442, code: "ASF", name: "Narimanovo Airport" },
  { id: 443, code: "ASH", name: "Nashua Airport (Boire Field)" },
  { id: 444, code: "AXV", name: "Neil Armstrong Airport" },
  { id: 445, code: "ABV", name: "Nnamdi Azikiwe International Airport" },
  { id: 446, code: "ABM", name: "Northern Peninsula Airport" },
  { id: 447, code: "ATO", name: "Ohio University Airport (Snyder Field) (FAA: UNI)" },
  { id: 448, code: "AGV", name: "Oswaldo Guevara Mujica Airport" },
  { id: 449, code: "AJN", name: "Ouani Airport" },
  { id: 450, code: "AZG", name: "Pablo L. Sidar Airport" },
  { id: 451, code: "ATG", name: "PAF Base Minhas" },
  { id: 452, code: "AOL", name: "Paso de los Libres Airport" },
  { id: 453, code: "AMQ", name: "Pattimura Airport" },
  { id: 454, code: "APG", name: "Phillips Army Airfield" },
  { id: 455, code: "AZA", name: "Phoenix–Mesa Gateway Airport (FAA: IWA)" },
  { id: 456, code: "AFD", name: "Port Alfred Airport" },
  { id: 457, code: "ABJ", name: "Port Bouet Airport (Felix Houphouet Boigny Int'l)" },
  { id: 458, code: "AKH", name: "Prince Sultan Air Base" },
  { id: 459, code: "AML", name: "Puerto Armuelles Airport" },
  { id: 460, code: "AJS", name: "Punta Abreojos Airstrip" },
  { id: 461, code: "AMM", name: "Queen Alia International Airport" },
  { id: 462, code: "AUA", name: "Queen Beatrix International Airport" },
  { id: 463, code: "AAZ", name: "Quetzaltenango Airport" },
  { id: 464, code: "AQB", name: "Quiché Airport" },
  { id: 465, code: "AAE", name: "Rabah Bitat Airport (Les Salines Airport)" },
  { id: 466, code: "AKT", name: "RAF Akrotiri" },
  { id: 467, code: "ASI", name: "RAF Ascension Island (Wideawake Field)" },
  { id: 468, code: "AMA", name: "Rick Husband Amarillo International Airport" },
  { id: 469, code: "ADR", name: "Robert F. Swinnie Airport (FAA: PHH)" },
  { id: 470, code: "AQP", name: "Rodríguez Ballón International Airport" },
  { id: 471, code: "AFZ", name: "Sabzevar Airport[1]" },
  { id: 472, code: "ACP", name: "Sahand Airport" },
  { id: 473, code: "AHW", name: "Saih Rawl Airport[1]" },
  { id: 474, code: "AZS", name: "Samaná El Catey International Airport" },
  { id: 475, code: "ALS", name: "San Luis Valley Regional Airport" },
  { id: 476, code: "AFA", name: "San Rafael Airport" },
  { id: 477, code: "AJU", name: "Santa Maria Airport" },
  { id: 478, code: "AUC", name: "Santiago Pérez Quiroz Airport" },
  { id: 479, code: "AQS", name: "Saqani Airport" },
  { id: 480, code: "AMD", name: "Sardar Vallabhbhai Patel International Airport" },
  { id: 481, code: "AMI", name: "Selaparang Airport (closed 2011)" },
  { id: 482, code: "AZD", name: "Shahid Sadooghi Airport" },
  { id: 483, code: "ASU", name: "Silvio Pettirossi International Airport" },
  { id: 484, code: "AKY", name: "Sittwe Airport" },
  { id: 485, code: "AER", name: "Sochi International Airport" },
  { id: 486, code: "ABY", name: "Southwest Georgia Regional Airport" },
  { id: 487, code: "AXP", name: "Spring Point Airport" },
  { id: 488, code: "ATQ", name: "Sri Guru Ram Dass Jee International Airport" },
  { id: 489, code: "ACH", name: "St. Gallen–Altenrhein Airport" },
  { id: 490, code: "ALN", name: "St. Louis Regional Airport" },
  { id: 491, code: "ARN", name: "Stockholm Arlanda Airport" },
  { id: 492, code: "AOR", name: "Sultan Abdul Halim Airport" },
  { id: 493, code: "ARH", name: "Talagi Airport" },
  { id: 494, code: "ASN", name: "Talladega Municipal Airport" },
  { id: 495, code: "ANC", name: "Ted Stevens Anchorage International Airport" },
  { id: 496, code: "ALX", name: "Thomas C. Russell Field" },
  { id: 497, code: "AYX", name: "Tnte. Gral. Gerardo Pérez Pinedo Airport" },
  { id: 498, code: "AZR", name: "Touat-Cheikh Sidi Mohamed Belkebir Airport" },
  { id: 499, code: "ANQ", name: "Tri-State Steuben County Airport" },
  { id: 500, code: "AFF", name: "United States Air Force Academy Airfield" },
  { id: 501, code: "ATD", name: "Uru Harbour Airport" },
  { id: 502, code: "ANU", name: "V. C. Bird International Airport" },
  { id: 503, code: "ACT", name: "Waco Regional Airport" },
  { id: 504, code: "AGI", name: "Wageningen Airstrip" },
  { id: 505, code: "AIN", name: "Wainwright Airport (FAA: AWI)" },
  { id: 506, code: "AWK", name: "Wake Island Airfield" },
  { id: 507, code: "ALW", name: "Walla Walla Regional Airport" },
  { id: 508, code: "ARG", name: "Walnut Ridge Regional Airport" },
  { id: 509, code: "AGE", name: "Wangerooge Airfield" },
  { id: 510, code: "AGL", name: "Wanigela Airport" },
  { id: 511, code: "ALO", name: "Waterloo Regional Airport" },
  { id: 512, code: "ART", name: "Watertown International Airport" },
  { id: 513, code: "ATY", name: "Watertown Regional Airport" },
  { id: 514, code: "AUW", name: "Wausau Downtown Airport" },
  { id: 515, code: "AYS", name: "Waycross–Ware County Airport" },
  { id: 516, code: "AWM", name: "West Memphis Municipal Airport" },
  { id: 517, code: "AVP", name: "Wilkes-Barre/Scranton International Airport" },
  { id: 518, code: "AXE", name: "Xanxere Airport" },
  { id: 519, code: "ACX", name: "Xingyi Wanfenglin Airport" },
  { id: 520, code: "AYG", name: "Yaguara Airport" },
  { id: 521, code: "AIG", name: "Yalinga Airport" },
  { id: 522, code: "ASK", name: "Yamoussoukro Airport" },
  { id: 523, code: "AYI", name: "Yari Airport" },
  { id: 524, code: "AYM", name: "Yas Island Seaplane Base[1]" },
  { id: 525, code: "ACZ", name: "Zabol Airport" },
  { id: 526, code: "AKM", name: "Zakouma Airport" },
  { id: 527, code: "ANJ", name: "Zanaga Airport" },
  { id: 528, code: "APZ", name: "Zapala Airport" },
  { id: 529, code: "AZT", name: "Zapatoca Airport" },
  { id: 530, code: "AFS", name: "Zarafshan Airport" },
  { id: 532, code: "BAA", name: "Bialla Airport" },
  { id: 533, code: "BAB", name: "Beale Air Force Base" },
  { id: 534, code: "BAC", name: "Barranca de Upia Airport" },
  { id: 535, code: "BAD", name: "Barksdale Air Force Base" },
  { id: 536, code: "BAE", name: "Barcelonnette – Saint-Pons Airport" },
  { id: 537, code: "BAF", name: "Westfield-Barnes Regional Airport" },
  { id: 538, code: "BAG", name: "Loakan Airport" },
  { id: 539, code: "BAH", name: "Bahrain International Airport" },
  { id: 540, code: "BAI", name: "Buenos Aires Airport" },
  { id: 541, code: "BAJ", name: "Bali Airport" },
  { id: 542, code: "BAK[1]", name: "metropolitan area2" },
  { id: 543, code: "BAL", name: "Batman Airport" },
  { id: 544, code: "BAM", name: "Battle Mountain Airport (Lander County Airport)" },
  { id: 545, code: "BAN", name: "Basongo Airport" },
  { id: 546, code: "BAP", name: "Baibara Airport" },
  { id: 547, code: "BAQ", name: "Ernesto Cortissoz International Airport" },
  { id: 548, code: "BAR", name: "Qionghai Bo'ao Airport" },
  { id: 549, code: "BAS", name: "Balalae Airport" },
  { id: 550, code: "BAT", name: "Chafei Amsei Airport" },
  { id: 551, code: "BAV", name: "Baotou Airport" },
  { id: 552, code: "BAW", name: "Biawonque Airport" },
  { id: 553, code: "BAX", name: "Barnaul Airport" },
  { id: 554, code: "BAY", name: "Baia Mare Airport" },
  { id: 555, code: "BAZ", name: "Barcelos Airport" },
  { id: 556, code: "BBA", name: "Balmaceda Airport" },
  { id: 557, code: "BBB", name: "Benson Municipal Airport" },
  { id: 558, code: "BBC", name: "Bay City Municipal Airport (FAA: BYY)" },
  { id: 559, code: "BBD", name: "Curtis Field" },
  { id: 560, code: "BBG", name: "Butaritari Atoll Airport" },
  { id: 561, code: "BBH", name: "Stralsund–Barth Airport" },
  { id: 562, code: "BBI", name: "Biju Patnaik International Airport" },
  { id: 563, code: "BBJ", name: "Bitburg Airport (former Bitburg Air Base)" },
  { id: 564, code: "BBK", name: "Kasane Airport" },
  { id: 565, code: "BBL", name: "Ballera Airport" },
  { id: 566, code: "BBM", name: "Battambang Airport" },
  { id: 567, code: "BBN", name: "Bario Airport" },
  { id: 568, code: "BBO", name: "Berbera Airport" },
  { id: 569, code: "BBP", name: "Bembridge Airport" },
  { id: 570, code: "BBQ", name: "Barbuda Codrington Airport" },
  { id: 571, code: "BBR", name: "Baillif Airport" },
  { id: 572, code: "BBS", name: "Blackbushe Airport" },
  { id: 573, code: "BBT", name: "Berbérati Airport" },
  { id: 574, code: "BBU", name: "Aurel Vlaicu International Airport (Băneasa Airport)" },
  { id: 575, code: "BBV", name: "Nero-Mer Airport" },
  { id: 576, code: "BBW", name: "Broken Bow Municipal Airport" },
  { id: 577, code: "BBX", name: "Wings Field (FAA: LOM)" },
  { id: 578, code: "BBY", name: "Bambari Airport" },
  { id: 579, code: "BBZ", name: "Zambezi Airport" },
  { id: 580, code: "BCA", name: "Gustavo Rizo Airport" },
  { id: 581, code: "BCB", name: "Virginia Tech Montgomery Executive Airport" },
  { id: 582, code: "BCC", name: "Bear Creek 3 Airport (FAA: Z48)" },
  { id: 583, code: "BCD", name: "Bacolod–Silay International Airport" },
  { id: 584, code: "BCE", name: "Bryce Canyon Airport" },
  { id: 585, code: "BCF", name: "Bouca Airport" },
  { id: 586, code: "BCG", name: "Bemichi Airport" },
  { id: 587, code: "BCH", name: "Baucau Airport" },
  { id: 588, code: "BCI", name: "Barcaldine Airport" },
  { id: 589, code: "BCK", name: "Bolwarra Airport" },
  { id: 590, code: "BCL", name: "Barra del Colorado Airport" },
  { id: 591, code: "BCM", name: "Bacău International Airport" },
  { id: 592, code: "BCN", name: "Barcelona–El Prat Airport" },
  { id: 593, code: "BCO", name: "Baco Airport (Jinka Airport)" },
  { id: 594, code: "BCP", name: "Bambu Airport" },
  { id: 595, code: "BCQ", name: "Brak Airport" },
  { id: 596, code: "BCR", name: "Novo Campo Airport" },
  { id: 597, code: "BCS", name: "Southern Seaplane Airport (FAA: 65LA)" },
  { id: 598, code: "BCT", name: "Boca Raton Airport" },
  { id: 599, code: "BCU", name: "Bauchi State Airport" },
  { id: 600, code: "BCV", name: "Hector Silva Airstrip" },
  { id: 601, code: "BCW", name: "Benguerra Island Airport" },
  { id: 602, code: "BCX", name: "Beloretsk Airport" },
  { id: 603, code: "BCY", name: "Bulchi Airport" },
  { id: 604, code: "BCZ", name: "Bickerton Island Airport" },
  { id: 605, code: "BDA", name: "L.F. Wade International Airport" },
  { id: 606, code: "BDB", name: "Bundaberg Airport" },
  { id: 607, code: "BDC", name: "Barra do Corda Airport" },
  { id: 608, code: "BDD", name: "Badu Island Airport" },
  { id: 609, code: "BDE", name: "Baudette International Airport" },
  { id: 610, code: "BDF", name: "Rinkenberger RLA Airport (FAA: 3IS8)" },
  { id: 611, code: "BDG", name: "Blanding Municipal Airport" },
  { id: 612, code: "BDH", name: "Bandar Lengeh Airport" },
  { id: 613, code: "BDI", name: "Bird Island Airport" },
  { id: 614, code: "BDJ", name: "Syamsudin Noor Airport" },
  { id: 615, code: "BDK", name: "Soko Airport" },
  { id: 616, code: "BDL", name: "Bradley International Airport" },
  { id: 617, code: "BDM", name: "Bandırma Airport" },
  { id: 618, code: "BDN", name: "Talhar Airport" },
  { id: 619, code: "BDO", name: "Husein Sastranegara International Airport" },
  { id: 620, code: "BDP", name: "Bhadrapur Airport (Chandragadhi Airport)" },
  { id: 621, code: "BDQ", name: "Vadodara Airport (Civil Airport Harni)" },
  { id: 622, code: "BDR", name: "Igor I. Sikorsky Memorial Airport" },
  { id: 623, code: "BDS", name: "Brindisi – Salento Airport" },
  { id: 624, code: "BDT", name: "Gbadolite Airport" },
  { id: 625, code: "BDU", name: "Bardufoss Airport" },
  { id: 626, code: "BDV", name: "Moba Airport" },
  { id: 627, code: "BDW", name: "Bedford Downs Airport" },
  { id: 628, code: "BDX", name: "Broadus Airport[1]" },
  { id: 629, code: "BDY", name: "Bandon State Airport (FAA: S05)" },
  { id: 630, code: "BDZ", name: "Baindoung Airport" },
  { id: 631, code: "BEA", name: "Bereina Airport" },
  { id: 632, code: "BEB", name: "Benbecula Airport" },
  { id: 633, code: "BEC", name: "Beech Factory Airport" },
  { id: 634, code: "BED", name: "Laurence G. Hanscom Field" },
  { id: 635, code: "BEE", name: "Beagle Bay Airport" },
  { id: 636, code: "BEF", name: "Bluefields Airport" },
  { id: 637, code: "BEG", name: "Belgrade Nikola Tesla Airport" },
  { id: 638, code: "BEH", name: "Southwest Michigan Regional Airport" },
  { id: 639, code: "BEI", name: "Beica Airport" },
  { id: 640, code: "BEJ", name: "Kalimarau Airport" },
  { id: 641, code: "BEK", name: "Bareilly Airport" },
  { id: 642, code: "BEL", name: "Val de Cans International Airport" },
  { id: 643, code: "BEM", name: "Beni Mellal Airport[1]" },
  { id: 644, code: "BEN", name: "Benina International Airport" },
  { id: 645, code: "BEO", name: "Lake Macquarie Airport (Belmont Airport)" },
  { id: 646, code: "BEP", name: "Bellary Airport" },
  { id: 647, code: "BEQ", name: "RAF Honington" },
  { id: 648, code: "BER", name: "Berlin Brandenburg Airport" },
  { id: 649, code: "BES", name: "Brest Bretagne Airport" },
  { id: 650, code: "BET", name: "Bethel Airport" },
  { id: 651, code: "BEU", name: "Bedourie Airport" },
  { id: 652, code: "BEV", name: "Beersheba Airport" },
  { id: 653, code: "BEW", name: "Beira Airport" },
  { id: 654, code: "BEX", name: "RAF Benson" },
  { id: 655, code: "BEY", name: "Beirut–Rafic Hariri International Airport / Beirut Air Base" },
  { id: 656, code: "BEZ", name: "Beru Island Airport" },
  { id: 657, code: "BFA[1]", name: "Bahía Negra Airport[1]" },
  { id: 658, code: "BFC", name: "Bloomfield Airport" },
  { id: 659, code: "BFD", name: "Bradford Regional Airport" },
  { id: 660, code: "BFE", name: "Bielefeld Airport" },
  { id: 661, code: "BFF", name: "Western Nebraska Regional Airport (William B. Heilig Field)" },
  { id: 662, code: "BFG", name: "Bullfrog Basin Airport (FAA: U07)" },
  { id: 663, code: "BFH", name: "Bacacheri Airport" },
  { id: 664, code: "BFI", name: "Boeing Field/King County International Airport" },
  { id: 665, code: "BFJ", name: "Bijie Feixiong Airport" },
  { id: 666, code: "BFK", name: "Buckley Space Force Base" },
  { id: 667, code: "BFL", name: "Meadows Field Airport" },
  { id: 668, code: "BFM", name: "Mobile Downtown Airport" },
  { id: 669, code: "BFN", name: "Bloemfontein Airport" },
  { id: 670, code: "BFO", name: "Buffalo Range Airport" },
  { id: 671, code: "BFP", name: "Beaver County Airport (FAA: BVI)" },
  { id: 672, code: "BFQ", name: "Bahía Piña Airport" },
  { id: 673, code: "BFR", name: "Virgil I. Grissom Municipal Airport" },
  { id: 674, code: "BFS", name: "Belfast International Airport" },
  { id: 675, code: "BFT", name: "Beaufort County Airport (FAA: ARW)" },
  { id: 676, code: "BFU", name: "Bengbu Airport" },
  { id: 677, code: "BFV", name: "Buriram Airport" },
  { id: 678, code: "BFW", name: "Sidi Bel Abbès Airport" },
  { id: 679, code: "BFX", name: "Bafoussam Airport" },
  { id: 680, code: "BGA", name: "Palonegro International Airport" },
  { id: 681, code: "BGB", name: "Booué Airport" },
  { id: 682, code: "BGC", name: "Bragança Airport" },
  { id: 683, code: "BGD", name: "Hutchinson County Airport" },
  { id: 684, code: "BGE", name: "Decatur County Industrial Air Park" },
  { id: 685, code: "BGF", name: "Bangui M'Poko International Airport" },
  { id: 686, code: "BGG", name: "Bingöl Airport[1]" },
  { id: 687, code: "BGH", name: "Abbaye Airport" },
  { id: 688, code: "BGI", name: "Grantley Adams International Airport" },
  { id: 689, code: "BGJ", name: "Borgarfjörður Eystri Airport" },
  { id: 690, code: "BGK", name: "Big Creek Airport" },
  { id: 691, code: "BGL", name: "Baglung Airport" },
  { id: 692, code: "BGM", name: "Greater Binghamton Airport (Edwin A. Link Field)" },
  { id: 693, code: "BGN", name: "Belaya Gora Airport" },
  { id: 694, code: "BGO", name: "Bergen Airport, Flesland" },
  { id: 695, code: "BGP", name: "Bongo Airport" },
  { id: 696, code: "BGQ", name: "Big Lake Airport" },
  { id: 697, code: "BGR", name: "Bangor International Airport" },
  { id: 698, code: "BGT", name: "Bagdad Airport (FAA: E51)" },
  { id: 699, code: "BGU", name: "Bangassou Airport" },
  { id: 700, code: "BGV", name: "Bento Gonçalves Airport" },
  { id: 701, code: "BGW", name: "Baghdad International Airport" },
  { id: 702, code: "BGX", name: "Comandante Gustavo Kraemer Airport" },
  { id: 703, code: "BGY", name: "Il Caravaggio International Airport (Orio al Serio Airport)" },
  { id: 704, code: "BGZ", name: "Braga Airport" },
  { id: 705, code: "BHA", name: "Los Perales Airport" },
  { id: 706, code: "BHB", name: "Hancock County-Bar Harbor Airport" },
  { id: 707, code: "BHD", name: "George Best Belfast City Airport" },
  { id: 708, code: "BHE", name: "Woodbourne Airport" },
  { id: 709, code: "BHF", name: "Bahía Cupica Airport" },
  { id: 710, code: "BHG", name: "Brus Laguna Airport" },
  { id: 711, code: "BHH", name: "Bisha Domestic Airport" },
  { id: 712, code: "BHI", name: "Comandante Espora Airport" },
  { id: 713, code: "BHJ", name: "Bhuj Airport / Bhuj Rudra Mata Air Force Base" },
  { id: 714, code: "BHK", name: "Bukhara International Airport" },
  { id: 715, code: "BHL", name: "Bahía de los Ángeles Airport" },
  { id: 716, code: "BHM", name: "Birmingham–Shuttlesworth International Airport" },
  { id: 717, code: "BHN", name: "Beihan Airport" },
  { id: 718, code: "BHO", name: "Raja Bhoj Airport" },
  { id: 719, code: "BHP", name: "Bhojpur Airport" },
  { id: 720, code: "BHQ", name: "Broken Hill Airport" },
  { id: 721, code: "BHR", name: "Bharatpur Airport" },
  { id: 722, code: "BHS", name: "Bathurst Airport" },
  { id: 723, code: "BHT", name: "Brighton Downs Airport" },
  { id: 724, code: "BHU", name: "Bhavnagar Airport" },
  { id: 725, code: "BHV", name: "Bahawalpur Airport" },
  { id: 726, code: "BHW", name: "Bhagatanwala Airport" },
  { id: 727, code: "BHX", name: "Birmingham Airport" },
  { id: 728, code: "BHY", name: "Beihai Fucheng Airport" },
  { id: 729, code: "BHZ[1]", name: "metropolitan area3" },
  { id: 730, code: "BIA", name: "Bastia – Poretta Airport" },
  { id: 731, code: "BIB", name: "Baidoa Airport" },
  { id: 732, code: "BID", name: "Block Island State Airport" },
  { id: 733, code: "BIE", name: "Beatrice Municipal Airport" },
  { id: 734, code: "BIF", name: "Biggs Army Airfield" },
  { id: 735, code: "BIG", name: "Allen Army Airfield" },
  { id: 736, code: "BIH", name: "Eastern Sierra Regional Airport" },
  { id: 737, code: "BII", name: "Bikini Atoll Airport" },
  { id: 738, code: "BIJ", name: "Biliau Airport" },
  { id: 739, code: "BIK", name: "Frans Kaisiepo Airport" },
  { id: 740, code: "BIL", name: "Billings Logan International Airport" },
  { id: 741, code: "BIM", name: "South Bimini Airport" },
  { id: 742, code: "BIN", name: "Bamyan Airport" },
  { id: 743, code: "BIO", name: "Bilbao Airport" },
  { id: 744, code: "BIP", name: "Bulimba Airport" },
  { id: 745, code: "BIQ", name: "Biarritz Pays Basque Airport" },
  { id: 746, code: "BIR", name: "Biratnagar Airport" },
  { id: 747, code: "BIS", name: "Bismarck Municipal Airport" },
  { id: 748, code: "BIT", name: "Baitadi Airport" },
  { id: 749, code: "BIU", name: "Bíldudalur Airport" },
  { id: 750, code: "BIV", name: "Bria Airport" },
  { id: 751, code: "BIW", name: "Billiluna Airport" },
  { id: 752, code: "BIX", name: "Keesler Air Force Base" },
  { id: 753, code: "BIY", name: "Bhisho Airport" },
  { id: 754, code: "BIZ", name: "Bimin Airport" },
  { id: 755, code: "BJA", name: "Soummam – Abane Ramdane Airport" },
  { id: 756, code: "BJB", name: "Bojnord Airport" },
  { id: 757, code: "BJC", name: "Rocky Mountain Metropolitan Airport" },
  { id: 758, code: "BJD", name: "Bakkafjörður Airport" },
  { id: 759, code: "BJE", name: "Baleela Airport[1]" },
  { id: 760, code: "BJF", name: "Båtsfjord Airport" },
  { id: 761, code: "BJG", name: "Kotamobagu Mopait Airport[1]" },
  { id: 762, code: "BJH", name: "Bajhang Airport" },
  { id: 763, code: "BJI", name: "Bemidji Regional Airport" },
  { id: 764, code: "BJJ", name: "Wayne County Airport" },
  { id: 765, code: "BJK", name: "Benjina Airport (Nangasuri Airport)" },
  { id: 766, code: "BJL", name: "Banjul International Airport" },
  { id: 767, code: "BJM", name: "Bujumbura International Airport" },
  { id: 768, code: "BJN", name: "Bajone Airport" },
  { id: 769, code: "BJO", name: "Bermejo Airport" },
  { id: 770, code: "BJP", name: "Arthur Siqueira–Bragança Paulista State Airport[1]" },
  { id: 771, code: "BJQ", name: "Bahja Airport[1]" },
  { id: 772, code: "BJR", name: "Bahir Dar Airport" },
  { id: 773, code: "BJS[1]", name: "metropolitan area4" },
  { id: 774, code: "BJT", name: "Bentota River Airport[1]" },
  { id: 775, code: "BJU", name: "Bajura Airport" },
  { id: 776, code: "BJV", name: "Milas–Bodrum Airport" },
  { id: 777, code: "BJW", name: "Bajawa Soa Airport" },
  { id: 778, code: "BJX", name: "Del Bajío International Airport (Guanajuato Int'l Airport)" },
  { id: 779, code: "BJY", name: "Batajnica Air Base" },
  { id: 780, code: "BJZ", name: "Badajoz Airport (Talavera la Real Air Base)" },
  { id: 781, code: "BKB", name: "Nal Airport" },
  { id: 782, code: "BKC", name: "Buckland Airport (FAA: BVK)" },
  { id: 783, code: "BKD", name: "Stephens County Airport" },
  { id: 784, code: "BKE", name: "Baker City Municipal Airport" },
  { id: 785, code: "BKF", name: "Lake Brooks Seaplane Base" },
  { id: 786, code: "BKG", name: "Branson Airport (FAA: BBG)" },
  { id: 787, code: "BKH", name: "Barking Sands PMRF" },
  { id: 788, code: "BKI", name: "Kota Kinabalu International Airport" },
  { id: 789, code: "BKJ", name: "Boké Baralande Airport" },
  { id: 790, code: "BKK", name: "Suvarnabhumi Airport" },
  { id: 791, code: "BKL", name: "Cleveland Burke Lakefront Airport" },
  { id: 792, code: "BKM", name: "Bakelalan Airport" },
  { id: 793, code: "BKN", name: "Balkanabat Airport[1]" },
  { id: 794, code: "BKO", name: "Bamako–Sénou International Airport" },
  { id: 795, code: "BKP", name: "Barkly Downs Airport" },
  { id: 796, code: "BKQ", name: "Blackall Airport" },
  { id: 797, code: "BKR", name: "Bokoro Airport" },
  { id: 798, code: "BKS", name: "Fatmawati Soekarno Airport" },
  { id: 799, code: "BKT", name: "Blackstone Army Airfield (Allen C. Perkinson Airport)" },
  { id: 800, code: "BKU", name: "Betioky Airport" },
  { id: 801, code: "BKW", name: "Raleigh County Memorial Airport" },
  { id: 802, code: "BKX", name: "Brookings Regional Airport" },
  { id: 803, code: "BKY", name: "Kavumu Airport" },
  { id: 804, code: "BKZ", name: "Bukoba Airport" },
  { id: 805, code: "BLA", name: "General José Antonio Anzoátegui International Airport" },
  { id: 806, code: "BLB", name: "Panamá Pacífico International Airport (former Howard AFB)" },
  { id: 807, code: "BLC", name: "Bali Airport" },
  { id: 808, code: "BLD", name: "Boulder City Municipal Airport (FAA: 61B)" },
  { id: 809, code: "BLE", name: "Dala Airport (Borlänge Airport)" },
  { id: 810, code: "BLF", name: "Mercer County Airport" },
  { id: 811, code: "BLG", name: "Belaga Airport" },
  { id: 812, code: "BLH", name: "Blythe Airport" },
  { id: 813, code: "BLI", name: "Bellingham International Airport" },
  { id: 814, code: "BLJ", name: "Mostépha Ben Boulaid Airport" },
  { id: 815, code: "BLK", name: "Blackpool Airport" },
  { id: 816, code: "BLL", name: "Billund Airport" },
  { id: 817, code: "BLM", name: "Monmouth Executive Airport" },
  { id: 818, code: "BLN", name: "Benalla Airport" },
  { id: 819, code: "BLO", name: "Blönduós Airport" },
  { id: 820, code: "BLP", name: "Huallaga Airport" },
  { id: 821, code: "BLQ", name: "Bologna Guglielmo Marconi Airport" },
  { id: 822, code: "BLR", name: "Kempegowda International Airport" },
  { id: 823, code: "BLS", name: "Bollon Airport" },
  { id: 824, code: "BLT", name: "Blackwater Airport" },
  { id: 825, code: "BLU", name: "Blue Canyon–Nyack Airport" },
  { id: 826, code: "BLV", name: "MidAmerica St. Louis Airport / Scott Air Force Base" },
  { id: 827, code: "BLX", name: "Belluno Airport" },
  { id: 828, code: "BLY", name: "Belmullet Aerodrome" },
  { id: 829, code: "BLZ", name: "Chileka International Airport" },
  { id: 830, code: "BMA", name: "Stockholm Bromma Airport" },
  { id: 831, code: "BMB", name: "Bumba Airport" },
  { id: 832, code: "BMC", name: "Brigham City Airport" },
  { id: 833, code: "BMD", name: "Belo sur Tsiribihina Airport" },
  { id: 834, code: "BME", name: "Broome International Airport" },
  { id: 835, code: "BMF", name: "Bakouma Airport" },
  { id: 836, code: "BMG", name: "Monroe County Airport" },
  { id: 837, code: "BMH", name: "Bomai Airport" },
  { id: 838, code: "BMI", name: "Central Illinois Regional Airport" },
  { id: 839, code: "BMJ", name: "Baramita Airport" },
  { id: 840, code: "BMK", name: "Borkum Airfield" },
  { id: 841, code: "BML", name: "Berlin Regional Airport" },
  { id: 842, code: "BMM", name: "Bitam Airport" },
  { id: 843, code: "BMN", name: "Bamarni Airport" },
  { id: 844, code: "BMO", name: "Bhamo Airport" },
  { id: 845, code: "BMP", name: "Brampton Island Airport" },
  { id: 846, code: "BMQ", name: "Bamburi Airport" },
  { id: 847, code: "BMR", name: "Baltrum Airport" },
  { id: 848, code: "BMS", name: "Socrates Mariani Bittencourt Airport" },
  { id: 849, code: "BMT", name: "Beaumont Municipal Airport" },
  { id: 850, code: "BMU", name: "Sultan Muhammad Salahudin Airport (Bima Airport)" },
  { id: 851, code: "BMV", name: "Buon Ma Thuot Airport" },
  { id: 852, code: "BMW", name: "Bordj Mokhtar Airport" },
  { id: 853, code: "BMX", name: "Big Mountain Air Force Station (FAA: 37AK)" },
  { id: 854, code: "BMY", name: "Île Art – Waala Airport" },
  { id: 855, code: "BMZ", name: "Bamu Airport" },
  { id: 856, code: "BNA", name: "Nashville International Airport" },
  { id: 857, code: "BNB", name: "Boende Airport" },
  { id: 858, code: "BNC", name: "Beni Airport" },
  { id: 859, code: "BND", name: "Bandar Abbas International Airport" },
  { id: 860, code: "BNE", name: "Brisbane Airport" },
  { id: 861, code: "BNF", name: "Warm Springs Bay Seaplane Base" },
  { id: 862, code: "BNG", name: "Banning Municipal Airport" },
  { id: 863, code: "BNI", name: "Benin Airport" },
  { id: 864, code: "BNK", name: "Ballina Byron Gateway Airport" },
  { id: 865, code: "BNL", name: "Barnwell Regional Airport" },
  { id: 866, code: "BNM", name: "Bodinumu Airport" },
  { id: 867, code: "BNN", name: "Brønnøysund Airport, Brønnøy" },
  { id: 868, code: "BNO", name: "Burns Municipal Airport" },
  { id: 869, code: "BNP", name: "Bannu Airport" },
  { id: 870, code: "BNQ", name: "Baganga Airport" },
  { id: 871, code: "BNR", name: "Banfora Airport" },
  { id: 872, code: "BNS", name: "Barinas Airport" },
  { id: 873, code: "BNT", name: "Bundi Airport" },
  { id: 874, code: "BNU", name: "Blumenau Airport" },
  { id: 875, code: "BNV", name: "Boana Airport" },
  { id: 876, code: "BNW", name: "Boone Municipal Airport" },
  { id: 877, code: "BNX", name: "Banja Luka International Airport" },
  { id: 878, code: "BNY", name: "Bellona/Anua Airport" },
  { id: 879, code: "BNZ", name: "Banz Airport" },
  { id: 880, code: "BOA", name: "Boma Airport" },
  { id: 881, code: "BOB", name: "Bora Bora Airport (Motu Mute Airport)" },
  { id: 882, code: "BOC", name: "Bocas del Toro Isla Colón International Airport" },
  { id: 883, code: "BOD", name: "Bordeaux–Mérignac Airport" },
  { id: 884, code: "BOE", name: "Boundji Airport" },
  { id: 885, code: "BOG", name: "El Dorado International Airport" },
  { id: 886, code: "BOH", name: "Bournemouth Airport" },
  { id: 887, code: "BOI", name: "Boise Air Terminal (Gowen Field)" },
  { id: 888, code: "BOJ", name: "Burgas Airport" },
  { id: 889, code: "BOK", name: "Brookings Airport" },
  { id: 890, code: "BOL", name: "Ballykelly Airfield (RAF Ballykelly)" },
  { id: 891, code: "BOM", name: "Chhatrapati Shivaji International Airport" },
  { id: 892, code: "BON", name: "Flamingo International Airport" },
  { id: 893, code: "BOO", name: "Bodø Airport" },
  { id: 894, code: "BOP", name: "Bouar Airport" },
  { id: 895, code: "BOQ", name: "Boku Airport" },
  { id: 896, code: "BOR", name: "Bokeo International Airport" },
  { id: 897, code: "BOS", name: "Logan International Airport" },
  { id: 898, code: "BOT", name: "Bosset Airport" },
  { id: 899, code: "BOU", name: "Bourges Airport" },
  { id: 900, code: "BOV", name: "Boang Island Airport" },
  { id: 901, code: "BOW", name: "Bartow Municipal Airport" },
  { id: 902, code: "BOX", name: "Borroloola Airport" },
  { id: 903, code: "BOY", name: "Bobo Dioulasso Airport" },
  { id: 904, code: "BOZ", name: "Bozoum Airport" },
  { id: 905, code: "BPB", name: "Boridi Airport" },
  { id: 906, code: "BPC", name: "Bamenda Airport" },
  { id: 907, code: "BPD", name: "Bapi Airport" },
  { id: 908, code: "BPE", name: "Qinhuangdao Beidaihe Airport" },
  { id: 909, code: "BPF", name: "Batuna Airport" },
  { id: 910, code: "BPG", name: "Barra do Garças Airport" },
  { id: 911, code: "BPH", name: "Bislig Airport" },
  { id: 912, code: "BPI", name: "Miley Memorial Field" },
  { id: 913, code: "BPK", name: "Biangabip Airport" },
  { id: 914, code: "BPL", name: "Bole Alashankou Airport" },
  { id: 915, code: "BPM", name: "Begumpet Airport" },
  { id: 916, code: "BPN", name: "Sultan Aji Muhammad Sulaiman Airport" },
  { id: 917, code: "BPS", name: "Porto Seguro Airport" },
  { id: 918, code: "BPT", name: "Jack Brooks Regional Airport" },
  { id: 919, code: "BPX", name: "Qamdo Bamda Airport" },
  { id: 920, code: "BPY", name: "Besalampy Airport" },
  { id: 921, code: "BQA", name: "Dr. Juan C. Angara Airport" },
  { id: 922, code: "BQB", name: "Busselton Margaret River Airport" },
  { id: 923, code: "BQE", name: "Bubaque Airport" },
  { id: 924, code: "BQG", name: "Bogorodskoye Airport[1]" },
  { id: 925, code: "BQH", name: "London Biggin Hill Airport" },
  { id: 926, code: "BQI", name: "Bagani Airport[1]" },
  { id: 927, code: "BQJ", name: "Batagay Airport" },
  { id: 928, code: "BQK", name: "Brunswick Golden Isles Airport" },
  { id: 929, code: "BQL", name: "Boulia Airport" },
  { id: 930, code: "BQN", name: "Rafael Hernández Airport" },
  { id: 931, code: "BQO", name: "Tehini Airport" },
  { id: 932, code: "BQQ", name: "Barra Airport" },
  { id: 933, code: "BQS", name: "Ignatyevo Airport" },
  { id: 934, code: "BQT", name: "Brest Airport" },
  { id: 935, code: "BQU", name: "J. F. Mitchell Airport" },
  { id: 936, code: "BQV", name: "Bartlett Cove Seaplane Base" },
  { id: 937, code: "BQW", name: "Balgo Hill Airport" },
  { id: 938, code: "BRA", name: "Barreiras Airport" },
  { id: 939, code: "BRB", name: "Barreirinhas Airport" },
  { id: 940, code: "BRC", name: "San Carlos de Bariloche Airport" },
  { id: 941, code: "BRD", name: "Brainerd Lakes Regional Airport" },
  { id: 942, code: "BRE", name: "Bremen Airport" },
  { id: 943, code: "BRH", name: "Brahman Airport" },
  { id: 944, code: "BRI", name: "Bari Karol Wojtyła Airport" },
  { id: 945, code: "BRJ", name: "Bright Airport" },
  { id: 946, code: "BRK", name: "Bourke Airport" },
  { id: 947, code: "BRL", name: "Southeast Iowa Regional Airport" },
  { id: 948, code: "BRM", name: "Jacinto Lara International Airport" },
  { id: 949, code: "BRN", name: "Bern Airport" },
  { id: 950, code: "BRO", name: "Brownsville/South Padre Island International Airport" },
  { id: 951, code: "BRP", name: "Biaru Airport" },
  { id: 952, code: "BRQ", name: "Brno-Tuřany Airport" },
  { id: 953, code: "BRR", name: "Barra Airport" },
  { id: 954, code: "BRS", name: "Bristol Airport" },
  { id: 955, code: "BRT", name: "Bathurst Island Airport" },
  { id: 956, code: "BRU", name: "Brussels Airport (Zaventem Airport)" },
  { id: 957, code: "BRV", name: "Bremerhaven Airport" },
  { id: 958, code: "BRW", name: "Wiley Post–Will Rogers Memorial Airport" },
  { id: 959, code: "BRX", name: "María Montez International Airport" },
  { id: 960, code: "BRY", name: "Samuels Field" },
  { id: 961, code: "BSA", name: "Bender Qassim International Airport" },
  { id: 962, code: "BSB", name: "Brasília International Airport (Presidente J. Kubitschek Int'l Airport)" },
  { id: 963, code: "BSC", name: "José Celestino Mutis Airport" },
  { id: 964, code: "BSD", name: "Baoshan Yunduan Airport" },
  { id: 965, code: "BSE", name: "Sematan Airport" },
  { id: 966, code: "BSF", name: "Bradshaw Army Airfield" },
  { id: 967, code: "BSG", name: "Bata Airport" },
  { id: 968, code: "BSI", name: "Balesin Airport" },
  { id: 969, code: "BSJ", name: "Bairnsdale Airport" },
  { id: 970, code: "BSK", name: "Biskra Airport" },
  { id: 971, code: "BSL", name: "EuroAirport Basel-Mulhouse-Freiburg" },
  { id: 972, code: "BSM", name: "Bishe Kola Air Base" },
  { id: 973, code: "BSN", name: "Bossangoa Airport" },
  { id: 974, code: "BSO", name: "Basco Airport" },
  { id: 975, code: "BSP", name: "Bensbach Airport" },
  { id: 976, code: "BSQ", name: "Bisbee Municipal Airport (FAA: P04)" },
  { id: 977, code: "BSR", name: "Basra International Airport" },
  { id: 978, code: "BSS", name: "Balsas Airport" },
  { id: 979, code: "BST", name: "Bost Airport" },
  { id: 980, code: "BSU", name: "Basankusu Airport" },
  { id: 981, code: "BSV", name: "Besakoa Airport[1]" },
  { id: 982, code: "BSW", name: "Boswell Bay Airport (FAA: AK97)" },
  { id: 983, code: "BSX", name: "Pathein Airport" },
  { id: 984, code: "BSY", name: "Bardera Airport" },
  { id: 985, code: "BTA", name: "Bertoua Airport" },
  { id: 986, code: "BTB", name: "Bétou Airport" },
  { id: 987, code: "BTC", name: "Batticaloa International Airport" },
  { id: 988, code: "BTD", name: "Brunette Downs Airport" },
  { id: 989, code: "BTE", name: "Sherbro International Airport" },
  { id: 990, code: "BTF", name: "Skypark Airport" },
  { id: 991, code: "BTG", name: "Batangafo Airport" },
  { id: 992, code: "BTH", name: "Hang Nadim Airport" },
  { id: 993, code: "BTI", name: "Barter Island LRRS Airport" },
  { id: 994, code: "BTJ", name: "Sultan Iskandar Muda International Airport" },
  { id: 995, code: "BTK", name: "Bratsk Airport" },
  { id: 996, code: "BTL", name: "W. K. Kellogg Airport" },
  { id: 997, code: "BTM", name: "Bert Mooney Airport" },
  { id: 998, code: "BTN", name: "Marlboro County Jetport (FAA: BBP)" },
  { id: 999, code: "BTO", name: "Botopasi Airstrip" },
  { id: 1000, code: "BTP", name: "Butler County Airport (K.W. Scholter Field)" },
  { id: 1001, code: "BTQ", name: "Butare Airport" },
  { id: 1002, code: "BTR", name: "Baton Rouge Metropolitan Airport (Ryan Field)" },
  { id: 1003, code: "BTS", name: "M. R. Štefánik Airport" },
  { id: 1004, code: "BTT", name: "Bettles Airport" },
  { id: 1005, code: "BTU", name: "Bintulu Airport" },
  { id: 1006, code: "BTV", name: "Burlington International Airport" },
  { id: 1007, code: "BTW", name: "Batu Licin Airport" },
  { id: 1008, code: "BTX", name: "Betoota Airport" },
  { id: 1009, code: "BTY", name: "Beatty Airport" },
  { id: 1010, code: "BTZ", name: "Betong Airport" },
  { id: 1011, code: "BUA", name: "Buka Island Airport" },
  { id: 1012, code: "BUB", name: "Cram Field" },
  { id: 1013, code: "BUC", name: "Burketown Airport" },
  { id: 1014, code: "BUD", name: "Budapest Ferenc Liszt International Airport" },
  { id: 1015, code: "BUE[1]", name: "metropolitan area5" },
  { id: 1016, code: "BUF", name: "Buffalo Niagara International Airport" },
  { id: 1017, code: "BUG", name: "Benguela Airport (Gen. V. Deslandes Airport)" },
  { id: 1018, code: "BUH[1]", name: "Bucharest Baneasa6" },
  { id: 1019, code: "BUI", name: "Bokondini Airport" },
  { id: 1020, code: "BUJ", name: "Bou Saada Airport" },
  { id: 1021, code: "BUK", name: "Albuq Airport" },
  { id: 1022, code: "BUL", name: "Bulolo Airport" },
  { id: 1023, code: "BUM", name: "Butler Memorial Airport" },
  { id: 1024, code: "BUN", name: "Gerardo Tobar López Airport" },
  { id: 1025, code: "BUO", name: "Burao Airport" },
  { id: 1026, code: "BUP", name: "Bathinda Airport (Bhisiana Air Force Station)" },
  { id: 1027, code: "BUQ", name: "Joshua Mqabuko Nkomo International Airport" },
  { id: 1028, code: "BUR", name: "Bob Hope Airport" },
  { id: 1029, code: "BUS", name: "Batumi International Airport (Alexander Kartveli Batumi Int'l Airport)" },
  { id: 1030, code: "BUT", name: "Bathpalathang Airport" },
  { id: 1031, code: "BUU", name: "Muara Bungo Airport" },
  { id: 1032, code: "BUV", name: "Placeres Airport" },
  { id: 1033, code: "BUW", name: "Betoambari Airport" },
  { id: 1034, code: "BUX", name: "Bunia Airport" },
  { id: 1035, code: "BUY", name: "Bunbury Airport" },
  { id: 1036, code: "BUZ", name: "Bushehr Airport" },
  { id: 1037, code: "BVA", name: "Beauvais–Tillé Airport" },
  { id: 1038, code: "BVB", name: "Boa Vista International Airport" },
  { id: 1039, code: "BVC", name: "Aristides Pereira International Airport (Rabil Airport)" },
  { id: 1040, code: "BVE", name: "Brive–Souillac Airport" },
  { id: 1041, code: "BVF", name: "Dama Airport" },
  { id: 1042, code: "BVG", name: "Berlevåg Airport" },
  { id: 1043, code: "BVH", name: "Vilhena Airport (Brigadeiro Camarão Airport)" },
  { id: 1044, code: "BVI", name: "Birdsville Airport" },
  { id: 1045, code: "BVJ", name: "Bovanenkovo Airport" },
  { id: 1046, code: "BVK", name: "Huacaraje Airport" },
  { id: 1047, code: "BVL", name: "Baures Airport" },
  { id: 1048, code: "BVM", name: "Belmonte Airport" },
  { id: 1049, code: "BVO", name: "Bartlesville Municipal Airport" },
  { id: 1050, code: "BVP", name: "Bolovip Airport" },
  { id: 1051, code: "BVR", name: "Esperadinha Airport" },
  { id: 1052, code: "BVS", name: "Breves Airport" },
  { id: 1053, code: "BVU", name: "Beluga Airport (FAA: BLG)" },
  { id: 1054, code: "BVV", name: "Burevestnik Airport[1]" },
  { id: 1055, code: "BVW", name: "Batavia Downs Airport" },
  { id: 1056, code: "BVX", name: "Batesville Regional Airport" },
  { id: 1057, code: "BVY", name: "Beverly Municipal Airport" },
  { id: 1058, code: "BVZ", name: "Beverley Springs Airport" },
  { id: 1059, code: "BWA", name: "Gautam Buddha Airport" },
  { id: 1060, code: "BWB", name: "Barrow Island Airport" },
  { id: 1061, code: "BWC", name: "Brawley Municipal Airport" },
  { id: 1062, code: "BWD", name: "Brownwood Regional Airport" },
  { id: 1063, code: "BWE", name: "Braunschweig–Wolfsburg Airport" },
  { id: 1064, code: "BWF", name: "Barrow/Walney Island Airport" },
  { id: 1065, code: "BWG", name: "Bowling Green-Warren County Regional Airport" },
  { id: 1066, code: "BWH", name: "RMAF Butterworth" },
  { id: 1067, code: "BWI", name: "Baltimore/Washington International Thurgood Marshall Airport" },
  { id: 1068, code: "BWJ", name: "Bawan Airport" },
  { id: 1069, code: "BWK", name: "Bol Airport (Brač Airport)" },
  { id: 1070, code: "BWL", name: "Blackwell–Tonkawa Municipal Airport[1] (FAA: BKN)" },
  { id: 1071, code: "BWM", name: "Bowman Municipal Airport (FAA: BPP)" },
  { id: 1072, code: "BWN", name: "Brunei International Airport" },
  { id: 1073, code: "BWO", name: "Balakovo Airport" },
  { id: 1074, code: "BWP", name: "Bewani Airport" },
  { id: 1075, code: "BWQ", name: "Brewarrina Airport" },
  { id: 1076, code: "BWT", name: "Burnie Airport" },
  { id: 1077, code: "BWU", name: "Bankstown Airport" },
  { id: 1078, code: "BWW", name: "Las Brujas Airport[1]" },
  { id: 1079, code: "BWX", name: "Banyuwangi Airport" },
  { id: 1080, code: "BWY", name: "RAF Bentwaters" },
  { id: 1081, code: "BXA", name: "George R. Carr Memorial Air Field" },
  { id: 1082, code: "BXB", name: "Babo Airport" },
  { id: 1083, code: "BXD", name: "Bade Airport" },
  { id: 1084, code: "BXE", name: "Bakel Airport" },
  { id: 1085, code: "BXF", name: "Bellburn Airstrip[1]" },
  { id: 1086, code: "BXG", name: "Bendigo Airport" },
  { id: 1087, code: "BXH", name: "Balkhash Airport" },
  { id: 1088, code: "BXI", name: "Boundiali Airport" },
  { id: 1089, code: "BXJ", name: "Boraldai Airport" },
  { id: 1090, code: "BXK", name: "Buckeye Municipal Airport" },
  { id: 1091, code: "BXL", name: "Blue Lagoon Seaplane Base" },
  { id: 1092, code: "BXM", name: "Batom Airport" },
  { id: 1093, code: "BXN", name: "Bodrum-Imsik Airport" },
  { id: 1094, code: "BXO", name: "Buochs Airport" },
  { id: 1095, code: "BXP", name: "Biała Podlaska Airport" },
  { id: 1096, code: "BXR", name: "Bam Airport" },
  { id: 1097, code: "BXS", name: "Borrego Valley Airport (FAA: L08)" },
  { id: 1098, code: "BXT", name: "PT Badak Bontang Airport" },
  { id: 1099, code: "BXU", name: "Bancasi Airport" },
  { id: 1100, code: "BXV", name: "Breiðdalsvík Airport" },
  { id: 1101, code: "BXW", name: "Bawean Airport" },
  { id: 1102, code: "BXX", name: "Borama Airport" },
  { id: 1103, code: "BXY", name: "Krayniy Airport" },
  { id: 1104, code: "BXZ", name: "Bunsil Airport" },
  { id: 1105, code: "BYA", name: "Boundary Airport" },
  { id: 1106, code: "BYB", name: "Dibba Airport" },
  { id: 1107, code: "BYC", name: "Yacuiba Airport" },
  { id: 1108, code: "BYD", name: "Al Bayda Airport" },
  { id: 1109, code: "BYF", name: "Albert – Picardie Airport[1]" },
  { id: 1110, code: "BYG", name: "Johnson County Airport" },
  { id: 1111, code: "BYH", name: "Arkansas International Airport" },
  { id: 1112, code: "BYI", name: "Burley Municipal Airport" },
  { id: 1113, code: "BYJ", name: "Beja Airport" },
  { id: 1114, code: "BYK", name: "Bouaké Airport" },
  { id: 1115, code: "BYL", name: "Bella Yella Airport" },
  { id: 1116, code: "BYM", name: "Carlos Manuel de Céspedes Airport" },
  { id: 1117, code: "BYN", name: "Bayankhongor Airport" },
  { id: 1118, code: "BYO", name: "Bonito Airport[1]" },
  { id: 1119, code: "BYP", name: "Barimunya Airport" },
  { id: 1120, code: "BYQ", name: "Bunyu Airport" },
  { id: 1121, code: "BYR", name: "Læsø Airport" },
  { id: 1122, code: "BYS", name: "Bicycle Lake Army Airfield (Fort Irwin)" },
  { id: 1123, code: "BYT", name: "Bantry Aerodrome" },
  { id: 1124, code: "BYU", name: "Bindlacher Berg Airport" },
  { id: 1125, code: "BYV", name: "Beira Lake Seaplane Base[1]" },
  { id: 1126, code: "BYW", name: "Blakely Island Airport (FAA: 38WA)" },
  { id: 1127, code: "BYX", name: "Baniyala Airport" },
  { id: 1128, code: "BZA", name: "San Pedro Airport" },
  { id: 1129, code: "BZB", name: "Bazaruto Island Airport" },
  { id: 1130, code: "BZC", name: "Umberto Modiano Airport" },
  { id: 1131, code: "BZD", name: "Balranald Airport" },
  { id: 1132, code: "BZE", name: "Philip S. W. Goldson International Airport" },
  { id: 1133, code: "BZF", name: "Benton Field[1]" },
  { id: 1134, code: "BZG", name: "Bydgoszcz Ignacy Jan Paderewski Airport" },
  { id: 1135, code: "BZH", name: "Bumi Hills Airstrip[1]" },
  { id: 1136, code: "BZI", name: "Balıkesir Airport (Merkez Airport)" },
  { id: 1137, code: "BZK", name: "Bryansk International Airport" },
  { id: 1138, code: "BZL", name: "Barisal Airport" },
  { id: 1139, code: "BZM", name: "Bemolanga Airport[1]" },
  { id: 1140, code: "BZN", name: "Bozeman Yellowstone International Airport (Gallatin Field)" },
  { id: 1141, code: "BZO", name: "Bolzano Airport" },
  { id: 1142, code: "BZP", name: "Bizant Airport" },
  { id: 1143, code: "BZR", name: "Béziers Cap d'Agde Airport" },
  { id: 1144, code: "BZT", name: "Eagle Air Park[1]" },
  { id: 1145, code: "BZU", name: "Buta Zega Airport" },
  { id: 1146, code: "BZV", name: "Maya-Maya Airport" },
  { id: 1147, code: "BZX", name: "Bazhong Enyang Airport" },
  { id: 1148, code: "BZY", name: "Bălți International Airport" },
  { id: 1149, code: "BZZ", name: "RAF Brize Norton" },
  { id: 1152, code: "CAA", name: "El Aguacate Airport" },
  { id: 1153, code: "CAB", name: "Cabinda Airport" },
  { id: 1154, code: "CAC", name: "Cascavel Airport (Adalberto Mendes da Silva Airport)" },
  { id: 1155, code: "CAD", name: "Wexford County Airport" },
  { id: 1156, code: "CAE", name: "Columbia Metropolitan Airport" },
  { id: 1157, code: "CAF", name: "Carauari Airport" },
  { id: 1158, code: "CAG", name: "Cagliari Elmas Airport" },
  { id: 1159, code: "CAH", name: "Cà Mau Airport" },
  { id: 1160, code: "CAI", name: "Cairo International Airport" },
  { id: 1161, code: "CAJ", name: "Canaima Airport" },
  { id: 1162, code: "CAK", name: "Akron-Canton Airport" },
  { id: 1163, code: "CAL", name: "Campbeltown Airport / RAF Machrihanish" },
  { id: 1164, code: "CAM", name: "Camiri Airport" },
  { id: 1165, code: "CAN", name: "Guangzhou Baiyun International Airport" },
  { id: 1166, code: "CAO", name: "Clayton Municipal Airpark" },
  { id: 1167, code: "CAP", name: "Hugo Chávez International Airport" },
  { id: 1168, code: "CAQ", name: "Juan H. White Airport" },
  { id: 1169, code: "CAR", name: "Caribou Municipal Airport" },
  { id: 1170, code: "CAS", name: "Anfa Airport" },
  { id: 1171, code: "CAT", name: "Cascais Municipal Aerodrome[1]" },
  { id: 1172, code: "CAU", name: "Caruaru Airport (Oscar Laranjeiras Airport)" },
  { id: 1173, code: "CAV", name: "Cazombo Airport" },
  { id: 1174, code: "CAW", name: "Bartolomeu Lysandro Airport" },
  { id: 1175, code: "CAX", name: "Carlisle Lake District Airport" },
  { id: 1176, code: "CAY", name: "Cayenne – Félix Eboué Airport" },
  { id: 1177, code: "CAZ", name: "Cobar Airport" },
  { id: 1179, code: "CBB", name: "Jorge Wilstermann International Airport" },
  { id: 1180, code: "CBC", name: "Cherrabun Airport" },
  { id: 1181, code: "CBD", name: "Car Nicobar Air Force Base" },
  { id: 1182, code: "CBE", name: "Greater Cumberland Regional Airport" },
  { id: 1183, code: "CBF", name: "Council Bluffs Municipal Airport" },
  { id: 1184, code: "CBG", name: "Cambridge Airport" },
  { id: 1185, code: "CBH", name: "Boudghene Ben Ali Lotfi Airport" },
  { id: 1186, code: "CBI", name: "Cape Barren Island Airport" },
  { id: 1187, code: "CBJ", name: "Cabo Rojo Airport" },
  { id: 1188, code: "CBK", name: "Colby Municipal Airport (Shalz Field)" },
  { id: 1189, code: "CBL", name: "Tomás de Heres Airport" },
  { id: 1190, code: "CBM", name: "Columbus Air Force Base" },
  { id: 1191, code: "CBN", name: "Penggung Airport (Cakrabuwana Airport)" },
  { id: 1192, code: "CBO", name: "Awang Airport" },
  { id: 1193, code: "CBP", name: "Coimbra Airport" },
  { id: 1194, code: "CBQ", name: "Margaret Ekpo International Airport" },
  { id: 1195, code: "CBR", name: "Canberra Airport" },
  { id: 1196, code: "CBS", name: "Oro Negro Airport" },
  { id: 1197, code: "CBT", name: "Catumbela Airport" },
  { id: 1198, code: "CBU", name: "Cottbus-Drewitz Airport" },
  { id: 1199, code: "CBV", name: "Cobán Airport" },
  { id: 1200, code: "CBW", name: "Campo Mourão Airport" },
  { id: 1201, code: "CBX", name: "Condobolin Airport" },
  { id: 1202, code: "CBY", name: "Canobie Airport" },
  { id: 1204, code: "CCA", name: "Chimore Airport" },
  { id: 1205, code: "CCB", name: "Cable Airport" },
  { id: 1206, code: "CCC", name: "Jardines del Rey Airport" },
  { id: 1207, code: "CCF", name: "Carcassonne Airport" },
  { id: 1208, code: "CCG", name: "Crane County Airport (FAA: E13)" },
  { id: 1209, code: "CCH", name: "Chile Chico Airfield" },
  { id: 1210, code: "CCI", name: "Concórdia Airport" },
  { id: 1211, code: "CCJ", name: "Calicut International Airport" },
  { id: 1212, code: "CCK", name: "Cocos (Keeling) Islands Airport" },
  { id: 1213, code: "CCL", name: "Chinchilla Airport" },
  { id: 1214, code: "CCM", name: "Diomício Freitas Airport" },
  { id: 1215, code: "CCN", name: "Chaghcharan Airport" },
  { id: 1216, code: "CCO", name: "Carimagua Airport" },
  { id: 1217, code: "CCP", name: "Carriel Sur International Airport" },
  { id: 1218, code: "CCR", name: "Buchanan Field Airport" },
  { id: 1219, code: "CCS", name: "Simón Bolívar International Airport" },
  { id: 1220, code: "CCT", name: "Colonia Catriel Airport" },
  { id: 1221, code: "CCU", name: "Netaji Subhas Chandra Bose International Airport" },
  { id: 1222, code: "CCV", name: "Craig Cove Airport" },
  { id: 1223, code: "CCW", name: "Cowell Airport" },
  { id: 1224, code: "CCX", name: "Cáceres Airport" },
  { id: 1225, code: "CCY", name: "Northeast Iowa Regional Airport" },
  { id: 1226, code: "CCZ", name: "Chub Cay International Airport" },
  { id: 1228, code: "CDA", name: "Cooinda Airport" },
  { id: 1229, code: "CDB", name: "Cold Bay Airport" },
  { id: 1230, code: "CDC", name: "Cedar City Regional Airport" },
  { id: 1231, code: "CDD", name: "Cauquira Airport" },
  { id: 1232, code: "CDE", name: "Chengde Puning Airport" },
  { id: 1233, code: "CDG", name: "Charles de Gaulle Airport (Roissy Airport)" },
  { id: 1234, code: "CDH", name: "Harrell Field" },
  { id: 1235, code: "CDI", name: "Cachoeiro de Itapemirim Airport (Raimundo de Andrade Airport)" },
  { id: 1236, code: "CDJ", name: "Conceição do Araguaia Airport" },
  { id: 1237, code: "CDK", name: "George T. Lewis Airport" },
  { id: 1238, code: "CDL", name: "Candle 2 Airport (FAA: AK75)" },
  { id: 1239, code: "CDN", name: "Woodward Field" },
  { id: 1240, code: "CDO", name: "Cradock Airport" },
  { id: 1241, code: "CDP", name: "Kadapa Airport" },
  { id: 1242, code: "CDQ", name: "Croydon Airport" },
  { id: 1243, code: "CDR", name: "Chadron Municipal Airport" },
  { id: 1244, code: "CDS", name: "Childress Municipal Airport" },
  { id: 1245, code: "CDT", name: "Castellón–Costa Azahar Airport" },
  { id: 1246, code: "CDU", name: "Camden Airport" },
  { id: 1247, code: "CDV", name: "Merle K. (Mudhole) Smith Airport" },
  { id: 1248, code: "CDW", name: "Essex County Airport" },
  { id: 1249, code: "CDY", name: "Cagayan de Sulu Airport" },
  { id: 1251, code: "CEA", name: "Cessna Aircraft Field" },
  { id: 1252, code: "CEB", name: "Mactan–Cebu International Airport" },
  { id: 1253, code: "CEC", name: "Del Norte County Airport (Jack McNamara Field)" },
  { id: 1254, code: "CED", name: "Ceduna Airport" },
  { id: 1255, code: "CEE", name: "Cherepovets Airport" },
  { id: 1256, code: "CEF", name: "Westover Metropolitan Airport / Westover Air Reserve Base" },
  { id: 1257, code: "CEG", name: "Hawarden Airport (Chester Airport)" },
  { id: 1258, code: "CEH", name: "Chelinda Airport" },
  { id: 1259, code: "CEI", name: "Chiang Rai International Airport (Mae Fah Luang Int'l)" },
  { id: 1260, code: "CEK", name: "Chelyabinsk Airport" },
  { id: 1261, code: "CEL", name: "Canela Airport" },
  { id: 1262, code: "CEM", name: "Central Airport" },
  { id: 1263, code: "CEN", name: "Ciudad Obregón International Airport" },
  { id: 1264, code: "CEO", name: "Waco Kungo Airport" },
  { id: 1265, code: "CEP", name: "Concepción Airport" },
  { id: 1266, code: "CEQ", name: "Cannes – Mandelieu Airport" },
  { id: 1267, code: "CER", name: "Cherbourg – Maupertus Airport" },
  { id: 1268, code: "CES", name: "Cessnock Airport" },
  { id: 1269, code: "CET", name: "Cholet Le Pontreau Airport" },
  { id: 1270, code: "CEU", name: "Oconee County Regional Airport" },
  { id: 1271, code: "CEV", name: "Mettel Field" },
  { id: 1272, code: "CEW", name: "Bob Sikes Airport" },
  { id: 1273, code: "CEX", name: "Chena Hot Springs Airport (FAA: AK13)" },
  { id: 1274, code: "CEY", name: "Murray-Calloway County Airport" },
  { id: 1275, code: "CEZ", name: "Cortez Municipal Airport" },
  { id: 1277, code: "CFB", name: "Cabo Frio International Airport" },
  { id: 1278, code: "CFC", name: "Caçador Airport" },
  { id: 1279, code: "CFD", name: "Coulter Field" },
  { id: 1280, code: "CFE", name: "Clermont-Ferrand Auvergne Airport" },
  { id: 1281, code: "CFF", name: "Cafunfo Airport" },
  { id: 1282, code: "CFG", name: "Jaime González Airport" },
  { id: 1283, code: "CFH", name: "Clifton Hills Airport" },
  { id: 1284, code: "CFI", name: "Camfield Airport" },
  { id: 1285, code: "CFK", name: "Chlef International Airport" },
  { id: 1286, code: "CFM", name: "Conklin (Leismer) Airport" },
  { id: 1287, code: "CFN", name: "Donegal Airport" },
  { id: 1288, code: "CFO", name: "Confresa Airport" },
  { id: 1289, code: "CFP", name: "Carpentaria Downs Airport" },
  { id: 1290, code: "CFQ", name: "Creston Aerodrome[1] (TC: CAJ3)" },
  { id: 1291, code: "CFR", name: "Caen – Carpiquet Airport" },
  { id: 1292, code: "CFS", name: "Coffs Harbour Airport" },
  { id: 1293, code: "CFT", name: "Greenlee County Airport" },
  { id: 1294, code: "CFU", name: "Corfu International Airport (Ioannis Kapodistrias Int'l Airport)" },
  { id: 1295, code: "CFV", name: "Coffeyville Municipal Airport" },
  { id: 1297, code: "CGA", name: "Craig Seaplane Base" },
  { id: 1298, code: "CGB", name: "Maréchal Rondon International Airport" },
  { id: 1299, code: "CGC", name: "Cape Gloucester Airport" },
  { id: 1300, code: "CGD", name: "Changde Taohuayuan Airport" },
  { id: 1301, code: "CGE", name: "Cambridge–Dorchester Airport" },
  { id: 1302, code: "CGF", name: "Cuyahoga County Airport" },
  { id: 1303, code: "CGG", name: "Casiguran Airport" },
  { id: 1304, code: "CGH", name: "São Paulo/Congonhas–Deputado Freitas Nobre Airport" },
  { id: 1305, code: "CGI", name: "Cape Girardeau Regional Airport" },
  { id: 1306, code: "CGJ", name: "Kasompe Airport" },
  { id: 1307, code: "CGK", name: "Soekarno–Hatta International Airport" },
  { id: 1308, code: "CGM", name: "Camiguin Airport" },
  { id: 1309, code: "CGN", name: "Cologne Bonn Airport" },
  { id: 1310, code: "CGO", name: "Zhengzhou Xinzheng International Airport" },
  { id: 1311, code: "CGP", name: "Shah Amanat International Airport" },
  { id: 1312, code: "CGQ", name: "Changchun Longjia International Airport" },
  { id: 1313, code: "CGR", name: "Campo Grande International Airport" },
  { id: 1314, code: "CGS", name: "College Park Airport" },
  { id: 1315, code: "CGT", name: "Chinguetti Airport" },
  { id: 1316, code: "CGV", name: "Caiguna Airport" },
  { id: 1317, code: "CGY", name: "Laguindingan Airport" },
  { id: 1318, code: "CGZ", name: "Casa Grande Municipal Airport" },
  { id: 1320, code: "CHA", name: "Chattanooga Metropolitan Airport (Lovell Field)" },
  { id: 1321, code: "CHB", name: "Chilas Airport" },
  { id: 1322, code: "CHC", name: "Christchurch International Airport" },
  { id: 1323, code: "CHF", name: "Jinhae Airport" },
  { id: 1324, code: "CHG", name: "Chaoyang Airport" },
  { id: 1325, code: "CHH", name: "Chachapoyas Airport" },
  { id: 1326, code: "CHI[1]", name: "metropolitan area2" },
  { id: 1327, code: "CHJ", name: "Chipinge Airport" },
  { id: 1328, code: "CHK", name: "Chickasha Municipal Airport" },
  { id: 1329, code: "CHL", name: "Challis Airport (FAA: LLJ)" },
  { id: 1330, code: "CHM", name: "Tnte. FAP Jaime Montreuil Morales Airport" },
  { id: 1331, code: "CHN", name: "Jeonju Airport" },
  { id: 1332, code: "CHO", name: "Charlottesville–Albemarle Airport" },
  { id: 1333, code: "CHP", name: "Circle Hot Springs Airport" },
  { id: 1334, code: "CHQ", name: "Chania International Airport Ioannis Daskalogiannis" },
  { id: 1335, code: "CHR", name: "Châteauroux-Centre Marcel Dassault Airport" },
  { id: 1336, code: "CHS", name: "Charleston International Airport / Charleston Air Force Base" },
  { id: 1337, code: "CHT", name: "Chatham Islands / Tuuta Airport" },
  { id: 1338, code: "CHU", name: "Chuathbaluk Airport (FAA: 9A3)" },
  { id: 1339, code: "CHV", name: "Chaves Airport" },
  { id: 1340, code: "CHX", name: "Changuinola Capitán Manuel Niño International Airport" },
  { id: 1341, code: "CHY", name: "Choiseul Bay Airport" },
  { id: 1342, code: "CHZ", name: "Chiloquin State Airport (FAA: 2S7)" },
  { id: 1344, code: "CIA", name: "Ciampino–G. B. Pastine International Airport" },
  { id: 1345, code: "CIC", name: "Chico Municipal Airport" },
  { id: 1346, code: "CID", name: "The Eastern Iowa Airport" },
  { id: 1347, code: "CIE", name: "Collie Airport" },
  { id: 1348, code: "CIF", name: "Chifeng Yulong Airport" },
  { id: 1349, code: "CIG", name: "Craig–Moffat Airport (FAA: CAG)" },
  { id: 1350, code: "CIH", name: "Changzhi Wangcun Airport" },
  { id: 1351, code: "CII", name: "Aydın Airport[1] (Çıldır Airport)" },
  { id: 1352, code: "CIJ", name: "Captain Aníbal Arab Airport" },
  { id: 1353, code: "CIK", name: "Chalkyitsik Airport" },
  { id: 1354, code: "CIL", name: "Council Airport (FAA: K29)" },
  { id: 1355, code: "CIM", name: "Cimitarra Airport" },
  { id: 1356, code: "CIN", name: "Arthur N. Neu Airport" },
  { id: 1357, code: "CIO", name: "Teniente Coronel Carmelo Peralta Airport" },
  { id: 1358, code: "CIP", name: "Chipata Airport" },
  { id: 1359, code: "CIQ", name: "Chiquimula Airport" },
  { id: 1360, code: "CIR", name: "Cairo Regional Airport" },
  { id: 1361, code: "CIS", name: "Canton Island Airport" },
  { id: 1362, code: "CIT", name: "Shymkent International Airport" },
  { id: 1363, code: "CIU", name: "Chippewa County International Airport" },
  { id: 1364, code: "CIW", name: "Canouan Airport" },
  { id: 1365, code: "CIX", name: "FAP Captain José Abelardo Quiñones González International Airport" },
  { id: 1366, code: "CIY", name: "Comiso Airport" },
  { id: 1367, code: "CIZ", name: "Coari Airport" },
  { id: 1369, code: "CJA", name: "Mayor General FAP Armando Revoredo Iglesias Airport" },
  { id: 1370, code: "CJB", name: "Coimbatore International Airport" },
  { id: 1371, code: "CJC", name: "El Loa Airport" },
  { id: 1372, code: "CJD", name: "Candilejas Airport" },
  { id: 1373, code: "CJF", name: "Coondewanna Airport" },
  { id: 1374, code: "CJH", name: "Chilko Lake (Tsylos Park Lodge) Aerodrome (TC: CAG3)" },
  { id: 1375, code: "CJJ", name: "Cheongju International Airport" },
  { id: 1376, code: "CJL", name: "Chitral Airport" },
  { id: 1377, code: "CJM", name: "Chumphon Airport" },
  { id: 1378, code: "CJN", name: "Cijulang Nusawiru Airport" },
  { id: 1379, code: "CJS", name: "Abraham González International Airport" },
  { id: 1380, code: "CJT", name: "Copalar Airport" },
  { id: 1381, code: "CJU", name: "Jeju International Airport" },
  { id: 1383, code: "CKA", name: "Kegelman Air Force Auxiliary Field" },
  { id: 1384, code: "CKB", name: "North Central West Virginia Airport" },
  { id: 1385, code: "CKC", name: "Cherkasy International Airport" },
  { id: 1386, code: "CKD", name: "Crooked Creek Airport (FAA: CJX)" },
  { id: 1387, code: "CKE", name: "Lampson Field[1] (FAA: 1O2)" },
  { id: 1388, code: "CKG", name: "Chongqing Jiangbei International Airport" },
  { id: 1389, code: "CKH", name: "Chokurdakh Airport" },
  { id: 1390, code: "CKI", name: "Croker Island Airport" },
  { id: 1391, code: "CKK", name: "Sharp County Regional Airport[1] (FAA: CVK)" },
  { id: 1392, code: "CKL", name: "Chkalovsky Airport" },
  { id: 1393, code: "CKM", name: "Fletcher Field" },
  { id: 1394, code: "CKN", name: "Crookston Municipal Airport (Kirkwood Field)" },
  { id: 1395, code: "CKO", name: "Cornélio Procópio Airport" },
  { id: 1396, code: "CKR", name: "Crane Island Airstrip[1]" },
  { id: 1397, code: "CKS", name: "Carajás Airport" },
  { id: 1398, code: "CKT", name: "Sarakhs Airport" },
  { id: 1399, code: "CKU", name: "Cordova Municipal Airport" },
  { id: 1400, code: "CKV", name: "Clarksville–Montgomery County Regional Airport (Outlaw Field)" },
  { id: 1401, code: "CKW", name: "Graeme Rowley Aerodrome" },
  { id: 1402, code: "CKX", name: "Chicken Airport" },
  { id: 1403, code: "CKY", name: "Conakry International Airport (Gbessia Int'l Airport)" },
  { id: 1404, code: "CKZ", name: "Çanakkale Airport" },
  { id: 1406, code: "CLA", name: "Comilla Airport" },
  { id: 1407, code: "CLD", name: "McClellan–Palomar Airport (FAA: CRQ)" },
  { id: 1408, code: "CLE", name: "Cleveland Hopkins International Airport" },
  { id: 1409, code: "CLG", name: "New Coalinga Municipal Airport (FAA: C80)" },
  { id: 1410, code: "CLH", name: "Coolah Airport" },
  { id: 1411, code: "CLI", name: "Clintonville Municipal Airport" },
  { id: 1412, code: "CLJ", name: "Cluj-Napoca International Airport" },
  { id: 1413, code: "CLK", name: "Clinton Regional Airport" },
  { id: 1414, code: "CLL", name: "Easterwood Airport (Easterwood Field)" },
  { id: 1415, code: "CLM", name: "William R. Fairchild International Airport" },
  { id: 1416, code: "CLN", name: "Carolina Airport" },
  { id: 1417, code: "CLO", name: "Alfonso Bonilla Aragón International Airport" },
  { id: 1418, code: "CLP", name: "Clarks Point Airport" },
  { id: 1419, code: "CLQ", name: "Licenciado Miguel de la Madrid Airport" },
  { id: 1420, code: "CLR", name: "Cliff Hatfield Memorial Airport[1]" },
  { id: 1421, code: "CLS", name: "Chehalis-Centralia Airport" },
  { id: 1422, code: "CLT", name: "Charlotte Douglas International Airport" },
  { id: 1423, code: "CLU", name: "Columbus Municipal Airport (FAA: BAK)" },
  { id: 1424, code: "CLV", name: "Caldas Novas Airport" },
  { id: 1425, code: "CLW", name: "Clearwater Air Park" },
  { id: 1426, code: "CLX", name: "Clorinda Airport" },
  { id: 1427, code: "CLY", name: "Calvi – Sainte-Catherine Airport" },
  { id: 1428, code: "CLZ", name: "Calabozo Airport" },
  { id: 1430, code: "CMA", name: "Cunnamulla Airport" },
  { id: 1431, code: "CMB", name: "Bandaranaike International Airport" },
  { id: 1432, code: "CMC", name: "Camocim Airport" },
  { id: 1433, code: "CMD", name: "Cootamundra Airport" },
  { id: 1434, code: "CME", name: "Ciudad del Carmen International Airport" },
  { id: 1435, code: "CMF", name: "Chambéry-Savoie Airport" },
  { id: 1436, code: "CMG", name: "Corumbá International Airport" },
  { id: 1437, code: "CMH", name: "John Glenn Columbus International Airport" },
  { id: 1438, code: "CMI", name: "University of Illinois Willard Airport" },
  { id: 1439, code: "CMJ", name: "Qimei Airport" },
  { id: 1440, code: "CMK", name: "Club Makokola Airport" },
  { id: 1441, code: "CML", name: "Camooweal Airport" },
  { id: 1442, code: "CMM", name: "Carmelita Airport" },
  { id: 1443, code: "CMN", name: "Mohammed V International Airport" },
  { id: 1444, code: "CMO", name: "Obbia Airport" },
  { id: 1445, code: "CMP", name: "Santana do Araguaia Airport" },
  { id: 1446, code: "CMQ", name: "Clermont Airport" },
  { id: 1447, code: "CMR", name: "Colmar – Houssen Airport" },
  { id: 1448, code: "CMS", name: "Iskushuban Airport" },
  { id: 1449, code: "CMT", name: "Cameta Airport" },
  { id: 1450, code: "CMU", name: "Chimbu Airport" },
  { id: 1451, code: "CMV", name: "Coromandel Aerodrome" },
  { id: 1452, code: "CMW", name: "Ignacio Agramonte International Airport" },
  { id: 1453, code: "CMX", name: "Houghton County Memorial Airport" },
  { id: 1454, code: "CMY", name: "Sparta/Fort McCoy Airport" },
  { id: 1455, code: "CMZ", name: "Caia Airport[1]" },
  { id: 1457, code: "CNA", name: "Cananea National Airport" },
  { id: 1458, code: "CNB", name: "Coonamble Airport" },
  { id: 1459, code: "CNC", name: "Coconut Island Airport" },
  { id: 1460, code: "CND", name: "Mihail Kogălniceanu International Airport" },
  { id: 1461, code: "CNE", name: "Fremont County Airport (FAA: 1V6)" },
  { id: 1462, code: "CNF", name: "Tancredo Neves International Airport (Confins Int'l Airport)" },
  { id: 1463, code: "CNG", name: "Cognac – Châteaubernard Air Base" },
  { id: 1464, code: "CNH", name: "Claremont Municipal Airport" },
  { id: 1465, code: "CNI", name: "Changhai Airport" },
  { id: 1466, code: "CNJ", name: "Cloncurry Airport" },
  { id: 1467, code: "CNK", name: "Blosser Municipal Airport" },
  { id: 1468, code: "CNL", name: "Sindal Airport" },
  { id: 1469, code: "CNM", name: "Cavern City Air Terminal" },
  { id: 1470, code: "CNN", name: "Kannur International Airport" },
  { id: 1471, code: "CNO", name: "Chino Airport" },
  { id: 1472, code: "CNP", name: "Nerlerit Inaat Airport (Constable Pynt Airport)" },
  { id: 1473, code: "CNQ", name: "Doctor Fernando Piragine Niveyro International Airport" },
  { id: 1474, code: "CNR", name: "Chañaral Airport" },
  { id: 1475, code: "CNS", name: "Cairns Airport" },
  { id: 1476, code: "CNT", name: "Charata Airport" },
  { id: 1477, code: "CNU", name: "Chanute Martin Johnson Airport" },
  { id: 1478, code: "CNV", name: "Canavieiras Airport" },
  { id: 1479, code: "CNW", name: "TSTC Waco Airport" },
  { id: 1480, code: "CNX", name: "Chiang Mai International Airport" },
  { id: 1481, code: "CNY", name: "Canyonlands Field" },
  { id: 1482, code: "CNZ", name: "Cangamba Airport" },
  { id: 1484, code: "COA", name: "Columbia Airport (FAA: O22)" },
  { id: 1485, code: "COB", name: "Coolibah Airport" },
  { id: 1486, code: "COC", name: "Comodoro Pierrestegui Airport" },
  { id: 1487, code: "COD", name: "Yellowstone Regional Airport" },
  { id: 1488, code: "COE", name: "Coeur d'Alene Airport" },
  { id: 1489, code: "COF", name: "Patrick Space Force Base" },
  { id: 1490, code: "COG", name: "Mandinga Airport" },
  { id: 1491, code: "COH", name: "Cooch Behar Airport" },
  { id: 1492, code: "COI", name: "Merritt Island Airport" },
  { id: 1493, code: "COJ", name: "Coonabarabran Airport" },
  { id: 1494, code: "COK", name: "Cochin International Airport (Nedumbassery Airport)" },
  { id: 1495, code: "COL", name: "Coll Airport" },
  { id: 1496, code: "COM", name: "Coleman Municipal Airport" },
  { id: 1497, code: "CON", name: "Concord Municipal Airport" },
  { id: 1498, code: "COO", name: "Cadjehoun Airport" },
  { id: 1499, code: "COP", name: "Cooperstown-Westville Airport (FAA: K23)" },
  { id: 1500, code: "COQ", name: "Choibalsan Airport" },
  { id: 1501, code: "COR", name: "Ingeniero Aeronáutico Ambrosio L.V. Taravella International Airport (Pajas Blancas)" },
  { id: 1502, code: "COS", name: "Colorado Springs Airport" },
  { id: 1503, code: "COT", name: "Cotulla–La Salle County Airport" },
  { id: 1504, code: "COU", name: "Columbia Regional Airport" },
  { id: 1505, code: "COW", name: "Coquimbo Airport" },
  { id: 1506, code: "COY", name: "Coolawanyah Station Airport" },
  { id: 1507, code: "COZ", name: "Constanza Airport" },
  { id: 1509, code: "CPA", name: "Cape Palmas Airport" },
  { id: 1510, code: "CPB", name: "Capurganá Airport" },
  { id: 1511, code: "CPC", name: "Aviador Carlos Campos Airport" },
  { id: 1512, code: "CPD", name: "Coober Pedy Airport" },
  { id: 1513, code: "CPE", name: "Ing. Alberto Acuña Ongay International Airport" },
  { id: 1514, code: "CPF", name: "Ngloram Airport" },
  { id: 1515, code: "CPG", name: "Carmen de Patagones Airport" },
  { id: 1516, code: "CPH", name: "Copenhagen Airport, Kastrup" },
  { id: 1517, code: "CPI", name: "Cape Orford Airport[1]" },
  { id: 1518, code: "CPL", name: "General Navas Pardo Airport" },
  { id: 1519, code: "CPM", name: "Compton/Woodley Airport" },
  { id: 1520, code: "CPN", name: "Cape Rodney Airport" },
  { id: 1521, code: "CPO", name: "Desierto de Atacama Airport" },
  { id: 1522, code: "CPP", name: "Coposa Airport" },
  { id: 1523, code: "CPR", name: "Casper–Natrona County International Airport" },
  { id: 1524, code: "CPS", name: "St. Louis Downtown Airport" },
  { id: 1525, code: "CPT", name: "Cape Town International Airport" },
  { id: 1526, code: "CPU", name: "Cururupu Airport" },
  { id: 1527, code: "CPV", name: "Campina Grande Airport (Presidente João Suassuna Airport)" },
  { id: 1528, code: "CPX", name: "Benjamín Rivera Noriega Airport" },
  { id: 1530, code: "CQA", name: "Canarana Airport" },
  { id: 1531, code: "CQD", name: "Shahrekord Airport" },
  { id: 1532, code: "CQF", name: "Calais–Dunkerque Airport" },
  { id: 1533, code: "CQM", name: "Ciudad Real Central Airport" },
  { id: 1534, code: "CQP", name: "Cape Flattery Airport" },
  { id: 1535, code: "CQS", name: "Costa Marques Airport" },
  { id: 1536, code: "CQT", name: "Caquetania Airport" },
  { id: 1537, code: "CQW", name: "Wulong Xiannüshan Airport" },
  { id: 1539, code: "CRA", name: "Craiova International Airport" },
  { id: 1540, code: "CRB", name: "Collarenebri Airport" },
  { id: 1541, code: "CRC", name: "Santa Ana Airport" },
  { id: 1542, code: "CRD", name: "General Enrique Mosconi International Airport" },
  { id: 1543, code: "CRE", name: "Grand Strand Airport" },
  { id: 1544, code: "CRF", name: "Carnot Airport" },
  { id: 1545, code: "CRG", name: "Jacksonville Executive at Craig Airport" },
  { id: 1546, code: "CRH", name: "Cherrabah Airport" },
  { id: 1547, code: "CRI", name: "Colonel Hill Airport (Crooked Island Airport)" },
  { id: 1548, code: "CRJ", name: "Coorabie Airport" },
  { id: 1549, code: "CRK", name: "Clark International Airport" },
  { id: 1550, code: "CRL", name: "Brussels South Charleroi Airport" },
  { id: 1551, code: "CRM", name: "Catarman National Airport" },
  { id: 1552, code: "CRO", name: "Corcoran Airport" },
  { id: 1553, code: "CRP", name: "Corpus Christi International Airport" },
  { id: 1554, code: "CRQ", name: "Caravelas Airport" },
  { id: 1555, code: "CRR", name: "Ceres Airport" },
  { id: 1556, code: "CRS", name: "C. David Campbell Field (Corsicana Municipal Airport)" },
  { id: 1557, code: "CRT", name: "Z. M. Jack Stell Field" },
  { id: 1558, code: "CRU", name: "Lauriston Airport (Carriacou Island Airport)" },
  { id: 1559, code: "CRV", name: "Crotone Airport (Sant'Anna Airport)" },
  { id: 1560, code: "CRW", name: "Yeager Airport" },
  { id: 1561, code: "CRX", name: "Roscoe Turner Airport" },
  { id: 1562, code: "CRY", name: "Carlton Hill Airport" },
  { id: 1563, code: "CRZ", name: "Turkmenabat Airport" },
  { id: 1565, code: "CSA", name: "Colonsay Airport" },
  { id: 1566, code: "CSB", name: "Caransebeș Airport" },
  { id: 1567, code: "CSC", name: "Cañas Mojica Airport" },
  { id: 1568, code: "CSD", name: "Cresswell Downs Airport" },
  { id: 1569, code: "CSE", name: "Buckhorn Ranch Airport (FAA: 0CO2)" },
  { id: 1570, code: "CSF", name: "Creil Air Base" },
  { id: 1571, code: "CSG", name: "Columbus Airport" },
  { id: 1572, code: "CSH", name: "Solovki Airport" },
  { id: 1573, code: "CSI", name: "Casino Airport" },
  { id: 1574, code: "CSK", name: "Cap Skirring Airport" },
  { id: 1575, code: "CSM", name: "Clinton-Sherman Airport" },
  { id: 1576, code: "CSN", name: "Carson Airport (FAA: CXP)" },
  { id: 1577, code: "CSO", name: "Magdeburg–Cochstedt Airport" },
  { id: 1578, code: "CSQ", name: "Creston Municipal Airport" },
  { id: 1579, code: "CSR", name: "Casuarito Airport" },
  { id: 1580, code: "CSS", name: "Cassilândia Airport" },
  { id: 1581, code: "CST", name: "Castaway Island Seaplane Base" },
  { id: 1582, code: "CSU", name: "Santa Cruz do Sul Airport[1]" },
  { id: 1583, code: "CSV", name: "Crossville Memorial-Whitson Field" },
  { id: 1584, code: "CSX", name: "Changsha Huanghua International Airport" },
  { id: 1585, code: "CSY", name: "Cheboksary Airport" },
  { id: 1586, code: "CSZ", name: "Brigadier Hector Eduardo Ruiz Airport" },
  { id: 1588, code: "CTA", name: "Catania–Fontanarossa Airport" },
  { id: 1589, code: "CTB", name: "Cut Bank Municipal Airport" },
  { id: 1590, code: "CTC", name: "Coronel Felipe Varela International Airport" },
  { id: 1591, code: "CTD", name: "Chitré Alonso Valderrama Airport" },
  { id: 1592, code: "CTE", name: "Cartí Airport" },
  { id: 1593, code: "CTF", name: "Coatepeque Airport" },
  { id: 1594, code: "CTG", name: "Rafael Núñez International Airport" },
  { id: 1595, code: "CTH", name: "Chester County G. O. Carlson Airport (FAA: MQS)" },
  { id: 1596, code: "CTI", name: "Cuito Cuanavale Airport" },
  { id: 1597, code: "CTK", name: "Canton Municipal Airport (FAA: 7G9)" },
  { id: 1598, code: "CTL", name: "Charleville Airport" },
  { id: 1599, code: "CTM", name: "Chetumal International Airport" },
  { id: 1600, code: "CTN", name: "Cooktown Airport" },
  { id: 1601, code: "CTO", name: "Calverton Executive Airpark (FAA: 3C8)" },
  { id: 1602, code: "CTP", name: "Carutapera Airport" },
  { id: 1603, code: "CTQ", name: "Do Palmar Airport" },
  { id: 1604, code: "CTR", name: "Cattle Creek Airport" },
  { id: 1605, code: "CTS", name: "New Chitose Airport" },
  { id: 1606, code: "CTT", name: "Le Castellet Airport" },
  { id: 1607, code: "CTU", name: "Chengdu Shuangliu International Airport" },
  { id: 1608, code: "CTW", name: "Cottonwood Airport (FAA: P52)" },
  { id: 1609, code: "CTX", name: "Cortland County Airport (Chase Field, FAA: N03)" },
  { id: 1610, code: "CTY", name: "Cross City Airport" },
  { id: 1611, code: "CTZ", name: "Clinton–Sampson County Airport" },
  { id: 1613, code: "CUA", name: "Ciudad Constitución Airport" },
  { id: 1614, code: "CUB", name: "Jim Hamilton–L.B. Owens Airport" },
  { id: 1615, code: "CUC", name: "Camilo Daza International Airport" },
  { id: 1616, code: "CUD", name: "Caloundra Airport" },
  { id: 1617, code: "CUE", name: "Mariscal Lamar International Airport" },
  { id: 1618, code: "CUF", name: "Cuneo International Airport" },
  { id: 1619, code: "CUG", name: "Cudal Airport" },
  { id: 1620, code: "CUH", name: "Cushing Municipal Airport" },
  { id: 1621, code: "CUI", name: "Curillo Airport" },
  { id: 1622, code: "CUJ", name: "Culion Airport" },
  { id: 1623, code: "CUK", name: "Caye Caulker Airport" },
  { id: 1624, code: "CUL", name: "Bachigualato Federal International Airport" },
  { id: 1625, code: "CUM", name: "Antonio José de Sucre Airport" },
  { id: 1626, code: "CUN", name: "Cancún International Airport" },
  { id: 1627, code: "CUO", name: "Caruru Airport" },
  { id: 1628, code: "CUP", name: "General José Francisco Bermúdez Airport" },
  { id: 1629, code: "CUQ", name: "Coen Airport" },
  { id: 1630, code: "CUR", name: "Curaçao International Airport (Hato Int'l Airport)" },
  { id: 1631, code: "CUS", name: "Columbus Municipal Airport (FAA: 0NM0)" },
  { id: 1632, code: "CUT", name: "Cutral Có Airport" },
  { id: 1633, code: "CUU", name: "General Roberto Fierro Villalobos International Airport" },
  { id: 1634, code: "CUV", name: "Casigua El Cubo Airport" },
  { id: 1635, code: "CUX", name: "Cuddihy Field (FAA: 07TE)" },
  { id: 1636, code: "CUY", name: "Cue Airport" },
  { id: 1637, code: "CUZ", name: "Alejandro Velasco Astete International Airport" },
  { id: 1639, code: "CVB", name: "Chungrebu Airport" },
  { id: 1640, code: "CVC", name: "Cleve Airport" },
  { id: 1641, code: "CVE", name: "Coveñas Airport" },
  { id: 1642, code: "CVF", name: "Courchevel Altiport" },
  { id: 1643, code: "CVG", name: "Cincinnati/Northern Kentucky International Airport" },
  { id: 1644, code: "CVH", name: "Caviahue Airport" },
  { id: 1645, code: "CVI", name: "Caleta Olivia Airport" },
  { id: 1646, code: "CVJ", name: "General Mariano Matamoros Airport" },
  { id: 1647, code: "CVL", name: "Cape Vogel Airport" },
  { id: 1648, code: "CVM", name: "General Pedro J. Méndez International Airport" },
  { id: 1649, code: "CVN", name: "Clovis Municipal Airport" },
  { id: 1650, code: "CVO", name: "Corvallis Municipal Airport" },
  { id: 1651, code: "CVQ", name: "Carnarvon Airport" },
  { id: 1652, code: "CVS", name: "Cannon Air Force Base" },
  { id: 1653, code: "CVT", name: "Coventry Airport" },
  { id: 1654, code: "CVU", name: "Corvo Airport" },
  { id: 1656, code: "CWA", name: "Central Wisconsin Airport" },
  { id: 1657, code: "CWB", name: "Afonso Pena International Airport" },
  { id: 1658, code: "CWC", name: "Chernivtsi International Airport" },
  { id: 1659, code: "CWF", name: "Chennault International Airport" },
  { id: 1660, code: "CWI", name: "Clinton Municipal Airport" },
  { id: 1661, code: "CWJ", name: "Cangyuan Washan Airport" },
  { id: 1662, code: "CWL", name: "Cardiff Airport" },
  { id: 1663, code: "CWR", name: "Cowarie Airport" },
  { id: 1664, code: "CWS", name: "Center Island Airport (FAA: 78WA)" },
  { id: 1665, code: "CWT", name: "Cowra Airport" },
  { id: 1666, code: "CWW", name: "Corowa Airport" },
  { id: 1667, code: "CWX", name: "Cochise County Airport[1] (FAA: P33)" },
  { id: 1669, code: "CXA", name: "Caicara del Orinoco Airport" },
  { id: 1670, code: "CXB", name: "Cox's Bazar Airport" },
  { id: 1671, code: "CXC", name: "Chitina Airport" },
  { id: 1672, code: "CXF", name: "Coldfoot Airport" },
  { id: 1673, code: "CXH", name: "Vancouver Harbour Flight Centre (Coal Harbour Seaplane Base)" },
  { id: 1674, code: "CXI", name: "Cassidy International Airport" },
  { id: 1675, code: "CXJ", name: "Caxias do Sul Airport (Hugo Cantergiani Regional Airport)" },
  { id: 1676, code: "CXL", name: "Calexico International Airport" },
  { id: 1677, code: "CXN", name: "Candala Airport" },
  { id: 1678, code: "CXO", name: "Lone Star Executive Airport" },
  { id: 1679, code: "CXP", name: "Tunggul Wulung Airport" },
  { id: 1680, code: "CXQ", name: "Christmas Creek Airport" },
  { id: 1681, code: "CXR", name: "Cam Ranh International Airport" },
  { id: 1682, code: "CXT", name: "Charters Towers Airport" },
  { id: 1683, code: "CXY", name: "Cat Cay Airport" },
  { id: 1685, code: "CYA", name: "Antoine-Simon Airport" },
  { id: 1686, code: "CYB", name: "Charles Kirkconnell International Airport" },
  { id: 1687, code: "CYC", name: "Caye Chapel Airport" },
  { id: 1688, code: "CYD", name: "San Ignacio Town Airstrip[1]" },
  { id: 1689, code: "CYF", name: "Chefornak Airport (FAA: CFK)" },
  { id: 1690, code: "CYG", name: "Corryong Airport" },
  { id: 1691, code: "CYI", name: "Chiayi Airport" },
  { id: 1692, code: "CYL", name: "Coyoles Airport" },
  { id: 1693, code: "CYM", name: "Chatham Seaplane Base" },
  { id: 1694, code: "CYO", name: "Vilo Acuña Airport" },
  { id: 1695, code: "CYP", name: "Calbayog Airport" },
  { id: 1696, code: "CYR", name: "Colonia Airport (Laguna de los Patos Intn'l Airport)" },
  { id: 1697, code: "CYS", name: "Cheyenne Regional Airport (Jerry Olson Field)" },
  { id: 1698, code: "CYT", name: "Yakataga Airport" },
  { id: 1699, code: "CYU", name: "Cuyo Airport" },
  { id: 1700, code: "CYW", name: "Captain Rogelio Castillo National Airport" },
  { id: 1701, code: "CYX", name: "Chersky Airport" },
  { id: 1702, code: "CYZ", name: "Cauayan Airport" },
  { id: 1704, code: "CZA", name: "Chichen Itza International Airport" },
  { id: 1705, code: "CZB", name: "Carlos Ruhl Airport" },
  { id: 1706, code: "CZC", name: "Copper Center 2 Airport (FAA: Z93)" },
  { id: 1707, code: "CZE", name: "José Leonardo Chirino Airport" },
  { id: 1708, code: "CZF", name: "Cape Romanzof LRRS Airport" },
  { id: 1709, code: "CZH", name: "Corozal Airport" },
  { id: 1710, code: "CZJ", name: "Corazón de Jesús Airport" },
  { id: 1711, code: "CZK", name: "Cascade Locks State Airport" },
  { id: 1712, code: "CZL", name: "Mohamed Boudiaf International Airport" },
  { id: 1713, code: "CZM", name: "Cozumel International Airport" },
  { id: 1714, code: "CZN", name: "Chisana Airport" },
  { id: 1715, code: "CZO", name: "Chistochina Airport" },
  { id: 1716, code: "CZP", name: "Cape Pole Seaplane Base (FAA: Z71)" },
  { id: 1717, code: "CZS", name: "Cruzeiro do Sul International Airport" },
  { id: 1718, code: "CZT", name: "Dimmit County Airport" },
  { id: 1719, code: "CZU", name: "Las Brujas Airport" },
  { id: 1720, code: "CZW", name: "Częstochowa-Rudniki Airport" },
  { id: 1721, code: "CZX", name: "Changzhou Benniu Airport" },
  { id: 1722, code: "CZY", name: "Cluny Airport" },
  { id: 1725, code: "DAA", name: "Davison Army Airfield" },
  { id: 1726, code: "DAB", name: "Daytona Beach International Airport" },
  { id: 1727, code: "DAC", name: "Shahjalal International Airport" },
  { id: 1728, code: "DAD", name: "Da Nang International Airport" },
  { id: 1729, code: "DAF", name: "Daup Airport" },
  { id: 1730, code: "DAG", name: "Barstow-Daggett Airport" },
  { id: 1731, code: "DAH", name: "Dathina Airport" },
  { id: 1732, code: "DAK", name: "Dakhla Oasis Airport" },
  { id: 1733, code: "DAL", name: "Dallas Love Field" },
  { id: 1734, code: "DAM", name: "Damascus International Airport" },
  { id: 1735, code: "DAN", name: "Danville Regional Airport" },
  { id: 1736, code: "DAO", name: "Dabo Airport[1]" },
  { id: 1737, code: "DAP", name: "Darchula Airport" },
  { id: 1738, code: "DAR", name: "Julius Nyerere International Airport" },
  { id: 1739, code: "DAS", name: "Great Bear Lake Airport[1] (TC: CFF4)" },
  { id: 1740, code: "DAT", name: "Datong Yungang Airport" },
  { id: 1741, code: "DAU", name: "Daru Airport" },
  { id: 1742, code: "DAV", name: "Enrique Malek International Airport" },
  { id: 1743, code: "DAX", name: "Dazhou Heshi Airport" },
  { id: 1744, code: "DAY", name: "Dayton International Airport" },
  { id: 1745, code: "DAZ", name: "Darwaz Airport" },
  { id: 1747, code: "DBA", name: "Dalbandin Airport" },
  { id: 1748, code: "DBB", name: "Al Alamain International Airport[1]" },
  { id: 1749, code: "DBC", name: "Baicheng Chang'an Airport[1]" },
  { id: 1750, code: "DBD", name: "Dhanbad Airport" },
  { id: 1751, code: "DBK", name: "Dutch Bay Seaplane Base[1]" },
  { id: 1752, code: "DBM", name: "Debre Marqos Airport" },
  { id: 1753, code: "DBN", name: "W. H. 'Bud' Barron Airport" },
  { id: 1754, code: "DBO", name: "Dubbo Regional Airport" },
  { id: 1755, code: "DBP", name: "Debepare Airport" },
  { id: 1756, code: "DBQ", name: "Dubuque Regional Airport" },
  { id: 1757, code: "DBR", name: "Darbhanga Airport" },
  { id: 1758, code: "DBS", name: "Dubois Municipal Airport (FAA: U41)" },
  { id: 1759, code: "DBT", name: "Debre Tabor Airport" },
  { id: 1760, code: "DBU", name: "Dambulu Oya Tank Seaplane Base[1]" },
  { id: 1761, code: "DBV", name: "Dubrovnik Airport" },
  { id: 1762, code: "DBY", name: "Dalby Airport" },
  { id: 1764, code: "DCA", name: "Ronald Reagan Washington National Airport" },
  { id: 1765, code: "DCF", name: "Canefield Airport" },
  { id: 1766, code: "DCG", name: "Dubai Creek Seaplane Base[1]" },
  { id: 1767, code: "DCI", name: "Decimomannu Air Base" },
  { id: 1768, code: "DCK", name: "Dahl Creek Airport" },
  { id: 1769, code: "DCM", name: "Castres–Mazamet Airport" },
  { id: 1770, code: "DCN", name: "RAAF Base Curtin[1]" },
  { id: 1771, code: "DCT", name: "Duncan Town Airport" },
  { id: 1772, code: "DCU", name: "Pryor Field Regional Airport" },
  { id: 1773, code: "DCY", name: "Daocheng Yading Airport" },
  { id: 1775, code: "DDC", name: "Dodge City Regional Airport" },
  { id: 1776, code: "DDD", name: "Dhaalu Airport" },
  { id: 1777, code: "DDG", name: "Dandong Langtou Airport" },
  { id: 1778, code: "DDM", name: "Dodoima Airport" },
  { id: 1779, code: "DDN", name: "Delta Downs Airport" },
  { id: 1780, code: "DDU", name: "Dadu Airport" },
  { id: 1782, code: "DEA", name: "Dera Ghazi Khan International Airport" },
  { id: 1783, code: "DEB", name: "Debrecen International Airport" },
  { id: 1784, code: "DEC", name: "Decatur Airport" },
  { id: 1785, code: "DED", name: "Jolly Grant Airport" },
  { id: 1786, code: "DEE", name: "Yuzhno-Kurilsk Mendeleyevo Airport[1]" },
  { id: 1787, code: "DEF", name: "Dezful Airport" },
  { id: 1788, code: "DEH", name: "Decorah Municipal Airport" },
  { id: 1789, code: "DEI", name: "Denis Island Airport" },
  { id: 1790, code: "DEL", name: "Indira Gandhi International Airport" },
  { id: 1791, code: "DEM", name: "Dembidolo Airport" },
  { id: 1792, code: "DEN", name: "Denver International Airport" },
  { id: 1793, code: "DEP", name: "Daporijo Airport" },
  { id: 1794, code: "DEQ", name: "Deqing Moganshan Airport" },
  { id: 1795, code: "DER", name: "Derim Airport" },
  { id: 1796, code: "DES", name: "Desroches Airport" },
  { id: 1797, code: "DET", name: "Coleman A. Young International Airport" },
  { id: 1798, code: "DEX", name: "Nop Goliat Dekai Airport[1]" },
  { id: 1799, code: "DEZ", name: "Deir ez-Zor Airport" },
  { id: 1801, code: "DFI", name: "Defiance Memorial Airport" },
  { id: 1802, code: "DFP", name: "Drumduff Airport" },
  { id: 1803, code: "DFW", name: "Dallas/Fort Worth International Airport" },
  { id: 1805, code: "DGA", name: "Dangriga Airport" },
  { id: 1806, code: "DGC", name: "Degeh Bur Airport" },
  { id: 1807, code: "DGD", name: "Dalgaranga Airport[1]" },
  { id: 1808, code: "DGE", name: "Mudgee Airport" },
  { id: 1809, code: "DGF", name: "Douglas Lake Airport[1]" },
  { id: 1810, code: "DGH", name: "Deoghar Airport[3]" },
  { id: 1811, code: "DGK", name: "Dugong Beach Lodge Airstrip[1]" },
  { id: 1812, code: "DGL", name: "Douglas Municipal Airport" },
  { id: 1813, code: "DGM", name: "Dandugama Seaplane Base[1]" },
  { id: 1814, code: "DGN", name: "Naval Surface Warfare Center Dahlgren Division (FAA: NDY)" },
  { id: 1815, code: "DGO", name: "General Guadalupe Victoria International Airport" },
  { id: 1816, code: "DGP", name: "Daugavpils International Airport" },
  { id: 1817, code: "DGR", name: "Dargaville Aerodrome" },
  { id: 1818, code: "DGT", name: "Sibulan Airport (Dumaguete Airport)" },
  { id: 1819, code: "DGU", name: "Dédougou Airport" },
  { id: 1820, code: "DGW", name: "Converse County Airport" },
  { id: 1822, code: "DHA", name: "King Abdulaziz Air Base" },
  { id: 1823, code: "DHB", name: "Deer Harbor Sea Plane Base[1]" },
  { id: 1824, code: "DHD", name: "Durham Downs Airport" },
  { id: 1825, code: "DHF", name: "Al Dhafra Air Base" },
  { id: 1826, code: "DHI", name: "Dhangadhi Airport" },
  { id: 1827, code: "DHL", name: "Dhala Airport" },
  { id: 1828, code: "DHM", name: "Gaggal Airport" },
  { id: 1829, code: "DHN", name: "Dothan Regional Airport" },
  { id: 1830, code: "DHR", name: "De Kooy Airfield" },
  { id: 1831, code: "DHT", name: "Dalhart Municipal Airport" },
  { id: 1833, code: "DIA", name: "Doha International Airport" },
  { id: 1834, code: "DIB", name: "Dibrugarh Airport (Mohanbari Airport)" },
  { id: 1835, code: "DIE", name: "Arrachart Airport" },
  { id: 1836, code: "DIG", name: "Diqing Shangri-La Airport" },
  { id: 1837, code: "DIJ", name: "Dijon Air Base" },
  { id: 1838, code: "DIK", name: "Dickinson Theodore Roosevelt Regional Airport" },
  { id: 1839, code: "DIL", name: "Presidente Nicolau Lobato International Airport" },
  { id: 1840, code: "DIM", name: "Dimbokro Airport" },
  { id: 1841, code: "DIN", name: "Dien Bien Phu Airport" },
  { id: 1842, code: "DIO", name: "Diomede Heliport" },
  { id: 1843, code: "DIP", name: "Diapaga Airport" },
  { id: 1844, code: "DIQ", name: "Divinópolis Airport (Brigadeiro Cabral Airport)" },
  { id: 1845, code: "DIR", name: "Aba Tenna Dejazmach Yilma International Airport" },
  { id: 1846, code: "DIS", name: "Dolisie Airport" },
  { id: 1847, code: "DIU", name: "Diu Airport" },
  { id: 1848, code: "DIV", name: "Divo Airport" },
  { id: 1849, code: "DIW", name: "Mawella Lagoon Seaplane Base[1]" },
  { id: 1850, code: "DIY", name: "Diyarbakır Airport" },
  { id: 1852, code: "DJA", name: "Djougou Airport" },
  { id: 1853, code: "DJB", name: "Sultan Thaha Airport" },
  { id: 1854, code: "DJE", name: "Djerba–Zarzis International Airport" },
  { id: 1855, code: "DJG", name: "Tiska Djanet Airport" },
  { id: 1856, code: "DJH", name: "Jebel Ali Seaplane Base" },
  { id: 1857, code: "DJJ", name: "Sentani Airport" },
  { id: 1858, code: "DJM", name: "Djambala Airport" },
  { id: 1859, code: "DJN", name: "Delta Junction Airport (FAA: D66)" },
  { id: 1860, code: "DJO", name: "Daloa Airport" },
  { id: 1861, code: "DJU", name: "Djúpivogur Airport" },
  { id: 1863, code: "DKA", name: "Katsina Airport[1]" },
  { id: 1864, code: "DKI", name: "Dunk Island Airport" },
  { id: 1865, code: "DKK", name: "Chautauqua County/Dunkirk Airport" },
  { id: 1866, code: "DKR", name: "Léopold Sédar Senghor International Airport" },
  { id: 1867, code: "DKS", name: "Dikson Airport" },
  { id: 1868, code: "DKV", name: "Docker River Airport" },
  { id: 1870, code: "DLA", name: "Douala International Airport" },
  { id: 1871, code: "DLB", name: "Dalbertis Airport" },
  { id: 1872, code: "DLC", name: "Dalian Zhoushuizi International Airport" },
  { id: 1873, code: "DLE", name: "Dole–Jura Airport" },
  { id: 1874, code: "DLF", name: "Laughlin Air Force Base" },
  { id: 1875, code: "DLG", name: "Dillingham Airport" },
  { id: 1876, code: "DLH", name: "Duluth International Airport" },
  { id: 1877, code: "DLI", name: "Lien Khuong Airport" },
  { id: 1878, code: "DLK", name: "Dulkaninna Airport" },
  { id: 1879, code: "DLL", name: "Dillon County Airport (FAA: DLC)" },
  { id: 1880, code: "DLM", name: "Dalaman Airport" },
  { id: 1881, code: "DLN", name: "Dillon Airport" },
  { id: 1882, code: "DLS", name: "Columbia Gorge Regional Airport (The Dalles Municipal Airport)" },
  { id: 1883, code: "DLU", name: "Dali Airport" },
  { id: 1884, code: "DLV", name: "Delissaville Airport" },
  { id: 1885, code: "DLY", name: "Dillon's Bay Airport" },
  { id: 1886, code: "DLZ", name: "Dalanzadgad Airport" },
  { id: 1888, code: "DMA", name: "Davis–Monthan Air Force Base" },
  { id: 1889, code: "DMB", name: "Taraz Airport (Jambyl Airport)" },
  { id: 1890, code: "DMD", name: "Doomadgee Airport" },
  { id: 1891, code: "DME", name: "Domodedovo International Airport" },
  { id: 1892, code: "DMK", name: "Don Mueang International Airport" },
  { id: 1893, code: "DMM", name: "King Fahd International Airport" },
  { id: 1894, code: "DMN", name: "Deming Municipal Airport" },
  { id: 1895, code: "DMO", name: "Sedalia Regional Airport" },
  { id: 1896, code: "DMR", name: "Dhamar Airport" },
  { id: 1897, code: "DMT", name: "Diamantino Airport" },
  { id: 1898, code: "DMU", name: "Dimapur Airport" },
  { id: 1900, code: "DNA", name: "Kadena Air Base" },
  { id: 1901, code: "DNB", name: "Dunbar Airport" },
  { id: 1902, code: "DND", name: "Dundee Airport" },
  { id: 1903, code: "DNF", name: "Martuba Air Base" },
  { id: 1904, code: "DNG", name: "Doongan Airport[1]" },
  { id: 1905, code: "DNH", name: "Dunhuang Airport" },
  { id: 1906, code: "DNI", name: "Wad Medani Airport" },
  { id: 1907, code: "DNK", name: "Dnipro International Airport" },
  { id: 1908, code: "DNL", name: "Daniel Field" },
  { id: 1909, code: "DNM", name: "Denham Airport" },
  { id: 1910, code: "DNN", name: "Dalton Municipal Airport" },
  { id: 1911, code: "DNO", name: "Dianópolis Airport" },
  { id: 1912, code: "DNP", name: "Tribhuvannagar Airport (Dang Airport)" },
  { id: 1913, code: "DNQ", name: "Deniliquin Airport" },
  { id: 1914, code: "DNR", name: "Dinard–Pleurtuit–Saint-Malo Airport" },
  { id: 1915, code: "DNS", name: "Denison Municipal Airport" },
  { id: 1916, code: "DNU", name: "Dinangat Airport" },
  { id: 1917, code: "DNV", name: "Vermilion Regional Airport" },
  { id: 1918, code: "DNX", name: "Galegu Airport" },
  { id: 1919, code: "DNZ", name: "Denizli Çardak Airport" },
  { id: 1921, code: "DOA", name: "Doany Airport" },
  { id: 1922, code: "DOB", name: "Dobo Airport" },
  { id: 1923, code: "DOC", name: "Dornoch Airfield" },
  { id: 1924, code: "DOD", name: "Dodoma Airport" },
  { id: 1925, code: "DOE", name: "Djumu Airstrip" },
  { id: 1926, code: "DOG", name: "Dongola Airport" },
  { id: 1927, code: "DOH", name: "Hamad International Airport" },
  { id: 1928, code: "DOI", name: "Doini Island Airport" },
  { id: 1929, code: "DOK", name: "Donetsk International Airport" },
  { id: 1930, code: "DOL", name: "Deauville – Saint-Gatien Airport" },
  { id: 1931, code: "DOM", name: "Douglas–Charles Airport" },
  { id: 1932, code: "DON", name: "Dos Lagunas Airport" },
  { id: 1933, code: "DOO", name: "Dorobisoro Airstrip" },
  { id: 1934, code: "DOP", name: "Dolpa Airport" },
  { id: 1935, code: "DOR", name: "Dori Airport" },
  { id: 1936, code: "DOS", name: "Dios Airport" },
  { id: 1937, code: "DOU", name: "Dourados Airport (Francisco de Matos Pereira Airport)" },
  { id: 1938, code: "DOV", name: "Dover Air Force Base" },
  { id: 1939, code: "DOX", name: "Dongara Airport" },
  { id: 1940, code: "DOY", name: "Dongying Shengli Airport[1]" },
  { id: 1942, code: "DPA", name: "DuPage Airport" },
  { id: 1943, code: "DPB", name: "Pampa Guanaco Airport" },
  { id: 1944, code: "DPE", name: "Dieppe - Saint-Aubin Airport" },
  { id: 1945, code: "DPG", name: "Michael Army Airfield" },
  { id: 1946, code: "DPL", name: "Dipolog Airport" },
  { id: 1947, code: "DPO", name: "Devonport Airport" },
  { id: 1948, code: "DPS", name: "Ngurah Rai International Airport" },
  { id: 1949, code: "DPT", name: "Deputatsky Airport" },
  { id: 1950, code: "DPU", name: "Dumpu Airport" },
  { id: 1952, code: "DQA", name: "Daqing Sartu Airport" },
  { id: 1953, code: "DQM", name: "Duqm International Airport[1]" },
  { id: 1955, code: "DRA", name: "Desert Rock Airport" },
  { id: 1956, code: "DRB", name: "Derby Airport" },
  { id: 1957, code: "DRC", name: "Dirico Airport" },
  { id: 1958, code: "DRD", name: "Dorunda Airport" },
  { id: 1959, code: "DRE", name: "Drummond Island Airport (FAA: DRM)" },
  { id: 1960, code: "DRF", name: "Drift River Airport[1]" },
  { id: 1961, code: "DRG", name: "Deering Airport (FAA: DEE)" },
  { id: 1962, code: "DRH", name: "Dabra Airport" },
  { id: 1963, code: "DRI", name: "Beauregard Regional Airport" },
  { id: 1964, code: "DRJ", name: "Drietabbetje Airstrip" },
  { id: 1965, code: "DRK", name: "Drake Bay Airport" },
  { id: 1966, code: "DRN", name: "Dirranbandi Airport" },
  { id: 1967, code: "DRO", name: "Durango–La Plata County Airport" },
  { id: 1968, code: "DRP", name: "Bicol International Airport" },
  { id: 1969, code: "DRR", name: "Durrie Airport" },
  { id: 1970, code: "DRS", name: "Dresden Airport" },
  { id: 1971, code: "DRT", name: "Del Rio International Airport" },
  { id: 1972, code: "DRU", name: "Drummond Airport (FAA: M26)" },
  { id: 1973, code: "DRV", name: "Dharavandhoo Airport[1]" },
  { id: 1974, code: "DRW", name: "Darwin International Airport" },
  { id: 1975, code: "DRY", name: "Drysdale River Airport[1]" },
  { id: 1977, code: "DSA", name: "Doncaster Sheffield Airport" },
  { id: 1978, code: "DSC", name: "Dschang Airport" },
  { id: 1979, code: "DSD", name: "La Désirade Airport (Grande-Anse Airport)" },
  { id: 1980, code: "DSE", name: "Combolcha Airport" },
  { id: 1981, code: "DSG", name: "Dilasag Airport" },
  { id: 1982, code: "DSI", name: "Destin Executive Airport (FAA: DTS)" },
  { id: 1983, code: "DSK", name: "Dera Ismail Khan Airport" },
  { id: 1984, code: "DSM", name: "Des Moines International Airport" },
  { id: 1985, code: "DSN", name: "Ordos Ejin Horo Airport" },
  { id: 1986, code: "DSO", name: "Sondok Airport[1]" },
  { id: 1987, code: "DSS", name: "Blaise Diagne International Airport" },
  { id: 1988, code: "DSV", name: "Dansville Municipal Airport" },
  { id: 1989, code: "DSX", name: "Dongsha Island Airport[1]" },
  { id: 1991, code: "DTA", name: "Delta Municipal Airport" },
  { id: 1992, code: "DTB", name: "Silangit Airport[1]" },
  { id: 1993, code: "DTD", name: "Datadawai Airport" },
  { id: 1994, code: "DTE", name: "Bagasbas Airport" },
  { id: 1995, code: "DTH", name: "Furnace Creek Airport (FAA: L06)" },
  { id: 1996, code: "DTI", name: "Diamantina Airport[1]" },
  { id: 1997, code: "DTL", name: "Detroit Lakes Airport (Wething Field)" },
  { id: 1998, code: "DTM", name: "Dortmund Airport" },
  { id: 1999, code: "DTN", name: "Shreveport Downtown Airport" },
  { id: 2000, code: "DTR", name: "Decatur Shores Airport[1]" },
  { id: 2001, code: "DTT[1]", name: "metropolitan area1" },
  { id: 2002, code: "DTU", name: "Wudalianchi Airport[1]" },
  { id: 2003, code: "DTW", name: "Detroit Metropolitan Wayne County Airport" },
  { id: 2005, code: "DUA", name: "Durant Regional Airport–Eaker Field" },
  { id: 2006, code: "DUB", name: "Dublin Airport" },
  { id: 2007, code: "DUC", name: "Halliburton Field" },
  { id: 2008, code: "DUD", name: "Dunedin International Airport" },
  { id: 2009, code: "DUE", name: "Dundo Airport" },
  { id: 2010, code: "DUF", name: "Pine Island Airport (FAA: 7NC2)" },
  { id: 2011, code: "DUG", name: "Bisbee Douglas International Airport" },
  { id: 2012, code: "DUJ", name: "DuBois Regional Airport" },
  { id: 2013, code: "DUK", name: "Dukuduku Airport" },
  { id: 2014, code: "DUM", name: "Pinang Kampai Airport" },
  { id: 2015, code: "DUQ", name: "Duncan Airport" },
  { id: 2016, code: "DUR", name: "King Shaka International Airport" },
  { id: 2017, code: "DUS", name: "Düsseldorf Airport" },
  { id: 2018, code: "DUT", name: "Unalaska Airport" },
  { id: 2020, code: "DVD", name: "Andavadoaka Airport" },
  { id: 2021, code: "DVK", name: "Diavik Airport[1]" },
  { id: 2022, code: "DVL", name: "Devils Lake Regional Airport (Devils Lake Municipal Airport)" },
  { id: 2023, code: "DVN", name: "Davenport Municipal Airport" },
  { id: 2024, code: "DVO", name: "Francisco Bangoy International Airport" },
  { id: 2025, code: "DVP", name: "Davenport Downs Airport" },
  { id: 2026, code: "DVR", name: "Daly River Airport" },
  { id: 2027, code: "DVT", name: "Phoenix Deer Valley Airport" },
  { id: 2029, code: "DWA", name: "Dwanga Airport (Dwangwa Airport)" },
  { id: 2030, code: "DWB", name: "Soalala Airport" },
  { id: 2031, code: "DWC", name: "Al Maktoum International Airport" },
  { id: 2032, code: "DWD", name: "Dawadmi Domestic Airport (King Salman bin Abdul Aziz Domestic Airport)" },
  { id: 2033, code: "DWH", name: "David Wayne Hooks Memorial Airport" },
  { id: 2034, code: "DWO", name: "Diyawanna Oya Seaplane Base[1]" },
  { id: 2035, code: "DWR", name: "Dwyer Airport[1]" },
  { id: 2037, code: "DXB", name: "Dubai International Airport" },
  { id: 2038, code: "DXD", name: "Dixie Airport" },
  { id: 2039, code: "DXE", name: "Bruce Campbell Field[1] (FAA: MBO)" },
  { id: 2040, code: "DXN", name: "Noida International Airport" },
  { id: 2041, code: "DXR", name: "Danbury Municipal Airport" },
  { id: 2043, code: "DYA", name: "Dysart Airport" },
  { id: 2044, code: "DYG", name: "Zhangjiajie Hehua Airport" },
  { id: 2045, code: "DYL", name: "Doylestown Airport" },
  { id: 2046, code: "DYM", name: "Diamantina Lakes Airport" },
  { id: 2047, code: "DYR", name: "Ugolny Airport" },
  { id: 2048, code: "DYS", name: "Dyess Air Force Base" },
  { id: 2049, code: "DYU", name: "Dushanbe International Airport" },
  { id: 2050, code: "DYW", name: "Daly Waters Airport" },
  { id: 2052, code: "DZA", name: "Dzaoudzi–Pamandzi International Airport" },
  { id: 2053, code: "DZH", name: "Dazhou Jinya Airport" },
  { id: 2054, code: "DZI", name: "Codazzi Airport" },
  { id: 2055, code: "DZN", name: "Zhezkazgan Airport" },
  { id: 2056, code: "DZO", name: "Santa Bernardina International Airport" },
  { id: 2057, code: "DZU", name: "Dazu Air Base" },
  { id: 2061, code: "EAA", name: "Eagle Airport" },
  { id: 2062, code: "EAB", name: "Abbs Airport" },
  { id: 2063, code: "EAE", name: "Siwo Airport" },
  { id: 2064, code: "EAL", name: "Elenak Airport" },
  { id: 2065, code: "EAM", name: "Najran Domestic Airport" },
  { id: 2066, code: "EAN", name: "Phifer Airfield" },
  { id: 2067, code: "EAP[1]", name: "metropolitan area2" },
  { id: 2068, code: "EAR", name: "Kearney Regional Airport" },
  { id: 2069, code: "EAS", name: "San Sebastián Airport" },
  { id: 2070, code: "EAT", name: "Pangborn Memorial Airport" },
  { id: 2071, code: "EAU", name: "Chippewa Valley Regional Airport" },
  { id: 2073, code: "EBA", name: "Marina di Campo Airport" },
  { id: 2074, code: "EBB", name: "Entebbe International Airport" },
  { id: 2075, code: "EBD", name: "El Obeid Airport" },
  { id: 2076, code: "EBG", name: "El Bagre Airport (El Tomin Airport)" },
  { id: 2077, code: "EBH", name: "El Bayadh Airport[1]" },
  { id: 2078, code: "EBJ", name: "Esbjerg Airport" },
  { id: 2079, code: "EBL", name: "Erbil International Airport" },
  { id: 2080, code: "EBM", name: "El Borma Airport" },
  { id: 2081, code: "EBN", name: "Ebadon Airstrip" },
  { id: 2082, code: "EBO", name: "Ebon Airport" },
  { id: 2083, code: "EBS", name: "Webster City Municipal Airport" },
  { id: 2084, code: "EBU", name: "Saint-Étienne–Bouthéon Airport" },
  { id: 2085, code: "EBW", name: "Ebolowa Airport" },
  { id: 2087, code: "ECA", name: "Iosco County Airport (FAA: 6D9)" },
  { id: 2088, code: "ECG", name: "Elizabeth City Regional Airport" },
  { id: 2089, code: "ECH", name: "Echuca Airport" },
  { id: 2090, code: "ECI", name: "Costa Esmeralda Airport[1]" },
  { id: 2091, code: "ECN", name: "Ercan International Airport[1]" },
  { id: 2092, code: "ECO", name: "El Encanto Airport" },
  { id: 2093, code: "ECP", name: "Northwest Florida Beaches International Airport" },
  { id: 2094, code: "ECR", name: "El Charco Airport" },
  { id: 2095, code: "ECS", name: "Mondell Field" },
  { id: 2097, code: "EDA", name: "Edna Bay Seaplane Base[1]" },
  { id: 2098, code: "EDB", name: "El Debba Airport" },
  { id: 2099, code: "EDD", name: "Erldunda Airport" },
  { id: 2100, code: "EDE", name: "Northeastern Regional Airport" },
  { id: 2101, code: "EDF", name: "Elmendorf Air Force Base" },
  { id: 2102, code: "EDI", name: "Edinburgh Airport" },
  { id: 2103, code: "EDK", name: "Captain Jack Thomas/El Dorado Airport (FAA: EQA)" },
  { id: 2104, code: "EDL", name: "Eldoret International Airport" },
  { id: 2105, code: "EDM", name: "La Roche-sur-Yon Aerodrome" },
  { id: 2106, code: "EDO", name: "Balıkesir Koca Seyit Airport" },
  { id: 2107, code: "EDQ", name: "Erandique Airport" },
  { id: 2108, code: "EDR", name: "Edward River Airport" },
  { id: 2109, code: "EDW", name: "Edwards Air Force Base" },
  { id: 2111, code: "EEA", name: "Planalto Serrano Regional Airport" },
  { id: 2112, code: "EED", name: "Needles Airport" },
  { id: 2113, code: "EEK", name: "Eek Airport" },
  { id: 2114, code: "EEN", name: "Dillant–Hopkins Airport" },
  { id: 2116, code: "EFD", name: "Ellington Field" },
  { id: 2117, code: "EFG", name: "Efogi Airport" },
  { id: 2118, code: "EFK", name: "Newport State Airport" },
  { id: 2119, code: "EFL", name: "Cephalonia International Airport" },
  { id: 2120, code: "EFW", name: "Jefferson Municipal Airport" },
  { id: 2122, code: "EGA", name: "Engati Airport" },
  { id: 2123, code: "EGC", name: "Bergerac Dordogne Périgord Airport" },
  { id: 2124, code: "EGE", name: "Eagle County Regional Airport" },
  { id: 2125, code: "EGI", name: "Duke Field (Eglin Auxiliary Field 3)" },
  { id: 2126, code: "EGL", name: "Neghelle Airport" },
  { id: 2127, code: "EGM", name: "Seghe Airport" },
  { id: 2128, code: "EGN", name: "Geneina Airport" },
  { id: 2129, code: "EGO", name: "Belgorod International Airport" },
  { id: 2130, code: "EGP", name: "Maverick County Memorial International Airport" },
  { id: 2131, code: "EGS", name: "Egilsstaðir Airport" },
  { id: 2132, code: "EGV", name: "Eagle River Union Airport" },
  { id: 2133, code: "EGX", name: "Egegik Airport (FAA: EII)" },
  { id: 2135, code: "EHL", name: "El Bolsón Airport" },
  { id: 2136, code: "EHM", name: "Cape Newenham LRRS Airport" },
  { id: 2137, code: "EHU", name: "Ezhou Huahu Airport" },
  { id: 2139, code: "EIA", name: "Popondetta Airport" },
  { id: 2140, code: "EIB", name: "Eisenach-Kindel Airport[1]" },
  { id: 2141, code: "EIE", name: "Yeniseysk Airport" },
  { id: 2142, code: "EIH", name: "Einasleigh Airport" },
  { id: 2143, code: "EIK", name: "Yeysk Airport[1]" },
  { id: 2144, code: "EIL", name: "Eielson Air Force Base" },
  { id: 2145, code: "EIN", name: "Eindhoven Airport" },
  { id: 2146, code: "EIS", name: "Terrance B. Lettsome International Airport" },
  { id: 2147, code: "EIY", name: "Ein Yahav Airfield" },
  { id: 2149, code: "EJA", name: "Yariguíes Airport" },
  { id: 2150, code: "EJH", name: "Al Wajh Domestic Airport" },
  { id: 2151, code: "EJN", name: "Ejin Banner Taolai Airport" },
  { id: 2152, code: "EJT", name: "Enejit Airport" },
  { id: 2154, code: "EKA", name: "Murray Field" },
  { id: 2155, code: "EKB", name: "Ekibastuz Airport" },
  { id: 2156, code: "EKD", name: "Elkedra Airport" },
  { id: 2157, code: "EKE", name: "Ekereku Airport" },
  { id: 2158, code: "EKI", name: "Elkhart Municipal Airport (FAA: EKM)" },
  { id: 2159, code: "EKN", name: "Elkins-Randolph County Airport" },
  { id: 2160, code: "EKO", name: "Elko Regional Airport" },
  { id: 2161, code: "EKS", name: "Shakhtyorsk Airport[1]" },
  { id: 2162, code: "EKT", name: "Eskilstuna Airport" },
  { id: 2163, code: "EKX", name: "Elizabethtown Regional Airport (Addington Field)" },
  { id: 2165, code: "ELA", name: "Eagle Lake Airport" },
  { id: 2166, code: "ELB", name: "Las Flores Airport" },
  { id: 2167, code: "ELC", name: "Elcho Island Airport" },
  { id: 2168, code: "ELD", name: "South Arkansas Regional Airport at Goodwin Field" },
  { id: 2169, code: "ELE", name: "El Real Airport" },
  { id: 2170, code: "ELF", name: "El Fasher Airport" },
  { id: 2171, code: "ELG", name: "El Golea Airport" },
  { id: 2172, code: "ELH", name: "North Eleuthera Airport" },
  { id: 2173, code: "ELI", name: "Elim Airport" },
  { id: 2174, code: "ELJ", name: "El Recreo Airport" },
  { id: 2175, code: "ELK", name: "Elk City Regional Business Airport" },
  { id: 2176, code: "ELL", name: "Ellisras Airport" },
  { id: 2177, code: "ELM", name: "Elmira/Corning Regional Airport" },
  { id: 2178, code: "ELN", name: "Bowers Field" },
  { id: 2179, code: "ELO", name: "Eldorado Airport" },
  { id: 2180, code: "ELP", name: "El Paso International Airport" },
  { id: 2181, code: "ELQ", name: "Prince Nayef bin Abdulaziz Regional Airport" },
  { id: 2182, code: "ELR", name: "Elelim Airport" },
  { id: 2183, code: "ELS", name: "East London Airport" },
  { id: 2184, code: "ELT", name: "El Tor Airport" },
  { id: 2185, code: "ELU", name: "Guemar Airport" },
  { id: 2186, code: "ELV", name: "Elfin Cove Seaplane Base" },
  { id: 2187, code: "ELW", name: "Ellamar Seaplane Base (FAA: 1Z9)" },
  { id: 2188, code: "ELX", name: "El Tigre Airport" },
  { id: 2189, code: "ELY", name: "Ely Airport" },
  { id: 2190, code: "ELZ", name: "Wellsville Municipal Airport (Tarantine Field)" },
  { id: 2192, code: "EMA", name: "East Midlands Airport" },
  { id: 2193, code: "EMD", name: "Emerald Airport" },
  { id: 2194, code: "EME", name: "Emden Airport" },
  { id: 2195, code: "EMG", name: "Empangeni Airport" },
  { id: 2196, code: "EMI", name: "Emirau Airport" },
  { id: 2197, code: "EMK", name: "Emmonak Airport (FAA: ENM)" },
  { id: 2198, code: "EML", name: "Emmen Air Base" },
  { id: 2199, code: "EMM", name: "Kemmerer Municipal Airport" },
  { id: 2200, code: "EMN", name: "Néma Airport" },
  { id: 2201, code: "EMO", name: "Emo Airport" },
  { id: 2202, code: "EMP", name: "Emporia Municipal Airport" },
  { id: 2203, code: "EMS", name: "Embessa Airport" },
  { id: 2204, code: "EMT", name: "San Gabriel Valley Airport" },
  { id: 2205, code: "EMX", name: "El Maitén Airport" },
  { id: 2206, code: "EMY", name: "El Minya Airport" },
  { id: 2208, code: "ENA", name: "Kenai Municipal Airport" },
  { id: 2209, code: "ENB", name: "Eneabba Airport" },
  { id: 2210, code: "ENC", name: "Nancy-Essey Airport" },
  { id: 2211, code: "END", name: "Vance Air Force Base" },
  { id: 2212, code: "ENE", name: "H. Hasan Aroeboesman Airport" },
  { id: 2213, code: "ENF", name: "Enontekiö Airport" },
  { id: 2214, code: "ENH", name: "Enshi Xujiaping Airport" },
  { id: 2215, code: "ENI", name: "El Nido Airport" },
  { id: 2216, code: "ENJ", name: "El Naranjo Airport" },
  { id: 2217, code: "ENK", name: "Enniskillen/St Angelo Airport" },
  { id: 2218, code: "ENL", name: "Centralia Municipal Airport" },
  { id: 2219, code: "ENN", name: "Nenana Municipal Airport" },
  { id: 2220, code: "ENO", name: "Teniente Amin Ayub Gonzalez Airport" },
  { id: 2221, code: "ENS", name: "Enschede Airport Twente" },
  { id: 2222, code: "ENT", name: "Enewetak Auxiliary Airfield" },
  { id: 2223, code: "ENU", name: "Akanu Ibiam International Airport" },
  { id: 2224, code: "ENV", name: "Wendover Airport" },
  { id: 2225, code: "ENW", name: "Kenosha Regional Airport" },
  { id: 2226, code: "ENY", name: "Yan'an Nanniwan Airport" },
  { id: 2228, code: "EOH", name: "Olaya Herrera Airport" },
  { id: 2229, code: "EOI", name: "Eday Airport" },
  { id: 2230, code: "EOK", name: "Keokuk Municipal Airport" },
  { id: 2231, code: "EOR", name: "El Dorado Airport" },
  { id: 2232, code: "EOS", name: "Neosho Hugh Robinson Airport" },
  { id: 2233, code: "EOZ", name: "Elorza Airport" },
  { id: 2235, code: "EPA", name: "El Palomar Airport[1]" },
  { id: 2236, code: "EPG", name: "Browns Airport (FAA: NE69)" },
  { id: 2237, code: "EPH", name: "Ephrata Municipal Airport" },
  { id: 2238, code: "EPL", name: "Épinal – Mirecourt Airport" },
  { id: 2239, code: "EPN", name: "Epéna Airport" },
  { id: 2240, code: "EPR", name: "Esperance Airport" },
  { id: 2241, code: "EPS", name: "Arroyo Barril Airport" },
  { id: 2242, code: "EPT", name: "Eliptamin Airport" },
  { id: 2243, code: "EPU", name: "Pärnu Airport" },
  { id: 2245, code: "EQS", name: "Esquel Airport" },
  { id: 2247, code: "ERA", name: "Erigavo Airport" },
  { id: 2248, code: "ERB", name: "Pukatja Airport (Ernabella Airport)" },
  { id: 2249, code: "ERC", name: "Erzincan Airport" },
  { id: 2250, code: "ERD", name: "Berdiansk Airport" },
  { id: 2251, code: "ERE", name: "Erave Airport" },
  { id: 2252, code: "ERF", name: "Erfurt–Weimar Airport" },
  { id: 2253, code: "ERG", name: "Erbogachen Airport" },
  { id: 2254, code: "ERH", name: "Moulay Ali Cherif Airport" },
  { id: 2255, code: "ERI", name: "Erie International Airport (Tom Ridge Field)" },
  { id: 2256, code: "ERL", name: "Erenhot Saiwusu International Airport" },
  { id: 2257, code: "ERM", name: "Erechim Airport" },
  { id: 2258, code: "ERN", name: "Eirunepé Airport (Amaury Feitosa Tomaz Airport)" },
  { id: 2259, code: "ERQ", name: "Elrose Airport" },
  { id: 2260, code: "ERR", name: "Errol Airport" },
  { id: 2261, code: "ERS", name: "Eros Airport" },
  { id: 2262, code: "ERT", name: "Erdenet Airport" },
  { id: 2263, code: "ERU", name: "Erume Airport" },
  { id: 2264, code: "ERV", name: "Kerrville Municipal Airport (Louis Schreiner Field)" },
  { id: 2265, code: "ERZ", name: "Erzurum Airport" },
  { id: 2267, code: "ESA", name: "Esa'ala Airport" },
  { id: 2268, code: "ESB", name: "Esenboğa International Airport" },
  { id: 2269, code: "ESC", name: "Delta County Airport" },
  { id: 2270, code: "ESD", name: "Orcas Island Airport (FAA: ORS)" },
  { id: 2271, code: "ESE", name: "Ensenada Airport" },
  { id: 2272, code: "ESF", name: "Esler Airfield (Esler Regional Airport)" },
  { id: 2273, code: "ESG", name: "Dr. Luis María Argaña International Airport" },
  { id: 2274, code: "ESH", name: "Shoreham Airport (Brighton City Airport)" },
  { id: 2275, code: "ESI", name: "Espinosa Airport" },
  { id: 2276, code: "ESK", name: "Eskişehir Airport" },
  { id: 2277, code: "ESL", name: "Elista Airport" },
  { id: 2278, code: "ESM", name: "Carlos Concha Torres International Airport" },
  { id: 2279, code: "ESN", name: "Easton Airport (Newnam Field)" },
  { id: 2280, code: "ESO", name: "Ohkay Owingeh Airport (FAA: E14)" },
  { id: 2281, code: "ESP", name: "Stroudsburg–Pocono Airport[1] (FAA: N53)" },
  { id: 2282, code: "ESR", name: "Ricardo García Posada Airport" },
  { id: 2283, code: "ESS", name: "Essen/Mülheim Airport" },
  { id: 2284, code: "EST", name: "Estherville Municipal Airport" },
  { id: 2285, code: "ESU", name: "Essaouira-Mogador Airport" },
  { id: 2286, code: "ESW", name: "Easton State Airport" },
  { id: 2288, code: "ETB", name: "West Bend Municipal Airport" },
  { id: 2289, code: "ETD", name: "Etadunna Airport" },
  { id: 2290, code: "ETE", name: "Genda Wuha Airport" },
  { id: 2291, code: "ETH", name: "J. Hozman Airport" },
  { id: 2292, code: "ETM", name: "Ramon Airport" },
  { id: 2293, code: "ETN", name: "Eastland Municipal Airport" },
  { id: 2294, code: "ETR", name: "Santa Rosa International Airport" },
  { id: 2295, code: "ETS", name: "Enterprise Municipal Airport (FAA: EDN)" },
  { id: 2296, code: "ETZ", name: "Metz–Nancy–Lorraine Airport" },
  { id: 2298, code: "EUA", name: "Eua Airport (Kaufana Airport)" },
  { id: 2299, code: "EUC", name: "Eucla Airport" },
  { id: 2300, code: "EUE", name: "Eureka Airport (FAA: 05U)" },
  { id: 2301, code: "EUF", name: "Weedon Field" },
  { id: 2302, code: "EUG", name: "Eugene Airport (Mahlon Sweet Airport)" },
  { id: 2303, code: "EUM", name: "Neumünster Airport" },
  { id: 2304, code: "EUN", name: "Hassan I Airport" },
  { id: 2305, code: "EUO", name: "Paratebueno Airport[1]" },
  { id: 2306, code: "EUQ", name: "Evelio Javier Airport (Antique Airport)" },
  { id: 2307, code: "EUX", name: "F. D. Roosevelt Airport" },
  { id: 2309, code: "EVA", name: "Ben Bruce Memorial Airpark (FAA: 4TE8)" },
  { id: 2310, code: "EVD", name: "Eva Downs Airport" },
  { id: 2311, code: "EVE", name: "Harstad/Narvik Airport, Evenes" },
  { id: 2312, code: "EVG", name: "Sveg Airport" },
  { id: 2313, code: "EVH", name: "Evans Head Memorial Aerodrome" },
  { id: 2314, code: "EVM", name: "Eveleth-Virginia Municipal Airport" },
  { id: 2315, code: "EVN", name: "Zvartnots International Airport" },
  { id: 2316, code: "EVV", name: "Evansville Regional Airport" },
  { id: 2317, code: "EVW", name: "Evanston-Uinta County Burns Field" },
  { id: 2318, code: "EVX", name: "Évreux-Fauville Air Base" },
  { id: 2320, code: "EWB", name: "New Bedford Regional Airport" },
  { id: 2321, code: "EWE", name: "Ewer Airport" },
  { id: 2322, code: "EWI", name: "Enarotali Airport" },
  { id: 2323, code: "EWK", name: "Newton City/County Airport" },
  { id: 2324, code: "EWN", name: "Coastal Carolina Regional Airport" },
  { id: 2325, code: "EWO", name: "Ewo Airport" },
  { id: 2326, code: "EWR", name: "Newark Liberty International Airport" },
  { id: 2328, code: "EXI", name: "Excursion Inlet Seaplane Base" },
  { id: 2329, code: "EXM", name: "Exmouth Airport" },
  { id: 2330, code: "EXT", name: "Exeter International Airport" },
  { id: 2332, code: "EYK", name: "Beloyarsk Airport" },
  { id: 2333, code: "EYL", name: "Yélimané Airport" },
  { id: 2334, code: "EYP", name: "El Alcaraván Airport" },
  { id: 2335, code: "EYR", name: "Yerington Municipal Airport[1] (FAA: O43)" },
  { id: 2336, code: "EYS", name: "Eliye Springs Airport" },
  { id: 2337, code: "EYW", name: "Key West International Airport" },
  { id: 2339, code: "EZE", name: "Ministro Pistarini International Airport" },
  { id: 2340, code: "EZS", name: "Elazığ Airport" },
  { id: 2341, code: "EZV", name: "Beryozovo Airport[1]" },
  { id: 2344, code: "FAA", name: "Faranah Airport" },
  { id: 2345, code: "FAB", name: "Farnborough Airport" },
  { id: 2346, code: "FAC", name: "Faaite Airport" },
  { id: 2347, code: "FAE", name: "Vágar Airport" },
  { id: 2348, code: "FAF", name: "Felker Army Airfield" },
  { id: 2349, code: "FAG", name: "Fagurhólsmýri Airport" },
  { id: 2350, code: "FAH", name: "Farah Airport" },
  { id: 2351, code: "FAI", name: "Fairbanks International Airport" },
  { id: 2352, code: "FAJ", name: "Diego Jiménez Torres Airport (FAA: X95)" },
  { id: 2353, code: "FAK", name: "False Island Seaplane Base (FAA: 2Z6)" },
  { id: 2354, code: "FAM", name: "Farmington Regional Airport" },
  { id: 2355, code: "FAO", name: "Faro Airport" },
  { id: 2356, code: "FAQ", name: "Frieda River Airport" },
  { id: 2357, code: "FAR", name: "Hector International Airport" },
  { id: 2358, code: "FAS", name: "Fáskrúðsfjörður Airport" },
  { id: 2359, code: "FAT", name: "Fresno Yosemite International Airport" },
  { id: 2360, code: "FAU", name: "Fahud Airport[1]" },
  { id: 2361, code: "FAV", name: "Fakarava Airport" },
  { id: 2362, code: "FAY", name: "Fayetteville Regional Airport (Grannis Field)" },
  { id: 2363, code: "FAZ", name: "Fasa Airport[1]" },
  { id: 2365, code: "FBA", name: "Fonte Boa Airport[1]" },
  { id: 2366, code: "FBD", name: "Fayzabad Airport" },
  { id: 2367, code: "FBE", name: "Francisco Beltrão Airport (Paulo Abdala Airport)" },
  { id: 2368, code: "FBG", name: "Simmons Army Airfield" },
  { id: 2369, code: "FBK", name: "Ladd Army Airfield" },
  { id: 2370, code: "FBL", name: "Faribault Municipal Airport" },
  { id: 2371, code: "FBM", name: "Lubumbashi International Airport" },
  { id: 2372, code: "FBR", name: "Fort Bridger Airport" },
  { id: 2373, code: "FBS", name: "Friday Harbor Seaplane Base (FAA: W33)" },
  { id: 2374, code: "FBY", name: "Fairbury Municipal Airport" },
  { id: 2376, code: "FCA", name: "Glacier Park International Airport (FAA: GPI)" },
  { id: 2377, code: "FCB", name: "Ficksburg Airport" },
  { id: 2378, code: "FCH", name: "Fresno Chandler Executive Airport" },
  { id: 2379, code: "FCM", name: "Flying Cloud Airport" },
  { id: 2380, code: "FCN", name: "Sea-Airport Cuxhaven/Nordholz" },
  { id: 2381, code: "FCO", name: "Leonardo da Vinci–Fiumicino Airport" },
  { id: 2382, code: "FCS", name: "Butts Army Airfield (Fort Carson)" },
  { id: 2383, code: "FCY", name: "Forrest City Municipal Airport" },
  { id: 2385, code: "FDE", name: "Førde Airport, Bringeland" },
  { id: 2386, code: "FDF", name: "Martinique Aimé Césaire International Airport" },
  { id: 2387, code: "FDH", name: "Friedrichshafen Airport (Bodensee Airport)" },
  { id: 2388, code: "FDK", name: "Frederick Municipal Airport" },
  { id: 2389, code: "FDR", name: "Frederick Regional Airport" },
  { id: 2390, code: "FDU", name: "Bandundu Airport" },
  { id: 2391, code: "FDY", name: "Findlay Airport" },
  { id: 2393, code: "FEA", name: "Fetlar Airport" },
  { id: 2394, code: "FEB", name: "Sanfebagar Airport" },
  { id: 2395, code: "FEC", name: "Feira de Santana Airport (Gov. João Durval Carneiro Airport)" },
  { id: 2396, code: "FEG", name: "Fergana International Airport" },
  { id: 2397, code: "FEJ", name: "Feijó Airport" },
  { id: 2398, code: "FEK", name: "Ferkessédougou Airport" },
  { id: 2399, code: "FEL", name: "Fürstenfeldbruck Air Base" },
  { id: 2400, code: "FEN", name: "Fernando de Noronha Airport (Gov. Carlos Wilson Airport)" },
  { id: 2401, code: "FEP", name: "Albertus Airport" },
  { id: 2402, code: "FET", name: "Fremont Municipal Airport" },
  { id: 2403, code: "FEZ", name: "Fes–Saïss Airport" },
  { id: 2405, code: "FFA", name: "First Flight Airport" },
  { id: 2406, code: "FFD", name: "RAF Fairford" },
  { id: 2407, code: "FFL", name: "Fairfield Municipal Airport" },
  { id: 2408, code: "FFM", name: "Fergus Falls Municipal Airport (Einar Mickelson Field)" },
  { id: 2409, code: "FFO", name: "Wright-Patterson Air Force Base (First Flight-Office)" },
  { id: 2410, code: "FFT", name: "Capital City Airport" },
  { id: 2411, code: "FFU", name: "Futaleufú Airfield" },
  { id: 2413, code: "FGD", name: "Fderik Airport" },
  { id: 2414, code: "FGI", name: "Fagali'i Airport" },
  { id: 2415, code: "FGU", name: "Fangatau Airport" },
  { id: 2417, code: "FHU", name: "Sierra Vista Municipal Airport (Libby Army Airfield)" },
  { id: 2418, code: "FHZ", name: "Fakahina Airport" },
  { id: 2420, code: "FID", name: "Elizabeth Field (FAA: 0B8)" },
  { id: 2421, code: "FIE", name: "Fair Isle Airport" },
  { id: 2422, code: "FIG", name: "Fria Airport" },
  { id: 2423, code: "FIH", name: "N'djili Airport (Kinshasa Int'l Airport)" },
  { id: 2424, code: "FIK", name: "Finke Airport" },
  { id: 2425, code: "FIL", name: "Fillmore Municipal Airport (FAA: FOM)" },
  { id: 2426, code: "FIN", name: "Finschhafen Airport" },
  { id: 2427, code: "FIZ", name: "Fitzroy Crossing Airport" },
  { id: 2429, code: "FJR", name: "Fujairah International Airport" },
  { id: 2431, code: "FKB", name: "Karlsruhe/Baden-Baden Airport" },
  { id: 2432, code: "FKI", name: "Bangoka International Airport" },
  { id: 2433, code: "FKJ", name: "Fukui Airport" },
  { id: 2434, code: "FKL", name: "Venango Regional Airport (Chess Lamberton Field)" },
  { id: 2435, code: "FKN", name: "Franklin Municipal–John Beverly Rose Airport" },
  { id: 2436, code: "FKQ", name: "Fakfak Torea Airport" },
  { id: 2437, code: "FKS", name: "Fukushima Airport" },
  { id: 2439, code: "FLA", name: "Gustavo Artunduaga Paredes Airport" },
  { id: 2440, code: "FLB", name: "Cangapara Airport" },
  { id: 2441, code: "FLD", name: "Fond du Lac County Airport" },
  { id: 2442, code: "FLF", name: "Flensburg-Schäferhaus Airport" },
  { id: 2443, code: "FLG", name: "Flagstaff Pulliam Airport" },
  { id: 2444, code: "FLH", name: "Flotta Isle Airport" },
  { id: 2445, code: "FLI", name: "Holt Airport" },
  { id: 2446, code: "FLL", name: "Fort Lauderdale–Hollywood International Airport" },
  { id: 2447, code: "FLM", name: "Filadelfia Airport" },
  { id: 2448, code: "FLN", name: "Hercílio Luz International Airport" },
  { id: 2449, code: "FLO", name: "Florence Regional Airport" },
  { id: 2450, code: "FLP", name: "Marion County Regional Airport" },
  { id: 2451, code: "FLR", name: "Florence Airport, Peretola (Amerigo Vespucci Airport)" },
  { id: 2452, code: "FLS", name: "Flinders Island Airport" },
  { id: 2453, code: "FLT", name: "Flat Airport" },
  { id: 2454, code: "FLV", name: "Sherman Army Airfield" },
  { id: 2455, code: "FLW", name: "Flores Airport" },
  { id: 2456, code: "FLX", name: "Fallon Municipal Airport" },
  { id: 2457, code: "FLY", name: "Finley Airport" },
  { id: 2458, code: "FLZ", name: "Ferdinand Lumban Tobing Airport[1]" },
  { id: 2460, code: "FMA", name: "Formosa International Airport (El Pucú Airport)" },
  { id: 2461, code: "FME", name: "Tipton Airport" },
  { id: 2462, code: "FMH", name: "Otis Air National Guard Base" },
  { id: 2463, code: "FMI", name: "Kalemie Airport" },
  { id: 2464, code: "FMM", name: "Memmingen Airport" },
  { id: 2465, code: "FMN", name: "Four Corners Regional Airport" },
  { id: 2466, code: "FMO", name: "Münster Osnabrück Airport" },
  { id: 2467, code: "FMS", name: "Fort Madison Municipal Airport (FAA: FSW)" },
  { id: 2468, code: "FMU", name: "Florence Municipal Airport[1] (FAA: 6S2)" },
  { id: 2469, code: "FMY", name: "Page Field" },
  { id: 2471, code: "FNA", name: "Lungi International Airport" },
  { id: 2472, code: "FNB", name: "Neubrandenburg Airport" },
  { id: 2473, code: "FNC", name: "Madeira Airport" },
  { id: 2474, code: "FND", name: "Funadhoo Airport" },
  { id: 2475, code: "FNE", name: "Fane Airport" },
  { id: 2476, code: "FNG", name: "Fada N'gourma Airport" },
  { id: 2477, code: "FNH", name: "Fincha Airport" },
  { id: 2478, code: "FNI", name: "Nîmes–Alès–Camargue–Cévennes Airport (Garons Airport)" },
  { id: 2479, code: "FNJ", name: "Pyongyang Sunan International Airport" },
  { id: 2480, code: "FNL", name: "Fort Collins–Loveland Municipal Airport" },
  { id: 2481, code: "FNR", name: "Funter Bay Seaplane Base" },
  { id: 2482, code: "FNT", name: "Bishop International Airport" },
  { id: 2483, code: "FNU", name: "Oristano-Fenosu Airport[1]" },
  { id: 2485, code: "FOA", name: "Foula Airfield" },
  { id: 2486, code: "FOB", name: "Fort Bragg Airport (FAA: 82CL)" },
  { id: 2487, code: "FOC", name: "Fuzhou Changle International Airport" },
  { id: 2488, code: "FOD", name: "Fort Dodge Regional Airport" },
  { id: 2489, code: "FOE", name: "Topeka Regional Airport" },
  { id: 2490, code: "FOG", name: "Foggia Gino Lisa Airport" },
  { id: 2491, code: "FOK", name: "Francis S. Gabreski Airport" },
  { id: 2492, code: "FOM", name: "Foumban Nkounja Airport" },
  { id: 2493, code: "FON", name: "La Fortuna Arenal Airport" },
  { id: 2494, code: "FOO", name: "Kornasoren Airport (Numfoor Airport)" },
  { id: 2495, code: "FOR", name: "Pinto Martins – Fortaleza International Airport" },
  { id: 2496, code: "FOS", name: "Forrest Airport" },
  { id: 2497, code: "FOT", name: "Forster (Wallis Island) Airport[1][2]" },
  { id: 2498, code: "FOU", name: "Fougamou Airport" },
  { id: 2499, code: "FOY", name: "Foya Airport" },
  { id: 2501, code: "FPO", name: "Grand Bahama International Airport" },
  { id: 2502, code: "FPR", name: "St. Lucie County International Airport" },
  { id: 2503, code: "FPY", name: "Perry-Foley Airport (FAA: 40J)" },
  { id: 2505, code: "FRA", name: "Frankfurt Airport" },
  { id: 2506, code: "FRB", name: "Forbes Airport" },
  { id: 2507, code: "FRC", name: "Franca Airport (Ten. Lund Presotto–Franca State Airport)" },
  { id: 2508, code: "FRD", name: "Friday Harbor Airport (FAA: FHR)" },
  { id: 2509, code: "FRE", name: "Fera Airport (Fera/Maringe Airport)" },
  { id: 2510, code: "FRG", name: "Republic Airport" },
  { id: 2511, code: "FRH", name: "French Lick Municipal Airport" },
  { id: 2512, code: "FRI", name: "Marshall Army Airfield" },
  { id: 2513, code: "FRK", name: "Frégate Island Airport" },
  { id: 2514, code: "FRL", name: "Forlì International Airport (Luigi Ridolfi Airport)" },
  { id: 2515, code: "FRM", name: "Fairmont Municipal Airport" },
  { id: 2516, code: "FRN", name: "Bryant Army Airport" },
  { id: 2517, code: "FRO", name: "Florø Airport" },
  { id: 2518, code: "FRQ", name: "Feramin Airport" },
  { id: 2519, code: "FRR", name: "Front Royal–Warren County Airport" },
  { id: 2520, code: "FRS", name: "Mundo Maya International Airport" },
  { id: 2521, code: "FRT", name: "Frutillar Airport" },
  { id: 2522, code: "FRU", name: "Manas International Airport" },
  { id: 2523, code: "FRW", name: "Francistown Airport" },
  { id: 2524, code: "FRY", name: "Eastern Slopes Regional Airport (FAA: IZG)" },
  { id: 2525, code: "FRZ", name: "Fritzlar Air Base" },
  { id: 2527, code: "FSC", name: "Figari–Sud Corse Airport" },
  { id: 2528, code: "FSD", name: "Sioux Falls Regional Airport (Joe Foss Field)" },
  { id: 2529, code: "FSI", name: "Henry Post Army Airfield (Fort Sill)" },
  { id: 2530, code: "FSK", name: "Fort Scott Municipal Airport" },
  { id: 2531, code: "FSL", name: "Fossil Downs Airport" },
  { id: 2532, code: "FSM", name: "Fort Smith Regional Airport" },
  { id: 2533, code: "FSP", name: "Saint-Pierre Airport" },
  { id: 2534, code: "FSS", name: "RAF Kinloss" },
  { id: 2535, code: "FST", name: "Fort Stockton–Pecos County Airport" },
  { id: 2536, code: "FSU", name: "Fort Sumner Municipal Airport" },
  { id: 2537, code: "FSZ", name: "Shizuoka Airport (Mt. Fuji Shizuoka Airport)" },
  { id: 2539, code: "FTA", name: "Futuna Airport" },
  { id: 2540, code: "FTE", name: "Comandante Armando Tola International Airport" },
  { id: 2541, code: "FTI", name: "Fitiuta Airport (FAA: FAQ)" },
  { id: 2542, code: "FTK", name: "Godman Army Airfield" },
  { id: 2543, code: "FTU", name: "Tôlanaro Airport (Marillac Airport)" },
  { id: 2544, code: "FTW", name: "Fort Worth Meacham International Airport" },
  { id: 2545, code: "FTX", name: "Owando Airport" },
  { id: 2546, code: "FTY", name: "Fulton County Airport (Charlie Brown Field)" },
  { id: 2548, code: "FUB", name: "Fulleborn Airport" },
  { id: 2549, code: "FUE", name: "Fuerteventura Airport" },
  { id: 2550, code: "FUG", name: "Fuyang Xiguan Airport" },
  { id: 2551, code: "FUJ", name: "Fukue Airport (Gotō-Fukue Airport)" },
  { id: 2552, code: "FUK", name: "Fukuoka Airport (Itazuke Air Base)" },
  { id: 2553, code: "FUL", name: "Fullerton Municipal Airport" },
  { id: 2554, code: "FUM", name: "Fuma Airport[1]" },
  { id: 2555, code: "FUN", name: "Funafuti International Airport" },
  { id: 2556, code: "FUO", name: "Foshan Shadi Airport" },
  { id: 2557, code: "FUT", name: "Pointe Vele Airport" },
  { id: 2559, code: "FVL", name: "Flora Valley Airport[1]" },
  { id: 2560, code: "FVM", name: "Fuvahmulah Airport" },
  { id: 2561, code: "FVR", name: "Forrest River Airport[1]" },
  { id: 2563, code: "FWA", name: "Fort Wayne International Airport" },
  { id: 2564, code: "FWH", name: "NAS Fort Worth JRB / Carswell Field (FAA: NFW)" },
  { id: 2565, code: "FWL", name: "Farewell Airport" },
  { id: 2567, code: "FXE", name: "Fort Lauderdale Executive Airport" },
  { id: 2568, code: "FXO", name: "Cuamba Airport" },
  { id: 2569, code: "FXY", name: "Forest City Municipal Airport" },
  { id: 2571, code: "FYJ", name: "Fuyuan Dongji Airport" },
  { id: 2572, code: "FYM", name: "Fayetteville Municipal Airport" },
  { id: 2573, code: "FYN", name: "Fuyun Koktokay Airport[1]" },
  { id: 2574, code: "FYT", name: "Faya-Largeau Airport" },
  { id: 2575, code: "FYU", name: "Fort Yukon Airport" },
  { id: 2576, code: "FYV", name: "Drake Field (Fayetteville Executive Airport)" },
  { id: 2578, code: "FZO", name: "Bristol Filton Airport" },
  { id: 2579, code: "FZL", name: "Fuzuli International Airport" },
  { id: 2581, code: "GAA", name: "Guamal Airport" },
  { id: 2582, code: "GAB", name: "Gabbs Airport" },
  { id: 2583, code: "GAC", name: "Gracias Airport" },
  { id: 2584, code: "GAD", name: "Northeast Alabama Regional Airport" },
  { id: 2585, code: "GAE", name: "Gabès – Matmata International Airport" },
  { id: 2586, code: "GAF", name: "Gafsa – Ksar International Airport" },
  { id: 2587, code: "GAG", name: "Gage Airport" },
  { id: 2588, code: "GAH", name: "Gayndah Airport" },
  { id: 2589, code: "GAI", name: "Montgomery County Airpark" },
  { id: 2590, code: "GAJ", name: "Yamagata Airport (Junmachi Airport)" },
  { id: 2591, code: "GAL", name: "Edward G. Pitka Sr. Airport" },
  { id: 2592, code: "GAM", name: "Gambell Airport" },
  { id: 2593, code: "GAN", name: "Gan International Airport" },
  { id: 2594, code: "GAO", name: "Mariana Grajales Airport" },
  { id: 2595, code: "GAP", name: "Gusap Airport" },
  { id: 2596, code: "GAQ", name: "Gao International Airport (Korogoussou Airport)" },
  { id: 2597, code: "GAR", name: "Garaina Airport" },
  { id: 2598, code: "GAS", name: "Garissa Airport" },
  { id: 2599, code: "GAT", name: "Gap–Tallard Airport" },
  { id: 2600, code: "GAU", name: "Lokpriya Gopinath Bordoloi International Airport" },
  { id: 2601, code: "GAV", name: "Gag Island Airport" },
  { id: 2602, code: "GAW", name: "Gangaw Airport" },
  { id: 2603, code: "GAX", name: "Gamba Airport" },
  { id: 2604, code: "GAY", name: "Gaya Airport (Bodhgaya Airport)" },
  { id: 2605, code: "GAZ", name: "Guasopa Airport" },
  { id: 2607, code: "GBA", name: "Cotswold Airport[1]" },
  { id: 2608, code: "GBB", name: "Qabala International Airport" },
  { id: 2609, code: "GBC", name: "Gasuke Airport" },
  { id: 2610, code: "GBD", name: "Great Bend Municipal Airport" },
  { id: 2611, code: "GBE", name: "Sir Seretse Khama International Airport" },
  { id: 2612, code: "GBF", name: "Negarbo Airport" },
  { id: 2613, code: "GBG", name: "Galesburg Municipal Airport" },
  { id: 2614, code: "GBH", name: "Galbraith Lake Airport" },
  { id: 2615, code: "GBI", name: "Kalaburagi Airport" },
  { id: 2616, code: "GBJ", name: "Marie-Galante Airport (Les Bases)" },
  { id: 2617, code: "GBK", name: "Gbangbatok Airport" },
  { id: 2618, code: "GBL", name: "South Goulburn Island Airport" },
  { id: 2619, code: "GBM", name: "Garbaharey Airport" },
  { id: 2620, code: "GBP", name: "Gamboola Airport" },
  { id: 2621, code: "GBR", name: "Walter J. Koladza Airport" },
  { id: 2622, code: "GBT", name: "Gorgan Airport[1]" },
  { id: 2623, code: "GBU", name: "Khashm el Girba Airport" },
  { id: 2624, code: "GBV", name: "Gibb River Airport" },
  { id: 2625, code: "GBW", name: "Ginbata Airport[1]" },
  { id: 2626, code: "GBZ", name: "Great Barrier Aerodrome" },
  { id: 2628, code: "GCA", name: "Guacamayas Airport" },
  { id: 2629, code: "GCC", name: "Gillette–Campbell County Airport" },
  { id: 2630, code: "GCD", name: "Grand Coulee Dam Airport[1] (FAA: 3W7)" },
  { id: 2631, code: "GCH", name: "Gachsaran Airport[1]" },
  { id: 2632, code: "GCI", name: "Guernsey Airport" },
  { id: 2633, code: "GCJ", name: "Grand Central Airport" },
  { id: 2634, code: "GCK", name: "Garden City Regional Airport" },
  { id: 2635, code: "GCM", name: "Owen Roberts International Airport" },
  { id: 2636, code: "GCN", name: "Grand Canyon National Park Airport" },
  { id: 2637, code: "GCT", name: "Grand Canyon Bar 10 Airport" },
  { id: 2638, code: "GCW", name: "Grand Canyon West Airport[1] (FAA: 1G4)" },
  { id: 2639, code: "GCY", name: "Greeneville–Greene County Municipal Airport" },
  { id: 2641, code: "GDA", name: "Gounda Airport" },
  { id: 2642, code: "GDC", name: "Donaldson Center Airport (FAA: GYH)" },
  { id: 2643, code: "GDD", name: "Gordon Downs Airport" },
  { id: 2644, code: "GDE", name: "Gode Airport" },
  { id: 2645, code: "GDG", name: "Magdagachi Airport" },
  { id: 2646, code: "GDH", name: "Golden Horn Lodge Seaplane Base (FAA: 3Z8)" },
  { id: 2647, code: "GDI", name: "Gordil Airport" },
  { id: 2648, code: "GDJ", name: "Gandajika Airport" },
  { id: 2649, code: "GDL", name: "Guadalajara International Airport (Miguel Hidalgo y Costilla Int'l)" },
  { id: 2650, code: "GDM", name: "Gardner Municipal Airport" },
  { id: 2651, code: "GDN", name: "Gdańsk Lech Wałęsa Airport" },
  { id: 2652, code: "GDO", name: "Guasdualito Airport (Vare Maria Airport)" },
  { id: 2653, code: "GDP", name: "Guadalupe Airport" },
  { id: 2654, code: "GDQ", name: "Gondar Airport (Atse Tewodros Airport)" },
  { id: 2655, code: "GDT", name: "JAGS McCartney International Airport (Grand Turk Int'l)" },
  { id: 2657, code: "GDV", name: "Dawson Community Airport" },
  { id: 2658, code: "GDW", name: "Gladwin Zettel Memorial Airport" },
  { id: 2659, code: "GDX", name: "Sokol Airport" },
  { id: 2660, code: "GDZ", name: "Gelendzhik Airport" },
  { id: 2662, code: "GEA", name: "Nouméa Magenta Airport" },
  { id: 2663, code: "GEB", name: "Gebe Airport" },
  { id: 2664, code: "GEC", name: "Geçitkale Air Base" },
  { id: 2665, code: "GED", name: "Delaware Coastal Airport" },
  { id: 2666, code: "GEE", name: "George Town Aerodrome" },
  { id: 2667, code: "GEF", name: "Geva Airport" },
  { id: 2668, code: "GEG", name: "Spokane International Airport" },
  { id: 2669, code: "GEL", name: "Sepé Tiaraju Airport" },
  { id: 2670, code: "GEM", name: "President Obiang Nguema International Airport[1]" },
  { id: 2671, code: "GEO", name: "Cheddi Jagan International Airport" },
  { id: 2672, code: "GER", name: "Rafael Cabrera Mustelier Airport" },
  { id: 2673, code: "GES", name: "General Santos International Airport (Tambler Airport)" },
  { id: 2674, code: "GET", name: "Geraldton Airport" },
  { id: 2675, code: "GEV", name: "Gällivare Airport" },
  { id: 2676, code: "GEW", name: "Gewoia Airport" },
  { id: 2677, code: "GEX", name: "Geelong Airport" },
  { id: 2678, code: "GEY", name: "South Big Horn County Airport" },
  { id: 2680, code: "GFD", name: "Pope Field" },
  { id: 2681, code: "GFE", name: "Grenfell Airport[1]" },
  { id: 2682, code: "GFF", name: "Griffith Airport" },
  { id: 2683, code: "GFK", name: "Grand Forks International Airport" },
  { id: 2684, code: "GFL", name: "Floyd Bennett Memorial Airport" },
  { id: 2685, code: "GFN", name: "Clarence Valley Regional Airport" },
  { id: 2686, code: "GFO", name: "Bartica Airport" },
  { id: 2687, code: "GFR", name: "Granville–Mont-Saint-Michel Aerodrome [fr]" },
  { id: 2688, code: "GFY", name: "Grootfontein Air Base" },
  { id: 2690, code: "GGB", name: "Água Boa Airport" },
  { id: 2691, code: "GGC", name: "Lumbala N'guimbo Airport" },
  { id: 2692, code: "GGD", name: "Gregory Downs Airport" },
  { id: 2693, code: "GGE", name: "Georgetown County Airport" },
  { id: 2694, code: "GGF", name: "Almeirim Airport" },
  { id: 2695, code: "GGG", name: "East Texas Regional Airport" },
  { id: 2696, code: "GGH", name: "Gastão Mesquita Airport" },
  { id: 2697, code: "GGJ", name: "Guaíra Airport" },
  { id: 2698, code: "GGL", name: "Gilgal Airport[1]" },
  { id: 2699, code: "GGM", name: "Kakamega Airport[1]" },
  { id: 2700, code: "GGN", name: "Gagnoa Airport" },
  { id: 2701, code: "GGO", name: "Guiglo Airport" },
  { id: 2702, code: "GGR", name: "Garowe International Airport" },
  { id: 2703, code: "GGS", name: "Gobernador Gregores Airport" },
  { id: 2704, code: "GGT", name: "Exuma International Airport" },
  { id: 2705, code: "GGW", name: "Glasgow Airport (Wokal Field)" },
  { id: 2707, code: "GHA", name: "Noumérat – Moufdi Zakaria Airport" },
  { id: 2708, code: "GHB", name: "Governor's Harbour Airport" },
  { id: 2709, code: "GHC", name: "Great Harbour Cay Airport" },
  { id: 2710, code: "GHE", name: "Garachiné Airport" },
  { id: 2711, code: "GHF", name: "Giebelstadt Airport" },
  { id: 2712, code: "GHK", name: "Gahcho Kue Aerodrome[1] (TC: CGK2)" },
  { id: 2713, code: "GHM", name: "Centerville Municipal Airport" },
  { id: 2714, code: "GHN", name: "Guanghan Airport" },
  { id: 2715, code: "GHS", name: "West Kutai Melalan Airport" },
  { id: 2716, code: "GHT", name: "Ghat Airport" },
  { id: 2717, code: "GHU", name: "Gualeguaychú Airport" },
  { id: 2718, code: "GHV", name: "Brașov-Ghimbav International Airport" },
  { id: 2720, code: "GIB", name: "Gibraltar International Airport (North Front Airport)" },
  { id: 2721, code: "GIC", name: "Boigu Island Airport" },
  { id: 2722, code: "GID", name: "Gitega Airport" },
  { id: 2723, code: "GIF", name: "Winter Haven's Gilbert Airport" },
  { id: 2724, code: "GIG", name: "Rio de Janeiro–Galeão International Airport" },
  { id: 2725, code: "GII", name: "Siguiri Airport" },
  { id: 2726, code: "GIL", name: "Gilgit Airport" },
  { id: 2727, code: "GIM", name: "Miele Mimbale Airport" },
  { id: 2728, code: "GIR", name: "Santiago Vila Airport" },
  { id: 2729, code: "GIS", name: "Gisborne Airport" },
  { id: 2730, code: "GIT", name: "Geita Airport" },
  { id: 2731, code: "GIU", name: "Sigiriya Airport[1]" },
  { id: 2732, code: "GIY", name: "Giyani Airport" },
  { id: 2733, code: "GIZ", name: "Jizan Regional Airport (King Abdullah bin Abdulaziz Airport)" },
  { id: 2735, code: "GJA", name: "Guanaja Airport" },
  { id: 2736, code: "GJL", name: "Jijel Ferhat Abbas Airport" },
  { id: 2737, code: "GJM", name: "Guajará-Mirim Airport" },
  { id: 2738, code: "GJR", name: "Gjögur Airport" },
  { id: 2739, code: "GJT", name: "Grand Junction Regional Airport (Walker Field)" },
  { id: 2741, code: "GKA", name: "Goroka Airport" },
  { id: 2742, code: "GKD", name: "Gökçeada Airport" },
  { id: 2743, code: "GKE", name: "NATO Air Base Geilenkirchen" },
  { id: 2744, code: "GKH", name: "Palungtar Airport" },
  { id: 2745, code: "GKK", name: "Kooddoo Airport[1]" },
  { id: 2746, code: "GKL", name: "Great Keppel Island Airport" },
  { id: 2747, code: "GKN", name: "Gulkana Airport" },
  { id: 2748, code: "GKO", name: "Kongo Boumba Airport" },
  { id: 2749, code: "GKT", name: "Gatlinburg–Pigeon Forge Airport" },
  { id: 2751, code: "GLA", name: "Glasgow Airport" },
  { id: 2752, code: "GLB", name: "San Carlos Apache Airport[1] (FAA: P13)" },
  { id: 2753, code: "GLC", name: "Geladi Airport" },
  { id: 2754, code: "GLD", name: "Goodland Municipal Airport (Renner Field)" },
  { id: 2755, code: "GLE", name: "Gainesville Municipal Airport" },
  { id: 2756, code: "GLF", name: "Golfito Airport" },
  { id: 2757, code: "GLG", name: "Glengyle Airport" },
  { id: 2758, code: "GLH", name: "Mid-Delta Regional Airport" },
  { id: 2759, code: "GLI", name: "Glen Innes Airport" },
  { id: 2760, code: "GLK", name: "Abdullahi Yusuf International Airport" },
  { id: 2761, code: "GLL", name: "Gol Airport, Klanten" },
  { id: 2762, code: "GLM", name: "Glenormiston Airport" },
  { id: 2763, code: "GLN", name: "Guelmim Airport" },
  { id: 2764, code: "GLO", name: "Gloucestershire Airport" },
  { id: 2765, code: "GLP", name: "Gulgubip Airport" },
  { id: 2766, code: "GLR", name: "Gaylord Regional Airport" },
  { id: 2767, code: "GLS", name: "Scholes International Airport at Galveston" },
  { id: 2768, code: "GLT", name: "Gladstone Airport" },
  { id: 2769, code: "GLU", name: "Gelephu Airport[1]" },
  { id: 2770, code: "GLV", name: "Golovin Airport" },
  { id: 2771, code: "GLW", name: "Glasgow Municipal Airport" },
  { id: 2772, code: "GLX", name: "Gamar Malamo Airport" },
  { id: 2773, code: "GLY", name: "Goldsworthy Airport" },
  { id: 2774, code: "GLZ", name: "Gilze-Rijen Air Base" },
  { id: 2776, code: "GMA", name: "Gemena Airport" },
  { id: 2777, code: "GMB", name: "Gambela Airport" },
  { id: 2778, code: "GMC", name: "Guerima Airport" },
  { id: 2779, code: "GMD", name: "Ben Slimane Airport[1]" },
  { id: 2780, code: "GME", name: "Gomel Airport" },
  { id: 2781, code: "GMI", name: "Gasmata Airport" },
  { id: 2782, code: "GMM", name: "Gamboma Airport" },
  { id: 2783, code: "GMN", name: "Greymouth Airport" },
  { id: 2784, code: "GMO", name: "Gombe Lawanti International Airport[1]" },
  { id: 2785, code: "GMP", name: "Gimpo International Airport" },
  { id: 2786, code: "GMQ", name: "Golog Maqin Airport[1]" },
  { id: 2787, code: "GMR", name: "Totegegie Airport (Gambier Island Airport)" },
  { id: 2788, code: "GMS", name: "Guimarães Airport" },
  { id: 2789, code: "GMT", name: "Granite Mountain Air Station (FAA: GSZ)" },
  { id: 2790, code: "GMU", name: "Greenville Downtown Airport" },
  { id: 2791, code: "GMV", name: "Monument Valley Airport (FAA: UT25)" },
  { id: 2792, code: "GMZ", name: "La Gomera Airport" },
  { id: 2794, code: "GNA", name: "Grodno Airport" },
  { id: 2795, code: "GNB", name: "Grenoble–Isère Airport" },
  { id: 2796, code: "GND", name: "Maurice Bishop International Airport" },
  { id: 2797, code: "GNF", name: "Gansner Field[1] (FAA: 2O1)" },
  { id: 2798, code: "GNG", name: "Gooding Municipal Airport" },
  { id: 2799, code: "GNI", name: "Lyudao Airport (Green Island Airport)" },
  { id: 2800, code: "GNJ", name: "Ganja International Airport" },
  { id: 2801, code: "GNM", name: "Guanambi Airport" },
  { id: 2802, code: "GNN", name: "Ginir Airport" },
  { id: 2803, code: "GNR", name: "Dr. Arturo Umberto Illia Airport" },
  { id: 2804, code: "GNS", name: "Binaka Airport" },
  { id: 2805, code: "GNT", name: "Grants-Milan Municipal Airport" },
  { id: 2806, code: "GNU", name: "Goodnews Airport" },
  { id: 2807, code: "GNV", name: "Gainesville Regional Airport" },
  { id: 2808, code: "GNY", name: "Şanlıurfa GAP Airport" },
  { id: 2809, code: "GNZ", name: "Ghanzi Airport" },
  { id: 2811, code: "GOA", name: "Genoa Cristoforo Colombo Airport" },
  { id: 2812, code: "GOB", name: "Robe Airport" },
  { id: 2813, code: "GOC", name: "Gora Airport" },
  { id: 2814, code: "GOE", name: "Gonaili Airstrip" },
  { id: 2815, code: "GOG", name: "Gobabis Airport" },
  { id: 2816, code: "GOH", name: "Nuuk Airport" },
  { id: 2817, code: "GOI", name: "Dabolim Airport" },
  { id: 2818, code: "GOJ", name: "Nizhny Novgorod International Airport (Strigino Airport)" },
  { id: 2819, code: "GOK", name: "Guthrie–Edmond Regional Airport" },
  { id: 2820, code: "GOL", name: "Gold Beach Municipal Airport (FAA: 4S1)" },
  { id: 2821, code: "GOM", name: "Goma International Airport" },
  { id: 2822, code: "GON", name: "Groton–New London Airport" },
  { id: 2823, code: "GOO", name: "Goondiwindi Airport" },
  { id: 2824, code: "GOP", name: "Gorakhpur Airport" },
  { id: 2825, code: "GOQ", name: "Golmud Airport" },
  { id: 2826, code: "GOR", name: "Gore Airport" },
  { id: 2827, code: "GOS", name: "Gosford Airport" },
  { id: 2828, code: "GOT", name: "Göteborg Landvetter Airport" },
  { id: 2829, code: "GOU", name: "Garoua International Airport" },
  { id: 2830, code: "GOV", name: "Gove Airport" },
  { id: 2831, code: "GOX", name: "Manohar International Airport" },
  { id: 2832, code: "GOZ", name: "Gorna Oryahovitsa Airport" },
  { id: 2834, code: "GPA", name: "Araxos Airport" },
  { id: 2835, code: "GPB", name: "Tancredo Thomas de Faria Airport" },
  { id: 2836, code: "GPD", name: "Mount Gordon Airport[1]" },
  { id: 2837, code: "GPI", name: "Guapi Airport (Juan Casiano Airport)" },
  { id: 2838, code: "GPL", name: "Guápiles Airport" },
  { id: 2839, code: "GPN", name: "Garden Point Airport" },
  { id: 2840, code: "GPO", name: "General Pico Airport" },
  { id: 2841, code: "GPS", name: "Seymour Airport" },
  { id: 2842, code: "GPT", name: "Gulfport–Biloxi International Airport" },
  { id: 2843, code: "GPZ", name: "Grand Rapids–Itasca County Airport (Gordon Newstrom Field)" },
  { id: 2845, code: "GQQ", name: "Galion Municipal Airport" },
  { id: 2847, code: "GRA", name: "Gamarra Airport" },
  { id: 2848, code: "GRB", name: "Austin Straubel International Airport" },
  { id: 2849, code: "GRC", name: "Grand Cess Airport" },
  { id: 2850, code: "GRD", name: "Greenwood County Airport" },
  { id: 2851, code: "GRE", name: "Greenville Airport" },
  { id: 2852, code: "GRF", name: "Gray Army Airfield" },
  { id: 2853, code: "GRG", name: "Gardez Airport" },
  { id: 2854, code: "GRH", name: "Garuahi Airport" },
  { id: 2855, code: "GRI", name: "Central Nebraska Regional Airport" },
  { id: 2856, code: "GRJ", name: "George Airport" },
  { id: 2857, code: "GRK", name: "Killeen Regional Airport / Robert Gray Army Airfield" },
  { id: 2858, code: "GRL", name: "Garasa Airport" },
  { id: 2859, code: "GRM", name: "Grand Marais/Cook County Airport (FAA: CKC)" },
  { id: 2860, code: "GRN", name: "Gordon Municipal Airport" },
  { id: 2861, code: "GRO", name: "Girona–Costa Brava Airport" },
  { id: 2862, code: "GRP", name: "Gurupi Airport" },
  { id: 2863, code: "GRQ", name: "Groningen Airport Eelde" },
  { id: 2864, code: "GRR", name: "Gerald R. Ford International Airport" },
  { id: 2865, code: "GRS", name: "Grosseto Airport" },
  { id: 2866, code: "GRT", name: "Gujrat Airport" },
  { id: 2867, code: "GRU", name: "São Paulo/Guarulhos–Governador André Franco Montoro International Airport" },
  { id: 2868, code: "GRV", name: "Grozny Airport" },
  { id: 2869, code: "GRW", name: "Graciosa Airport" },
  { id: 2870, code: "GRX", name: "Federico García Lorca Airport (Granada Jaén Airport)" },
  { id: 2871, code: "GRY", name: "Grímsey Airport" },
  { id: 2872, code: "GRZ", name: "Graz Airport" },
  { id: 2874, code: "GSA", name: "Long Pasia Airport" },
  { id: 2875, code: "GSB", name: "Seymour Johnson Air Force Base" },
  { id: 2876, code: "GSC", name: "Gascoyne Junction Airport" },
  { id: 2877, code: "GSE", name: "Göteborg City Airport" },
  { id: 2878, code: "GSH", name: "Goshen Municipal Airport" },
  { id: 2879, code: "GSI", name: "Grand-Santi Airport[1]" },
  { id: 2880, code: "GSJ", name: "San José Airport[1]" },
  { id: 2881, code: "GSL", name: "Taltheilei Narrows Airport[1] (TC: CFA7)" },
  { id: 2882, code: "GSM", name: "Dayrestan Airport (Qeshm International Airport)" },
  { id: 2883, code: "GSN", name: "Mount Gunson Airport" },
  { id: 2884, code: "GSO", name: "Piedmont Triad International Airport" },
  { id: 2885, code: "GSP", name: "Greenville–Spartanburg International Airport" },
  { id: 2886, code: "GSQ", name: "Sharq Al-Owainat Airport" },
  { id: 2887, code: "GSR", name: "Qardho Airport" },
  { id: 2888, code: "GSS", name: "Sabi Sabi Airport" },
  { id: 2889, code: "GST", name: "Gustavus Airport" },
  { id: 2890, code: "GSU", name: "Azaza Airport" },
  { id: 2891, code: "GSV", name: "Saratov Gagarin Airport" },
  { id: 2893, code: "GTA", name: "Gatokae Aerodrome" },
  { id: 2894, code: "GTE", name: "Groote Eylandt Airport" },
  { id: 2895, code: "GTF", name: "Great Falls International Airport" },
  { id: 2896, code: "GTG", name: "Grantsburg Municipal Airport" },
  { id: 2897, code: "GTI", name: "Rügen Airport (Güttin Airfield)" },
  { id: 2898, code: "GTN", name: "Glentanner Aerodrome" },
  { id: 2899, code: "GTO", name: "Jalaluddin Airport" },
  { id: 2900, code: "GTP", name: "Grants Pass Airport[1] (FAA: 3S8)" },
  { id: 2901, code: "GTR", name: "Golden Triangle Regional Airport" },
  { id: 2902, code: "GTS", name: "The Granites Airport" },
  { id: 2903, code: "GTT", name: "Georgetown Airport" },
  { id: 2904, code: "GTW", name: "Holešov Airport" },
  { id: 2905, code: "GTY", name: "Gettysburg Regional Airport (FAA: W05)" },
  { id: 2906, code: "GTZ", name: "Kirawira B Airstrip[1]" },
  { id: 2908, code: "GUA", name: "La Aurora International Airport" },
  { id: 2909, code: "GUB", name: "Guerrero Negro Airport" },
  { id: 2910, code: "GUC", name: "Gunnison–Crested Butte Regional Airport" },
  { id: 2911, code: "GUD", name: "Goundam Airport" },
  { id: 2912, code: "GUE", name: "Guriaso Airport" },
  { id: 2913, code: "GUF", name: "Jack Edwards Airport (FAA: JKA)" },
  { id: 2914, code: "GUG", name: "Guari Airport" },
  { id: 2915, code: "GUH", name: "Gunnedah Airport" },
  { id: 2916, code: "GUI", name: "Güiria Airport" },
  { id: 2917, code: "GUJ", name: "Guaratinguetá Airport" },
  { id: 2918, code: "GUL", name: "Goulburn Airport" },
  { id: 2919, code: "GUM", name: "Antonio B. Won Pat International Airport (Guam Int'l)" },
  { id: 2920, code: "GUP", name: "Gallup Municipal Airport" },
  { id: 2921, code: "GUQ", name: "Guanare Airport" },
  { id: 2922, code: "GUR", name: "Gurney Airport" },
  { id: 2923, code: "GUS", name: "Grissom Air Reserve Base" },
  { id: 2924, code: "GUT", name: "RAF Gütersloh" },
  { id: 2925, code: "GUU", name: "Grundarfjörður Airport" },
  { id: 2926, code: "GUV", name: "Mougulu Airport" },
  { id: 2927, code: "GUW", name: "Atyrau Airport" },
  { id: 2928, code: "GUX", name: "Guna Airport" },
  { id: 2929, code: "GUY", name: "Guymon Municipal Airport" },
  { id: 2930, code: "GUZ", name: "Guarapari Airport" },
  { id: 2932, code: "GVA", name: "Geneva Airport" },
  { id: 2933, code: "GVE", name: "Gordonsville Municipal Airport" },
  { id: 2934, code: "GVI", name: "Green River Airport" },
  { id: 2935, code: "GVL", name: "Lee Gilmer Memorial Airport" },
  { id: 2936, code: "GVN", name: "Sovetskaya Gavan Airport[1]" },
  { id: 2937, code: "GVP", name: "Greenvale Airport" },
  { id: 2938, code: "GVR", name: "Coronel Altino Machado de Oliveira Airport" },
  { id: 2939, code: "GVT", name: "Majors Airport" },
  { id: 2940, code: "GVX", name: "Gävle-Sandviken Airport" },
  { id: 2942, code: "GWA", name: "Gwa Airport" },
  { id: 2943, code: "GWD", name: "Gwadar International Airport" },
  { id: 2944, code: "GWE", name: "Thornhill Air Base" },
  { id: 2945, code: "GWL", name: "Rajmata Vijaya Raje Scindia Airport (Gwalior Airport)" },
  { id: 2946, code: "GWN", name: "Gnarowein Airport" },
  { id: 2947, code: "GWO", name: "Greenwood–Leflore Airport" },
  { id: 2948, code: "GWS", name: "Glenwood Springs Municipal Airport" },
  { id: 2949, code: "GWT", name: "Sylt Airport (Westerland Airport)" },
  { id: 2950, code: "GWV", name: "Glendale Fokker Field (FAA: WV66)" },
  { id: 2951, code: "GWY", name: "Galway Airport" },
  { id: 2953, code: "GXA", name: "Beringin Airport" },
  { id: 2954, code: "GXF", name: "Sayun Airport" },
  { id: 2955, code: "GXG", name: "Negage Airport" },
  { id: 2956, code: "GXH", name: "Gannan Xiahe Airport" },
  { id: 2957, code: "GXQ", name: "Teniente Vidal Airfield" },
  { id: 2958, code: "GXX", name: "Yagoua Airport" },
  { id: 2959, code: "GXY", name: "Greeley–Weld County Airport" },
  { id: 2961, code: "GYA", name: "Guayaramerín Airport" },
  { id: 2962, code: "GYD", name: "Heydar Aliyev International Airport" },
  { id: 2963, code: "GYE", name: "José Joaquín de Olmedo International Airport" },
  { id: 2964, code: "GYG", name: "Magan Airport" },
  { id: 2965, code: "GYI", name: "Gisenyi Airport" },
  { id: 2966, code: "GYL", name: "Argyle Airport" },
  { id: 2967, code: "GYM", name: "General José María Yáñez International Airport" },
  { id: 2968, code: "GYN", name: "Santa Genoveva Airport" },
  { id: 2969, code: "GYP", name: "Gympie Airport" },
  { id: 2970, code: "GYR", name: "Phoenix Goodyear Airport" },
  { id: 2971, code: "GYS", name: "Guangyuan Panlong Airport" },
  { id: 2972, code: "GYU", name: "Guyuan Liupanshan Airport[1]" },
  { id: 2973, code: "GYZ", name: "Gruyere Airport" },
  { id: 2975, code: "GZA", name: "Yasser Arafat International Airport" },
  { id: 2976, code: "GZG", name: "Garze Gesar Airport" },
  { id: 2977, code: "GZI", name: "Ghazni Airport" },
  { id: 2978, code: "GZO", name: "Nusatupe Airport" },
  { id: 2979, code: "GZP", name: "Gazipaşa–Alanya Airport[1]" },
  { id: 2980, code: "GZT", name: "Gaziantep Oğuzeli International Airport" },
  { id: 2981, code: "GZW", name: "Qazvin Airport[1]" },
  { id: 2984, code: "HAA", name: "Hasvik Airport" },
  { id: 2985, code: "HAB", name: "Marion County – Rankin Fite Airport" },
  { id: 2986, code: "HAC", name: "Hachijojima Airport" },
  { id: 2987, code: "HAD", name: "Halmstad Airport (Halmstad City Airport)" },
  { id: 2988, code: "HAF", name: "Half Moon Bay Airport" },
  { id: 2989, code: "HAH", name: "Prince Said Ibrahim International Airport" },
  { id: 2990, code: "HAI", name: "Three Rivers Municipal Airport (Dr. Haines Flying Field)" },
  { id: 2991, code: "HAJ", name: "Hannover Airport" },
  { id: 2992, code: "HAK", name: "Haikou Meilan International Airport" },
  { id: 2993, code: "HAL", name: "Halali Airport" },
  { id: 2994, code: "HAM", name: "Hamburg Airport" },
  { id: 2995, code: "HAN", name: "Noi Bai International Airport" },
  { id: 2996, code: "HAO", name: "Butler County Regional Airport" },
  { id: 2997, code: "HAQ", name: "Hanimaadhoo International Airport" },
  { id: 2998, code: "HAR", name: "Capital City Airport (FAA: CXY)" },
  { id: 2999, code: "HAS", name: "Ha'il Regional Airport" },
  { id: 3000, code: "HAT", name: "Heathlands Airport" },
  { id: 3001, code: "HAU", name: "Haugesund Airport, Karmøy" },
  { id: 3002, code: "HAV", name: "José Martí International Airport" },
  { id: 3003, code: "HAW", name: "Haverfordwest Aerodrome" },
  { id: 3004, code: "HAY", name: "Hacaritama Airport" },
  { id: 3005, code: "HAZ", name: "Hatzfeldthaven Airport" },
  { id: 3007, code: "HBA", name: "Hobart Airport" },
  { id: 3008, code: "HBB", name: "Hobbs Industrial Airpark" },
  { id: 3009, code: "HBD", name: "Habi Airport" },
  { id: 3010, code: "HBE", name: "Borg El Arab International Airport" },
  { id: 3011, code: "HBG", name: "Hattiesburg Bobby L. Chain Municipal Airport" },
  { id: 3012, code: "HBH", name: "Entrance Island Seaplane Base (Hobart Bay) (FAA: 2Z1)" },
  { id: 3013, code: "HBK", name: "Holbrook Municipal Airport[1] (FAA: P14)" },
  { id: 3014, code: "HBQ", name: "Qilian Airport" },
  { id: 3015, code: "HBR", name: "Hobart Regional Airport" },
  { id: 3016, code: "HBT", name: "Hambantota Sea Plane Base" },
  { id: 3017, code: "HBU", name: "Bulgan Airport, Khovd[1]" },
  { id: 3018, code: "HBX", name: "Hubli Airport" },
  { id: 3020, code: "HCA", name: "Big Spring McMahon–Wrinkle Airport[1] (FAA: BPG)" },
  { id: 3021, code: "HCC", name: "Columbia County Airport (FAA: 1B1)" },
  { id: 3022, code: "HCJ", name: "Hechi Jinchengjiang Airport" },
  { id: 3023, code: "HCM", name: "Eyl Airport" },
  { id: 3024, code: "HCN", name: "Hengchun Airport" },
  { id: 3025, code: "HCQ", name: "Halls Creek Airport" },
  { id: 3026, code: "HCR", name: "Holy Cross Airport (FAA: HCA)" },
  { id: 3027, code: "HCW", name: "Cheraw Municipal Airport (Lynch Bellinger Field, FAA: CQW)" },
  { id: 3028, code: "HCZ", name: "Chenzhou Beihu Airport" },
  { id: 3030, code: "HDB", name: "Heidelberg Airport" },
  { id: 3031, code: "HDD", name: "Hyderabad Airport" },
  { id: 3032, code: "HDE", name: "Brewster Field" },
  { id: 3033, code: "HDF", name: "Heringsdorf Airport" },
  { id: 3034, code: "HDG", name: "Handan Airport" },
  { id: 3035, code: "HDH", name: "Dillingham Airfield" },
  { id: 3036, code: "HDK", name: "Kulhudhuffushi Airport" },
  { id: 3037, code: "HDM", name: "Hamadan Airport" },
  { id: 3038, code: "HDN", name: "Yampa Valley Airport" },
  { id: 3039, code: "HDO", name: "Hindon Airport" },
  { id: 3040, code: "HDR", name: "Havadarya Airport[1]" },
  { id: 3041, code: "HDS", name: "Air Force Base Hoedspruit" },
  { id: 3042, code: "HDY", name: "Hat Yai International Airport" },
  { id: 3044, code: "HEA", name: "Herat International Airport" },
  { id: 3045, code: "HEB", name: "Hinthada Airport" },
  { id: 3046, code: "HED", name: "Herendeen Bay Airport (FAA: AK33)" },
  { id: 3047, code: "HEE", name: "Thompson–Robbins Airport" },
  { id: 3048, code: "HEH", name: "Heho Airport" },
  { id: 3049, code: "HEI", name: "Heide–Büsum Airport" },
  { id: 3050, code: "HEK", name: "Heihe Airport" },
  { id: 3051, code: "HEL", name: "Helsinki Airport (Helsinki-Vantaa Airport)" },
  { id: 3052, code: "HEM", name: "Helsinki-Malmi Airport" },
  { id: 3053, code: "HEO", name: "Haelogo Airport" },
  { id: 3054, code: "HER", name: "Heraklion International Airport (Nikos Kazantzakis Airport)" },
  { id: 3055, code: "HES", name: "Hermiston Municipal Airport (FAA: HRI)" },
  { id: 3056, code: "HET", name: "Hohhot Baita International Airport" },
  { id: 3057, code: "HEZ", name: "Natchez–Adams County Airport (Hardy–Anders Field)" },
  { id: 3059, code: "HFA", name: "Haifa Airport (Uri Michaeli Airport)" },
  { id: 3060, code: "HFD", name: "Hartford–Brainard Airport" },
  { id: 3061, code: "HFE", name: "Hefei Xinqiao International Airport (formerly Hefei Luogang International Airport)" },
  { id: 3062, code: "HFF", name: "Mackall Army Airfield" },
  { id: 3063, code: "HFN", name: "Hornafjörður Airport" },
  { id: 3064, code: "HFS", name: "Hagfors Airport" },
  { id: 3065, code: "HFT", name: "Hammerfest Airport" },
  { id: 3067, code: "HGA", name: "Hargeisa International Airport (Egal Int'l)" },
  { id: 3068, code: "HGD", name: "Hughenden Airport" },
  { id: 3069, code: "HGE", name: "Higuerote Airport[1]" },
  { id: 3070, code: "HGH", name: "Hangzhou Xiaoshan International Airport" },
  { id: 3071, code: "HGI", name: "Paloich Airport[1]" },
  { id: 3072, code: "HGL", name: "Heligoland Airfield" },
  { id: 3073, code: "HGN", name: "Mae Hong Son Airport" },
  { id: 3074, code: "HGO", name: "Korhogo Airport" },
  { id: 3075, code: "HGR", name: "Hagerstown Regional Airport (Richard A. Henson Field)" },
  { id: 3076, code: "HGS", name: "Hastings Airport" },
  { id: 3077, code: "HGU", name: "Mount Hagen Airport" },
  { id: 3078, code: "HGZ", name: "Hog River Airport (FAA: 2AK6)" },
  { id: 3080, code: "HHE", name: "JMSDF Hachinohe Air Base" },
  { id: 3081, code: "HHH", name: "Hilton Head Airport (FAA: HXD)" },
  { id: 3082, code: "HHI", name: "Wheeler Army Airfield" },
  { id: 3083, code: "HHN", name: "Frankfurt–Hahn Airport" },
  { id: 3084, code: "HHQ", name: "Hua Hin Airport" },
  { id: 3085, code: "HHR", name: "Hawthorne Municipal Airport (Jack Northrop Field)" },
  { id: 3086, code: "HHZ", name: "Hikueru Airport" },
  { id: 3088, code: "HIA", name: "Huai'an Lianshui Airport" },
  { id: 3089, code: "HIB", name: "Range Regional Airport" },
  { id: 3090, code: "HID", name: "Horn Island Airport" },
  { id: 3091, code: "HIE", name: "Mount Washington Regional Airport" },
  { id: 3092, code: "HIF", name: "Hill Air Force Base" },
  { id: 3093, code: "HIG", name: "Highbury Airport" },
  { id: 3094, code: "HII", name: "Lake Havasu City Airport" },
  { id: 3095, code: "HIJ", name: "Hiroshima Airport" },
  { id: 3096, code: "HIL", name: "Shilavo Airport" },
  { id: 3097, code: "HIM", name: "Hingurakgoda Airport (Minneriya Airport)" },
  { id: 3098, code: "HIN", name: "Sacheon Airport" },
  { id: 3099, code: "HIO", name: "Hillsboro Airport (Portland–Hillsboro Airport)" },
  { id: 3100, code: "HIP", name: "Headingly Airport" },
  { id: 3101, code: "HIR", name: "Honiara International Airport" },
  { id: 3102, code: "HIT", name: "Haivaro Airport" },
  { id: 3103, code: "HIW", name: "Hiroshima–Nishi Airport" },
  { id: 3105, code: "HJJ", name: "Huaihua Zhijiang Airport" },
  { id: 3106, code: "HJR", name: "Civil Aerodrome Khajuraho" },
  { id: 3107, code: "HJT", name: "Khujirt Airport" },
  { id: 3109, code: "HKA", name: "Blytheville Municipal Airport" },
  { id: 3110, code: "HKB", name: "Healy Lake Airport" },
  { id: 3111, code: "HKD", name: "Hakodate Airport" },
  { id: 3112, code: "HKG", name: "Hong Kong International Airport (Chek Lap Kok Airport)" },
  { id: 3113, code: "HKK", name: "Hokitika Airport" },
  { id: 3114, code: "HKN", name: "Hoskins Airport" },
  { id: 3115, code: "HKS", name: "Hawkins Field" },
  { id: 3116, code: "HKT", name: "Phuket International Airport" },
  { id: 3117, code: "HKV", name: "Haskovo Malevo Airport" },
  { id: 3118, code: "HKY", name: "Hickory Regional Airport" },
  { id: 3120, code: "HLA", name: "Lanseria International Airport" },
  { id: 3121, code: "HLB", name: "Hillenbrand Industries Airport" },
  { id: 3122, code: "HLC", name: "Hill City Municipal Airport" },
  { id: 3123, code: "HLD", name: "Hulunbuir Hailar Airport" },
  { id: 3124, code: "HLE", name: "Saint Helena Airport" },
  { id: 3126, code: "HLF", name: "Hultsfred-Vimmerby Airport" },
  { id: 3127, code: "HLG", name: "Wheeling Ohio County Airport" },
  { id: 3128, code: "HLH", name: "Ulanhot Airport" },
  { id: 3129, code: "HLI", name: "Hollister Municipal Airport (FAA: CVH)" },
  { id: 3130, code: "HLL", name: "Hillside Airport" },
  { id: 3131, code: "HLM", name: "Park Township Airport" },
  { id: 3132, code: "HLN", name: "Helena Regional Airport" },
  { id: 3133, code: "HLP", name: "Halim Perdanakusuma International Airport" },
  { id: 3134, code: "HLR", name: "Yoakum–DeFrenn Army Heliport" },
  { id: 3135, code: "HLS", name: "St Helens Airport" },
  { id: 3136, code: "HLT", name: "Hamilton Airport" },
  { id: 3137, code: "HLV", name: "Helenvale Airport" },
  { id: 3138, code: "HLW", name: "Hluhluwe Airport" },
  { id: 3139, code: "HLZ", name: "Hamilton Airport" },
  { id: 3141, code: "HMA", name: "Khanty-Mansiysk Airport" },
  { id: 3142, code: "HMB", name: "Sohag International Airport[1]" },
  { id: 3143, code: "HME", name: "Oued Irara–Krim Belkacem Airport" },
  { id: 3144, code: "HMG", name: "Hermannsburg Airport" },
  { id: 3145, code: "HMI", name: "Hami Airport (Kumul Airport)" },
  { id: 3146, code: "HMJ", name: "Khmelnytskyi Airport" },
  { id: 3147, code: "HMN", name: "Holloman Air Force Base" },
  { id: 3148, code: "HMO", name: "General Ignacio Pesqueira García International Airport" },
  { id: 3149, code: "HMR", name: "Hamar Airport, Stafsberg" },
  { id: 3150, code: "HMT", name: "Hemet-Ryan Airport" },
  { id: 3151, code: "HMV", name: "Hemavan Tärnaby Airport" },
  { id: 3152, code: "HMY", name: "Seosan Air Base[1]" },
  { id: 3154, code: "HNA", name: "Hanamaki Airport" },
  { id: 3155, code: "HNB", name: "Huntingburg Airport" },
  { id: 3156, code: "HNC", name: "Billy Mitchell Airport (FAA: HSE)" },
  { id: 3157, code: "HND", name: "Haneda Airport" },
  { id: 3158, code: "HNH", name: "Hoonah Airport" },
  { id: 3159, code: "HNI", name: "Heiweni Airport" },
  { id: 3160, code: "HNL", name: "Honolulu International Airport" },
  { id: 3161, code: "HNM", name: "Hana Airport" },
  { id: 3162, code: "HNN", name: "Honinabi Airport" },
  { id: 3163, code: "HNS", name: "Haines Airport" },
  { id: 3164, code: "HNY", name: "Hengyang Nanyue Airport" },
  { id: 3166, code: "HOA", name: "Hola Airport" },
  { id: 3167, code: "HOB", name: "Lea County Regional Airport" },
  { id: 3168, code: "HOC", name: "Komako Airport" },
  { id: 3169, code: "HOD", name: "Hodeida International Airport" },
  { id: 3170, code: "HOE", name: "Ban Huoeisay Airport" },
  { id: 3171, code: "HOF", name: "Al-Ahsa International Airport" },
  { id: 3172, code: "HOG", name: "Frank País Airport" },
  { id: 3173, code: "HOH", name: "Hohenems-Dornbirn Airport" },
  { id: 3174, code: "HOI", name: "Hao Airport" },
  { id: 3175, code: "HOK", name: "Hooker Creek Airport" },
  { id: 3176, code: "HOM", name: "Homer Airport" },
  { id: 3177, code: "HON", name: "Huron Regional Airport" },
  { id: 3178, code: "HOO", name: "Nhon Co Airport" },
  { id: 3179, code: "HOP", name: "Campbell Army Airfield" },
  { id: 3180, code: "HOQ", name: "Hof–Plauen Airport" },
  { id: 3181, code: "HOR", name: "Horta Airport" },
  { id: 3182, code: "HOS", name: "Chos Malal Airport" },
  { id: 3183, code: "HOT", name: "Memorial Field Airport" },
  { id: 3184, code: "HOU", name: "William P. Hobby Airport" },
  { id: 3185, code: "HOV", name: "Ørsta–Volda Airport, Hovden" },
  { id: 3186, code: "HOX", name: "Homalin Airport" },
  { id: 3187, code: "HOY", name: "Hoy Island Airport" },
  { id: 3189, code: "HPA", name: "Lifuka Island Airport (Salote Pilolevu Airport)" },
  { id: 3190, code: "HPB", name: "Hooper Bay Airport" },
  { id: 3191, code: "HPE", name: "Hopevale Airport" },
  { id: 3192, code: "HPG", name: "Shennongjia Hongping Airport" },
  { id: 3193, code: "HPH", name: "Cat Bi International Airport" },
  { id: 3194, code: "HPN", name: "Westchester County Airport" },
  { id: 3195, code: "HPT", name: "Hampton Municipal Airport" },
  { id: 3196, code: "HPV", name: "Princeville Airport (FAA: HI01)" },
  { id: 3197, code: "HPY", name: "Baytown Airport" },
  { id: 3199, code: "HQM", name: "Bowerman Airport" },
  { id: 3201, code: "HRB", name: "Harbin Taiping International Airport" },
  { id: 3202, code: "HRC", name: "Zhayrem Airport" },
  { id: 3203, code: "HRE", name: "Harare International Airport" },
  { id: 3204, code: "HRG", name: "Hurghada International Airport" },
  { id: 3205, code: "HRI", name: "Mattala Rajapaksa International Airport" },
  { id: 3206, code: "HRK", name: "Kharkiv International Airport (Osnova Airport)" },
  { id: 3207, code: "HRL", name: "Valley International Airport" },
  { id: 3208, code: "HRM", name: "Hassi R'Mel Airport (Tilrempt Airport)" },
  { id: 3209, code: "HRO", name: "Boone County Airport" },
  { id: 3210, code: "HRR", name: "La Herrera Airport" },
  { id: 3211, code: "HRS", name: "Harrismith Airport" },
  { id: 3212, code: "HRT", name: "RAF Linton-on-Ouse" },
  { id: 3213, code: "HRY", name: "Henbury Airport" },
  { id: 3214, code: "HRZ", name: "Horizontina Airport" },
  { id: 3216, code: "HSA", name: "Hazret Sultan International Airport" },
  { id: 3217, code: "HSB", name: "Harrisburg-Raleigh Airport" },
  { id: 3218, code: "HSC", name: "Shaoguan Guitou Airport" },
  { id: 3219, code: "HSG", name: "Saga Airport" },
  { id: 3220, code: "HSH", name: "Henderson Executive Airport (FAA: HND)" },
  { id: 3221, code: "HSI", name: "Hastings Municipal Airport" },
  { id: 3222, code: "HSJ", name: "Zhengzhou Shangjie Airport[1]" },
  { id: 3223, code: "HSK", name: "Huesca–Pirineos Airport" },
  { id: 3224, code: "HSL", name: "Huslia Airport (FAA: HLA)" },
  { id: 3225, code: "HSM", name: "Horsham Airport" },
  { id: 3226, code: "HSN", name: "Zhoushan Putuoshan Airport" },
  { id: 3227, code: "HSP", name: "Ingalls Field" },
  { id: 3228, code: "HSR", name: "Rajkot International Airport" },
  { id: 3229, code: "HSS", name: "Hisar Airport" },
  { id: 3230, code: "HST", name: "Homestead Air Reserve Base" },
  { id: 3231, code: "HSV", name: "Huntsville International Airport (Carl T. Jones Field)" },
  { id: 3232, code: "HSZ", name: "Hsinchu Air Base" },
  { id: 3234, code: "HTA", name: "Chita International Airport (Kadala Airport)" },
  { id: 3235, code: "HTG", name: "Khatanga Airport" },
  { id: 3236, code: "HTH", name: "Hawthorne Industrial Airport" },
  { id: 3237, code: "HTI", name: "Hamilton Island Airport" },
  { id: 3238, code: "HTL", name: "Roscommon County–Blodgett Memorial Airport" },
  { id: 3239, code: "HTM", name: "Khatgal Airport[1]" },
  { id: 3240, code: "HTN", name: "Hotan Airport" },
  { id: 3241, code: "HTO", name: "East Hampton Airport" },
  { id: 3242, code: "HTR", name: "Hateruma Airport" },
  { id: 3243, code: "HTS", name: "Tri-State Airport (Milton J. Ferguson Field)" },
  { id: 3244, code: "HTT", name: "Huatugou Airport" },
  { id: 3245, code: "HTU", name: "Hopetoun Airport" },
  { id: 3246, code: "HTV", name: "Huntsville Municipal Airport (Bruce Brothers Regional)" },
  { id: 3247, code: "HTW", name: "Lawrence County Airpark" },
  { id: 3248, code: "HTY", name: "Hatay Airport" },
  { id: 3249, code: "HTZ", name: "Hato Corozal Airport" },
  { id: 3251, code: "HUA", name: "Redstone Army Airfield" },
  { id: 3252, code: "HUB", name: "Humbert River Airport" },
  { id: 3253, code: "HUC", name: "Humacao Airport" },
  { id: 3254, code: "HUD", name: "Humboldt Municipal Airport (FAA: 0K7)" },
  { id: 3255, code: "HUE", name: "Humera Airport" },
  { id: 3256, code: "HUF", name: "Terre Haute International Airport (Hulman Field)" },
  { id: 3257, code: "HUG", name: "Huehuetenango Airport" },
  { id: 3258, code: "HUH", name: "Huahine – Fare Airport" },
  { id: 3259, code: "HUI", name: "Phu Bai International Airport" },
  { id: 3260, code: "HUJ", name: "Stan Stamper Municipal Airport (FAA: HHW)" },
  { id: 3261, code: "HUK", name: "Hukuntsi Airport" },
  { id: 3262, code: "HUL", name: "Houlton International Airport" },
  { id: 3265, code: "HUM", name: "Houma–Terrebonne Airport" },
  { id: 3266, code: "HUN", name: "Hualien Airport" },
  { id: 3267, code: "HUO", name: "Holingol Huolinhe Airport[1]" },
  { id: 3268, code: "HUQ", name: "Hun Airport" },
  { id: 3269, code: "HUS", name: "Hughes Airport" },
  { id: 3270, code: "HUT", name: "Hutchinson Municipal Airport" },
  { id: 3271, code: "HUU", name: "Alférez FAP David Figueroa Fernandini Airport" },
  { id: 3272, code: "HUV", name: "Hudiksvall Airport" },
  { id: 3273, code: "HUW", name: "Francisco Correa da Cruz Airport[1]" },
  { id: 3274, code: "HUX", name: "Bahías de Huatulco International Airport" },
  { id: 3275, code: "HUY", name: "Humberside Airport" },
  { id: 3276, code: "HUZ", name: "Huizhou Pingtan Airport" },
  { id: 3278, code: "HVA", name: "Analalava Airport" },
  { id: 3279, code: "HVB", name: "Hervey Bay Airport" },
  { id: 3280, code: "HVD", name: "Khovd Airport" },
  { id: 3281, code: "HVE", name: "Hanksville Airport" },
  { id: 3282, code: "HVG", name: "Honningsvåg Airport, Valan" },
  { id: 3283, code: "HVK", name: "Hólmavík Airport" },
  { id: 3284, code: "HVN", name: "Tweed New Haven Airport" },
  { id: 3285, code: "HVR", name: "Havre City–County Airport" },
  { id: 3286, code: "HVS", name: "Hartsville Regional Airport" },
  { id: 3288, code: "HWA", name: "Hawabango Airport" },
  { id: 3289, code: "HWD", name: "Hayward Executive Airport" },
  { id: 3290, code: "HWI", name: "Hawk Inlet Seaplane Base" },
  { id: 3291, code: "HWK", name: "Wilpena Pound Airport" },
  { id: 3292, code: "HWN", name: "Hwange National Park Airport" },
  { id: 3293, code: "HWO", name: "North Perry Airport" },
  { id: 3295, code: "HXD", name: "Delingha Airport" },
  { id: 3296, code: "HXX", name: "Hay Airport" },
  { id: 3298, code: "HYA", name: "Barnstable Municipal Airport (Boardman/Polando Field)" },
  { id: 3299, code: "HYC", name: "Wycombe Air Park" },
  { id: 3300, code: "HYD", name: "Rajiv Gandhi International Airport" },
  { id: 3301, code: "HYF", name: "Hayfields Airport" },
  { id: 3302, code: "HYG", name: "Hydaburg Seaplane Base" },
  { id: 3303, code: "HYL", name: "Hollis Clark Bay Seaplane Base" },
  { id: 3304, code: "HYN", name: "Taizhou Luqiao Airport" },
  { id: 3305, code: "HYR", name: "Sawyer County Airport" },
  { id: 3306, code: "HYS", name: "Hays Regional Airport" },
  { id: 3307, code: "HYV", name: "Hyvinkää Airfield" },
  { id: 3309, code: "HZA", name: "Heze Mudan Airport" },
  { id: 3310, code: "HZB", name: "Merville–Calonne Airport" },
  { id: 3311, code: "HZG", name: "Hanzhong Chenggu Airport" },
  { id: 3312, code: "HZH", name: "Liping Airport" },
  { id: 3313, code: "HZK", name: "Húsavík Airport" },
  { id: 3314, code: "HZL", name: "Hazleton Municipal Airport" },
  { id: 3315, code: "HZP", name: "Fort MacKay/Horizon Airport[1]" },
  { id: 3316, code: "HZU", name: "Chengdu Huaizhou Airport" },
  { id: 3317, code: "HZV", name: "Hazyview Airport" },
  { id: 3319, code: "IAA", name: "Igarka Airport" },
  { id: 3320, code: "IAB", name: "McConnell Air Force Base" },
  { id: 3321, code: "IAD", name: "Washington Dulles International Airport" },
  { id: 3322, code: "IAG", name: "Niagara Falls International Airport" },
  { id: 3323, code: "IAH", name: "George Bush Intercontinental Airport" },
  { id: 3324, code: "IAM", name: "In Amenas Airport (Zarzaitine Airport)" },
  { id: 3325, code: "IAN", name: "Bob Baker Memorial Airport" },
  { id: 3326, code: "IAO", name: "Sayak Airport[1] (Siargao Airport)" },
  { id: 3327, code: "IAQ", name: "Bahregan Airport" },
  { id: 3328, code: "IAR", name: "Tunoshna Airport" },
  { id: 3329, code: "IAS", name: "Iași International Airport" },
  { id: 3330, code: "IAU", name: "Iaura Airport" },
  { id: 3332, code: "IBA", name: "Ibadan Airport" },
  { id: 3333, code: "IBB", name: "General Villamil Airport[1]" },
  { id: 3334, code: "IBE", name: "Perales Airport" },
  { id: 3335, code: "IBI", name: "Iboki Airport" },
  { id: 3336, code: "IBL", name: "Indigo Bay Lodge Airport" },
  { id: 3337, code: "IBO", name: "Ibo Island Airport[1]" },
  { id: 3338, code: "IBP", name: "Iberia Airport" },
  { id: 3339, code: "IBR", name: "Ibaraki Airport" },
  { id: 3340, code: "IBZ", name: "Ibiza Airport" },
  { id: 3342, code: "ICA", name: "Icabarú Airport" },
  { id: 3343, code: "ICC", name: "Andrés Miguel Salazar Marcano Airport[1]" },
  { id: 3344, code: "ICI", name: "Cicia Airport" },
  { id: 3345, code: "ICK", name: "Majoor Henk Fernandes Airport (Nieuw Nickerie Airport)" },
  { id: 3346, code: "ICL", name: "Schenck Field" },
  { id: 3347, code: "ICN", name: "Incheon International Airport" },
  { id: 3348, code: "ICO", name: "Sicogon Airport" },
  { id: 3349, code: "ICS", name: "Cascade Airport[1] (FAA: KU70)" },
  { id: 3350, code: "ICT", name: "Wichita Dwight D. Eisenhower National Airport" },
  { id: 3351, code: "ICY", name: "Icy Bay Airport (FAA: 19AK)" },
  { id: 3353, code: "IDA", name: "Idaho Falls Regional Airport" },
  { id: 3354, code: "IDB", name: "Idre Airport" },
  { id: 3355, code: "IDC", name: "Chilonzuine Island Airstrip[1]" },
  { id: 3356, code: "IDF", name: "Idiofa Airport" },
  { id: 3357, code: "IDG", name: "Ida Grove Municipal Airport" },
  { id: 3358, code: "IDH", name: "Idaho County Airport[1] (FAA: GIC)" },
  { id: 3359, code: "IDI", name: "Indiana County–Jimmy Stewart Airport" },
  { id: 3360, code: "IDK", name: "Indulkana Airport" },
  { id: 3361, code: "IDN", name: "Indagen Airport" },
  { id: 3362, code: "IDO", name: "Santa Isabel do Morro Airport" },
  { id: 3363, code: "IDP", name: "Independence Municipal Airport" },
  { id: 3364, code: "IDR", name: "Devi Ahilyabai Holkar International Airport" },
  { id: 3365, code: "IDY", name: "Île d'Yeu Aerodrome" },
  { id: 3367, code: "IEG", name: "Zielona Góra Airport" },
  { id: 3368, code: "IEJ", name: "Iejima Airport" },
  { id: 3369, code: "IES", name: "Riesa–Göhlis Airfield" },
  { id: 3370, code: "IEV", name: "Kyiv International Airport (Zhuliany)" },
  { id: 3372, code: "IFA", name: "Iowa Falls Municipal Airport" },
  { id: 3373, code: "IFF", name: "Iffley Airport" },
  { id: 3374, code: "IFH", name: "Hesa Air Base[1]" },
  { id: 3375, code: "IFJ", name: "Ísafjörður Airport" },
  { id: 3376, code: "IFL", name: "Innisfail Airport" },
  { id: 3377, code: "IFN", name: "Isfahan International Airport (Shahid Beheshti Int'l)" },
  { id: 3378, code: "IFO", name: "Ivano-Frankivsk International Airport" },
  { id: 3379, code: "IFP", name: "Laughlin/Bullhead International Airport" },
  { id: 3380, code: "IFU", name: "Ifuru Airport[1]" },
  { id: 3382, code: "IGA", name: "Inagua Airport (Matthew Town Airport)" },
  { id: 3383, code: "IGB", name: "Ingeniero Jacobacci Airport (Capitán FAA H. R. Borden Airport)" },
  { id: 3384, code: "IGD", name: "Iğdır Airport[1]" },
  { id: 3385, code: "IGE", name: "Tchongorove Airport" },
  { id: 3386, code: "IGG", name: "Igiugig Airport" },
  { id: 3387, code: "IGH", name: "Ingham Airport" },
  { id: 3388, code: "IGL", name: "Çiğli Air Base" },
  { id: 3389, code: "IGM", name: "Kingman Airport" },
  { id: 3390, code: "IGN", name: "Maria Cristina Airport (Iligan Airport)" },
  { id: 3391, code: "IGO", name: "Jaime Ortíz Betancur Airport" },
  { id: 3392, code: "IGR", name: "Cataratas del Iguazú International Airport" },
  { id: 3393, code: "IGS", name: "Ingolstadt Manching Airport" },
  { id: 3394, code: "IGT", name: "Magas Airport (Sleptsovskaya Airport)" },
  { id: 3395, code: "IGU", name: "Foz do Iguaçu International Airport" },
  { id: 3397, code: "IHC", name: "Inhaca Airport[1]" },
  { id: 3398, code: "IHN", name: "Qishn Airport" },
  { id: 3399, code: "IHO", name: "Ihosy Airport" },
  { id: 3400, code: "IHR", name: "Iranshahr Airport[1]" },
  { id: 3401, code: "IHU", name: "Ihu Airport" },
  { id: 3403, code: "IIA", name: "Inishmaan Aerodrome" },
  { id: 3404, code: "IIL", name: "Ilam Airport[1]" },
  { id: 3405, code: "IIS", name: "Nissan Island Airport" },
  { id: 3407, code: "IJK", name: "Izhevsk Airport" },
  { id: 3408, code: "IJU", name: "João Batista Bos Filho Airport" },
  { id: 3409, code: "IJX", name: "Jacksonville Municipal Airport" },
  { id: 3411, code: "IKA", name: "Tehran Imam Khomeini International Airport" },
  { id: 3412, code: "IKB", name: "Wilkes County Airport (FAA: UKF)" },
  { id: 3413, code: "IKI", name: "Iki Airport" },
  { id: 3414, code: "IKK", name: "Greater Kankakee Airport" },
  { id: 3415, code: "IKL", name: "Ikela Airport" },
  { id: 3416, code: "IKO", name: "Nikolski Air Station" },
  { id: 3417, code: "IKP", name: "Inkerman Airport" },
  { id: 3418, code: "IKS", name: "Tiksi Airport" },
  { id: 3419, code: "IKT", name: "International Airport Irkutsk" },
  { id: 3420, code: "IKU", name: "Issyk-Kul International Airport" },
  { id: 3422, code: "ILA", name: "Illaga Airport" },
  { id: 3423, code: "ILD", name: "Lleida–Alguaire Airport" },
  { id: 3424, code: "ILE", name: "Skylark Field" },
  { id: 3425, code: "ILF", name: "Ilford Airport" },
  { id: 3426, code: "ILG", name: "Wilmington Airport (New Castle Airport)" },
  { id: 3427, code: "ILH", name: "Storck Barracks" },
  { id: 3428, code: "ILI", name: "Iliamna Airport" },
  { id: 3429, code: "ILK", name: "Ilaka-Est Airport (Atsinanana Airport)" },
  { id: 3430, code: "ILL", name: "Willmar Municipal Airport (John L. Rice Field)" },
  { id: 3431, code: "ILM", name: "Wilmington International Airport" },
  { id: 3432, code: "ILN", name: "Wilmington Air Park" },
  { id: 3433, code: "ILO", name: "Iloilo International Airport" },
  { id: 3434, code: "ILP", name: "Île des Pins Airport" },
  { id: 3435, code: "ILQ", name: "Ilo Airport" },
  { id: 3436, code: "ILR", name: "Ilorin International Airport" },
  { id: 3437, code: "ILS", name: "Ilopango International Airport" },
  { id: 3438, code: "ILU", name: "Kilaguni Airport" },
  { id: 3439, code: "ILX", name: "Ileg Airport" },
  { id: 3440, code: "ILY", name: "Islay Airport (Glenegedale Airport)" },
  { id: 3441, code: "ILZ", name: "Žilina Airport" },
  { id: 3443, code: "IMA", name: "Iamalele Airport" },
  { id: 3444, code: "IMB", name: "Imbaimadai Airport" },
  { id: 3445, code: "IMD", name: "Imonda Airport" },
  { id: 3446, code: "IMF", name: "Imphal International Airport (Tulihal Airport)" },
  { id: 3447, code: "IMG", name: "Inhaminga Airport" },
  { id: 3448, code: "IMI", name: "Ine Airport (FAA: N20)" },
  { id: 3449, code: "IMK", name: "Simikot Airport" },
  { id: 3450, code: "IML", name: "Imperial Municipal Airport" },
  { id: 3451, code: "IMM", name: "Immokalee Regional Airport" },
  { id: 3452, code: "IMN", name: "Imane Airport" },
  { id: 3453, code: "IMO", name: "Zemio Airport" },
  { id: 3454, code: "IMP", name: "Imperatriz Airport (Prefeito Renato Moreira Airport)" },
  { id: 3455, code: "IMQ", name: "Maku International Airport" },
  { id: 3456, code: "IMT", name: "Ford Airport" },
  { id: 3458, code: "INA", name: "Inta Airport" },
  { id: 3459, code: "INB", name: "Independence Airport" },
  { id: 3460, code: "INC", name: "Yinchuan Hedong International Airport" },
  { id: 3461, code: "IND", name: "Indianapolis International Airport" },
  { id: 3462, code: "INE", name: "Chinde Airport" },
  { id: 3463, code: "INF", name: "In Guezzam Airport" },
  { id: 3464, code: "INH", name: "Inhambane Airport" },
  { id: 3465, code: "INI", name: "Niš Constantine the Great Airport" },
  { id: 3466, code: "INJ", name: "Injune Airport" },
  { id: 3467, code: "INK", name: "Winkler County Airport" },
  { id: 3468, code: "INL", name: "Falls International Airport" },
  { id: 3469, code: "INM", name: "Innamincka Airport" },
  { id: 3470, code: "INN", name: "Innsbruck Airport (Kranebitten Airport)" },
  { id: 3471, code: "INO", name: "Inongo Airport" },
  { id: 3472, code: "INQ", name: "Inisheer Aerodrome" },
  { id: 3473, code: "INS", name: "Creech Air Force Base" },
  { id: 3474, code: "INT", name: "Smith Reynolds Airport" },
  { id: 3475, code: "INU", name: "Nauru International Airport" },
  { id: 3476, code: "INV", name: "Inverness Airport" },
  { id: 3477, code: "INW", name: "Winslow–Lindbergh Regional Airport" },
  { id: 3478, code: "INX", name: "Inanwatan Airport" },
  { id: 3479, code: "INY", name: "Inyati Airport" },
  { id: 3480, code: "INZ", name: "In Salah Airport" },
  { id: 3482, code: "IOA", name: "Ioannina National Airport" },
  { id: 3483, code: "IOK", name: "Iokea Airport" },
  { id: 3484, code: "IOM", name: "Isle of Man Airport (Ronaldsway Airport)" },
  { id: 3485, code: "ION", name: "Impfondo Airport" },
  { id: 3486, code: "IOP", name: "Ioma Airport" },
  { id: 3487, code: "IOR", name: "Inishmore Aerodrome (Kilronan Airport)" },
  { id: 3488, code: "IOS", name: "Ilhéus Jorge Amado Airport" },
  { id: 3489, code: "IOT", name: "Illorsuit Heliport" },
  { id: 3490, code: "IOW", name: "Iowa City Municipal Airport" },
  { id: 3492, code: "IPA", name: "Ipota Airport" },
  { id: 3493, code: "IPC", name: "Mataveri International Airport (Isla de Pascua Airport)" },
  { id: 3494, code: "IPE", name: "Ipil Airport" },
  { id: 3495, code: "IPG", name: "Ipiranga Airport" },
  { id: 3496, code: "IPH", name: "Sultan Azlan Shah Airport" },
  { id: 3497, code: "IPI", name: "San Luis Airport" },
  { id: 3498, code: "IPL", name: "Imperial County Airport (Boley Field)" },
  { id: 3499, code: "IPN", name: "Usiminas Airport" },
  { id: 3500, code: "IPT", name: "Williamsport Regional Airport" },
  { id: 3501, code: "IPU", name: "Ipiaú Airport" },
  { id: 3502, code: "IPZ", name: "San Isidro de El General Airport" },
  { id: 3504, code: "IQA", name: "Al Asad Airbase[1]" },
  { id: 3505, code: "IQM", name: "Qiemo Airport" },
  { id: 3506, code: "IQN", name: "Qingyang Airport" },
  { id: 3507, code: "IQQ", name: "Diego Aracena International Airport" },
  { id: 3508, code: "IQT", name: "Coronel FAP Francisco Secada Vignetta International Airport" },
  { id: 3510, code: "IRA", name: "Kirakira Airport (Ngorangora Airstrip)" },
  { id: 3511, code: "IRB", name: "Iraan Municipal Airport (FAA: 2F0)" },
  { id: 3512, code: "IRC", name: "Circle City Airport (FAA: CRC)" },
  { id: 3513, code: "IRD", name: "Ishwardi Airport" },
  { id: 3514, code: "IRE", name: "Irecê Airport" },
  { id: 3515, code: "IRG", name: "Lockhart River Airport" },
  { id: 3516, code: "IRI", name: "Iringa Airport (Nduli Airport)" },
  { id: 3517, code: "IRJ", name: "Capitán Vicente Almandos Almonacid Airport" },
  { id: 3518, code: "IRK", name: "Kirksville Regional Airport" },
  { id: 3519, code: "IRM", name: "Igrim Airport[1]" },
  { id: 3520, code: "IRN", name: "Iriona Airport" },
  { id: 3521, code: "IRO", name: "Birao Airport" },
  { id: 3522, code: "IRP", name: "Matari Airport" },
  { id: 3523, code: "IRS", name: "Kirsch Municipal Airport" },
  { id: 3524, code: "IRU", name: "Iranamadu Waterdrome" },
  { id: 3525, code: "IRZ", name: "Tapuruquara Airport[1]" },
  { id: 3527, code: "ISA", name: "Mount Isa Airport" },
  { id: 3528, code: "ISB", name: "Islamabad International Airport" },
  { id: 3529, code: "ISC", name: "St Mary's Airport" },
  { id: 3530, code: "ISD", name: "Iscuande Airport" },
  { id: 3531, code: "ISE", name: "Isparta Süleyman Demirel Airport" },
  { id: 3532, code: "ISG", name: "New Ishigaki Airport" },
  { id: 3533, code: "ISI", name: "Isisford Airport" },
  { id: 3534, code: "ISJ", name: "Isla Mujeres Airport" },
  { id: 3535, code: "ISK", name: "Ozar Airport" },
  { id: 3536, code: "ISL", name: "Istanbul Atatürk Airport" },
  { id: 3537, code: "ISM", name: "Kissimmee Gateway Airport" },
  { id: 3538, code: "ISN", name: "Sloulin Field International Airport" },
  { id: 3539, code: "ISO", name: "Kinston Regional Jetport (Stallings Field)" },
  { id: 3540, code: "ISP", name: "Long Island MacArthur Airport" },
  { id: 3541, code: "ISQ", name: "Schoolcraft County Airport" },
  { id: 3542, code: "ISS", name: "Wiscasset Airport (FAA: IWI)" },
  { id: 3543, code: "IST", name: "Istanbul Airport" },
  { id: 3544, code: "ISU", name: "Sulaimaniyah International Airport" },
  { id: 3545, code: "ISW", name: "South Wood County Airport (Alexander Field)" },
  { id: 3547, code: "ITA", name: "Itacoatiara Airport" },
  { id: 3548, code: "ITB", name: "Itaituba Airport" },
  { id: 3549, code: "ITE", name: "Ituberá Airport" },
  { id: 3550, code: "ITH", name: "Ithaca Tompkins Regional Airport" },
  { id: 3551, code: "ITI", name: "Itambacuri Airport" },
  { id: 3552, code: "ITK", name: "Itokama Airport" },
  { id: 3553, code: "ITM", name: "Osaka International Airport (Itami Int'l)" },
  { id: 3554, code: "ITN", name: "Itabuna Airport" },
  { id: 3555, code: "ITO", name: "Hilo International Airport" },
  { id: 3556, code: "ITP", name: "Itaperuna Airport" },
  { id: 3557, code: "ITQ", name: "Itaqui Airport" },
  { id: 3558, code: "ITR", name: "Itumbiara Airport" },
  { id: 3559, code: "ITU", name: "Iturup Airport[1]" },
  { id: 3561, code: "IUE", name: "Niue International Airport (Hanan Int'l)" },
  { id: 3562, code: "IUL", name: "Ilu Airport" },
  { id: 3563, code: "IUS", name: "Inus Airport" },
  { id: 3565, code: "IVA", name: "Ambanja Airport" },
  { id: 3566, code: "IVC", name: "Invercargill Airport" },
  { id: 3567, code: "IVG", name: "Dolac Airport" },
  { id: 3568, code: "IVI", name: "Viveros Island Airport[1]" },
  { id: 3569, code: "IVL", name: "Ivalo Airport" },
  { id: 3570, code: "IVO", name: "Chibolo Airport" },
  { id: 3571, code: "IVR", name: "Inverell Airport" },
  { id: 3572, code: "IVW", name: "Inverway Airport" },
  { id: 3574, code: "IWA", name: "Ivanovo Yuzhny Airport" },
  { id: 3575, code: "IWD", name: "Gogebic–Iron County Airport" },
  { id: 3576, code: "IWJ", name: "Iwami Airport (Hagi-Iwami Airport)" },
  { id: 3577, code: "IWK", name: "Marine Corps Air Station Iwakuni[1]" },
  { id: 3578, code: "IWO", name: "Iwo Jima Air Base" },
  { id: 3579, code: "IWS", name: "West Houston Airport" },
  { id: 3581, code: "IXA", name: "Agartala Airport (Singerbhil Airport)" },
  { id: 3582, code: "IXB", name: "Bagdogra Airport" },
  { id: 3583, code: "IXC", name: "Chandigarh Airport" },
  { id: 3584, code: "IXD", name: "Allahabad Airport (Bamrauli Air Force Base)" },
  { id: 3585, code: "IXE", name: "Mangalore Airport" },
  { id: 3586, code: "IXG", name: "Belgaum Airport" },
  { id: 3587, code: "IXH", name: "Kailashahar Airport" },
  { id: 3588, code: "IXI", name: "Lilabari Airport" },
  { id: 3589, code: "IXJ", name: "Jammu Airport (Satwari Airport)" },
  { id: 3590, code: "IXK", name: "Keshod Airport" },
  { id: 3591, code: "IXL", name: "Kushok Bakula Rimpochee Airport" },
  { id: 3592, code: "IXM", name: "Madurai Airport" },
  { id: 3593, code: "IXN", name: "Khowai Airport" },
  { id: 3594, code: "IXP", name: "Pathankot Airport" },
  { id: 3595, code: "IXQ", name: "Kamalpur Airport" },
  { id: 3596, code: "IXR", name: "Birsa Munda Airport" },
  { id: 3597, code: "IXS", name: "Silchar Airport (Kumbhirgram Air Force Base)" },
  { id: 3598, code: "IXT", name: "Pasighat Airport" },
  { id: 3599, code: "IXU", name: "Aurangabad Airport (Chikkalthana Airport)" },
  { id: 3600, code: "IXV", name: "Along Airport" },
  { id: 3601, code: "IXW", name: "Sonari Airport" },
  { id: 3602, code: "IXX", name: "Bidar Airport" },
  { id: 3603, code: "IXY", name: "Kandla Airport (Gandhidham Airport)" },
  { id: 3604, code: "IXZ", name: "Veer Savarkar International Airport (Port Blair Airport)" },
  { id: 3606, code: "IYK", name: "Inyokern Airport" },
  { id: 3608, code: "IZA", name: "Presidente Itamar Franco Airport (Zona da Mata Regional Airport)" },
  { id: 3609, code: "IZM[1]", name: "metropolitan area2" },
  { id: 3610, code: "IZO", name: "Izumo Airport" },
  { id: 3611, code: "IZT", name: "Ixtepec Airport" },
  { id: 3613, code: "JAA", name: "Jalalabad Airport" },
  { id: 3614, code: "JAB", name: "Jabiru Airport" },
  { id: 3615, code: "JAC", name: "Jackson Hole Airport" },
  { id: 3616, code: "JAD", name: "Jandakot Airport" },
  { id: 3617, code: "JAE", name: "Jaén Airport" },
  { id: 3618, code: "JAF", name: "Jaffna International Airport" },
  { id: 3619, code: "JAG", name: "PAF Base Shahbaz" },
  { id: 3620, code: "JAI", name: "Jaipur International Airport" },
  { id: 3621, code: "JAK", name: "Jacmel Airport" },
  { id: 3622, code: "JAL", name: "El Lencero Airport" },
  { id: 3623, code: "JAM", name: "Bezmer Air Base" },
  { id: 3624, code: "JAN", name: "Jackson–Evers International Airport" },
  { id: 3625, code: "JAP", name: "Chacarita Airport[1]" },
  { id: 3626, code: "JAQ", name: "Jacquinot Bay Airport" },
  { id: 3627, code: "JAR", name: "Jahrom Airport[1]" },
  { id: 3628, code: "JAS", name: "Jasper County Airport (Bell Field)" },
  { id: 3629, code: "JAT", name: "Jabot Airport" },
  { id: 3630, code: "JAU", name: "Francisco Carle Airport" },
  { id: 3631, code: "JAV", name: "Ilulissat Airport" },
  { id: 3632, code: "JAX", name: "Jacksonville International Airport" },
  { id: 3634, code: "JBB", name: "Notohadinegoro Airport" },
  { id: 3635, code: "JBQ", name: "La Isabela International Airport (Dr. Joaquin Balaguer Int'l)" },
  { id: 3636, code: "JBR", name: "Jonesboro Municipal Airport" },
  { id: 3637, code: "JBS", name: "São Borja Airport" },
  { id: 3638, code: "JBT", name: "Bethel Seaplane Base (FAA: Z59)" },
  { id: 3640, code: "JCB", name: "Santa Terezinha Municipal Airport" },
  { id: 3641, code: "JCI", name: "New Century AirCenter (FAA: IXD)" },
  { id: 3642, code: "JCK", name: "Julia Creek Airport" },
  { id: 3643, code: "JCM", name: "Jacobina Airport" },
  { id: 3644, code: "JCR", name: "Jacareacanga Airport" },
  { id: 3645, code: "JCT", name: "Kimble County Airport" },
  { id: 3646, code: "JCY", name: "LBJ Ranch Airport (FAA: 0TE7)" },
  { id: 3648, code: "JDA", name: "Grant County Regional Airport (Ogilvie Field) (FAA: GCD)" },
  { id: 3649, code: "JDF", name: "Francisco Álvares de Assis Airport" },
  { id: 3650, code: "JDG", name: "Jeongseok Airport" },
  { id: 3651, code: "JDH", name: "Jodhpur Airport" },
  { id: 3652, code: "JDN", name: "Jordan Airport" },
  { id: 3653, code: "JDO", name: "Juazeiro do Norte Airport" },
  { id: 3654, code: "JDR", name: "Prefeito Octávio de Almeida Neves Airport[1]" },
  { id: 3655, code: "JDZ", name: "Jingdezhen Luojia Airport" },
  { id: 3657, code: "JED", name: "King Abdulaziz International Airport" },
  { id: 3658, code: "JEE", name: "Jérémie Airport" },
  { id: 3659, code: "JEF", name: "Jefferson City Memorial Airport" },
  { id: 3660, code: "JEG", name: "Aasiaat Airport" },
  { id: 3661, code: "JEJ", name: "Jeh Airport" },
  { id: 3662, code: "JEK", name: "Jeki Airstrip[1]" },
  { id: 3663, code: "JEQ", name: "Jequié Airport" },
  { id: 3664, code: "JER", name: "Jersey Airport" },
  { id: 3666, code: "JFK", name: "John F. Kennedy International Airport" },
  { id: 3667, code: "JFN", name: "Northeast Ohio Regional Airport (FAA: HZY)" },
  { id: 3668, code: "JFR", name: "Paamiut Airport" },
  { id: 3670, code: "JGA", name: "Jamnagar Airport (Govardhanpur Airport)" },
  { id: 3671, code: "JGB", name: "Jagdalpur Airport" },
  { id: 3672, code: "JGD", name: "Jiagedaqi Airport" },
  { id: 3673, code: "JGN", name: "Jiayuguan Airport" },
  { id: 3674, code: "JGS", name: "Jinggangshan Airport" },
  { id: 3676, code: "JHB", name: "Senai International Airport" },
  { id: 3677, code: "JHG", name: "Xishuangbanna Gasa Airport" },
  { id: 3678, code: "JHL", name: "Fort MacKay/Albian Aerodrome[1] (TC: CAL4)" },
  { id: 3679, code: "JHM", name: "Kapalua Airport" },
  { id: 3680, code: "JHS", name: "Sisimiut Airport" },
  { id: 3681, code: "JHW", name: "Chautauqua County-Jamestown Airport" },
  { id: 3683, code: "JIA", name: "Juína Airport" },
  { id: 3684, code: "JIB", name: "Djibouti–Ambouli International Airport" },
  { id: 3685, code: "JIC", name: "Jinchang Jinchuan Airport" },
  { id: 3686, code: "JIJ", name: "Wilwal International Airport" },
  { id: 3687, code: "JIK", name: "Ikaria Island National Airport" },
  { id: 3688, code: "JIL", name: "Jilin Ertaizi Airport" },
  { id: 3689, code: "JIM", name: "Aba Segud Airport" },
  { id: 3690, code: "JIN", name: "Jinja Airport" },
  { id: 3691, code: "JIO", name: "Jos Orno Imsula Airport" },
  { id: 3692, code: "JIP", name: "Jipijapa Airport" },
  { id: 3693, code: "JIQ", name: "Qianjiang Wulingshan Airport" },
  { id: 3694, code: "JIR", name: "Jiri Airport" },
  { id: 3695, code: "JIU", name: "Jiujiang Lushan Airport" },
  { id: 3696, code: "JIW", name: "Jiwani Airport" },
  { id: 3698, code: "JJA", name: "Jajao Airport[1]" },
  { id: 3699, code: "JJD", name: "Comte. Ariston Pessoa Regional Airport[1]" },
  { id: 3700, code: "JJG", name: "Humberto Ghizzo Bortoluzzi Regional Airport[1]" },
  { id: 3701, code: "JJI", name: "Juanjuí Airport" },
  { id: 3702, code: "JJM", name: "Mulika Lodge Airport[1]" },
  { id: 3703, code: "JJN", name: "Quanzhou Jinjiang International Airport" },
  { id: 3705, code: "JKG", name: "Jönköping Airport" },
  { id: 3706, code: "JKH", name: "Chios Island National Airport" },
  { id: 3707, code: "JKL", name: "Kalymnos Island National Airport" },
  { id: 3708, code: "JKR", name: "Janakpur Airport" },
  { id: 3709, code: "JKT[1]", name: "metropolitan area2" },
  { id: 3710, code: "JKV", name: "Cherokee County Airport (FAA: JSO)" },
  { id: 3712, code: "JLA", name: "Quartz Creek Airport" },
  { id: 3713, code: "JLN", name: "Joplin Regional Airport" },
  { id: 3714, code: "JLR", name: "Jabalpur Airport (Dumna Airport)" },
  { id: 3715, code: "JLS", name: "Jales Airport" },
  { id: 3717, code: "JMB", name: "Jamba Airport" },
  { id: 3718, code: "JMJ", name: "Lancang Jingmai Airport" },
  { id: 3719, code: "JMK", name: "Mykonos Island National Airport" },
  { id: 3720, code: "JMO", name: "Jomsom Airport" },
  { id: 3721, code: "JMS", name: "Jamestown Regional Airport" },
  { id: 3722, code: "JMU", name: "Jiamusi Dongjiao Airport" },
  { id: 3724, code: "JNA", name: "Januária Airport" },
  { id: 3725, code: "JNB", name: "O. R. Tambo International Airport" },
  { id: 3726, code: "JNG", name: "Jining Qufu Airport" },
  { id: 3727, code: "JNI", name: "Junín Airport" },
  { id: 3728, code: "JNJ", name: "Ja'Aluni Airport" },
  { id: 3729, code: "JNU", name: "Juneau International Airport" },
  { id: 3730, code: "JNX", name: "Naxos Island National Airport" },
  { id: 3731, code: "JNZ", name: "Jinzhou Bay Airport" },
  { id: 3733, code: "JOE", name: "Joensuu Airport" },
  { id: 3734, code: "JOG", name: "Adisucipto International Airport" },
  { id: 3735, code: "JOH", name: "Port St. Johns Airport" },
  { id: 3736, code: "JOI", name: "Joinville-Lauro Carneiro de Loyola Airport" },
  { id: 3737, code: "JOJ", name: "Doris Lake Aerodrome[1] (TC: CDL7)" },
  { id: 3738, code: "JOK", name: "Yoshkar-Ola Airport" },
  { id: 3739, code: "JOL", name: "Jolo Airport" },
  { id: 3740, code: "JOM", name: "Njombe Airport" },
  { id: 3741, code: "JOP", name: "Josephstaal Airport" },
  { id: 3742, code: "JOS", name: "Yakubu Gowon Airport" },
  { id: 3743, code: "JOT", name: "Joliet Regional Airport" },
  { id: 3745, code: "JPA", name: "Presidente Castro Pinto International Airport" },
  { id: 3746, code: "JPR", name: "José Coleto Airport" },
  { id: 3748, code: "JQA", name: "Qaarsut Airport (Uummannaq/Qaarsut Airport)" },
  { id: 3749, code: "JQE", name: "Jaqué Airport" },
  { id: 3751, code: "JRF", name: "Kalaeloa Airport[1] (John Rodgers Field)" },
  { id: 3752, code: "JRG", name: "Veer Surendra Sai Airport[1]" },
  { id: 3753, code: "JRH", name: "Jorhat Airport (Rowriah Airport)" },
  { id: 3754, code: "JRN", name: "Juruena Airport" },
  { id: 3755, code: "JRO", name: "Kilimanjaro International Airport" },
  { id: 3756, code: "JRS", name: "Atarot Airport (Jerusalem International Airport)" },
  { id: 3758, code: "JSA", name: "Jaisalmer Airport" },
  { id: 3759, code: "JSH", name: "Sitia Public Airport" },
  { id: 3760, code: "JSI", name: "Skiathos Island National Airport" },
  { id: 3761, code: "JSJ", name: "Jiansanjiang Airport" },
  { id: 3762, code: "JSK", name: "Jask Airport" },
  { id: 3763, code: "JSM", name: "José de San Martín Airport" },
  { id: 3764, code: "JSR", name: "Jessore Airport" },
  { id: 3765, code: "JST", name: "John Murtha Johnstown–Cambria County Airport" },
  { id: 3766, code: "JSU", name: "Maniitsoq Airport" },
  { id: 3767, code: "JSY", name: "Syros Island National Airport" },
  { id: 3769, code: "JTC", name: "Moussa Nakhl Tobias–Bauru/Arealva State Airport[1]" },
  { id: 3770, code: "JTI", name: "Jataí Airport" },
  { id: 3771, code: "JTR", name: "Santorini (Thira) National Airport" },
  { id: 3772, code: "JTY", name: "Astypalaia Island National Airport" },
  { id: 3774, code: "JUA", name: "Inácio Luís do Nascimento Airport" },
  { id: 3775, code: "JUB", name: "Juba International Airport" },
  { id: 3776, code: "JUH", name: "Chizhou Jiuhuashan Airport" },
  { id: 3777, code: "JUI", name: "Juist Airport" },
  { id: 3778, code: "JUJ", name: "Gobernador Horacio Guzmán International Airport" },
  { id: 3779, code: "JUL", name: "Inca Manco Cápac International Airport" },
  { id: 3780, code: "JUM", name: "Jumla Airport" },
  { id: 3781, code: "JUN", name: "Jundah Airport" },
  { id: 3782, code: "JUO", name: "Juradó Airport" },
  { id: 3783, code: "JUR", name: "Jurien Bay Airport" },
  { id: 3784, code: "JUT", name: "Juticalpa Airport" },
  { id: 3785, code: "JUV", name: "Upernavik Airport" },
  { id: 3786, code: "JUZ", name: "Quzhou Airport" },
  { id: 3788, code: "JVA", name: "Ankavandra Airport" },
  { id: 3789, code: "JVI", name: "Central Jersey Regional Airport (FAA: 47N)" },
  { id: 3790, code: "JVL", name: "Southern Wisconsin Regional Airport" },
  { id: 3792, code: "JWA", name: "Jwaneng Airport" },
  { id: 3793, code: "JWN", name: "Zanjan Airport[1]" },
  { id: 3794, code: "JWO", name: "Jungwon Air Base[1]" },
  { id: 3796, code: "JXA", name: "Jixi Xingkaihu Airport" },
  { id: 3797, code: "JXN", name: "Jackson County Airport (Reynolds Field)" },
  { id: 3799, code: "JYR", name: "Jiroft Airport[1]" },
  { id: 3800, code: "JYV", name: "Jyväskylä Airport" },
  { id: 3802, code: "JZH", name: "Jiuzhai Huanglong Airport" },
  { id: 3804, code: "KAA", name: "Kasama Airport" },
  { id: 3805, code: "KAB", name: "Kariba Airport" },
  { id: 3806, code: "KAC", name: "Kamishly Airport" },
  { id: 3807, code: "KAD", name: "Kaduna Airport" },
  { id: 3808, code: "KAE", name: "Kake Seaplane Base" },
  { id: 3809, code: "KAF", name: "Karato Airport" },
  { id: 3810, code: "KAG", name: "Gangneung Air Base" },
  { id: 3811, code: "KAI", name: "Kaieteur International Airport" },
  { id: 3812, code: "KAJ", name: "Kajaani Airport" },
  { id: 3813, code: "KAK", name: "Kar Airport" },
  { id: 3814, code: "KAL", name: "Kaltag Airport" },
  { id: 3815, code: "KAM", name: "Kamaran Airport" },
  { id: 3816, code: "KAN", name: "Mallam Aminu Kano International Airport" },
  { id: 3817, code: "KAO", name: "Kuusamo Airport" },
  { id: 3818, code: "KAP", name: "Kapanga Airport" },
  { id: 3819, code: "KAQ", name: "Kamulai Airport[1]" },
  { id: 3820, code: "KAR", name: "Kamarang Airport" },
  { id: 3821, code: "KAS", name: "Karasburg Airport" },
  { id: 3822, code: "KAT", name: "Kaitaia Airport" },
  { id: 3823, code: "KAU", name: "Kauhava Airfield" },
  { id: 3824, code: "KAV", name: "Kavanayén Airport" },
  { id: 3825, code: "KAW", name: "Kawthaung Airport" },
  { id: 3826, code: "KAX", name: "Kalbarri Airport" },
  { id: 3827, code: "KAY", name: "Wakaya Airport" },
  { id: 3828, code: "KAZ", name: "Kuabang Airport" },
  { id: 3830, code: "KBA", name: "Kabala Airport" },
  { id: 3831, code: "KBB", name: "Kirkimbie Airport[1]" },
  { id: 3832, code: "KBC", name: "Birch Creek Airport (FAA: Z91)" },
  { id: 3833, code: "KBD", name: "Kimberley Downs Airport" },
  { id: 3834, code: "KBE", name: "Bell Island Hot Springs Seaplane Base" },
  { id: 3835, code: "KBF", name: "Karubaga Airport" },
  { id: 3836, code: "KBG", name: "Kabalega Falls Airport" },
  { id: 3837, code: "KBI", name: "Kribi Airport" },
  { id: 3838, code: "KBJ", name: "Kings Canyon Airport" },
  { id: 3839, code: "KBL", name: "Kabul International Airport" },
  { id: 3840, code: "KBM", name: "Kabwum Airport" },
  { id: 3841, code: "KBN", name: "Tunta Airport" },
  { id: 3842, code: "KBO", name: "Kabalo Airport" },
  { id: 3843, code: "KBP", name: "Boryspil International Airport" },
  { id: 3844, code: "KBQ", name: "Kasungu Airport" },
  { id: 3845, code: "KBR", name: "Sultan Ismail Petra Airport" },
  { id: 3846, code: "KBS", name: "Bo Airport" },
  { id: 3847, code: "KBT", name: "Kaben Airport" },
  { id: 3848, code: "KBU", name: "Gusti Syamsir Alam Airport (Stagen Airport)" },
  { id: 3849, code: "KBV", name: "Krabi Airport" },
  { id: 3850, code: "KBW", name: "Chignik Bay Seaplane Base (FAA: Z78)" },
  { id: 3851, code: "KBX", name: "Kambuaya Airport" },
  { id: 3852, code: "KBY", name: "Streaky Bay Airport" },
  { id: 3853, code: "KBZ", name: "Kaikoura Aerodrome" },
  { id: 3855, code: "KCA", name: "Kuqa Qiuci Airport" },
  { id: 3856, code: "KCB", name: "Tepoe Airstrip" },
  { id: 3857, code: "KCC", name: "Coffman Cove Seaplane Base" },
  { id: 3858, code: "KCD", name: "Kamur Airport" },
  { id: 3859, code: "KCE", name: "Collinsville Airport" },
  { id: 3860, code: "KCF", name: "Kadanwari Airport" },
  { id: 3861, code: "KCG", name: "Chignik Fisheries Airport (closed)" },
  { id: 3862, code: "KCH", name: "Kuching International Airport" },
  { id: 3863, code: "KCJ", name: "Komaio Airport" },
  { id: 3864, code: "KCK", name: "Kirensk Airport" },
  { id: 3865, code: "KCL", name: "Chignik Lagoon Airport (Chignik Flats Airport)" },
  { id: 3866, code: "KCM", name: "Kahramanmaraş Airport" },
  { id: 3867, code: "KCN", name: "Chernofski Harbor Seaplane Base" },
  { id: 3868, code: "KCO", name: "Cengiz Topel Naval Air Station" },
  { id: 3869, code: "KCP", name: "Kamianets-Podilskyi Airport" },
  { id: 3870, code: "KCQ", name: "Chignik Lake Airport (FAA: A79)" },
  { id: 3871, code: "KCR", name: "Colorado Creek Airport" },
  { id: 3872, code: "KCS", name: "Kings Creek Station Airport" },
  { id: 3873, code: "KCT", name: "Koggala Airport" },
  { id: 3874, code: "KCU", name: "Masindi Airport" },
  { id: 3875, code: "KCZ", name: "Kōchi Ryōma Airport" },
  { id: 3877, code: "KDA", name: "Kolda North Airport" },
  { id: 3878, code: "KDB", name: "Kambalda Airport" },
  { id: 3879, code: "KDC", name: "Kandi Airport" },
  { id: 3880, code: "KDD", name: "Khuzdar Airport" },
  { id: 3881, code: "KDE", name: "Koroba Airport" },
  { id: 3882, code: "KDH", name: "Kandahar International Airport" },
  { id: 3883, code: "KDI", name: "Haluoleo Airport" },
  { id: 3884, code: "KDJ", name: "Ndjolé Ville Airport" },
  { id: 3885, code: "KDK", name: "Kodiak Municipal Airport" },
  { id: 3886, code: "KDL", name: "Kärdla Airport" },
  { id: 3887, code: "KDM", name: "Kaadedhdhoo Airport" },
  { id: 3888, code: "KDN", name: "Ndendé Airport" },
  { id: 3889, code: "KDO", name: "Kadhdhoo Airport" },
  { id: 3890, code: "KDP", name: "Kandep Airport" },
  { id: 3891, code: "KDQ", name: "Kamberatoro Airport" },
  { id: 3892, code: "KDR", name: "Kandrian Airport" },
  { id: 3893, code: "KDS", name: "Kamaran Downs Airport" },
  { id: 3894, code: "KDT", name: "Kamphaeng Saen Airport" },
  { id: 3895, code: "KDU", name: "Skardu Airport" },
  { id: 3896, code: "KDV", name: "Vunisea Airport" },
  { id: 3897, code: "KDW", name: "Victoria Reservoir Seaplane Base[1]" },
  { id: 3898, code: "KDX", name: "Kadugli Airport[1]" },
  { id: 3899, code: "KDY", name: "Teply Klyuch Airport" },
  { id: 3900, code: "KDZ", name: "Polgolla Reservoir Seaplane Base[1]" },
  { id: 3902, code: "KEA", name: "Kerki Airport" },
  { id: 3903, code: "KEB", name: "Nanwalek Airport" },
  { id: 3904, code: "KEC", name: "Kasenga Airport" },
  { id: 3905, code: "KED", name: "Kaédi Airport" },
  { id: 3906, code: "KEE", name: "Kelle Airport" },
  { id: 3907, code: "KEF", name: "Keflavík International Airport" },
  { id: 3908, code: "KEG", name: "Keglsugl Airport" },
  { id: 3909, code: "KEH", name: "Kenmore Air Harbor (FAA: S60)" },
  { id: 3910, code: "KEI", name: "Kepi Airport" },
  { id: 3911, code: "KEJ", name: "Kemerovo International Airport" },
  { id: 3912, code: "KEK", name: "Ekwok Airport" },
  { id: 3913, code: "KEL", name: "Kiel Airport" },
  { id: 3914, code: "KEM", name: "Kemi-Tornio Airport" },
  { id: 3915, code: "KEN", name: "Kenema Airport" },
  { id: 3916, code: "KEO", name: "Odienné Airport" },
  { id: 3917, code: "KEP", name: "Nepalgunj Airport" },
  { id: 3918, code: "KEQ", name: "Kebar Airport" },
  { id: 3919, code: "KER", name: "Kerman Airport" },
  { id: 3920, code: "KES", name: "Kelsey Airport" },
  { id: 3921, code: "KET", name: "Kengtung Airport" },
  { id: 3922, code: "KEU", name: "Keekorok Airport[1]" },
  { id: 3923, code: "KEV", name: "Halli Airport" },
  { id: 3924, code: "KEW", name: "Keewaywin Airport (TC LID: CPV8)" },
  { id: 3925, code: "KEX", name: "Kanabea Airport" },
  { id: 3926, code: "KEY", name: "Kericho Airport" },
  { id: 3927, code: "KEZ", name: "Kelani River-Peliyagoda Waterdrome[1]" },
  { id: 3929, code: "KFA", name: "Kiffa Airport" },
  { id: 3930, code: "KFE", name: "Fortescue Dave Forrest Airport" },
  { id: 3931, code: "KFG", name: "Kalkgurung Airport" },
  { id: 3932, code: "KFM", name: "Kirby Lake Airport" },
  { id: 3933, code: "KFP", name: "False Pass Airport" },
  { id: 3934, code: "KFS", name: "Kastamonu Airport" },
  { id: 3935, code: "KFZ", name: "Kukës International Airport" },
  { id: 3937, code: "KGA", name: "Kananga Airport" },
  { id: 3938, code: "KGB", name: "Konge Airport" },
  { id: 3939, code: "KGC", name: "Kingscote Airport" },
  { id: 3940, code: "KGD", name: "Khrabrovo Airport" },
  { id: 3941, code: "KGE", name: "Kaghau Airport" },
  { id: 3942, code: "KGF", name: "Sary-Arka Airport" },
  { id: 3943, code: "KGG", name: "Kédougou Airport" },
  { id: 3944, code: "KGH", name: "Yongai Airport" },
  { id: 3945, code: "KGI", name: "Kalgoorlie-Boulder Airport" },
  { id: 3946, code: "KGJ", name: "Karonga Airport" },
  { id: 3947, code: "KGK", name: "Koliganek Airport (FAA: JZZ)" },
  { id: 3948, code: "KGL", name: "Kigali International Airport (Kanombe Airport)" },
  { id: 3949, code: "KGM", name: "Kungim Airport[1]" },
  { id: 3950, code: "KGN", name: "Kasongo Lunda Airport" },
  { id: 3951, code: "KGO", name: "Kirovohrad Airport" },
  { id: 3952, code: "KGP", name: "Kogalym International Airport" },
  { id: 3953, code: "KGR", name: "Kulgera Airport" },
  { id: 3954, code: "KGS", name: "Kos Island International Airport" },
  { id: 3955, code: "KGT", name: "Kangding Airport[1]" },
  { id: 3956, code: "KGU", name: "Keningau Airport" },
  { id: 3957, code: "KGW", name: "Kagi Airport" },
  { id: 3958, code: "KGX", name: "Grayling Airport" },
  { id: 3959, code: "KGY", name: "Kingaroy Airport" },
  { id: 3960, code: "KGZ", name: "Glacier Creek Airport" },
  { id: 3962, code: "KHA", name: "Khaneh Airport (Piranshahr Airport)" },
  { id: 3963, code: "KHC", name: "Kerch Airport (Voykovo Airport)" },
  { id: 3964, code: "KHD", name: "Khorramabad Airport" },
  { id: 3965, code: "KHE", name: "Kherson International Airport" },
  { id: 3966, code: "KHG", name: "Kashgar Airport (Kashi Airport)" },
  { id: 3967, code: "KHH", name: "Kaohsiung International Airport" },
  { id: 3968, code: "KHI", name: "Jinnah International Airport" },
  { id: 3969, code: "KHJ", name: "Kauhajoki Airfield" },
  { id: 3970, code: "KHK", name: "Kharg Airport" },
  { id: 3971, code: "KHM", name: "Khamti Airport" },
  { id: 3972, code: "KHN", name: "Nanchang Changbei International Airport" },
  { id: 3973, code: "KHO", name: "Khoka Moya Airport" },
  { id: 3974, code: "KHR", name: "Kharkhorin Airport" },
  { id: 3975, code: "KHS", name: "Khasab Airport" },
  { id: 3976, code: "KHT", name: "Khost Airfield" },
  { id: 3977, code: "KHU", name: "Kremenchuk Airport" },
  { id: 3978, code: "KHV", name: "Khabarovsk Novy Airport" },
  { id: 3979, code: "KHW", name: "Khwai River Airport" },
  { id: 3980, code: "KHX", name: "Kihihi Airstrip[1]" },
  { id: 3981, code: "KHY", name: "Khoy Airport[1]" },
  { id: 3982, code: "KHZ", name: "Kauehi Aerodrome" },
  { id: 3984, code: "KIA", name: "Kaiapit Airport" },
  { id: 3985, code: "KIB", name: "Ivanof Bay Seaplane Base" },
  { id: 3986, code: "KIC", name: "Mesa Del Rey Airport" },
  { id: 3987, code: "KID", name: "Kristianstad Airport" },
  { id: 3988, code: "KIE", name: "Aropa Airport" },
  { id: 3989, code: "KIF", name: "Kingfisher Lake Airport" },
  { id: 3990, code: "KIG", name: "Koingnaas Airport" },
  { id: 3991, code: "KIH", name: "Kish International Airport" },
  { id: 3992, code: "KII", name: "Kibuli Airport" },
  { id: 3993, code: "KIJ", name: "Niigata Airport" },
  { id: 3994, code: "KIK", name: "Kirkuk Airport" },
  { id: 3995, code: "KIL", name: "Kilwa Airport" },
  { id: 3996, code: "KIM", name: "Kimberley Airport" },
  { id: 3997, code: "KIN", name: "Norman Manley International Airport" },
  { id: 3998, code: "KIO", name: "Kili Airport (FAA: Q51)" },
  { id: 3999, code: "KIP", name: "Kickapoo Downtown Airport (FAA: CWC)" },
  { id: 4000, code: "KIQ", name: "Kira Airport" },
  { id: 4001, code: "KIR", name: "Kerry Airport (Farranfore Airport)" },
  { id: 4002, code: "KIS", name: "Kisumu International Airport" },
  { id: 4003, code: "KIT", name: "Kithira Island National Airport" },
  { id: 4004, code: "KIU", name: "Kiunga Airport" },
  { id: 4005, code: "KIW", name: "Southdowns Airport" },
  { id: 4006, code: "KIX", name: "Kansai International Airport" },
  { id: 4007, code: "KIY", name: "Kilwa Masoko Airport" },
  { id: 4008, code: "KIZ", name: "Kikinonda Airport" },
  { id: 4010, code: "KJA", name: "Yemelyanovo International Airport" },
  { id: 4011, code: "KJB", name: "Kurnool Airport" },
  { id: 4012, code: "KJH", name: "Kaili Huangping Airport" },
  { id: 4013, code: "KJI", name: "Kanas Airport" },
  { id: 4014, code: "KJK", name: "Kortrijk–Wevelgem International Airport" },
  { id: 4015, code: "KJP", name: "Kerama Airport" },
  { id: 4016, code: "KJT", name: "Kertajati International Airport" },
  { id: 4017, code: "KJU", name: "Kamiraba Airport" },
  { id: 4018, code: "KJX", name: "Blangpidie Airport" },
  { id: 4020, code: "KKA", name: "Koyuk Alfred Adams Airport" },
  { id: 4021, code: "KKB", name: "Kitoi Bay Seaplane Base" },
  { id: 4022, code: "KKC", name: "Khon Kaen Airport" },
  { id: 4023, code: "KKD", name: "Kokoda Airport" },
  { id: 4024, code: "KKE", name: "Kerikeri Airport (Bay of Islands Airport)" },
  { id: 4025, code: "KKG", name: "Konawaruk Airport" },
  { id: 4026, code: "KKH", name: "Kongiganak Airport (FAA: DUY)" },
  { id: 4027, code: "KKI", name: "Akiachak Airport (FAA: Z13)" },
  { id: 4028, code: "KKJ", name: "Kitakyushu Airport" },
  { id: 4029, code: "KKK", name: "Kalakaket Creek Air Station (FAA: 1KC)" },
  { id: 4030, code: "KKL", name: "Karluk Lake Seaplane Base" },
  { id: 4031, code: "KKM", name: "Khok Kathiam Air Force Base" },
  { id: 4032, code: "KKN", name: "Kirkenes Airport, Høybuktmoen" },
  { id: 4033, code: "KKO", name: "Kaikohe Aerodrome" },
  { id: 4034, code: "KKP", name: "Koolburra Airport" },
  { id: 4035, code: "KKQ", name: "Krasnoselkup Airport[1]" },
  { id: 4036, code: "KKR", name: "Kaukura Airport" },
  { id: 4037, code: "KKS", name: "Kashan Airport" },
  { id: 4038, code: "KKT", name: "Kentland Municipal Airport (FAA: 50I)" },
  { id: 4039, code: "KKU", name: "Ekuk Airport" },
  { id: 4040, code: "KKW", name: "Kikwit Airport" },
  { id: 4041, code: "KKX", name: "Kikai Airport (Kikaiga Shima Airport)" },
  { id: 4042, code: "KKY", name: "Kilkenny Airport" },
  { id: 4043, code: "KKZ", name: "Koh Kong Airport" },
  { id: 4045, code: "KLB", name: "Kalabo Airport" },
  { id: 4046, code: "KLC", name: "Kaolack Airport" },
  { id: 4047, code: "KLD", name: "Migalovo Air Base" },
  { id: 4048, code: "KLE", name: "Kaélé Airport" },
  { id: 4049, code: "KLF", name: "Grabtsevo Airport" },
  { id: 4050, code: "KLG", name: "Kalskag Airport" },
  { id: 4051, code: "KLH", name: "Kolhapur Airport" },
  { id: 4052, code: "KLI", name: "Kotakoli Air Base" },
  { id: 4053, code: "KLK", name: "Kalokol Airport (Fergusons Gulf Airport)" },
  { id: 4054, code: "KLL", name: "Levelock Airport (FAA: 9Z8)" },
  { id: 4055, code: "KLM", name: "Kalaleh Airport[1]" },
  { id: 4056, code: "KLN", name: "Larsen Bay Airport (FAA: 2A3)" },
  { id: 4057, code: "KLO", name: "Kalibo International Airport" },
  { id: 4058, code: "KLQ", name: "Keluang Airport" },
  { id: 4059, code: "KLR", name: "Kalmar Airport" },
  { id: 4060, code: "KLS", name: "Southwest Washington Regional Airport" },
  { id: 4061, code: "KLU", name: "Klagenfurt Airport" },
  { id: 4062, code: "KLV", name: "Karlovy Vary Airport" },
  { id: 4063, code: "KLW", name: "Klawock Airport (FAA: AKW)" },
  { id: 4064, code: "KLX", name: "Kalamata International Airport" },
  { id: 4065, code: "KLY", name: "Kamisuku Airport[2]" },
  { id: 4066, code: "KLZ", name: "Kleinzee Airport" },
  { id: 4068, code: "KMA", name: "Kerema Airport" },
  { id: 4069, code: "KMB", name: "Koinambe Airport" },
  { id: 4070, code: "KMC", name: "King Khaled Military City Airport" },
  { id: 4071, code: "KME", name: "Kamembe Airport" },
  { id: 4072, code: "KMF", name: "Kamina Airport" },
  { id: 4073, code: "KMG", name: "Kunming Changshui International Airport" },
  { id: 4074, code: "KMH", name: "Johan Pienaar Airport" },
  { id: 4075, code: "KMI", name: "Miyazaki Airport" },
  { id: 4076, code: "KMJ", name: "Kumamoto Airport" },
  { id: 4077, code: "KMK", name: "Makabana Airport" },
  { id: 4078, code: "KML", name: "Kamileroi Airport" },
  { id: 4079, code: "KMM", name: "Kimam Airport" },
  { id: 4080, code: "KMN", name: "Kamina Airport[1] (Kamina Ville Airport)" },
  { id: 4081, code: "KMO", name: "Manokotak Airport (FAA: MBA)" },
  { id: 4082, code: "KMP", name: "Keetmanshoop Airport" },
  { id: 4083, code: "KMQ", name: "Komatsu Airport (Kanazawa Airport)" },
  { id: 4084, code: "KMR", name: "Karimui Airport" },
  { id: 4085, code: "KMS", name: "Kumasi Airport" },
  { id: 4086, code: "KMT", name: "Kampot Airport" },
  { id: 4087, code: "KMU", name: "Kismayo Airport (Kisimayu Airport)" },
  { id: 4088, code: "KMV", name: "Kalaymyo Airport (Kalemyo Airport)" },
  { id: 4089, code: "KMW", name: "Kostroma Airport" },
  { id: 4090, code: "KMX", name: "King Khalid Air Base" },
  { id: 4091, code: "KMY", name: "Moser Bay Seaplane Base" },
  { id: 4092, code: "KMZ", name: "Kaoma Airport" },
  { id: 4094, code: "KNA", name: "Viña del Mar Airport" },
  { id: 4095, code: "KNB", name: "Kanab Municipal Airport" },
  { id: 4096, code: "KND", name: "Kindu Airport" },
  { id: 4097, code: "KNE", name: "Kanainj Airport" },
  { id: 4098, code: "KNF", name: "RAF Marham" },
  { id: 4099, code: "KNG", name: "Kaimana Airport" },
  { id: 4100, code: "KNH", name: "Kinmen Airport (Shang Yi Airport)" },
  { id: 4101, code: "KNI", name: "Katanning Airport" },
  { id: 4102, code: "KNJ", name: "Kindamba Airport" },
  { id: 4103, code: "KNK", name: "Kokhanok Airport (FAA: 9K2)" },
  { id: 4104, code: "KNL", name: "Kelanoa Airport" },
  { id: 4105, code: "KNM", name: "Kaniama Airport" },
  { id: 4106, code: "KNN", name: "Kankan Airport (Diankana Airport)" },
  { id: 4107, code: "KNO", name: "Kualanamu International Airport" },
  { id: 4108, code: "KNP", name: "Kapanda Airport" },
  { id: 4109, code: "KNQ", name: "Koné Airport" },
  { id: 4110, code: "KNR", name: "Jam Airport" },
  { id: 4111, code: "KNS", name: "King Island Airport" },
  { id: 4112, code: "KNT", name: "Kennett Memorial Airport (FAA: TKX)" },
  { id: 4113, code: "KNU", name: "Kanpur Airport (Chakeri Air Force Station)" },
  { id: 4114, code: "KNW", name: "New Stuyahok Airport" },
  { id: 4115, code: "KNX", name: "East Kimberley Regional Airport" },
  { id: 4116, code: "KNZ", name: "Kéniéba Airport" },
  { id: 4118, code: "KOA", name: "Kona International Airport at Keāhole" },
  { id: 4119, code: "KOC", name: "Koumac Airport" },
  { id: 4120, code: "KOD", name: "Kotabangun Airport" },
  { id: 4121, code: "KOE", name: "El Tari Airport" },
  { id: 4122, code: "KOF", name: "Komatipoort Airport" },
  { id: 4123, code: "KOG", name: "Khong Island Airport" },
  { id: 4124, code: "KOH", name: "Koolatah Airport" },
  { id: 4125, code: "KOI", name: "Kirkwall Airport" },
  { id: 4126, code: "KOJ", name: "Kagoshima Airport" },
  { id: 4127, code: "KOK", name: "Kokkola-Pietarsaari Airport" },
  { id: 4128, code: "KOL", name: "Koumala Airport" },
  { id: 4129, code: "KOM", name: "Komo-Manda Airport" },
  { id: 4130, code: "KON", name: "Kontum Airport" },
  { id: 4131, code: "KOO", name: "Kongolo Airport" },
  { id: 4132, code: "KOP", name: "Nakhon Phanom Airport" },
  { id: 4133, code: "KOQ", name: "Köthen Airport" },
  { id: 4134, code: "KOR", name: "Kakoro Airport" },
  { id: 4135, code: "KOS", name: "Sihanoukville International Airport (Kaong Kang Airport)" },
  { id: 4136, code: "KOT", name: "Kotlik Airport (FAA: 2A9)" },
  { id: 4137, code: "KOU", name: "Koulamoutou Airport" },
  { id: 4138, code: "KOV", name: "Kokshetau Airport" },
  { id: 4139, code: "KOW", name: "Ganzhou Huangjin Airport" },
  { id: 4140, code: "KOX", name: "Kokonao Airport" },
  { id: 4141, code: "KOY", name: "Olga Bay Seaplane Base" },
  { id: 4142, code: "KOZ", name: "Ouzinkie Airport (FAA: 4K5)" },
  { id: 4144, code: "KPA", name: "Kopiago Airport" },
  { id: 4145, code: "KPB", name: "Point Baker Seaplane Base" },
  { id: 4146, code: "KPC", name: "Port Clarence Coast Guard Station" },
  { id: 4147, code: "KPE", name: "Yapsiei Airport" },
  { id: 4148, code: "KPF", name: "Kondubol Airport" },
  { id: 4149, code: "KPG", name: "Kurupung Airport" },
  { id: 4150, code: "KPI", name: "Kapit Airport" },
  { id: 4151, code: "KPL", name: "Kapal Airport" },
  { id: 4152, code: "KPM", name: "Kompiam Airport" },
  { id: 4153, code: "KPN", name: "Kipnuk Airport (FAA: IIK)" },
  { id: 4154, code: "KPO", name: "Pohang Airport" },
  { id: 4155, code: "KPP", name: "Kalpowar Airport" },
  { id: 4156, code: "KPR", name: "Port Williams Seaplane Base" },
  { id: 4157, code: "KPS", name: "Kempsey Airport" },
  { id: 4158, code: "KPT", name: "Jackpot Airport (Hayden Field) (FAA: 06U)" },
  { id: 4159, code: "KPV", name: "Perryville Airport (FAA: PEV)" },
  { id: 4160, code: "KPW", name: "Keperveyem Airport[1]" },
  { id: 4161, code: "KPY", name: "Port Bailey Seaplane Base" },
  { id: 4163, code: "KQA", name: "Akutan Airport" },
  { id: 4164, code: "KQH", name: "Ajmer Kishangarh Airport" },
  { id: 4165, code: "KQL", name: "Kol Airport" },
  { id: 4166, code: "KQR", name: "Karara Airport[1]" },
  { id: 4167, code: "KQT", name: "Bokhtar International Airport[1]" },
  { id: 4169, code: "KRA", name: "Kerang Airport" },
  { id: 4170, code: "KRB", name: "Karumba Airport" },
  { id: 4171, code: "KRC", name: "Depati Parbo Airport" },
  { id: 4172, code: "KRD", name: "Kurundi Airport" },
  { id: 4173, code: "KRE", name: "Kirundo Airport" },
  { id: 4174, code: "KRF", name: "Höga Kusten Airport (Kramfors-Sollefteå Airport)" },
  { id: 4175, code: "KRG", name: "Karasabai Airport" },
  { id: 4176, code: "KRI", name: "Kikori Airport" },
  { id: 4177, code: "KRJ", name: "Karawari Airport" },
  { id: 4178, code: "KRK", name: "John Paul II International Airport Kraków–Balice" },
  { id: 4179, code: "KRL", name: "Korla Airport" },
  { id: 4180, code: "KRM", name: "Karanambo Airport" },
  { id: 4181, code: "KRN", name: "Kiruna Airport" },
  { id: 4182, code: "KRO", name: "Kurgan Airport" },
  { id: 4183, code: "KRP", name: "Karup Airport" },
  { id: 4184, code: "KRQ", name: "Kramatorsk Airport" },
  { id: 4185, code: "KRR", name: "Krasnodar International Airport (Pashkovsky Airport)" },
  { id: 4186, code: "KRS", name: "Kristiansand Airport, Kjevik" },
  { id: 4187, code: "KRT", name: "Khartoum International Airport" },
  { id: 4188, code: "KRU", name: "Kerau Airport" },
  { id: 4189, code: "KRV", name: "Kimwarer Airport (Kerio Valley Airport)" },
  { id: 4190, code: "KRW", name: "Turkmenbashi International Airport" },
  { id: 4191, code: "KRX", name: "Karkar Airport" },
  { id: 4192, code: "KRY", name: "Karamay Airport" },
  { id: 4193, code: "KRZ", name: "Basango Mboliasa Airport" },
  { id: 4195, code: "KSA", name: "Kosrae International Airport (FAA: TTK)" },
  { id: 4196, code: "KSB", name: "Kasanombe Airport" },
  { id: 4197, code: "KSC", name: "Košice International Airport" },
  { id: 4198, code: "KSD", name: "Karlstad Airport" },
  { id: 4199, code: "KSE", name: "Kasese Airport" },
  { id: 4200, code: "KSF", name: "Kassel Airport" },
  { id: 4201, code: "KSG", name: "Kisengam Airport" },
  { id: 4202, code: "KSH", name: "Shahid Ashrafi Esfahani Airport (Kermanshah Airport)" },
  { id: 4203, code: "KSI", name: "Kissidougou Airport" },
  { id: 4204, code: "KSJ", name: "Kasos Island Public Airport" },
  { id: 4205, code: "KSK", name: "Karlskoga Airport" },
  { id: 4206, code: "KSL", name: "Kassala Airport" },
  { id: 4207, code: "KSM", name: "St. Mary's Airport" },
  { id: 4208, code: "KSN", name: "Kostanay Airport" },
  { id: 4209, code: "KSO", name: "Kastoria National Airport (Aristotelis Airport)" },
  { id: 4210, code: "KSP", name: "Kosipe Airport" },
  { id: 4211, code: "KSQ", name: "Karshi Airport" },
  { id: 4212, code: "KSR", name: "H. Aroeppala Airport" },
  { id: 4213, code: "KSS", name: "Sikasso Airport" },
  { id: 4214, code: "KST", name: "Rabak Airport" },
  { id: 4215, code: "KSU", name: "Kristiansund Airport, Kvernberget" },
  { id: 4216, code: "KSV", name: "Springvale Airport" },
  { id: 4217, code: "KSW", name: "Kiryat Shmona Airport" },
  { id: 4218, code: "KSX", name: "Yasuru Airport" },
  { id: 4219, code: "KSY", name: "Kars Harakani Airport" },
  { id: 4220, code: "KSZ", name: "Kotlas Airport" },
  { id: 4222, code: "KTA", name: "Karratha Airport" },
  { id: 4223, code: "KTB", name: "Thorne Bay Seaplane Base" },
  { id: 4224, code: "KTC", name: "Katiola Airport" },
  { id: 4225, code: "KTD", name: "Kitadaito Airport" },
  { id: 4226, code: "KTE", name: "Kerteh Airport" },
  { id: 4227, code: "KTF", name: "Takaka Aerodrome" },
  { id: 4228, code: "KTG", name: "Rahadi Osman Airport (Ketapang Airport)" },
  { id: 4229, code: "KTH", name: "Tikchik Lodge Seaplane Base (FAA: AK56)" },
  { id: 4230, code: "KTI", name: "Kratié Airport" },
  { id: 4231, code: "KTJ", name: "Kichwa Tembo Airport[1]" },
  { id: 4232, code: "KTK", name: "Kunua Airport" },
  { id: 4233, code: "KTL", name: "Kitale Airport" },
  { id: 4234, code: "KTM", name: "Tribhuvan International Airport" },
  { id: 4235, code: "KTN", name: "Ketchikan International Airport" },
  { id: 4236, code: "KTO", name: "Kato Airport" },
  { id: 4237, code: "KTP", name: "Tinson Pen Aerodrome" },
  { id: 4238, code: "KTQ", name: "Kitee Airfield" },
  { id: 4239, code: "KTR", name: "RAAF Base Tindal" },
  { id: 4240, code: "KTS", name: "Brevig Mission Airport" },
  { id: 4241, code: "KTT", name: "Kittilä Airport" },
  { id: 4242, code: "KTU", name: "Kota Airport" },
  { id: 4243, code: "KTV", name: "Kamarata Airport" },
  { id: 4244, code: "KTW", name: "Katowice International Airport" },
  { id: 4245, code: "KTX", name: "Koutiala Airport" },
  { id: 4246, code: "KTY", name: "Katukurunda Airport[1]" },
  { id: 4248, code: "KUA", name: "Sultan Haji Ahmad Shah Airport (RMAF Kuantan)" },
  { id: 4249, code: "KUC", name: "Kuria Airport" },
  { id: 4250, code: "KUD", name: "Kudat Airport" },
  { id: 4251, code: "KUE", name: "Kukundu Airport" },
  { id: 4252, code: "KUF", name: "Kurumoch International Airport" },
  { id: 4253, code: "KUG", name: "Kubin Airport" },
  { id: 4254, code: "KUH", name: "Kushiro Airport" },
  { id: 4255, code: "KUK", name: "Kasigluk Airport (FAA: Z09)" },
  { id: 4256, code: "KUL", name: "Kuala Lumpur International Airport" },
  { id: 4257, code: "KUM", name: "Yakushima Airport" },
  { id: 4258, code: "KUN", name: "Kaunas International Airport" },
  { id: 4259, code: "KUO", name: "Kuopio Airport" },
  { id: 4260, code: "KUP", name: "Kupiano Airport" },
  { id: 4261, code: "KUQ", name: "Kuri Airport" },
  { id: 4262, code: "KUR", name: "Razer Airport" },
  { id: 4263, code: "KUS", name: "Kulusuk Airport" },
  { id: 4264, code: "KUT", name: "David the Builder Kutaisi International Airport" },
  { id: 4265, code: "KUU", name: "Bhuntar Airport (Kullu Manali Airport)" },
  { id: 4266, code: "KUV", name: "Gunsan Airport" },
  { id: 4267, code: "KUX", name: "Kuyol Airport[1]" },
  { id: 4268, code: "KUY", name: "Kamusi Airport[1]" },
  { id: 4270, code: "KVA", name: "Kavala International Airport (Alexander the Great Airport)" },
  { id: 4271, code: "KVB", name: "Skövde Airport" },
  { id: 4272, code: "KVC", name: "King Cove Airport" },
  { id: 4273, code: "KVE", name: "Kitava Island Airport" },
  { id: 4274, code: "KVG", name: "Kavieng Airport" },
  { id: 4275, code: "KVK", name: "Kirovsk-Apatity Airport (Khibiny Airport)" },
  { id: 4276, code: "KVL", name: "Kivalina Airport" },
  { id: 4277, code: "KVM", name: "Markovo Airport" },
  { id: 4278, code: "KVO", name: "Morava Airport" },
  { id: 4279, code: "KVR", name: "Kavalerovo Airport[1]" },
  { id: 4280, code: "KVU", name: "Korolevu Seaplane Base" },
  { id: 4281, code: "KVX", name: "Pobedilovo Airport" },
  { id: 4283, code: "KWA", name: "Bucholz Army Airfield" },
  { id: 4284, code: "KWB", name: "Dewadaru Airport" },
  { id: 4285, code: "KWD", name: "Kavadja Airport[1]" },
  { id: 4286, code: "KWE", name: "Guiyang Longdongbao International Airport" },
  { id: 4287, code: "KWF", name: "Waterfall Seaplane Base" },
  { id: 4288, code: "KWG", name: "Kryvyi Rih International Airport" },
  { id: 4289, code: "KWH", name: "Khwahan Airport" },
  { id: 4290, code: "KWI", name: "Kuwait International Airport" },
  { id: 4291, code: "KWJ", name: "Gwangju Airport" },
  { id: 4292, code: "KWK", name: "Kwigillingok Airport (FAA: GGV)" },
  { id: 4293, code: "KWL", name: "Guilin Liangjiang International Airport" },
  { id: 4294, code: "KWM", name: "Kowanyama Airport" },
  { id: 4295, code: "KWN", name: "Quinhagak Airport (FAA: AQH)" },
  { id: 4296, code: "KWO", name: "Kawito Airport" },
  { id: 4297, code: "KWP", name: "West Point Village Seaplane Base" },
  { id: 4298, code: "KWR", name: "Kwai Harbour Airport" },
  { id: 4299, code: "KWS", name: "Kwailabesi Airport" },
  { id: 4300, code: "KWT", name: "Kwethluk Airport" },
  { id: 4301, code: "KWV", name: "Kurwina Airport" },
  { id: 4302, code: "KWX", name: "Kiwai Island Airport" },
  { id: 4303, code: "KWY", name: "Kiwayu Airport" },
  { id: 4304, code: "KWZ", name: "Kolwezi Airport" },
  { id: 4306, code: "KXA", name: "Kasaan Seaplane Base" },
  { id: 4307, code: "KXB", name: "Sangia Nibandera Airport[1]" },
  { id: 4308, code: "KXD", name: "Kondinskoye Airport[1]" },
  { id: 4309, code: "KXE", name: "Klerksdorp Airport (P.C. Pelser Airport)" },
  { id: 4310, code: "KXF", name: "Koro Airport" },
  { id: 4311, code: "KXK", name: "Komsomolsk-on-Amur Airport" },
  { id: 4312, code: "KXR", name: "Karoola Airport" },
  { id: 4313, code: "KXU", name: "Katiu Airport[1]" },
  { id: 4315, code: "KYA", name: "Konya Airport" },
  { id: 4316, code: "KYD", name: "Lanyu Airport" },
  { id: 4317, code: "KYE", name: "Rene Mouawad Air Base (Kleyate Airport)" },
  { id: 4318, code: "KYF", name: "Yeelirrie Airport" },
  { id: 4319, code: "KYI", name: "Yalata Airport" },
  { id: 4320, code: "KYK", name: "Karluk Airport" },
  { id: 4321, code: "KYO", name: "Tampa North Aero Park[1] (FAA: X39)" },
  { id: 4322, code: "KYP", name: "Kyaukpyu Airport" },
  { id: 4323, code: "KYS", name: "Kayes Airport (Dag-Dag Airport)" },
  { id: 4324, code: "KYT", name: "Kyauktu Airport" },
  { id: 4325, code: "KYU", name: "Koyukuk Airport" },
  { id: 4326, code: "KYX", name: "Yalumet Airport" },
  { id: 4327, code: "KYZ", name: "Kyzyl Airport" },
  { id: 4329, code: "KZB", name: "Zachar Bay Seaplane Base" },
  { id: 4330, code: "KZC", name: "Kampong Chhnang Airport" },
  { id: 4331, code: "KZD", name: "Krakor Airport" },
  { id: 4332, code: "KZF", name: "Kaintiba Airport" },
  { id: 4333, code: "KZG", name: "Kitzingen Airport" },
  { id: 4334, code: "KZI", name: "Kozani National Airport (Filippos Airport)" },
  { id: 4335, code: "KZN", name: "Kazan International Airport" },
  { id: 4336, code: "KZO", name: "Kyzylorda Airport" },
  { id: 4337, code: "KZR", name: "Zafer Airport" },
  { id: 4338, code: "KZS", name: "Kastellorizo Island Public Airport" },
  { id: 4340, code: "LAA", name: "Lamar Municipal Airport" },
  { id: 4341, code: "LAB", name: "Lab Lab Airport" },
  { id: 4342, code: "LAC", name: "Layang-Layang Airport (Swallow Reef Airport)" },
  { id: 4343, code: "LAD", name: "Quatro de Fevereiro Airport" },
  { id: 4344, code: "LAE", name: "Lae Nadzab Airport" },
  { id: 4345, code: "LAF", name: "Purdue University Airport" },
  { id: 4346, code: "LAH", name: "Oesman Sadik Airport" },
  { id: 4347, code: "LAI", name: "Lannion – Côte de Granit Airport" },
  { id: 4348, code: "LAJ", name: "Antônio Correia Pinto de Macedo Airport" },
  { id: 4349, code: "LAK", name: "Aklavik/Freddie Carmichael Airport" },
  { id: 4350, code: "LAL", name: "Lakeland Linder International Airport" },
  { id: 4351, code: "LAM", name: "Los Alamos County Airport" },
  { id: 4352, code: "LAN", name: "Capital Region International Airport" },
  { id: 4353, code: "LAO", name: "Laoag International Airport" },
  { id: 4354, code: "LAP", name: "Manuel Márquez de León International Airport" },
  { id: 4355, code: "LAQ", name: "Al Abraq International Airport" },
  { id: 4356, code: "LAR", name: "Laramie Regional Airport" },
  { id: 4357, code: "LAS", name: "Harry Reid International Airport" },
  { id: 4358, code: "LAU", name: "Manda Airport" },
  { id: 4359, code: "LAW", name: "Lawton–Fort Sill Regional Airport" },
  { id: 4360, code: "LAX", name: "Los Angeles International Airport" },
  { id: 4361, code: "LAY", name: "Ladysmith Airport" },
  { id: 4362, code: "LAZ", name: "Bom Jesus da Lapa Airport" },
  { id: 4364, code: "LBA", name: "Leeds Bradford Airport" },
  { id: 4365, code: "LBB", name: "Lubbock Preston Smith International Airport" },
  { id: 4366, code: "LBC", name: "Lübeck Airport" },
  { id: 4367, code: "LBD", name: "Khujand Airport" },
  { id: 4368, code: "LBE", name: "Arnold Palmer Regional Airport" },
  { id: 4369, code: "LBF", name: "North Platte Regional Airport (Lee Bird Field)" },
  { id: 4370, code: "LBG", name: "Paris–Le Bourget Airport" },
  { id: 4371, code: "LBH", name: "Palm Beach Water Airport" },
  { id: 4372, code: "LBI", name: "Le Sequestre Airport" },
  { id: 4373, code: "LBJ", name: "Komodo Airport" },
  { id: 4374, code: "LBK", name: "Liboi Airport" },
  { id: 4375, code: "LBL", name: "Liberal Mid-America Regional Airport" },
  { id: 4376, code: "LBM", name: "Luabo Airport" },
  { id: 4377, code: "LBN", name: "Lake Baringo Airport" },
  { id: 4378, code: "LBO", name: "Lusambo Airport" },
  { id: 4379, code: "LBP", name: "Long Banga Airport" },
  { id: 4380, code: "LBQ", name: "Lambaréné Airport" },
  { id: 4381, code: "LBR", name: "Lábrea Airport" },
  { id: 4382, code: "LBS", name: "Labasa Airport" },
  { id: 4383, code: "LBT", name: "Lumberton Municipal Airport" },
  { id: 4384, code: "LBU", name: "Labuan Airport" },
  { id: 4385, code: "LBV", name: "Libreville International Airport" },
  { id: 4386, code: "LBW", name: "Juvai Semaring Airport (Long Bawan Airport)" },
  { id: 4387, code: "LBX", name: "Lubang Airport" },
  { id: 4388, code: "LBY", name: "La Baule-Escoublac Airport" },
  { id: 4389, code: "LBZ", name: "Lucapa Airport" },
  { id: 4391, code: "LCA", name: "Larnaca International Airport" },
  { id: 4392, code: "LCB", name: "Pontes e Lacerda Airport" },
  { id: 4393, code: "LCC", name: "Galatina Air Base" },
  { id: 4394, code: "LCD", name: "Louis Trichardt Airport" },
  { id: 4395, code: "LCE", name: "Golosón International Airport" },
  { id: 4396, code: "LCF", name: "Río Dulce Airport (Las Vegas Airport)" },
  { id: 4397, code: "LCG", name: "A Coruña Airport" },
  { id: 4398, code: "LCH", name: "Lake Charles Regional Airport" },
  { id: 4399, code: "LCI", name: "Laconia Municipal Airport" },
  { id: 4400, code: "LCJ", name: "Łódź Władysław Reymont Airport" },
  { id: 4401, code: "LCK", name: "Rickenbacker International Airport" },
  { id: 4402, code: "LCL", name: "La Coloma Airport" },
  { id: 4403, code: "LCM", name: "La Cumbre Airport" },
  { id: 4404, code: "LCN", name: "Balcanoona Airport" },
  { id: 4405, code: "LCO", name: "Lague Airport" },
  { id: 4406, code: "LCP", name: "Loncopué Airport" },
  { id: 4407, code: "LCQ", name: "Lake City Gateway Airport" },
  { id: 4408, code: "LCR", name: "La Chorrera Airport" },
  { id: 4409, code: "LCT", name: "Shijiazhuang Luancheng Airport" },
  { id: 4410, code: "LCV", name: "Lucca-Tassignano Airport" },
  { id: 4411, code: "LCX", name: "Longyan Guanzhishan Airport" },
  { id: 4412, code: "LCY", name: "London City Airport" },
  { id: 4414, code: "LDA", name: "Malda Airport" },
  { id: 4415, code: "LDB", name: "Londrina–Governador José Richa Airport" },
  { id: 4416, code: "LDC", name: "Lindeman Island Airport" },
  { id: 4417, code: "LDE", name: "Tarbes–Lourdes–Pyrénées Airport" },
  { id: 4418, code: "LDG", name: "Leshukonskoye Airport" },
  { id: 4419, code: "LDH", name: "Lord Howe Island Airport" },
  { id: 4420, code: "LDI", name: "Lindi Airport (Kikwetu Airport)" },
  { id: 4421, code: "LDJ", name: "Linden Airport" },
  { id: 4422, code: "LDK", name: "Lidköping-Hovby Airport" },
  { id: 4423, code: "LDM", name: "Mason County Airport" },
  { id: 4424, code: "LDN", name: "Lamidanda Airport" },
  { id: 4425, code: "LDO", name: "Laduani Airstrip" },
  { id: 4426, code: "LDR", name: "Lawdar Airport" },
  { id: 4427, code: "LDS", name: "Yichun Lindu Airport[2]" },
  { id: 4428, code: "LDU", name: "Lahad Datu Airport" },
  { id: 4429, code: "LDV", name: "Landivisiau Air Base" },
  { id: 4430, code: "LDW", name: "Lansdowne Airport" },
  { id: 4431, code: "LDX", name: "Saint-Laurent-du-Maroni Airport" },
  { id: 4432, code: "LDY", name: "City of Derry Airport" },
  { id: 4433, code: "LDZ", name: "Londolozi Airport" },
  { id: 4435, code: "LEA", name: "Learmonth Airport" },
  { id: 4436, code: "LEB", name: "Lebanon Municipal Airport" },
  { id: 4437, code: "LEC", name: "Coronel Horácio de Mattos Airport" },
  { id: 4438, code: "LED", name: "Pulkovo Airport" },
  { id: 4439, code: "LEE", name: "Leesburg International Airport" },
  { id: 4440, code: "LEF", name: "Lebakeng Airport" },
  { id: 4441, code: "LEG", name: "Aleg Airport" },
  { id: 4442, code: "LEH", name: "Le Havre – Octeville Airport" },
  { id: 4443, code: "LEI", name: "Almería Airport" },
  { id: 4444, code: "LEJ", name: "Leipzig/Halle Airport" },
  { id: 4445, code: "LEK", name: "Tata Airport" },
  { id: 4446, code: "LEL", name: "Lake Evella Airport" },
  { id: 4447, code: "LEM", name: "Lemmon Municipal Airport" },
  { id: 4448, code: "LEN", name: "León Airport" },
  { id: 4449, code: "LEO", name: "Lékoni Airport" },
  { id: 4450, code: "LEP", name: "Leopoldina Airport" },
  { id: 4451, code: "LEQ", name: "Land's End Airport" },
  { id: 4452, code: "LER", name: "Leinster Airport" },
  { id: 4453, code: "LES", name: "Lesobeng Airport" },
  { id: 4454, code: "LET", name: "Alfredo Vásquez Cobo International Airport" },
  { id: 4455, code: "LEU", name: "La Seu d'Urgell Airport" },
  { id: 4456, code: "LEV", name: "Levuka Airfield (Bureta Airport)" },
  { id: 4457, code: "LEW", name: "Auburn/Lewiston Municipal Airport" },
  { id: 4458, code: "LEX", name: "Blue Grass Airport" },
  { id: 4459, code: "LEY", name: "Lelystad Airport" },
  { id: 4460, code: "LEZ", name: "La Esperanza Airport" },
  { id: 4462, code: "LFB", name: "Lumbo Airport[2]" },
  { id: 4463, code: "LFI", name: "Langley Air Force Base[2]" },
  { id: 4464, code: "LFK", name: "Angelina County Airport" },
  { id: 4465, code: "LFM", name: "Lamerd Airport[2]" },
  { id: 4466, code: "LFN", name: "Triangle North Executive Airport (Franklin County Airport) (FAA: LHZ)" },
  { id: 4467, code: "LFO", name: "Kelafo Airport" },
  { id: 4468, code: "LFP", name: "Lakefield Airport" },
  { id: 4469, code: "LFQ", name: "Linfen Qiaoli Airport[2]" },
  { id: 4470, code: "LFR", name: "La Fría Airport" },
  { id: 4471, code: "LFT", name: "Lafayette Regional Airport" },
  { id: 4472, code: "LFW", name: "Lomé–Tokoin Airport (Gnassingbé Eyadéma Int'l)" },
  { id: 4474, code: "LGA", name: "LaGuardia Airport" },
  { id: 4475, code: "LGB", name: "Long Beach Airport" },
  { id: 4476, code: "LGC", name: "LaGrange Callaway Airport" },
  { id: 4477, code: "LGD", name: "La Grande/Union County Airport" },
  { id: 4478, code: "LGE", name: "Lake Gregory Airport" },
  { id: 4479, code: "LGF", name: "Laguna Army Airfield" },
  { id: 4480, code: "LGG", name: "Liège Airport" },
  { id: 4481, code: "LGH", name: "Leigh Creek Airport" },
  { id: 4482, code: "LGI", name: "Deadman's Cay Airport" },
  { id: 4483, code: "LGK", name: "Langkawi International Airport" },
  { id: 4484, code: "LGL", name: "Long Lellang Airport" },
  { id: 4485, code: "LGM", name: "Laiagam Airport" },
  { id: 4486, code: "LGN", name: "Linga Linga Airport" },
  { id: 4487, code: "LGO", name: "Langeoog Airport" },
  { id: 4488, code: "LGQ", name: "Lago Agrio Airport" },
  { id: 4489, code: "LGR", name: "Cochrane Airfield" },
  { id: 4490, code: "LGS", name: "Comodoro D. Ricardo Salomón Airport" },
  { id: 4491, code: "LGT", name: "Las Gaviotas Airport" },
  { id: 4492, code: "LGU", name: "Logan-Cache Airport" },
  { id: 4493, code: "LGW", name: "Gatwick Airport" },
  { id: 4494, code: "LGX", name: "Lugh Ganane Airport" },
  { id: 4495, code: "LGY", name: "Lagunillas Airport" },
  { id: 4497, code: "LHA", name: "Flughafen Lahr (Lahr Airport)" },
  { id: 4498, code: "LHE", name: "Allama Iqbal International Airport" },
  { id: 4499, code: "LHG", name: "Lightning Ridge Airport" },
  { id: 4500, code: "LHI", name: "Lereh Airport" },
  { id: 4501, code: "LHK", name: "Laohekou Airport" },
  { id: 4502, code: "LHP", name: "Lehu Airport" },
  { id: 4503, code: "LHR", name: "Heathrow Airport" },
  { id: 4504, code: "LHS", name: "Las Heras Airport" },
  { id: 4505, code: "LHU", name: "Lianshulu Airport" },
  { id: 4506, code: "LHV", name: "William T. Piper Memorial Airport" },
  { id: 4507, code: "LHW", name: "Lanzhou Zhongchuan International Airport" },
  { id: 4509, code: "LIA", name: "Liangping Airport" },
  { id: 4510, code: "LIB", name: "Limbunya Airport" },
  { id: 4511, code: "LIC", name: "Limon Municipal Airport" },
  { id: 4512, code: "LIE", name: "Libenge Airport" },
  { id: 4513, code: "LIF", name: "Ouanaham Airport" },
  { id: 4514, code: "LIG", name: "Limoges – Bellegarde Airport" },
  { id: 4515, code: "LIH", name: "Lihue Airport" },
  { id: 4516, code: "LII", name: "Mulia Airport" },
  { id: 4517, code: "LIK", name: "Likiep Airport" },
  { id: 4518, code: "LIL", name: "Lille Airport (Lille–Lesquin Airport)" },
  { id: 4519, code: "LIM", name: "Jorge Chávez International Airport" },
  { id: 4520, code: "LIN", name: "Linate Airport" },
  { id: 4521, code: "LIO", name: "Limón International Airport" },
  { id: 4522, code: "LIP", name: "Lins Airport" },
  { id: 4523, code: "LIQ", name: "Lisala Airport" },
  { id: 4524, code: "LIR", name: "Daniel Oduber Quirós International Airport" },
  { id: 4525, code: "LIS", name: "Lisbon Portela Airport" },
  { id: 4526, code: "LIT", name: "Clinton National Airport (Adams Field)" },
  { id: 4527, code: "LIV", name: "Livengood Camp Airport (FAA: 4AK)" },
  { id: 4528, code: "LIW", name: "Loikaw Airport" },
  { id: 4529, code: "LIX", name: "Likoma Airport" },
  { id: 4530, code: "LIY", name: "MidCoast Regional Airport at Wright Army Airfield (FAA: LHW)" },
  { id: 4531, code: "LIZ", name: "Loring International Airport (FAA: ME16)" },
  { id: 4533, code: "LJA", name: "Lodja Airport" },
  { id: 4534, code: "LJG", name: "Lijiang Sanyi Airport" },
  { id: 4535, code: "LJN", name: "Texas Gulf Coast Regional Airport (FAA: LBX)" },
  { id: 4536, code: "LJU", name: "Ljubljana Jože Pučnik Airport (Brnik Airport)" },
  { id: 4538, code: "LKA", name: "Gewayantana Airport" },
  { id: 4539, code: "LKB", name: "Lakeba Airport" },
  { id: 4540, code: "LKC", name: "Lekana Airport" },
  { id: 4541, code: "LKD", name: "Lakeland Downs Airport" },
  { id: 4542, code: "LKE", name: "Kenmore Air Harbor Seaplane Base (Seattle Lake Union SPB) (FAA: W55)" },
  { id: 4543, code: "LKG", name: "Lokichogio Airport" },
  { id: 4544, code: "LKH", name: "Long Akah Airport[2]" },
  { id: 4545, code: "LKI", name: "Lasikin Airport" },
  { id: 4546, code: "LKK", name: "Kulik Lake Airport" },
  { id: 4547, code: "LKL", name: "Lakselv Airport, Banak" },
  { id: 4548, code: "LKN", name: "Leknes Airport" },
  { id: 4549, code: "LKO", name: "Chaudhary Charan Singh International Airport" },
  { id: 4550, code: "LKP", name: "Lake Placid Airport" },
  { id: 4551, code: "LKR", name: "Las Khorey Airport" },
  { id: 4552, code: "LKU", name: "Lake Turkana Airport" },
  { id: 4553, code: "LKV", name: "Lake County Airport" },
  { id: 4554, code: "LKW", name: "Lekhwair Airport[2]" },
  { id: 4555, code: "LKY", name: "Lake Manyara Airport" },
  { id: 4556, code: "LKZ", name: "RAF Lakenheath" },
  { id: 4558, code: "LLA", name: "Luleå/Kallax Airport" },
  { id: 4559, code: "LLB", name: "Libo Airport (Qiannan Airport)" },
  { id: 4560, code: "LLC", name: "Cagayan North International Airport (Lal-lo Airport)" },
  { id: 4561, code: "LLE", name: "Malelane Airport" },
  { id: 4562, code: "LLF", name: "Yongzhou Lingling Airport" },
  { id: 4563, code: "LLG", name: "Chillagoe Airport" },
  { id: 4564, code: "LLH", name: "Las Limas Airport" },
  { id: 4565, code: "LLI", name: "Lalibela Airport" },
  { id: 4566, code: "LLJ", name: "Silampari Airport" },
  { id: 4567, code: "LLK", name: "Lankaran International Airport" },
  { id: 4568, code: "LLL", name: "Lissadell Airport" },
  { id: 4569, code: "LLM", name: "Lomlom Airport" },
  { id: 4570, code: "LLN", name: "Kelila Airport" },
  { id: 4571, code: "LLO", name: "Palopo Lagaligo Airport" },
  { id: 4572, code: "LLP", name: "Linda Downs Airport" },
  { id: 4573, code: "LLS", name: "Alférez Armando Rodríguez Airport" },
  { id: 4574, code: "LLT", name: "Lobito Airport[2]" },
  { id: 4575, code: "LLV", name: "Lüliang Airport" },
  { id: 4576, code: "LLW", name: "Lilongwe International Airport (Kamuzu Int'l)" },
  { id: 4577, code: "LLX", name: "Caledonia County Airport (FAA: CDA)" },
  { id: 4578, code: "LLY", name: "South Jersey Regional Airport (FAA: VAY)" },
  { id: 4580, code: "LMA", name: "Lake Minchumina Airport (FAA: MHM)" },
  { id: 4581, code: "LMB", name: "Salima Airport" },
  { id: 4582, code: "LMC", name: "La Macarena Airport" },
  { id: 4583, code: "LMD", name: "Los Menucos Airport" },
  { id: 4584, code: "LME", name: "Le Mans Arnage Airport" },
  { id: 4585, code: "LMG", name: "Lamassa Airport" },
  { id: 4586, code: "LMH", name: "Limón Airport" },
  { id: 4587, code: "LMI", name: "Lumi Airport" },
  { id: 4588, code: "LML", name: "Lae Airport" },
  { id: 4589, code: "LMM", name: "Fort Valley Federal International Airport" },
  { id: 4590, code: "LMN", name: "Limbang Airport" },
  { id: 4591, code: "LMO", name: "RAF Lossiemouth" },
  { id: 4592, code: "LMP", name: "Lampedusa Airport" },
  { id: 4593, code: "LMQ", name: "Marsa Brega Airport" },
  { id: 4594, code: "LMR", name: "Finsch Mine Airport" },
  { id: 4595, code: "LMS", name: "Louisville Winston County Airport" },
  { id: 4596, code: "LMT", name: "Klamath Falls Airport" },
  { id: 4597, code: "LMU", name: "Letung Airport" },
  { id: 4598, code: "LMV", name: "Madivaru Airport" },
  { id: 4599, code: "LMX", name: "Lopéz de Micay Airport" },
  { id: 4600, code: "LMY", name: "Lake Murray Airport" },
  { id: 4601, code: "LMZ", name: "Palma Airport" },
  { id: 4603, code: "LNA", name: "Palm Beach County Park Airport" },
  { id: 4604, code: "LNB", name: "Lamen Bay Airport" },
  { id: 4605, code: "LNC", name: "Lengbati Airport" },
  { id: 4606, code: "LND", name: "Hunt Field" },
  { id: 4607, code: "LNE", name: "Lonorore Airport" },
  { id: 4608, code: "LNF", name: "Munbil Airport" },
  { id: 4609, code: "LNG", name: "Lese Airport" },
  { id: 4610, code: "LNH", name: "Lake Nash Airport" },
  { id: 4611, code: "LNI", name: "Point Lonely Short Range Radar Site (FAA: AK71)" },
  { id: 4612, code: "LNJ", name: "Lincang Airport" },
  { id: 4613, code: "LNK", name: "Lincoln Airport" },
  { id: 4614, code: "LNL", name: "Longnan Chengzhou Airport" },
  { id: 4615, code: "LNM", name: "Langimar Airport" },
  { id: 4616, code: "LNN", name: "Lost Nation Airport" },
  { id: 4617, code: "LNO", name: "Leonora Airport" },
  { id: 4618, code: "LNP", name: "Lonesome Pine Airport" },
  { id: 4619, code: "LNQ", name: "Loani Airport" },
  { id: 4620, code: "LNR", name: "Tri-County Regional Airport" },
  { id: 4621, code: "LNS", name: "Lancaster Airport" },
  { id: 4622, code: "LNU", name: "Robert Atty Bessing Airport" },
  { id: 4623, code: "LNV", name: "Lihir Island Airport" },
  { id: 4624, code: "LNX", name: "Smolensk South Airport" },
  { id: 4625, code: "LNY", name: "Lanai Airport" },
  { id: 4626, code: "LNZ", name: "Linz Airport (Blue Danube Airport)" },
  { id: 4628, code: "LOA", name: "Lorraine Airport" },
  { id: 4629, code: "LOB", name: "San Rafael Airport" },
  { id: 4630, code: "LOC", name: "Lock Airport" },
  { id: 4631, code: "LOD", name: "Longana Airport" },
  { id: 4632, code: "LOE", name: "Loei Airport" },
  { id: 4633, code: "LOF", name: "Loen Airport" },
  { id: 4634, code: "LOH", name: "Ciudad de Catamayo Airport" },
  { id: 4635, code: "LOI", name: "Helmuth Baungartem Airport" },
  { id: 4636, code: "LOK", name: "Lodwar Airport" },
  { id: 4637, code: "LOL", name: "Derby Field" },
  { id: 4638, code: "LOM", name: "Francisco Primo de Verdad National Airport" },
  { id: 4639, code: "LON[2]", name: "metropolitan area3" },
  { id: 4640, code: "LOO", name: "L'Mekrareg Airport (Laghouat Airport)" },
  { id: 4641, code: "LOP", name: "Lombok International Airport" },
  { id: 4642, code: "LOQ", name: "Lobatse Airport" },
  { id: 4643, code: "LOS", name: "Murtala Muhammed International Airport" },
  { id: 4644, code: "LOT", name: "Lewis University Airport" },
  { id: 4645, code: "LOU", name: "Bowman Field" },
  { id: 4646, code: "LOV", name: "Venustiano Carranza International Airport" },
  { id: 4647, code: "LOW", name: "Louisa County Airport (Freeman Field) (FAA: LKU)" },
  { id: 4648, code: "LOX", name: "Los Tablones Airport" },
  { id: 4649, code: "LOY", name: "Loiyangalani Airport" },
  { id: 4650, code: "LOZ", name: "London-Corbin Airport (Magee Field)" },
  { id: 4652, code: "LPA", name: "Gran Canaria Airport" },
  { id: 4653, code: "LPB", name: "El Alto International Airport" },
  { id: 4654, code: "LPC", name: "Lompoc Airport" },
  { id: 4655, code: "LPD", name: "La Pedrera Airport" },
  { id: 4656, code: "LPE", name: "La Primavera Airport" },
  { id: 4657, code: "LPF", name: "Liupanshui Yuezhao Airport[2]" },
  { id: 4658, code: "LPG", name: "La Plata Airport" },
  { id: 4659, code: "LPI", name: "Linköping/Saab Airport" },
  { id: 4660, code: "LPJ", name: "Armando Schwarck Airport" },
  { id: 4661, code: "LPK", name: "Lipetsk Airport" },
  { id: 4662, code: "LPL", name: "Liverpool John Lennon Airport" },
  { id: 4663, code: "LPM", name: "Malekoula Airport (Lamap Airport)" },
  { id: 4664, code: "LPN", name: "Leron Plains Airport[2]" },
  { id: 4665, code: "LPO", name: "La Porte Municipal Airport (FAA: PPO)" },
  { id: 4666, code: "LPP", name: "Lappeenranta Airport" },
  { id: 4667, code: "LPQ", name: "Luang Prabang International Airport" },
  { id: 4668, code: "LPS", name: "Fishermans Bay/LPS Seaplane Base" },
  { id: 4669, code: "LPT", name: "Lampang Airport" },
  { id: 4670, code: "LPU", name: "Long Apung Airport" },
  { id: 4671, code: "LPX", name: "Liepāja International Airport" },
  { id: 4672, code: "LPY", name: "Le Puy – Loudes Airport" },
  { id: 4674, code: "LQK", name: "Pickens County Airport" },
  { id: 4675, code: "LQM", name: "Caucayá Airport" },
  { id: 4676, code: "LQN", name: "Qala i Naw Airport" },
  { id: 4678, code: "LRA", name: "Larissa National Airport" },
  { id: 4679, code: "LRB", name: "Leribe Airport" },
  { id: 4680, code: "LRD", name: "Laredo International Airport" },
  { id: 4681, code: "LRE", name: "Longreach Airport" },
  { id: 4682, code: "LRF", name: "Little Rock Air Force Base" },
  { id: 4683, code: "LRG", name: "Loralai Airport" },
  { id: 4684, code: "LRH", name: "La Rochelle – Île de Ré Airport" },
  { id: 4685, code: "LRI", name: "Lorica Airport" },
  { id: 4686, code: "LRJ", name: "Le Mars Municipal Airport" },
  { id: 4687, code: "LRL", name: "Niamtougou International Airport" },
  { id: 4688, code: "LRM", name: "La Romana International Airport (Casa de Campo International Airport)" },
  { id: 4689, code: "LRQ", name: "Laurie River Airport" },
  { id: 4690, code: "LRR", name: "Larestan International Airport" },
  { id: 4691, code: "LRS", name: "Leros Municipal Airport" },
  { id: 4692, code: "LRT", name: "Lorient South Brittany Airport (Lann-Bihoué Airport)" },
  { id: 4693, code: "LRU", name: "Las Cruces International Airport" },
  { id: 4694, code: "LRV", name: "Los Roques Airport" },
  { id: 4696, code: "LSA", name: "Losuia Airport" },
  { id: 4697, code: "LSB", name: "Lordsburg Municipal Airport" },
  { id: 4698, code: "LSC", name: "La Florida Airport" },
  { id: 4699, code: "LSE", name: "La Crosse Regional Airport" },
  { id: 4700, code: "LSF", name: "Lawson Army Airfield" },
  { id: 4701, code: "LSH", name: "Lashio Airport" },
  { id: 4702, code: "LSI", name: "Sumburgh Airport" },
  { id: 4703, code: "LSJ", name: "Long Island Airport" },
  { id: 4704, code: "LSK", name: "Lusk Municipal Airport" },
  { id: 4705, code: "LSL", name: "Los Chiles Airport" },
  { id: 4706, code: "LSM", name: "Long Semado Airport" },
  { id: 4707, code: "LSN", name: "Los Banos Municipal Airport" },
  { id: 4708, code: "LSO", name: "Les Sables-d'Olonne – Talmont Airport" },
  { id: 4709, code: "LSP", name: "Josefa Camejo International Airport" },
  { id: 4710, code: "LSQ", name: "Maria Dolores Airport" },
  { id: 4711, code: "LSS", name: "Les Saintes Airport" },
  { id: 4712, code: "LST", name: "Launceston Airport" },
  { id: 4713, code: "LSU", name: "Long Sukang Airport" },
  { id: 4714, code: "LSV", name: "Nellis Air Force Base" },
  { id: 4715, code: "LSW", name: "Malikus Saleh Airport" },
  { id: 4716, code: "LSX", name: "Lhok Sukon Airport" },
  { id: 4717, code: "LSY", name: "Lismore Airport" },
  { id: 4718, code: "LSZ", name: "Lošinj Airport" },
  { id: 4720, code: "LTA", name: "Tzaneen Airport (Letaba Airport)" },
  { id: 4721, code: "LTB", name: "Latrobe Airport" },
  { id: 4722, code: "LTC", name: "Laï Airport" },
  { id: 4723, code: "LTD", name: "Ghadames Airport" },
  { id: 4724, code: "LTF", name: "Leitre Airport" },
  { id: 4725, code: "LTG", name: "Langtang Airport" },
  { id: 4726, code: "LTI", name: "Altai Airport" },
  { id: 4727, code: "LTK", name: "Bassel Al-Assad International Airport" },
  { id: 4728, code: "LTL", name: "Lastourville Airport" },
  { id: 4729, code: "LTM", name: "Lethem Airport" },
  { id: 4730, code: "LTN", name: "Luton Airport" },
  { id: 4731, code: "LTO", name: "Loreto International Airport" },
  { id: 4732, code: "LTP", name: "Lyndhurst Airport" },
  { id: 4733, code: "LTQ", name: "Le Touquet – Côte d'Opale Airport" },
  { id: 4734, code: "LTR", name: "Letterkenny Airfield" },
  { id: 4735, code: "LTS", name: "Altus Air Force Base" },
  { id: 4736, code: "LTT", name: "La Môle – Saint-Tropez Airport" },
  { id: 4737, code: "LTU", name: "Latur Airport" },
  { id: 4738, code: "LTV", name: "Lotus Vale Station Airport" },
  { id: 4739, code: "LTW", name: "St. Mary's County Regional Airport (FAA: 2W6)" },
  { id: 4741, code: "LTX", name: "Cotopaxi International Airport" },
  { id: 4743, code: "LUA", name: "Tenzing-Hillary Airport" },
  { id: 4744, code: "LUB", name: "Lumid Pau Airport" },
  { id: 4745, code: "LUC", name: "Laucala Airport" },
  { id: 4746, code: "LUD", name: "Lüderitz Airport" },
  { id: 4747, code: "LUE", name: "Boľkovce Airport" },
  { id: 4748, code: "LUF", name: "Luke Air Force Base" },
  { id: 4749, code: "LUG", name: "Lugano Airport" },
  { id: 4750, code: "LUH", name: "Sahnewal Airport (Ludhiana Airport)" },
  { id: 4751, code: "LUI", name: "La Unión Airport" },
  { id: 4752, code: "LUK", name: "Cincinnati Municipal Airport (Lunken Field)" },
  { id: 4753, code: "LUL", name: "Hesler-Noble Field" },
  { id: 4754, code: "LUM", name: "Dehong Mangshi Airport" },
  { id: 4755, code: "LUN", name: "Kenneth Kaunda International Airport" },
  { id: 4756, code: "LUO", name: "Luena Airport" },
  { id: 4757, code: "LUP", name: "Kalaupapa Airport" },
  { id: 4758, code: "LUQ", name: "Brigadier Mayor César Raúl Ojeda Airport" },
  { id: 4759, code: "LUR", name: "Cape Lisburne LRRS Airport" },
  { id: 4760, code: "LUS", name: "Lusanga Airport" },
  { id: 4761, code: "LUT", name: "New Laura Airport" },
  { id: 4762, code: "LUU", name: "Laura Airport" },
  { id: 4763, code: "LUV", name: "Karel Sadsuitubun Airport" },
  { id: 4764, code: "LUW", name: "Syukuran Aminuddin Amir Airport" },
  { id: 4765, code: "LUX", name: "Luxembourg Findel Airport" },
  { id: 4766, code: "LUZ", name: "Lublin Airport" },
  { id: 4768, code: "LVA", name: "Laval Entrammes Airport" },
  { id: 4769, code: "LVB", name: "Galpões Airport" },
  { id: 4770, code: "LVD", name: "Lime Village Airport (FAA: 2AK)" },
  { id: 4771, code: "LVI", name: "Harry Mwanga Nkumbula International Airport" },
  { id: 4772, code: "LVK", name: "Livermore Municipal Airport" },
  { id: 4773, code: "LVL", name: "Lawrenceville/Brunswick Municipal Airport" },
  { id: 4774, code: "LVM", name: "Mission Field" },
  { id: 4775, code: "LVO", name: "Laverton Airport" },
  { id: 4776, code: "LVP", name: "Lavan Airport" },
  { id: 4777, code: "LVR", name: "Bom Futuro Municipal Airport[2]" },
  { id: 4778, code: "LVS", name: "Las Vegas Municipal Airport" },
  { id: 4780, code: "LWA", name: "Lebak Airport" },
  { id: 4781, code: "LWB", name: "Greenbrier Valley Airport" },
  { id: 4782, code: "LWC", name: "Lawrence Municipal Airport" },
  { id: 4783, code: "LWE", name: "Wonopito Airport" },
  { id: 4784, code: "LWH", name: "Lawn Hill Airport" },
  { id: 4785, code: "LWI", name: "Lowai Airport" },
  { id: 4786, code: "LWK", name: "Tingwall Airport (Lerwick/Tingwall Airport)" },
  { id: 4787, code: "LWL", name: "Wells Municipal Airport (Harriet Field)" },
  { id: 4788, code: "LWM", name: "Lawrence Municipal Airport" },
  { id: 4789, code: "LWN", name: "Shirak Airport" },
  { id: 4790, code: "LWO", name: "Lviv Danylo Halytskyi International Airport" },
  { id: 4791, code: "LWR", name: "Leeuwarden Air Base" },
  { id: 4792, code: "LWS", name: "Lewiston–Nez Perce County Airport" },
  { id: 4793, code: "LWT", name: "Lewistown Municipal Airport" },
  { id: 4794, code: "LWV", name: "Lawrenceville–Vincennes International Airport" },
  { id: 4795, code: "LWY", name: "Lawas Airport" },
  { id: 4797, code: "LXA", name: "Lhasa Gonggar Airport" },
  { id: 4798, code: "LXG", name: "Louang Namtha Airport" },
  { id: 4799, code: "LXN", name: "Jim Kelly Field" },
  { id: 4800, code: "LXR", name: "Luxor International Airport" },
  { id: 4801, code: "LXS", name: "Lemnos International Airport" },
  { id: 4802, code: "LXU", name: "Lukulu Airport" },
  { id: 4803, code: "LXV", name: "Lake County Airport" },
  { id: 4805, code: "LYA", name: "Luoyang Beijiao Airport" },
  { id: 4806, code: "LYB", name: "Edward Bodden Airfield" },
  { id: 4807, code: "LYC", name: "Lycksele Airport" },
  { id: 4808, code: "LYE", name: "RAF Lyneham" },
  { id: 4809, code: "LYG", name: "Lianyungang Baitabu Airport" },
  { id: 4810, code: "LYH", name: "Lynchburg Regional Airport (Preston Glenn Field)" },
  { id: 4811, code: "LYI", name: "Linyi Qiyang Airport (formerly Linyi Shubuling Airport)" },
  { id: 4812, code: "LYK", name: "Lunyuk Airport" },
  { id: 4813, code: "LYN", name: "Lyon–Bron Airport" },
  { id: 4814, code: "LYO", name: "Lyons–Rice County Municipal Airport" },
  { id: 4815, code: "LYP", name: "Faisalabad International Airport" },
  { id: 4816, code: "LYR", name: "Svalbard Airport, Longyear" },
  { id: 4817, code: "LYS", name: "Lyon–Saint-Exupéry Airport" },
  { id: 4818, code: "LYT", name: "Lady Elliot Island Airport" },
  { id: 4819, code: "LYU", name: "Ely Municipal Airport (FAA: ELO)" },
  { id: 4820, code: "LYX", name: "Lydd Airport (London Ashford Airport)" },
  { id: 4822, code: "LZA", name: "Luiza Airport" },
  { id: 4823, code: "LZC", name: "Lázaro Cárdenas Airport" },
  { id: 4824, code: "LZH", name: "Liuzhou Bailian Airport" },
  { id: 4825, code: "LZI", name: "Luozi Airport" },
  { id: 4826, code: "LZM", name: "Cuango-Luzamba Airport" },
  { id: 4827, code: "LZN", name: "Matsu Nangan Airport" },
  { id: 4828, code: "LZO", name: "Luzhou Yunlong Airport" },
  { id: 4829, code: "LZR", name: "Lizard Island Airport" },
  { id: 4830, code: "LZU", name: "Gwinnett County Airport[2] (Briscoe Field)" },
  { id: 4831, code: "LZY", name: "Nyingchi Mainling Airport" },
  { id: 4833, code: "MAA", name: "Chennai International Airport" },
  { id: 4834, code: "MAB", name: "João Correa da Rocha Airport" },
  { id: 4835, code: "MAC", name: "Macon Downtown Airport" },
  { id: 4836, code: "MAD", name: "Adolfo Suárez Madrid–Barajas Airport" },
  { id: 4837, code: "MAE", name: "Madera Municipal Airport" },
  { id: 4838, code: "MAF", name: "Midland International Air and Space Port" },
  { id: 4839, code: "MAG", name: "Madang Airport" },
  { id: 4840, code: "MAH", name: "Menorca Airport (Mahón Airport)" },
  { id: 4841, code: "MAI", name: "Mangochi Airport" },
  { id: 4842, code: "MAJ", name: "Marshall Islands International Airport (Amata Kabua Int'l)" },
  { id: 4843, code: "MAK", name: "Malakal Airport" },
  { id: 4844, code: "MAL", name: "Mangole Airport" },
  { id: 4845, code: "MAM", name: "General Servando Canales International Airport" },
  { id: 4846, code: "MAN", name: "Manchester Airport" },
  { id: 4847, code: "MAO", name: "Eduardo Gomes International Airport" },
  { id: 4848, code: "MAP", name: "Mamai Airport" },
  { id: 4849, code: "MAQ", name: "Mae Sot Airport" },
  { id: 4850, code: "MAR", name: "La Chinita International Airport" },
  { id: 4851, code: "MAS", name: "Momote Airport" },
  { id: 4852, code: "MAT", name: "Matadi Tshimpi Airport" },
  { id: 4853, code: "MAU", name: "Maupiti Airport" },
  { id: 4854, code: "MAV", name: "Maloelap Airport (FAA: 3N1)" },
  { id: 4855, code: "MAW", name: "Malden Regional Airport" },
  { id: 4856, code: "MAX", name: "Ouro Sogui Airport" },
  { id: 4857, code: "MAY", name: "Clarence A. Bain Airport" },
  { id: 4858, code: "MAZ", name: "Eugenio María de Hostos Airport" },
  { id: 4860, code: "MBA", name: "Moi International Airport" },
  { id: 4861, code: "MBB", name: "Marble Bar Airport" },
  { id: 4862, code: "MBC", name: "Mbigou Airport" },
  { id: 4863, code: "MBD", name: "Mahikeng Airport (Mmabatho Airport)" },
  { id: 4864, code: "MBE", name: "Monbetsu Airport" },
  { id: 4865, code: "MBF", name: "Porepunkah Airfield" },
  { id: 4866, code: "MBG", name: "Mobridge Municipal Airport" },
  { id: 4867, code: "MBH", name: "Maryborough Airport" },
  { id: 4868, code: "MBI", name: "Mbeya Airport" },
  { id: 4869, code: "MBJ", name: "Sangster International Airport" },
  { id: 4870, code: "MBK", name: "Orlando Villas-Bôas Regional Airport" },
  { id: 4871, code: "MBL", name: "Manistee County Blacker Airport" },
  { id: 4872, code: "MBM", name: "Mkambati Airport[1]" },
  { id: 4873, code: "MBN", name: "Mount Barnett Airport" },
  { id: 4874, code: "MBO", name: "Mamburao Airport" },
  { id: 4875, code: "MBP", name: "Moyobamba Airport" },
  { id: 4876, code: "MBQ", name: "Mbarara Airport" },
  { id: 4877, code: "MBR", name: "M'Bout Airport" },
  { id: 4878, code: "MBS", name: "MBS International Airport" },
  { id: 4879, code: "MBT", name: "Moises R. Espinosa Airport (Masbate Airport)" },
  { id: 4880, code: "MBU", name: "Mbambanakira Airport" },
  { id: 4881, code: "MBV", name: "Masa Airport" },
  { id: 4882, code: "MBW", name: "Moorabbin Airport" },
  { id: 4883, code: "MBX", name: "Maribor Edvard Rusjan Airport" },
  { id: 4884, code: "MBY", name: "Omar N. Bradley Airport" },
  { id: 4885, code: "MBZ", name: "Maués Airport" },
  { id: 4887, code: "MCA", name: "Macenta Airport" },
  { id: 4888, code: "MCB", name: "McComb–Pike County Airport (John E. Lewis Field)" },
  { id: 4889, code: "MCC", name: "McClellan Airfield" },
  { id: 4890, code: "MCD", name: "Mackinac Island Airport" },
  { id: 4891, code: "MCE", name: "Merced Regional Airport (MacReady Field)" },
  { id: 4892, code: "MCF", name: "MacDill Air Force Base" },
  { id: 4893, code: "MCG", name: "McGrath Airport" },
  { id: 4894, code: "MCH", name: "General Manuel Serrano Airport" },
  { id: 4895, code: "MCI", name: "Kansas City International Airport" },
  { id: 4896, code: "MCJ", name: "Jorge Isaacs Airport (La Mina Airport)" },
  { id: 4897, code: "MCK", name: "McCook Ben Nelson Regional Airport" },
  { id: 4898, code: "MCL", name: "McKinley National Park Airport (FAA: INR)" },
  { id: 4899, code: "MCN", name: "Middle Georgia Regional Airport" },
  { id: 4900, code: "MCO", name: "Orlando International Airport" },
  { id: 4901, code: "MCP", name: "Alberto Alcolumbre International Airport" },
  { id: 4902, code: "MCQ", name: "Miskolc Airport" },
  { id: 4903, code: "MCS", name: "Monte Caseros Airport" },
  { id: 4904, code: "MCT", name: "Muscat International Airport" },
  { id: 4905, code: "MCU", name: "Montluçon – Guéret Airport" },
  { id: 4906, code: "MCV", name: "McArthur River Mine Airport" },
  { id: 4907, code: "MCW", name: "Mason City Municipal Airport" },
  { id: 4908, code: "MCX", name: "Uytash Airport" },
  { id: 4909, code: "MCY", name: "Sunshine Coast Airport" },
  { id: 4910, code: "MCZ", name: "Zumbi dos Palmares International Airport" },
  { id: 4912, code: "MDB", name: "Melinda Airport" },
  { id: 4913, code: "MDC", name: "Sam Ratulangi International Airport" },
  { id: 4914, code: "MDD", name: "Midland Airpark" },
  { id: 4915, code: "MDE", name: "José María Córdova International Airport" },
  { id: 4916, code: "MDF", name: "Taylor County Airport" },
  { id: 4917, code: "MDG", name: "Mudanjiang Hailang Airport" },
  { id: 4918, code: "MDH", name: "Southern Illinois Airport" },
  { id: 4919, code: "MDI", name: "Makurdi Airport" },
  { id: 4920, code: "MDJ", name: "Madras Municipal Airport (FAA: S33)" },
  { id: 4921, code: "MDK", name: "Mbandaka Airport" },
  { id: 4922, code: "MDL", name: "Mandalay International Airport" },
  { id: 4923, code: "MDM", name: "Munduku Airport" },
  { id: 4924, code: "MDN", name: "Madison Municipal Airport" },
  { id: 4925, code: "MDO", name: "Middleton Island Airport" },
  { id: 4926, code: "MDP", name: "Mindiptana Airport" },
  { id: 4927, code: "MDQ", name: "Astor Piazzolla International Airport" },
  { id: 4928, code: "MDS", name: "Middle Caicos Airport" },
  { id: 4930, code: "MDT", name: "Harrisburg International Airport" },
  { id: 4931, code: "MDU", name: "Mendi Airport" },
  { id: 4932, code: "MDV", name: "Médouneu Airport" },
  { id: 4933, code: "MDW", name: "Midway International Airport" },
  { id: 4934, code: "MDX", name: "Mercedes Airport" },
  { id: 4935, code: "MDY", name: "Henderson Field" },
  { id: 4936, code: "MDZ", name: "Gov. Francisco Gabrielli International Airport (El Plumerillo)" },
  { id: 4938, code: "MEA", name: "Benedito Lacerda Airport" },
  { id: 4939, code: "MEB", name: "Essendon Airport" },
  { id: 4940, code: "MEC", name: "Eloy Alfaro International Airport" },
  { id: 4941, code: "MED", name: "Prince Mohammad bin Abdulaziz Airport" },
  { id: 4942, code: "MEE", name: "Maré Airport" },
  { id: 4943, code: "MEF", name: "Melfi Airport" },
  { id: 4944, code: "MEG", name: "Malanje Airport" },
  { id: 4945, code: "MEH", name: "Mehamn Airport" },
  { id: 4946, code: "MEI", name: "Meridian Regional Airport (Key Field)" },
  { id: 4947, code: "MEJ", name: "Port Meadville Airport (FAA: GKJ)" },
  { id: 4948, code: "MEK", name: "Bassatine Air Base[1]" },
  { id: 4949, code: "MEL", name: "Melbourne Airport" },
  { id: 4950, code: "MEM", name: "Memphis International Airport" },
  { id: 4951, code: "MEN", name: "Brenoux Airport" },
  { id: 4952, code: "MEO", name: "Dare County Regional Airport (FAA: MQI)" },
  { id: 4953, code: "MEP", name: "Mersing Airport" },
  { id: 4954, code: "MEQ", name: "Cut Nyak Dhien Airport" },
  { id: 4955, code: "MER", name: "Castle Airport" },
  { id: 4956, code: "MES", name: "Soewondo Air Force Base" },
  { id: 4957, code: "MET", name: "Moreton Airport" },
  { id: 4958, code: "MEU", name: "Serra do Areão Airport" },
  { id: 4959, code: "MEV", name: "Minden–Tahoe Airport" },
  { id: 4960, code: "MEW", name: "Mweka Airport" },
  { id: 4961, code: "MEX", name: "Mexico City International Airport" },
  { id: 4962, code: "MEY", name: "Meghauli Airport" },
  { id: 4963, code: "MEZ", name: "Messina Airport" },
  { id: 4965, code: "MFA", name: "Mafia Airport" },
  { id: 4966, code: "MFB", name: "Monfort Airport" },
  { id: 4967, code: "MFC", name: "Mafeteng Airport" },
  { id: 4968, code: "MFD", name: "Mansfield Lahm Regional Airport" },
  { id: 4969, code: "MFE", name: "McAllen Miller International Airport" },
  { id: 4970, code: "MFF", name: "Moanda Airport" },
  { id: 4971, code: "MFG", name: "Muzaffarabad Airport" },
  { id: 4972, code: "MFH", name: "Mesquite Airport (FAA: 67L)" },
  { id: 4973, code: "MFI", name: "Marshfield Municipal Airport" },
  { id: 4974, code: "MFJ", name: "Moala Airport" },
  { id: 4975, code: "MFK", name: "Matsu Beigan Airport[1]" },
  { id: 4976, code: "MFL", name: "Mount Full Stop Airport[1]" },
  { id: 4977, code: "MFM", name: "Macau International Airport" },
  { id: 4978, code: "MFN", name: "Milford Sound Airport" },
  { id: 4979, code: "MFO", name: "Manguna Airport" },
  { id: 4980, code: "MFP", name: "Manners Creek Airport[1]" },
  { id: 4981, code: "MFQ", name: "Maradi Airport" },
  { id: 4982, code: "MFR", name: "Rogue Valley International–Medford Airport" },
  { id: 4983, code: "MFS", name: "Miraflores Airport" },
  { id: 4984, code: "MFU", name: "Mfuwe Airport" },
  { id: 4985, code: "MFV", name: "Accomack County Airport" },
  { id: 4986, code: "MFW", name: "Magaruque Airport" },
  { id: 4987, code: "MFX", name: "Méribel Altiport" },
  { id: 4988, code: "MFY", name: "Mayfa'ah Airport" },
  { id: 4989, code: "MFZ", name: "Meselia Airport" },
  { id: 4991, code: "MGA", name: "Augusto C. Sandino International Airport" },
  { id: 4992, code: "MGB", name: "Mount Gambier Airport" },
  { id: 4993, code: "MGC", name: "Michigan City Municipal Airport" },
  { id: 4994, code: "MGD", name: "Magdalena Airport" },
  { id: 4995, code: "MGE", name: "Dobbins Air Reserve Base" },
  { id: 4996, code: "MGF", name: "Sílvio Name Júnior Regional Airport" },
  { id: 4997, code: "MGG", name: "Margarima Airport" },
  { id: 4998, code: "MGH", name: "Margate Airport" },
  { id: 4999, code: "MGI", name: "Aransas National Wildlife Refuge Airport[1] (FAA: XS10)" },
  { id: 5000, code: "MGJ", name: "Orange County Airport" },
  { id: 5001, code: "MGK", name: "Mong Ton Airport" },
  { id: 5002, code: "MGL", name: "Düsseldorf Mönchengladbach Airport" },
  { id: 5003, code: "MGM", name: "Montgomery Regional Airport (Dannelly Field)" },
  { id: 5004, code: "MGN", name: "Baracoa Regional Airport" },
  { id: 5005, code: "MGO", name: "Manega Airport[1]" },
  { id: 5006, code: "MGP", name: "Manga Airport" },
  { id: 5007, code: "MGQ", name: "Aden Adde International Airport" },
  { id: 5008, code: "MGR", name: "Moultrie Municipal Airport" },
  { id: 5009, code: "MGS", name: "Mangaia Airport" },
  { id: 5010, code: "MGT", name: "Milingimbi Airport" },
  { id: 5011, code: "MGU", name: "Manaung Airport[1]" },
  { id: 5012, code: "MGV", name: "Margaret River Station Airport" },
  { id: 5013, code: "MGW", name: "Morgantown Municipal Airport (Walter L. Bill Hart Field)" },
  { id: 5014, code: "MGX", name: "Moabi Airport" },
  { id: 5015, code: "MGY", name: "Dayton–Wright Brothers Airport" },
  { id: 5016, code: "MGZ", name: "Myeik Airport" },
  { id: 5018, code: "MHA", name: "Mahdia Airport" },
  { id: 5019, code: "MHC", name: "Mocopulli Airport" },
  { id: 5020, code: "MHD", name: "Mashhad International Airport (Shahid Hashemi Nejad Airport)" },
  { id: 5021, code: "MHE", name: "Mitchell Municipal Airport" },
  { id: 5022, code: "MHF", name: "Morichal Airport" },
  { id: 5023, code: "MHG", name: "Mannheim City Airport" },
  { id: 5024, code: "MHH", name: "Marsh Harbour Airport" },
  { id: 5025, code: "MHI", name: "Moucha Airport" },
  { id: 5026, code: "MHK", name: "Manhattan Regional Airport" },
  { id: 5027, code: "MHL", name: "Marshall Memorial Municipal Airport" },
  { id: 5028, code: "MHN", name: "Hooker County Airport" },
  { id: 5029, code: "MHO", name: "Mount House Airport" },
  { id: 5030, code: "MHP", name: "Minsk-1 Airport (closed 2015)" },
  { id: 5031, code: "MHQ", name: "Mariehamn Airport" },
  { id: 5032, code: "MHR", name: "Sacramento Mather Airport" },
  { id: 5033, code: "MHS", name: "Dunsmuir Municipal-Mott Airport[1] (FAA: 1O6)" },
  { id: 5034, code: "MHT", name: "Manchester–Boston Regional Airport" },
  { id: 5035, code: "MHU", name: "Mount Hotham Airport" },
  { id: 5036, code: "MHV", name: "Mojave Air and Space Port" },
  { id: 5037, code: "MHW", name: "Monteagudo Airport[1]" },
  { id: 5038, code: "MHX", name: "Manihiki Island Airport" },
  { id: 5039, code: "MHY", name: "Morehead Airport" },
  { id: 5040, code: "MHZ", name: "RAF Mildenhall" },
  { id: 5042, code: "MIA", name: "Miami International Airport" },
  { id: 5043, code: "MIB", name: "Minot Air Force Base" },
  { id: 5044, code: "MIC", name: "Crystal Airport" },
  { id: 5045, code: "MID", name: "Manuel Crescencio Rejón International Airport" },
  { id: 5046, code: "MIE", name: "Delaware County Regional Airport" },
  { id: 5047, code: "MIF", name: "Roy Hurd Memorial Airport (FAA: E01)" },
  { id: 5048, code: "MIG", name: "Mianyang Nanjiao Airport" },
  { id: 5049, code: "MIH", name: "Mitchell Plateau Airport" },
  { id: 5050, code: "MII", name: "Frank Miloye Milenkowichi–Marília State Airport" },
  { id: 5051, code: "MIJ", name: "Mili Airport (FAA: 1Q9)" },
  { id: 5052, code: "MIK", name: "Mikkeli Airport" },
  { id: 5053, code: "MIL[1]", name: "metropolitan area1" },
  { id: 5054, code: "MIM", name: "Merimbula Airport" },
  { id: 5055, code: "MIN", name: "Minnipa Airport" },
  { id: 5056, code: "MIO", name: "Miami Municipal Airport" },
  { id: 5057, code: "MIP", name: "Mitzpe Ramon Airport" },
  { id: 5058, code: "MIQ", name: "Millard Airport (FAA: MLE)" },
  { id: 5059, code: "MIR", name: "Monastir Habib Bourguiba International Airport" },
  { id: 5060, code: "MIS", name: "Misima Island Airport" },
  { id: 5061, code: "MIT", name: "Shafter Airport (Minter Field)" },
  { id: 5062, code: "MIU", name: "Maiduguri International Airport" },
  { id: 5063, code: "MIV", name: "Millville Municipal Airport" },
  { id: 5064, code: "MIW", name: "Marshalltown Municipal Airport" },
  { id: 5065, code: "MIX", name: "Mirití-Paraná Airport" },
  { id: 5066, code: "MIY", name: "Mittiebah Airport[1]" },
  { id: 5067, code: "MIZ", name: "Mainoru Airport[1]" },
  { id: 5069, code: "MJA", name: "Manja Airport" },
  { id: 5070, code: "MJB", name: "Mejit Airport (FAA: Q30)" },
  { id: 5071, code: "MJC", name: "Man Airport" },
  { id: 5072, code: "MJD", name: "Moenjodaro Airport" },
  { id: 5073, code: "MJE", name: "Majkin Airport" },
  { id: 5074, code: "MJF", name: "Mosjøen Airport, Kjærstad" },
  { id: 5075, code: "MJI", name: "Mitiga International Airport" },
  { id: 5076, code: "MJJ", name: "Moki Airport" },
  { id: 5077, code: "MJK", name: "Shark Bay Airport" },
  { id: 5078, code: "MJL", name: "Mouila Airport" },
  { id: 5079, code: "MJM", name: "Mbuji Mayi Airport" },
  { id: 5080, code: "MJN", name: "Amborovy Airport (Philibert Tsiranana Airport)" },
  { id: 5081, code: "MJO", name: "Mount Etjo Airport[1]" },
  { id: 5082, code: "MJP", name: "Manjimup Airport" },
  { id: 5083, code: "MJQ", name: "Jackson Municipal Airport" },
  { id: 5084, code: "MJR", name: "Miramar Airport" },
  { id: 5085, code: "MJS", name: "Maganja da Costa Airport[1]" },
  { id: 5086, code: "MJT", name: "Mytilene International Airport" },
  { id: 5087, code: "MJU", name: "Tampa Padang Airport" },
  { id: 5088, code: "MJV", name: "Murcia–San Javier Airport" },
  { id: 5089, code: "MJW", name: "Mahenye Airport[1]" },
  { id: 5090, code: "MJX", name: "Robert J. Miller Air Park (Ocean County Airport)" },
  { id: 5091, code: "MJZ", name: "Mirny Airport" },
  { id: 5093, code: "MKA", name: "Mariánské Lázně Airport" },
  { id: 5094, code: "MKB", name: "Mékambo Airport" },
  { id: 5095, code: "MKC", name: "Charles B. Wheeler Downtown Airport" },
  { id: 5096, code: "MKE", name: "Milwaukee Mitchell International Airport" },
  { id: 5097, code: "MKG", name: "Muskegon County Airport" },
  { id: 5098, code: "MKH", name: "Mokhotlong Airport" },
  { id: 5099, code: "MKI", name: "M'Boki Airport" },
  { id: 5100, code: "MKJ", name: "Makoua Airport" },
  { id: 5101, code: "MKK", name: "Molokai Airport" },
  { id: 5102, code: "MKL", name: "McKellar–Sipes Regional Airport" },
  { id: 5103, code: "MKM", name: "Mukah Airport" },
  { id: 5104, code: "MKN", name: "Malekolon Airport" },
  { id: 5105, code: "MKO", name: "Davis Field" },
  { id: 5106, code: "MKP", name: "Makemo Airport" },
  { id: 5107, code: "MKQ", name: "Mopah Airport" },
  { id: 5108, code: "MKR", name: "Meekatharra Airport" },
  { id: 5109, code: "MKS", name: "Mekane Selam Airport" },
  { id: 5110, code: "MKT", name: "Mankato Regional Airport" },
  { id: 5111, code: "MKU", name: "Makokou Airport" },
  { id: 5112, code: "MKV", name: "Mount Cavenagh Airport" },
  { id: 5113, code: "MKW", name: "Rendani Airport" },
  { id: 5114, code: "MKY", name: "Mackay Airport" },
  { id: 5115, code: "MKZ", name: "Malacca International Airport" },
  { id: 5117, code: "MLA", name: "Malta International Airport (Luqa Airport)" },
  { id: 5118, code: "MLB", name: "Melbourne Orlando International Airport" },
  { id: 5119, code: "MLC", name: "McAlester Regional Airport" },
  { id: 5120, code: "MLD", name: "Malad City Airport" },
  { id: 5121, code: "MLE", name: "Ibrahim Nasir International Airport" },
  { id: 5122, code: "MLF", name: "Milford Municipal Airport (Ben and Judy Briscoe Field)" },
  { id: 5123, code: "MLG", name: "Abdul Rachman Saleh Airport" },
  { id: 5124, code: "MLH", name: "EuroAirport Basel Mulhouse Freiburg" },
  { id: 5125, code: "MLI", name: "Quad Cities International Airport" },
  { id: 5126, code: "MLJ", name: "Baldwin County Airport" },
  { id: 5127, code: "MLK", name: "Malta Airport[1] (FAA: M75)" },
  { id: 5128, code: "MLL", name: "Marshall Don Hunter Sr. Airport (FAA: MDM)" },
  { id: 5129, code: "MLM", name: "General Francisco J. Mujica International Airport" },
  { id: 5130, code: "MLN", name: "Melilla Airport" },
  { id: 5131, code: "MLO", name: "Milos Island National Airport" },
  { id: 5132, code: "MLP", name: "Malabang Airport" },
  { id: 5133, code: "MLQ", name: "Malalaua Airport[1]" },
  { id: 5134, code: "MLR", name: "Millicent Airport" },
  { id: 5135, code: "MLS", name: "Miles City Airport (Frank Wiley Field)" },
  { id: 5136, code: "MLT", name: "Millinocket Municipal Airport" },
  { id: 5137, code: "MLU", name: "Monroe Regional Airport" },
  { id: 5138, code: "MLV", name: "Merluna Airport" },
  { id: 5139, code: "MLW", name: "Spriggs Payne Airport" },
  { id: 5140, code: "MLX", name: "Malatya Erhaç Airport" },
  { id: 5141, code: "MLY", name: "Manley Hot Springs Airport" },
  { id: 5142, code: "MLZ", name: "Cerro Largo International Airport" },
  { id: 5144, code: "MMA[1]", name: "metropolitan area2" },
  { id: 5145, code: "MMB", name: "Memanbetsu Airport" },
  { id: 5146, code: "MMC", name: "Ciudad Mante National Airport" },
  { id: 5147, code: "MMD", name: "Minami-Daito Airport" },
  { id: 5148, code: "MME", name: "Teesside International Airport" },
  { id: 5149, code: "MMF", name: "Mamfe Airport" },
  { id: 5150, code: "MMG", name: "Mount Magnet Airport" },
  { id: 5151, code: "MMH", name: "Mammoth Yosemite Airport" },
  { id: 5152, code: "MMI", name: "McMinn County Airport" },
  { id: 5153, code: "MMJ", name: "Matsumoto Airport" },
  { id: 5154, code: "MMK", name: "Murmansk Airport" },
  { id: 5155, code: "MML", name: "Southwest Minnesota Regional Airport (Marshall/Ryan Field)" },
  { id: 5156, code: "MMM", name: "Middlemount Airport" },
  { id: 5157, code: "MMN", name: "Minute Man Air Field[1] (FAA: 6B6)" },
  { id: 5158, code: "MMO", name: "Maio Airport" },
  { id: 5159, code: "MMP", name: "San Bernardo Airport" },
  { id: 5160, code: "MMQ", name: "Mbala Airport" },
  { id: 5161, code: "MMS", name: "Selfs Airport" },
  { id: 5162, code: "MMT", name: "McEntire Joint National Guard Base" },
  { id: 5163, code: "MMU", name: "Morristown Municipal Airport" },
  { id: 5164, code: "MMV", name: "Mal Island Airport" },
  { id: 5165, code: "MMW", name: "Moma Airport" },
  { id: 5166, code: "MMX", name: "Malmö Airport" },
  { id: 5167, code: "MMY", name: "Miyako Airport" },
  { id: 5168, code: "MMZ", name: "Maymana Airport" },
  { id: 5170, code: "MNA", name: "Melangguane Airport" },
  { id: 5171, code: "MNB", name: "Muanda Airport (Moanda Airport)" },
  { id: 5172, code: "MNC", name: "Nacala Airport" },
  { id: 5173, code: "MND", name: "Medina Airport[1]" },
  { id: 5174, code: "MNE", name: "Mungeranie Airport" },
  { id: 5175, code: "MNF", name: "Mana Island Airport" },
  { id: 5176, code: "MNG", name: "Maningrida Airport" },
  { id: 5177, code: "MNH", name: "Al-Musannah Airport[1]" },
  { id: 5178, code: "MNI", name: "John A. Osborne Airport" },
  { id: 5179, code: "MNJ", name: "Mananjary Airport" },
  { id: 5180, code: "MNK", name: "Maiana Airport" },
  { id: 5181, code: "MNL", name: "Ninoy Aquino International Airport / Villamor Air Base" },
  { id: 5182, code: "MNM", name: "Menominee-Marinette Twin County Airport" },
  { id: 5183, code: "MNN", name: "Marion Municipal Airport" },
  { id: 5184, code: "MNO", name: "Manono Airport" },
  { id: 5185, code: "MNP", name: "Maron Island Airport[1]" },
  { id: 5186, code: "MNQ", name: "Monto Airport" },
  { id: 5187, code: "MNR", name: "Mongu Airport" },
  { id: 5188, code: "MNS", name: "Mansa Airport" },
  { id: 5189, code: "MNT", name: "Minto Al Wright Airport (FAA: 51Z)" },
  { id: 5190, code: "MNU", name: "Mawlamyaing Airport" },
  { id: 5191, code: "MNV", name: "Mount Valley Airport[1]" },
  { id: 5192, code: "MNW", name: "MacDonald Downs Airport" },
  { id: 5193, code: "MNX", name: "Manicoré Airport" },
  { id: 5194, code: "MNY", name: "Mono Airport" },
  { id: 5195, code: "MNZ", name: "Manassas Regional Airport (FAA: HEF)" },
  { id: 5197, code: "MOA", name: "Orestes Acosta Airport" },
  { id: 5198, code: "MOB", name: "Mobile Regional Airport" },
  { id: 5199, code: "MOC", name: "Montes Claros/Mário Ribeiro Airport" },
  { id: 5200, code: "MOD", name: "Modesto City–County Airport (Harry Sham Field)" },
  { id: 5201, code: "MOE", name: "Momeik Airport" },
  { id: 5202, code: "MOF", name: "Frans Seda Airport (Wai Oti Airport)" },
  { id: 5203, code: "MOG", name: "Monghsat Airport" },
  { id: 5204, code: "MOH", name: "Maleo Airport" },
  { id: 5205, code: "MOI", name: "Mitiaro Airport (Nukuroa Airport)" },
  { id: 5206, code: "MOJ", name: "Moengo Airstrip" },
  { id: 5207, code: "MOK", name: "Muynak Airport" },
  { id: 5208, code: "MOL", name: "Molde Airport, Årø" },
  { id: 5209, code: "MOM", name: "Letfotar Airport" },
  { id: 5210, code: "MON", name: "Mount Cook Aerodrome" },
  { id: 5211, code: "MOO", name: "Moomba Airport" },
  { id: 5212, code: "MOP", name: "Mount Pleasant Municipal Airport" },
  { id: 5213, code: "MOQ", name: "Morondava Airport[1]" },
  { id: 5214, code: "MOR", name: "Morristown Regional Airport (Moore–Murrell Airport)" },
  { id: 5215, code: "MOS", name: "Moses Point Airport[1]" },
  { id: 5216, code: "MOT", name: "Minot International Airport" },
  { id: 5217, code: "MOU", name: "Mountain Village Airport" },
  { id: 5218, code: "MOV", name: "Moranbah Airport" },
  { id: 5219, code: "MOW[1]", name: "metropolitan area3" },
  { id: 5220, code: "MOX", name: "Morris Municipal Airport" },
  { id: 5221, code: "MOY", name: "Monterrey Airport" },
  { id: 5222, code: "MOZ", name: "Moorea Airport (Temae Airport)" },
  { id: 5224, code: "MPA", name: "Katima Mulilo Airport (Mpacha Airport)" },
  { id: 5225, code: "MPB", name: "Miami Seaplane Base (FAA: X44)" },
  { id: 5226, code: "MPC", name: "Mukomuko Airport" },
  { id: 5227, code: "MPD", name: "Sindhri Airport" },
  { id: 5228, code: "MPF", name: "Mapoda Airport" },
  { id: 5229, code: "MPG", name: "Makini Airport" },
  { id: 5230, code: "MPH", name: "Godofredo P. Ramos Airport (Caticlan Airport)" },
  { id: 5231, code: "MPI", name: "Mamitupu Airport" },
  { id: 5232, code: "MPJ", name: "Petit Jean Park Airport" },
  { id: 5233, code: "MPL", name: "Montpellier–Méditerranée Airport (Fréjorgues Airport)" },
  { id: 5234, code: "MPM", name: "Maputo International Airport" },
  { id: 5235, code: "MPN", name: "RAF Mount Pleasant" },
  { id: 5236, code: "MPO", name: "Pocono Mountains Municipal Airport" },
  { id: 5237, code: "MPP", name: "Mulatupo Airport" },
  { id: 5238, code: "MPQ", name: "Ma'an Airport" },
  { id: 5239, code: "MPR", name: "McPherson Airport" },
  { id: 5240, code: "MPS", name: "Mount Pleasant Regional Airport[1] (FAA: OSA)" },
  { id: 5241, code: "MPT", name: "Maliana Airport" },
  { id: 5242, code: "MPU", name: "Mabua Airstrip" },
  { id: 5243, code: "MPV", name: "Edward F. Knapp State Airport" },
  { id: 5244, code: "MPW", name: "Mariupol International Airport" },
  { id: 5245, code: "MPX", name: "Miyanmin Airport" },
  { id: 5246, code: "MPY", name: "Maripasoula Airport" },
  { id: 5247, code: "MPZ", name: "Mount Pleasant Municipal Airport" },
  { id: 5249, code: "MQA", name: "Mandora Station Airport" },
  { id: 5250, code: "MQB", name: "Macomb Municipal Airport" },
  { id: 5251, code: "MQC", name: "Miquelon Airport" },
  { id: 5252, code: "MQD", name: "Maquinchao Airport" },
  { id: 5253, code: "MQE", name: "Marqua Airport[1]" },
  { id: 5254, code: "MQF", name: "Magnitogorsk International Airport" },
  { id: 5255, code: "MQG", name: "Midgard Airport[1]" },
  { id: 5256, code: "MQH", name: "Minaçu Airport" },
  { id: 5257, code: "MQJ", name: "Moma Airport[1]" },
  { id: 5258, code: "MQK", name: "San Matías Airport[1]" },
  { id: 5259, code: "MQL", name: "Mildura Airport" },
  { id: 5260, code: "MQM", name: "Mardin Airport" },
  { id: 5261, code: "MQN", name: "Mo i Rana Airport, Røssvoll" },
  { id: 5262, code: "MQO", name: "Malam Airport[1]" },
  { id: 5263, code: "MQP", name: "Kruger Mpumalanga International Airport" },
  { id: 5264, code: "MQQ", name: "Moundou Airport" },
  { id: 5265, code: "MQR", name: "Mosquera Airport[1]" },
  { id: 5266, code: "MQS", name: "Mustique Airport" },
  { id: 5267, code: "MQT", name: "Sawyer International Airport (FAA: SAW)" },
  { id: 5268, code: "MQU", name: "Mariquita Airport" },
  { id: 5269, code: "MQV", name: "Mostaganem Airport[1]" },
  { id: 5270, code: "MQW", name: "Telfair–Wheeler Airport" },
  { id: 5271, code: "MQX", name: "Alula Aba Nega Airport" },
  { id: 5272, code: "MQY", name: "Smyrna Airport" },
  { id: 5273, code: "MQZ", name: "Margaret River Airport[1]" },
  { id: 5275, code: "MRA", name: "Misrata Airport" },
  { id: 5276, code: "MRB", name: "Eastern WV Regional Airport (Shepherd Field)" },
  { id: 5277, code: "MRC", name: "Maury County Airport" },
  { id: 5278, code: "MRD", name: "Alberto Carnevalli Airport" },
  { id: 5279, code: "MRE", name: "Mara Serena Airport" },
  { id: 5280, code: "MRF", name: "Marfa Municipal Airport" },
  { id: 5281, code: "MRG", name: "Mareeba Airfield" },
  { id: 5282, code: "MRH", name: "May River Airport[1]" },
  { id: 5283, code: "MRI", name: "Merrill Field" },
  { id: 5284, code: "MRJ", name: "Marcala Airport" },
  { id: 5285, code: "MRK", name: "Marco Island Airport (FAA: MKY)" },
  { id: 5286, code: "MRL", name: "Miners Lake Airport[1]" },
  { id: 5287, code: "MRM", name: "Manari Airport" },
  { id: 5288, code: "MRN", name: "Foothills Regional Airport (was Morganton-Lenoir Airport)" },
  { id: 5289, code: "MRO", name: "Hood Aerodrome" },
  { id: 5290, code: "MRP", name: "Marla Airport" },
  { id: 5291, code: "MRQ", name: "Marinduque Airport" },
  { id: 5292, code: "MRR", name: "José María Velasco Ibarra Airport" },
  { id: 5293, code: "MRS", name: "Marseille Provence Airport" },
  { id: 5294, code: "MRT", name: "Moroak Airport" },
  { id: 5295, code: "MRU", name: "Sir Seewoosagur Ramgoolam International Airport" },
  { id: 5296, code: "MRV", name: "Mineralnye Vody Airport" },
  { id: 5297, code: "MRW", name: "Lolland Falster Airport" },
  { id: 5298, code: "MRX", name: "Mahshahr Airport" },
  { id: 5299, code: "MRY", name: "Monterey Regional Airport" },
  { id: 5300, code: "MRZ", name: "Moree Airport" },
  { id: 5302, code: "MSA", name: "Muskrat Dam Airport" },
  { id: 5303, code: "MSC", name: "Falcon Field Airport (FAA: FFZ)" },
  { id: 5304, code: "MSD", name: "Mount Pleasant Airport (FAA: 43U)" },
  { id: 5305, code: "MSE", name: "Manston Airport (Kent International Airport)" },
  { id: 5306, code: "MSF", name: "Mount Swan Airport" },
  { id: 5307, code: "MSG", name: "Matsaile Airport[1]" },
  { id: 5308, code: "MSH", name: "Masirah Air Base" },
  { id: 5309, code: "MSI", name: "Masalembo Airport[1]" },
  { id: 5310, code: "MSJ", name: "Misawa Airport" },
  { id: 5311, code: "MSL", name: "Northwest Alabama Regional Airport" },
  { id: 5312, code: "MSM", name: "Masi-Manimba Airport" },
  { id: 5313, code: "MSN", name: "Dane County Regional Airport (Truax Field)" },
  { id: 5314, code: "MSO", name: "Missoula International Airport" },
  { id: 5315, code: "MSP", name: "Minneapolis–Saint Paul International Airport (Wold–Chamberlain Field)" },
  { id: 5316, code: "MSQ", name: "Minsk National Airport" },
  { id: 5317, code: "MSR", name: "Muş Airport" },
  { id: 5318, code: "MSS", name: "Massena International Airport (Richards Field)" },
  { id: 5319, code: "MST", name: "Maastricht Aachen Airport" },
  { id: 5320, code: "MSU", name: "Moshoeshoe I International Airport" },
  { id: 5321, code: "MSV", name: "Sullivan County International Airport" },
  { id: 5322, code: "MSW", name: "Massawa International Airport" },
  { id: 5323, code: "MSX", name: "Mossendjo Airport" },
  { id: 5324, code: "MSY", name: "Louis Armstrong New Orleans International Airport" },
  { id: 5325, code: "MSZ", name: "Moçâmedes Airport (Yuri Gagarin Airport)" },
  { id: 5327, code: "MTA", name: "Matamata Airport" },
  { id: 5328, code: "MTB", name: "Montelíbano Airport" },
  { id: 5329, code: "MTC", name: "Selfridge Air National Guard Base" },
  { id: 5330, code: "MTD", name: "Mount Sandford Station Airport[1]" },
  { id: 5331, code: "MTE", name: "Monte Alegre Airport" },
  { id: 5332, code: "MTF", name: "Mizan Teferi Airport" },
  { id: 5333, code: "MTG", name: "Mato Grosso Airport" },
  { id: 5334, code: "MTH", name: "Florida Keys Marathon Airport" },
  { id: 5335, code: "MTI", name: "Mosteiros Airport" },
  { id: 5336, code: "MTJ", name: "Montrose Regional Airport" },
  { id: 5337, code: "MTK", name: "Makin Airport" },
  { id: 5338, code: "MTL", name: "Maitland Airport" },
  { id: 5339, code: "MTM", name: "Metlakatla Seaplane Base" },
  { id: 5340, code: "MTN", name: "Martin State Airport" },
  { id: 5341, code: "MTO", name: "Coles County Memorial Airport" },
  { id: 5342, code: "MTP", name: "Montauk Airport" },
  { id: 5343, code: "MTQ", name: "Mitchell Airport" },
  { id: 5344, code: "MTR", name: "Los Garzones Airport" },
  { id: 5345, code: "MTS", name: "Matsapha Airport" },
  { id: 5346, code: "MTT", name: "Minatitlán/Coatzacoalcos International Airport" },
  { id: 5347, code: "MTU", name: "Montepuez Airport" },
  { id: 5348, code: "MTV", name: "Mota Lava Airport" },
  { id: 5349, code: "MTW", name: "Manitowoc County Airport" },
  { id: 5350, code: "MTX", name: "Metro Field (FAA: MTF)" },
  { id: 5351, code: "MTY", name: "General Mariano Escobedo International Airport" },
  { id: 5352, code: "MTZ", name: "Bar Yehuda Airfield (Masada Airfield)" },
  { id: 5354, code: "MUA", name: "Munda Airport" },
  { id: 5355, code: "MUB", name: "Maun Airport" },
  { id: 5356, code: "MUC", name: "Munich Airport" },
  { id: 5357, code: "MUD", name: "Mueda Airport" },
  { id: 5358, code: "MUE", name: "Waimea-Kohala Airport" },
  { id: 5359, code: "MUF", name: "Muting Airport" },
  { id: 5360, code: "MUG", name: "Mulegé Airstrip" },
  { id: 5361, code: "MUH", name: "Marsa Matruh International Airport" },
  { id: 5362, code: "MUI", name: "Muir Army Airfield" },
  { id: 5363, code: "MUJ", name: "Mui Airport" },
  { id: 5364, code: "MUK", name: "Mauke Airport" },
  { id: 5365, code: "MUL", name: "Spence Airport" },
  { id: 5366, code: "MUN", name: "José Tadeo Monagas International Airport" },
  { id: 5367, code: "MUO", name: "Mountain Home Air Force Base" },
  { id: 5368, code: "MUP", name: "Mulga Park Airport" },
  { id: 5369, code: "MUQ", name: "Muccan Station Airport" },
  { id: 5370, code: "MUR", name: "Marudi Airport" },
  { id: 5371, code: "MUS", name: "Minami Torishima Airport" },
  { id: 5372, code: "MUT", name: "Muscatine Municipal Airport" },
  { id: 5373, code: "MUW", name: "Ghriss Airport" },
  { id: 5374, code: "MUX", name: "Multan International Airport" },
  { id: 5375, code: "MUY", name: "Mouyondzi Airport" },
  { id: 5376, code: "MUZ", name: "Musoma Airport" },
  { id: 5378, code: "MVA", name: "Mývatn Airport" },
  { id: 5379, code: "MVB", name: "M'Vengue El Hadj Omar Bongo Ondimba International Airport" },
  { id: 5380, code: "MVC", name: "Monroe County Airport" },
  { id: 5381, code: "MVD", name: "Carrasco Gral. Cesáreo L. Berisso International Airport" },
  { id: 5382, code: "MVE", name: "Montevideo–Chippewa County Airport" },
  { id: 5383, code: "MVF", name: "Gov. Dix-Sept Rosado Airport" },
  { id: 5384, code: "MVG", name: "Mevang Airport" },
  { id: 5385, code: "MVH", name: "Macksville Airport[1]" },
  { id: 5386, code: "MVI", name: "Manetai Airport[1]" },
  { id: 5387, code: "MVK", name: "Mulka Airport" },
  { id: 5388, code: "MVL", name: "Morrisville–Stowe State Airport" },
  { id: 5389, code: "MVM", name: "Kayenta Airport (FAA: 0V7)" },
  { id: 5390, code: "MVN", name: "Mount Vernon Airport" },
  { id: 5391, code: "MVO", name: "Mongo Airport" },
  { id: 5392, code: "MVP", name: "Fabio Alberto León Bentley Airport" },
  { id: 5393, code: "MVQ", name: "Mogilev Airport" },
  { id: 5394, code: "MVR", name: "Salak Airport" },
  { id: 5395, code: "MVS", name: "Mucuri Airport" },
  { id: 5396, code: "MVT", name: "Mataiva Airport" },
  { id: 5397, code: "MVU", name: "Musgrave Airport" },
  { id: 5398, code: "MVV", name: "Megève Altiport" },
  { id: 5399, code: "MVW", name: "Skagit Regional Airport (FAA: BVS)" },
  { id: 5400, code: "MVX", name: "Minvoul Airport" },
  { id: 5401, code: "MVY", name: "Martha's Vineyard Airport" },
  { id: 5402, code: "MVZ", name: "Masvingo Airport" },
  { id: 5404, code: "MWA", name: "Williamson County Regional Airport" },
  { id: 5405, code: "MWB", name: "Morawa Airport" },
  { id: 5406, code: "MWC", name: "Lawrence J. Timmerman Airport" },
  { id: 5407, code: "MWD", name: "PAF Base M.M. Alam" },
  { id: 5408, code: "MWE", name: "Merowe Airport" },
  { id: 5409, code: "MWF", name: "Maewo-Naone Airport" },
  { id: 5410, code: "MWG", name: "Marawaka Airport" },
  { id: 5411, code: "MWH", name: "Grant County International Airport" },
  { id: 5412, code: "MWI", name: "Maramuni Airport[1]" },
  { id: 5413, code: "MWJ", name: "Matthews Ridge Airport" },
  { id: 5414, code: "MWK", name: "Matak Airport (Tarempa Airport)" },
  { id: 5415, code: "MWL", name: "Mineral Wells Airport" },
  { id: 5416, code: "MWM", name: "Windom Municipal Airport" },
  { id: 5417, code: "MWN", name: "Mwadui Airport[1]" },
  { id: 5418, code: "MWO", name: "Middletown Regional Airport (Hook Field)" },
  { id: 5419, code: "MWQ", name: "Magway Airport" },
  { id: 5420, code: "MWR", name: "Motswari Airstrip[1]" },
  { id: 5421, code: "MWT", name: "Moolawatana Airport" },
  { id: 5422, code: "MWU", name: "Mussau Island Airport" },
  { id: 5423, code: "MWV", name: "Mondulkiri Airport[1]" },
  { id: 5424, code: "MWX", name: "Muan International Airport[1]" },
  { id: 5425, code: "MWY", name: "Miranda Downs Airport" },
  { id: 5426, code: "MWZ", name: "Mwanza Airport" },
  { id: 5428, code: "MXA", name: "Manila Municipal Airport" },
  { id: 5429, code: "MXB", name: "Andi Jemma Airport" },
  { id: 5430, code: "MXC", name: "Monticello Airport (FAA: U43)" },
  { id: 5431, code: "MXD", name: "Marion Downs Airport" },
  { id: 5432, code: "MXE", name: "Laurinburg–Maxton Airport (FAA: MEB)" },
  { id: 5433, code: "MXF", name: "Maxwell Air Force Base" },
  { id: 5434, code: "MXG", name: "Marlboro Airport[1] (FAA: 9B1)" },
  { id: 5435, code: "MXH", name: "Moro Airport" },
  { id: 5436, code: "MXI", name: "Mati Airport (Imelda R. Marcos Airport)" },
  { id: 5437, code: "MXJ", name: "Minna Airport" },
  { id: 5438, code: "MXK", name: "Mindik Airport" },
  { id: 5439, code: "MXL", name: "Mexicali International Airport" },
  { id: 5440, code: "MXM", name: "Morombe Airport" },
  { id: 5441, code: "MXN", name: "Morlaix – Ploujean Airport" },
  { id: 5442, code: "MXO", name: "Monticello Regional Airport" },
  { id: 5443, code: "MXP", name: "Milan–Malpensa Airport" },
  { id: 5444, code: "MXR", name: "Myrhorod Air Base" },
  { id: 5445, code: "MXS", name: "Maota Airport" },
  { id: 5446, code: "MXT", name: "Maintirano Airport" },
  { id: 5447, code: "MXU", name: "Mullewa Airport" },
  { id: 5448, code: "MXV", name: "Mörön Airport" },
  { id: 5449, code: "MXW", name: "Mandalgovi Airport" },
  { id: 5450, code: "MXX", name: "Mora–Siljan Airport" },
  { id: 5451, code: "MXY", name: "McCarthy Airport (FAA: 15Z)" },
  { id: 5452, code: "MXZ", name: "Meixian Airport" },
  { id: 5454, code: "MYA", name: "Moruya Airport" },
  { id: 5455, code: "MYB", name: "Mayumba Airport" },
  { id: 5456, code: "MYC", name: "Mariscal Sucre Airport[1]" },
  { id: 5457, code: "MYD", name: "Malindi Airport" },
  { id: 5458, code: "MYE", name: "Miyakejima Airport" },
  { id: 5459, code: "MYF", name: "Montgomery Field Airport" },
  { id: 5460, code: "MYG", name: "Mayaguana Airport (Abraham's Bay Airport)" },
  { id: 5461, code: "MYH", name: "Marble Canyon Airport[1] (FAA: L41)" },
  { id: 5462, code: "MYI", name: "Murray Island Airport" },
  { id: 5463, code: "MYJ", name: "Matsuyama Airport" },
  { id: 5464, code: "MYK", name: "May Creek Airport" },
  { id: 5465, code: "MYL", name: "McCall Municipal Airport" },
  { id: 5466, code: "MYM", name: "Monkey Mountain Airport" },
  { id: 5467, code: "MYN", name: "Marib Airport" },
  { id: 5468, code: "MYO", name: "Myroodah Airport" },
  { id: 5469, code: "MYP", name: "Mary International Airport" },
  { id: 5470, code: "MYQ", name: "Mysore Airport (Mandakalli Airport)" },
  { id: 5471, code: "MYR", name: "Myrtle Beach International Airport" },
  { id: 5472, code: "MYT", name: "Myitkyina Airport" },
  { id: 5473, code: "MYU", name: "Mekoryuk Airport" },
  { id: 5474, code: "MYV", name: "Yuba County Airport" },
  { id: 5475, code: "MYW", name: "Mtwara Airport" },
  { id: 5476, code: "MYX", name: "Menyamya Airport" },
  { id: 5477, code: "MYY", name: "Miri Airport" },
  { id: 5478, code: "MYZ", name: "Monkey Bay Airport" },
  { id: 5480, code: "MZA", name: "Manuel Prado Ugarteche Airport[1]" },
  { id: 5481, code: "MZB", name: "Mocímboa da Praia Airport" },
  { id: 5482, code: "MZC", name: "Mitzic Airport" },
  { id: 5483, code: "MZD", name: "Méndez Airport" },
  { id: 5484, code: "MZE", name: "Manatee Airport[1]" },
  { id: 5485, code: "MZF", name: "Wild Coast Sun Airport" },
  { id: 5486, code: "MZG", name: "Magong Airport" },
  { id: 5487, code: "MZH", name: "Amasya Merzifon Airport" },
  { id: 5488, code: "MZI", name: "Mopti Airport (Ambodedjo Airport)" },
  { id: 5489, code: "MZJ", name: "Pinal Airpark" },
  { id: 5490, code: "MZK", name: "Marakei Airport" },
  { id: 5491, code: "MZL", name: "La Nubia Airport (Santaguida Airport)" },
  { id: 5492, code: "MZM", name: "Metz-Frescaty Air Base" },
  { id: 5493, code: "MZN", name: "Minj Airport" },
  { id: 5494, code: "MZO", name: "Sierra Maestra Airport" },
  { id: 5495, code: "MZP", name: "Motueka Aerodrome" },
  { id: 5496, code: "MZQ", name: "Mkuze Airport[1]" },
  { id: 5497, code: "MZR", name: "Mazar-e Sharif International Airport" },
  { id: 5498, code: "MZT", name: "Mazatlán International Airport" },
  { id: 5499, code: "MZU", name: "Muzaffarpur Airport" },
  { id: 5500, code: "MZV", name: "Mulu Airport" },
  { id: 5501, code: "MZW", name: "Mécheria Airport" },
  { id: 5502, code: "MZX", name: "Mena Airport" },
  { id: 5503, code: "MZY", name: "Mossel Bay Airport" },
  { id: 5504, code: "MZZ", name: "Marion Municipal Airport" },
  { id: 5506, code: "NAA", name: "Narrabri Airport[1]" },
  { id: 5507, code: "NAC", name: "Naracoorte Airport[1]" },
  { id: 5508, code: "NAD", name: "Macanal Airport[1]" },
  { id: 5509, code: "NAE", name: "Boundétingou Airport" },
  { id: 5510, code: "NAF", name: "Banaina Airport[1]" },
  { id: 5511, code: "NAG", name: "Dr. Babasaheb Ambedkar International Airport" },
  { id: 5512, code: "NAH", name: "Naha Airport" },
  { id: 5513, code: "NAI", name: "Annai Airport" },
  { id: 5514, code: "NAJ", name: "Nakhchivan International Airport" },
  { id: 5515, code: "NAK", name: "Nakhon Ratchasima Airport" },
  { id: 5516, code: "NAL", name: "Nalchik Airport" },
  { id: 5517, code: "NAM", name: "Namlea Airport[1]" },
  { id: 5518, code: "NAN", name: "Nadi International Airport" },
  { id: 5519, code: "NAO", name: "Nanchong Gaoping Airport" },
  { id: 5520, code: "NAP", name: "Naples International Airport" },
  { id: 5521, code: "NAQ", name: "Qaanaaq Airport[1]" },
  { id: 5522, code: "NAR", name: "Puerto Nare Airport[1]" },
  { id: 5523, code: "NAS", name: "Lynden Pindling International Airport" },
  { id: 5524, code: "NAT", name: "São Gonçalo do Amarante–Governador Aluízio Alves International Airport" },
  { id: 5525, code: "NAU", name: "Napuka Airport[1]" },
  { id: 5526, code: "NAV", name: "Nevşehir Kapadokya Airport" },
  { id: 5527, code: "NAW", name: "Narathiwat Airport[1]" },
  { id: 5528, code: "NAY", name: "Beijing Nanyuan Airport" },
  { id: 5529, code: "NAZ", name: "Nana Airport[1]" },
  { id: 5531, code: "NBA", name: "Nambaiyufa Airport[1]" },
  { id: 5532, code: "NBB", name: "Barranco Minas Airport[1]" },
  { id: 5533, code: "NBC", name: "Begishevo Airport" },
  { id: 5534, code: "NBE", name: "Enfidha-Hammamet International Airport" },
  { id: 5535, code: "NBG", name: "NAS JRB New Orleans (Alvin Callender Field)" },
  { id: 5536, code: "NBH", name: "Nambucca Heads Airport[1]" },
  { id: 5537, code: "NBL", name: "Wannukandi Airport[1]" },
  { id: 5538, code: "NBN", name: "Annobón Airport" },
  { id: 5539, code: "NBO", name: "Jomo Kenyatta International Airport" },
  { id: 5540, code: "NBS", name: "Changbaishan Airport" },
  { id: 5541, code: "NBW", name: "Leeward Point Field" },
  { id: 5542, code: "NBX", name: "Nabire Airport" },
  { id: 5544, code: "NCA", name: "North Caicos Airport" },
  { id: 5546, code: "NCE", name: "Nice Côte d'Azur Airport" },
  { id: 5547, code: "NCG", name: "Nuevo Casas Grandes Municipal Airport" },
  { id: 5548, code: "NCH", name: "Nachingwea Airport[1]" },
  { id: 5549, code: "NCI", name: "Antioquia Airport[1]" },
  { id: 5550, code: "NCJ", name: "Sunchales Aeroclub Airport[1]" },
  { id: 5551, code: "NCL", name: "Newcastle Airport" },
  { id: 5552, code: "NCN", name: "Chenega Bay Airport (FAA: C05)" },
  { id: 5553, code: "NCO", name: "Quonset State Airport[1] (FAA: OQU)" },
  { id: 5554, code: "NCR", name: "San Carlos Airport[1]" },
  { id: 5555, code: "NCS", name: "Newcastle Airport[1]" },
  { id: 5556, code: "NCT", name: "Nicoya Guanacaste Airport[1]" },
  { id: 5557, code: "NCU", name: "Nukus Airport" },
  { id: 5558, code: "NCY", name: "Annecy – Haute-Savoie – Mont Blanc Airport" },
  { id: 5560, code: "NDA", name: "Bandanaira Airport[1]" },
  { id: 5561, code: "NDB", name: "Nouadhibou International Airport" },
  { id: 5562, code: "NDC", name: "Shri Guru Gobind Singh Ji Airport" },
  { id: 5563, code: "NDD", name: "Sumbe Airport[1]" },
  { id: 5564, code: "NDE", name: "Mandera Airport[1]" },
  { id: 5565, code: "NDF", name: "N'dalatando Airport[1]" },
  { id: 5566, code: "NDG", name: "Qiqihar Sanjiazi Airport[1]" },
  { id: 5567, code: "NDI", name: "Namudi Airport[1]" },
  { id: 5568, code: "NDJ", name: "N'Djamena International Airport" },
  { id: 5569, code: "NDK", name: "Namorik Airport (Namdrik Airport) (FAA: 3N0)" },
  { id: 5570, code: "NDL", name: "N'Délé Airport[1]" },
  { id: 5571, code: "NDM", name: "Mendi Airport" },
  { id: 5572, code: "NDN", name: "Nadunumu Airport[1]" },
  { id: 5573, code: "NDP", name: "Naval Air Station Ellyson Field[2] (now retired)" },
  { id: 5574, code: "NDR", name: "Nador International Airport" },
  { id: 5575, code: "NDS", name: "Sandstone Airport[1]" },
  { id: 5576, code: "NDU", name: "Rundu Airport" },
  { id: 5577, code: "NDY", name: "Sanday Airport" },
  { id: 5579, code: "NEC", name: "Necochea Airport" },
  { id: 5580, code: "NEF", name: "Neftekamsk Airport" },
  { id: 5581, code: "NEG", name: "Negril Aerodrome" },
  { id: 5582, code: "NEJ", name: "Nejjo Airport[1]" },
  { id: 5583, code: "NEK", name: "Nekemte Airport[1]" },
  { id: 5584, code: "NEL", name: "NAES Lakehurst (Maxfield Field)" },
  { id: 5585, code: "NEN", name: "NOLF Whitehouse" },
  { id: 5586, code: "NER", name: "Chulman Neryungri Airport" },
  { id: 5587, code: "NEU", name: "Nathong Airport[1]" },
  { id: 5588, code: "NEV", name: "Vance W. Amory International Airport" },
  { id: 5589, code: "NEW", name: "Lakefront Airport" },
  { id: 5591, code: "NFG", name: "Nefteyugansk Airport" },
  { id: 5592, code: "NFL", name: "NAS Fallon (Van Voorhis Field)" },
  { id: 5593, code: "NFO", name: "Niuafo'ou Airport" },
  { id: 5594, code: "NFR", name: "Nafoora Airport" },
  { id: 5596, code: "NGA", name: "Young Airport[1]" },
  { id: 5597, code: "NGB", name: "Ningbo Lishe International Airport" },
  { id: 5598, code: "NGD", name: "Auguste George Airport" },
  { id: 5599, code: "NGE", name: "Ngaoundéré Airport[1]" },
  { id: 5600, code: "NGF", name: "MCAS Kaneohe Bay[1]" },
  { id: 5601, code: "NGI", name: "Gau Airport[1]" },
  { id: 5602, code: "NGK", name: "Nogliki Airport[1]" },
  { id: 5603, code: "NGL", name: "Ngala Airfield[1]" },
  { id: 5604, code: "NGN", name: "Narganá Airport[1]" },
  { id: 5605, code: "NGO", name: "Chūbu Centrair International Airport" },
  { id: 5606, code: "NGP", name: "NAS Corpus Christi (Truax Field)" },
  { id: 5607, code: "NGQ", name: "Ngari Gunsa Airport" },
  { id: 5608, code: "NGR", name: "Ningerum Airport[1]" },
  { id: 5609, code: "NGS", name: "Nagasaki Airport" },
  { id: 5610, code: "NGU", name: "NS Norfolk (Chambers Field)" },
  { id: 5611, code: "NGW", name: "NOLF Cabaniss Field" },
  { id: 5612, code: "NGX", name: "Manang Airport[1]" },
  { id: 5614, code: "NHA", name: "Nha Trang Air Base[1]" },
  { id: 5615, code: "NHD", name: "Al Minhad Air Base[1]" },
  { id: 5616, code: "NHF", name: "New Halfa Airport[1]" },
  { id: 5617, code: "NHK", name: "NAS Patuxent River (Trapnell Field)" },
  { id: 5618, code: "NHS", name: "Nushki Airport[1]" },
  { id: 5619, code: "NHT", name: "RAF Northolt" },
  { id: 5620, code: "NHV", name: "Nuku Hiva Airport[1]" },
  { id: 5621, code: "NHX", name: "NOLF Barin (FAA: NBJ)" },
  { id: 5622, code: "NHZ", name: "Brunswick Executive Airport" },
  { id: 5624, code: "NIA", name: "Nimba Airport" },
  { id: 5625, code: "NIB", name: "Nikolai Airport (FAA: FSP)" },
  { id: 5626, code: "NIC", name: "Nicosia International Airport1" },
  { id: 5627, code: "NIF", name: "Nifty Airport[1]" },
  { id: 5628, code: "NIG", name: "Nikunau Airport[1]" },
  { id: 5629, code: "NIK", name: "Niokolo-Koba Airport[1]" },
  { id: 5630, code: "NIM", name: "Diori Hamani International Airport" },
  { id: 5631, code: "NIN", name: "Ninilchik Airport" },
  { id: 5632, code: "NIO", name: "Nioki Airport" },
  { id: 5633, code: "NIP", name: "NAS Jacksonville (Towers Field)" },
  { id: 5634, code: "NIR", name: "Chase Field Industrial Complex[1] (FAA: 1XA2)" },
  { id: 5635, code: "NIS", name: "Simberi Airport" },
  { id: 5636, code: "NIT", name: "Niort - Souché Airport[1]" },
  { id: 5637, code: "NIU", name: "Niau Airport[1]" },
  { id: 5638, code: "NIX", name: "Nioro Airport" },
  { id: 5640, code: "NJA", name: "Naval Air Facility Atsugi[1]" },
  { id: 5641, code: "NJC", name: "Nizhnevartovsk Airport" },
  { id: 5642, code: "NJF", name: "Al Najaf International Airport" },
  { id: 5643, code: "NJK", name: "NAF El Centro" },
  { id: 5645, code: "NKA", name: "Nkan Airport[1]" },
  { id: 5646, code: "NKB", name: "Noonkanbah Airport[1]" },
  { id: 5647, code: "NKC", name: "Nouakchott–Oumtounsy International Airport" },
  { id: 5648, code: "NKD", name: "Sinak Airport[1]" },
  { id: 5649, code: "NKG", name: "Nanjing Lukou International Airport" },
  { id: 5650, code: "NKI", name: "Naukati Bay Seaplane Base[1] (FAA: AK62)" },
  { id: 5651, code: "NKL", name: "Nkolo-Fuma Airport" },
  { id: 5652, code: "NKM", name: "Nagoya Airfield (Komaki Airport)" },
  { id: 5653, code: "NKN", name: "Nankina Airport[1]" },
  { id: 5654, code: "NKO", name: "Ankokoambo Airport[1]" },
  { id: 5655, code: "NKP", name: "Nukutepipi Airport[1]" },
  { id: 5656, code: "NKS", name: "Nkongsamba Airport" },
  { id: 5657, code: "NKT", name: "Şırnak Airport" },
  { id: 5658, code: "NKU", name: "Nkaus Airport[1]" },
  { id: 5659, code: "NKX", name: "MCAS Miramar" },
  { id: 5660, code: "NKY", name: "Yokangassi Airport" },
  { id: 5662, code: "NLA", name: "Simon Mwansa Kapwepwe International Airport" },
  { id: 5663, code: "NLC", name: "NAS Lemoore (Reeves Field)" },
  { id: 5664, code: "NLD", name: "Quetzalcóatl International Airport" },
  { id: 5665, code: "NLE", name: "Jerry Tyler Memorial Airport (FAA: 3TR)" },
  { id: 5666, code: "NLF", name: "Darnley Island Airport[1]" },
  { id: 5667, code: "NLG", name: "Nelson Lagoon Airport (FAA: OUL)" },
  { id: 5668, code: "NLH", name: "Ninglang Luguhu Airport[1]" },
  { id: 5669, code: "NLI", name: "Nikolayevsk-on-Amur Airport" },
  { id: 5670, code: "NLK", name: "Norfolk Island Airport" },
  { id: 5671, code: "NLL", name: "Nullagine Airport[1]" },
  { id: 5672, code: "NLN", name: "Kneeland Airport[1] (FAA: O19)" },
  { id: 5673, code: "NLO", name: "N'Dolo Airport[1]" },
  { id: 5674, code: "NLP", name: "Nelspruit Airport[1]" },
  { id: 5675, code: "NLS", name: "Nicholson Airport[1]" },
  { id: 5676, code: "NLT", name: "Xinyuan Nalati Airport" },
  { id: 5677, code: "NLU", name: "Santa Lucía Air Force Base Num 1, Felipe Ángeles International Airport" },
  { id: 5678, code: "NLV", name: "Mykolaiv International Airport" },
  { id: 5680, code: "NMA", name: "Namangan Airport[1]" },
  { id: 5681, code: "NMB", name: "Daman Airport" },
  { id: 5682, code: "NMC", name: "Norman's Cay Airport[1]" },
  { id: 5683, code: "NME", name: "Nightmute Airport (FAA: IGT)" },
  { id: 5684, code: "NMF", name: "Maafaru International Airport[1]" },
  { id: 5685, code: "NMG", name: "San Miguel Airport[1]" },
  { id: 5686, code: "NMI", name: "Navi Mumbai International Airport" },
  { id: 5687, code: "NML", name: "Fort McMurray/Mildred Lake Airport[1] (TC: CAJ3)" },
  { id: 5688, code: "NMN", name: "Nomane Airport[1]" },
  { id: 5689, code: "NMP", name: "New Moon Airport[1]" },
  { id: 5690, code: "NMR", name: "Nappa Merrie Airport[1]" },
  { id: 5691, code: "NMS", name: "Nansang Airport[1]" },
  { id: 5692, code: "NMT", name: "Namtu Airport[1]" },
  { id: 5694, code: "NNA", name: "Kenitra Air Base" },
  { id: 5695, code: "NNB", name: "Santa Ana Airport[1]" },
  { id: 5696, code: "NND", name: "Nangade Airport[1]" },
  { id: 5697, code: "NNG", name: "Nanning Wuxu International Airport" },
  { id: 5698, code: "NNI", name: "Namutoni Airport[1]" },
  { id: 5699, code: "NNK", name: "Naknek Airport (FAA: 5NK)" },
  { id: 5700, code: "NNL", name: "Nondalton Airport (FAA: 5NN)" },
  { id: 5701, code: "NNM", name: "Naryan-Mar Airport" },
  { id: 5702, code: "NNR", name: "Connemara Airport" },
  { id: 5703, code: "NNT", name: "Nan Nakhon Airport[1]" },
  { id: 5704, code: "NNU", name: "Nanuque Airport[1]" },
  { id: 5705, code: "NNX", name: "Nunukan Airport" },
  { id: 5706, code: "NNY", name: "Nanyang Jiangying Airport" },
  { id: 5708, code: "NOA", name: "NAS Nowra[1]" },
  { id: 5709, code: "NOB", name: "Nosara Airport" },
  { id: 5710, code: "NOC", name: "Ireland West Airport" },
  { id: 5711, code: "NOD", name: "Norddeich Airport" },
  { id: 5712, code: "NOG", name: "Nogales International Airport" },
  { id: 5713, code: "NOI", name: "Novorossiysk Airport[1]" },
  { id: 5714, code: "NOJ", name: "Noyabrsk Airport" },
  { id: 5715, code: "NOK", name: "Nova Xavantina Airport[1]" },
  { id: 5716, code: "NOM", name: "Nomad River Airport[1]" },
  { id: 5717, code: "NON", name: "Nonouti Airport[1]" },
  { id: 5718, code: "NOO", name: "Naoro Airport[1]" },
  { id: 5719, code: "NOP", name: "Sinop Airport" },
  { id: 5720, code: "NOR", name: "Norðfjörður Airport[1]" },
  { id: 5721, code: "NOS", name: "Fascene Airport[1]" },
  { id: 5722, code: "NOT", name: "Marin County Airport (Gnoss Field) (FAA: DVO)" },
  { id: 5723, code: "NOU", name: "La Tontouta International Airport" },
  { id: 5724, code: "NOV", name: "Albano Machado Airport" },
  { id: 5725, code: "NOZ", name: "Spichenkovo Airport" },
  { id: 5727, code: "NPA", name: "NAS Pensacola (Forrest Sherman Field)" },
  { id: 5728, code: "NPE", name: "Hawke's Bay Airport" },
  { id: 5729, code: "NPG", name: "Nipa Airport[1]" },
  { id: 5730, code: "NPH", name: "Nephi Municipal Airport (FAA: U14)" },
  { id: 5731, code: "NPL", name: "New Plymouth Airport" },
  { id: 5732, code: "NPO", name: "Nanga Pinoh Airport[1]" },
  { id: 5733, code: "NPP", name: "Napperby Airport[1]" },
  { id: 5734, code: "NPR", name: "Novo Progresso Airport[1]" },
  { id: 5735, code: "NPT", name: "Newport State Airport (FAA: UUU)" },
  { id: 5736, code: "NPU", name: "San Pedro de Urabá Airport[1]" },
  { id: 5737, code: "NPY", name: "Mpanda Airport" },
  { id: 5739, code: "NQA", name: "Millington Regional Jetport" },
  { id: 5740, code: "NQI", name: "NAS Kingsville" },
  { id: 5741, code: "NQL", name: "Niquelândia Airport[1]" },
  { id: 5742, code: "NQN", name: "Presidente Perón International Airport" },
  { id: 5743, code: "NQT", name: "Nottingham Airport[1]" },
  { id: 5744, code: "NQU", name: "Reyes Murillo Airport" },
  { id: 5745, code: "NQX", name: "NAS Key West (Boca Chica Field)" },
  { id: 5746, code: "NQY", name: "Newquay Airport" },
  { id: 5747, code: "NQZ", name: "Nursultan Nazarbayev International Airport (since June 8, 2020)" },
  { id: 5749, code: "NRA", name: "Narrandera Airport[1]" },
  { id: 5750, code: "NRB", name: "NS Mayport (Admiral David L. McDonald Field)" },
  { id: 5751, code: "NRC", name: "NASA Crows Landing Airport" },
  { id: 5752, code: "NRD", name: "Norderney Airfield" },
  { id: 5753, code: "NRE", name: "Namrole Airport" },
  { id: 5754, code: "NRG", name: "Narrogin Airport" },
  { id: 5755, code: "NRI", name: "Grand Lake Regional Airport[1] (FAA: 3O9)" },
  { id: 5756, code: "NRK", name: "Norrköping Airport" },
  { id: 5757, code: "NRL", name: "North Ronaldsay Airport[1]" },
  { id: 5758, code: "NRM", name: "Keibane Airport" },
  { id: 5759, code: "NRN", name: "Weeze Airport (Niederrhein Airport)" },
  { id: 5760, code: "NRR", name: "José Aponte de la Torre Airport[1] (FAA: RVR)" },
  { id: 5761, code: "NRS", name: "NOLF Imperial Beach (Ream Field)" },
  { id: 5762, code: "NRT", name: "Narita International Airport" },
  { id: 5763, code: "NRY", name: "Newry Airport[1]" },
  { id: 5765, code: "NSB", name: "North Seaplane Base[1]" },
  { id: 5766, code: "NSE", name: "NAS Whiting Field – North" },
  { id: 5767, code: "NSH", name: "Noshahr Airport[1]" },
  { id: 5768, code: "NSI", name: "Yaoundé Nsimalen International Airport" },
  { id: 5769, code: "NSK", name: "Alykel Airport" },
  { id: 5770, code: "NSL", name: "Slayton Municipal Airport[1] (FAA: DVP)" },
  { id: 5771, code: "NSM", name: "Norseman Airport[1]" },
  { id: 5772, code: "NSN", name: "Nelson Airport" },
  { id: 5773, code: "NSO", name: "Scone Airport[1]" },
  { id: 5774, code: "NST", name: "Nakhon Si Thammarat Airport" },
  { id: 5775, code: "NSV", name: "Noosa Airport[1]" },
  { id: 5776, code: "NSY", name: "Naval Air Station Sigonella" },
  { id: 5778, code: "NTA", name: "Natadola Seaplane Base[1]" },
  { id: 5779, code: "NTB", name: "Notodden Airport, Tuven" },
  { id: 5780, code: "NTC", name: "Santa Carolina Airport[1]" },
  { id: 5781, code: "NTD", name: "NAS Point Mugu (Naval Base Ventura County)" },
  { id: 5782, code: "NTE", name: "Nantes Atlantique Airport" },
  { id: 5783, code: "NTG", name: "Nantong Xingdong Airport" },
  { id: 5784, code: "NTI", name: "Stenkool Airport[1]" },
  { id: 5785, code: "NTJ", name: "Manti-Ephraim Airport (FAA: 41U)" },
  { id: 5786, code: "NTL", name: "Newcastle Airport / RAAF Base Williamtown" },
  { id: 5787, code: "NTM", name: "Miracema do Tocantins Airport[1]" },
  { id: 5788, code: "NTN", name: "Normanton Airport[1]" },
  { id: 5789, code: "NTO", name: "Agostinho Neto Airport" },
  { id: 5790, code: "NTQ", name: "Noto Airport[1]" },
  { id: 5791, code: "NTR", name: "Del Norte International Airport[1]" },
  { id: 5792, code: "NTT", name: "Niuatoputapu Airport" },
  { id: 5793, code: "NTU", name: "NAS Oceana (Apollo Soucek Field)" },
  { id: 5794, code: "NTX", name: "Ranai Airport" },
  { id: 5795, code: "NTY", name: "Pilanesberg International Airport" },
  { id: 5797, code: "NUA", name: "Gregory Lake Seaplane Base[1]" },
  { id: 5798, code: "NUB", name: "Numbulwar Airport[1]" },
  { id: 5799, code: "NUD", name: "En Nahud Airport[1]" },
  { id: 5800, code: "NUE", name: "Nuremberg Airport" },
  { id: 5801, code: "NUF", name: "Castlereigh Reservoir Seaplane Base[1]" },
  { id: 5802, code: "NUG", name: "Nuguria Airstrip[1]" },
  { id: 5803, code: "NUH", name: "Nunchía Airport[1]" },
  { id: 5804, code: "NUI", name: "Nuiqsut Airport (FAA: AQT)" },
  { id: 5805, code: "NUJ", name: "Hamedan Air Base[1] (Nogeh Airport)" },
  { id: 5806, code: "NUK", name: "Nukutavake Airport" },
  { id: 5807, code: "NUL", name: "Nulato Airport" },
  { id: 5808, code: "NUM", name: "Neom Bay Airport" },
  { id: 5809, code: "NUN", name: "NOLF Saufley Field" },
  { id: 5810, code: "NUP", name: "Nunapitchuk Airport (FAA: 16A)" },
  { id: 5811, code: "NUQ", name: "Moffett Federal Airfield" },
  { id: 5812, code: "NUR", name: "Nullabor Motel Airport[1]" },
  { id: 5813, code: "NUS", name: "Norsup Airport" },
  { id: 5814, code: "NUT", name: "Nutuve Airport[1]" },
  { id: 5815, code: "NUU", name: "Nakuru Airport[1]" },
  { id: 5816, code: "NUW", name: "NAS Whidbey Island (Ault Field)" },
  { id: 5817, code: "NUX", name: "Novy Urengoy Airport" },
  { id: 5819, code: "NVA", name: "Benito Salas Airport" },
  { id: 5820, code: "NVD", name: "Nevada Municipal Airport" },
  { id: 5821, code: "NVG", name: "Nueva Guinea Airport[1]" },
  { id: 5822, code: "NVI", name: "Navoiy International Airport[1]" },
  { id: 5823, code: "NVK", name: "Narvik Airport, Framnes" },
  { id: 5824, code: "NVN", name: "Nervino Airport (FAA: O02)" },
  { id: 5825, code: "NVP", name: "Novo Aripuanã Airport[1]" },
  { id: 5826, code: "NVR", name: "Novgorod Airport" },
  { id: 5827, code: "NVS", name: "Nevers - Fourchambault Airport[1]" },
  { id: 5828, code: "NVT", name: "Navegantes–Ministro Victor Konder International Airport" },
  { id: 5829, code: "NVY", name: "Neyveli Airport" },
  { id: 5831, code: "NWA", name: "Mohéli Bandar Es Eslam Airport[1]" },
  { id: 5832, code: "NWH", name: "Parlin Field (FAA: 2B3)" },
  { id: 5833, code: "NWI", name: "Norwich International Airport" },
  { id: 5834, code: "NWT", name: "Nowata Airport[1]" },
  { id: 5836, code: "NYA", name: "Nyagan Airport" },
  { id: 5837, code: "NYC[1]", name: "metropolitan area2" },
  { id: 5838, code: "NYE", name: "Nyeri Airport[1]" },
  { id: 5839, code: "NYG", name: "MCAF Quantico (Turner Field)" },
  { id: 5840, code: "NYI", name: "Sunyani Airport" },
  { id: 5841, code: "NYK", name: "Nanyuki Airport" },
  { id: 5842, code: "NYM", name: "Nadym Airport" },
  { id: 5843, code: "NYN", name: "Nyngan Airport[1]" },
  { id: 5844, code: "NYO", name: "Stockholm Skavsta Airport" },
  { id: 5845, code: "NYR", name: "Nyurba Airport" },
  { id: 5846, code: "NYS", name: "New York Skyports Seaplane Base" },
  { id: 5847, code: "NYT", name: "Naypyidaw Airport" },
  { id: 5848, code: "NYU", name: "Nyaung U Airport" },
  { id: 5849, code: "NYW", name: "Monywa Airport[1]" },
  { id: 5851, code: "NZA", name: "Nzagi Airport" },
  { id: 5852, code: "NZC", name: "Maria Reiche Neuman Airport" },
  { id: 5853, code: "NZE", name: "Nzérékoré Airport" },
  { id: 5854, code: "NZH", name: "Manzhouli Xijiao Airport[1]" },
  { id: 5855, code: "NZL", name: "Zhalantun Chengjisihan Airport[1]" },
  { id: 5856, code: "NZY", name: "NAS North Island (Halsey Field)" },
  { id: 5858, code: "OAA", name: "Forward Operating Base Shank" },
  { id: 5859, code: "OAG", name: "Orange Airport[1]" },
  { id: 5860, code: "OAH", name: "Shindand Air Base" },
  { id: 5861, code: "OAI", name: "Bagram Airfield" },
  { id: 5862, code: "OAJ", name: "Albert J. Ellis Airport" },
  { id: 5863, code: "OAK", name: "Oakland International Airport" },
  { id: 5864, code: "OAL", name: "Capital do Café Airport[1]" },
  { id: 5865, code: "OAM", name: "Oamaru Airport" },
  { id: 5866, code: "OAN", name: "El Arrayán Airport[1]" },
  { id: 5867, code: "OAR", name: "Marina Municipal Airport" },
  { id: 5868, code: "OAS", name: "Sharana Airstrip / Forward Operating Base Sharana" },
  { id: 5869, code: "OAX", name: "Xoxocotlán International Airport" },
  { id: 5870, code: "OAZ", name: "Camp Bastion Air Base" },
  { id: 5872, code: "OBA", name: "Oban Airport[1]" },
  { id: 5873, code: "OBC", name: "Obock Airport" },
  { id: 5874, code: "OBD", name: "Obano Airport" },
  { id: 5875, code: "OBE", name: "Okeechobee County Airport" },
  { id: 5876, code: "OBF", name: "Oberpfaffenhofen Airport" },
  { id: 5877, code: "OBI", name: "Óbidos Airport[1]" },
  { id: 5878, code: "OBL", name: "Oostmalle Airfield" },
  { id: 5879, code: "OBM", name: "Morobe Airport[1]" },
  { id: 5880, code: "OBN", name: "Oban Airport[1] (North Connel Airport)" },
  { id: 5881, code: "OBO", name: "Tokachi–Obihiro Airport" },
  { id: 5882, code: "OBS", name: "Aubenas Aerodrome[1] (Ardèche Méridionale Aerodrome)" },
  { id: 5883, code: "OBU", name: "Kobuk Airport" },
  { id: 5884, code: "OBX", name: "Obo Airport" },
  { id: 5886, code: "OCA", name: "Ocean Reef Club Airport (FAA: 07FA)" },
  { id: 5887, code: "OCC", name: "Francisco de Orellana Airport" },
  { id: 5888, code: "OCE", name: "Ocean City Municipal Airport" },
  { id: 5889, code: "OCF", name: "Ocala International Airport (Jim Taylor Field)" },
  { id: 5890, code: "OCH", name: "A.L. Mangham Jr. Regional Airport" },
  { id: 5891, code: "OCJ", name: "Ian Fleming International Airport" },
  { id: 5892, code: "OCM", name: "Boolgeeda Airport[1]" },
  { id: 5893, code: "OCN", name: "Oceanside Municipal Airport (FAA: OKB)" },
  { id: 5894, code: "OCS", name: "Corisco International Airport[1]" },
  { id: 5895, code: "OCV", name: "Aguas Claras Airport[1]" },
  { id: 5896, code: "OCW", name: "Washington–Warren Airport (Warren Field)" },
  { id: 5898, code: "ODA", name: "Ouadda Airport[1]" },
  { id: 5899, code: "ODB", name: "Córdoba Airport" },
  { id: 5900, code: "ODC", name: "Oakdale Airport[1] (FAA: O27)" },
  { id: 5901, code: "ODD", name: "Oodnadatta Airport[1]" },
  { id: 5902, code: "ODE", name: "Hans Christian Andersen Airport" },
  { id: 5903, code: "ODH", name: "RAF Odiham" },
  { id: 5904, code: "ODJ", name: "Ouanda Djallé Airport[1]" },
  { id: 5905, code: "ODL", name: "Cordillo Downs Airport[1]" },
  { id: 5906, code: "ODM", name: "Garrett County Airport[1] (FAA: 2G4)" },
  { id: 5907, code: "ODN", name: "Long Seridan Airport[1]" },
  { id: 5908, code: "ODO", name: "Bodaybo Airport[1]" },
  { id: 5909, code: "ODR", name: "Ord River Airport[1]" },
  { id: 5910, code: "ODS", name: "Odesa International Airport" },
  { id: 5911, code: "ODW", name: "A.J. Eisenberg Airport (FAA: OKH)" },
  { id: 5912, code: "ODY", name: "Oudomsay Airport" },
  { id: 5914, code: "OEC", name: "Oecusse Airport" },
  { id: 5915, code: "OEL", name: "Oryol Yuzhny Airport" },
  { id: 5916, code: "OEM", name: "Vincent Fayks Airport" },
  { id: 5917, code: "OEO", name: "L.O. Simenstad Municipal Airport" },
  { id: 5918, code: "OER", name: "Örnsköldsvik Airport" },
  { id: 5919, code: "OES", name: "Antoine de Saint Exupéry Airport" },
  { id: 5921, code: "OFF", name: "Offutt Air Force Base" },
  { id: 5922, code: "OFI", name: "Ouango Fitini Airport[1]" },
  { id: 5923, code: "OFJ", name: "Ólafsfjörður Airport[1]" },
  { id: 5924, code: "OFK", name: "Norfolk Regional Airport (Karl Stefan Memorial Field)" },
  { id: 5925, code: "OFU", name: "Ofu Airport (FAA: Z08)" },
  { id: 5927, code: "OGA", name: "Searle Field" },
  { id: 5928, code: "OGB", name: "Orangeburg Municipal Airport" },
  { id: 5929, code: "OGD", name: "Ogden-Hinckley Airport" },
  { id: 5930, code: "OGE", name: "Ogeramnang Airport[1]" },
  { id: 5931, code: "OGG", name: "Kahului Airport" },
  { id: 5932, code: "OGL", name: "Ogle Airport" },
  { id: 5933, code: "OGM", name: "Ustupu-Ogobsucum Airport[1]" },
  { id: 5934, code: "OGN", name: "Yonaguni Airport" },
  { id: 5935, code: "OGO", name: "Abengourou Airport[1]" },
  { id: 5936, code: "OGR", name: "Bongor Airport" },
  { id: 5937, code: "OGS", name: "Ogdensburg International Airport" },
  { id: 5938, code: "OGU", name: "Ordu–Giresun Airport" },
  { id: 5939, code: "OGV", name: "Ongava Airstrip[1]" },
  { id: 5940, code: "OGX", name: "Ain Beida Airport" },
  { id: 5941, code: "OGZ", name: "Beslan Airport" },
  { id: 5943, code: "OHA", name: "RNZAF Base Ohakea[1]" },
  { id: 5944, code: "OHB", name: "Ambohibary Airport[1]" },
  { id: 5945, code: "OHD", name: "Ohrid St. Paul the Apostle Airport" },
  { id: 5946, code: "OHE", name: "Mohe Gulian Airport" },
  { id: 5947, code: "OHH", name: "Okha Airport (Novostroyka Airport)" },
  { id: 5948, code: "OHI", name: "Oshakati Airport[1]" },
  { id: 5949, code: "OHO", name: "Okhotsk Airport" },
  { id: 5950, code: "OHR", name: "Wyk auf Föhr Airport[1]" },
  { id: 5951, code: "OHS", name: "Sohar Airport[1]" },
  { id: 5952, code: "OHT", name: "PAF Base Kohat" },
  { id: 5954, code: "OIA", name: "Ourilândia do Norte Airport[1]" },
  { id: 5955, code: "OIC", name: "Lt. Warren Eaton Airport" },
  { id: 5956, code: "OIM", name: "Oshima Airport[1]" },
  { id: 5957, code: "OIR", name: "Okushiri Airport" },
  { id: 5958, code: "OIS", name: "Goris Airport" },
  { id: 5959, code: "OIT", name: "Oita Airport" },
  { id: 5961, code: "OJC", name: "Johnson County Executive Airport" },
  { id: 5962, code: "OJU", name: "Tanjung Api Airport" },
  { id: 5964, code: "OKA", name: "Naha Airport" },
  { id: 5965, code: "OKB", name: "Orchid Beach Airport" },
  { id: 5966, code: "OKC", name: "Will Rogers World Airport" },
  { id: 5967, code: "OKD", name: "Okadama Airport[1]" },
  { id: 5968, code: "OKE", name: "Okinoerabu Airport[1]" },
  { id: 5969, code: "OKF", name: "Okaukuejo Airport[1]" },
  { id: 5970, code: "OKG", name: "Okoyo Airport[1]" },
  { id: 5971, code: "OKH", name: "RAF Cottesmore" },
  { id: 5972, code: "OKI", name: "Oki Airport[1]" },
  { id: 5973, code: "OKJ", name: "Okayama Airport" },
  { id: 5974, code: "OKK", name: "Kokomo Municipal Airport" },
  { id: 5975, code: "OKL", name: "Gunung Bintang Airport" },
  { id: 5976, code: "OKM", name: "Okmulgee Regional Airport" },
  { id: 5977, code: "OKN", name: "Okondja Airport[1]" },
  { id: 5978, code: "OKO", name: "Yokota Air Base[1]" },
  { id: 5979, code: "OKP", name: "Oksapmin Airport[1]" },
  { id: 5980, code: "OKQ", name: "Okaba Airport[1]" },
  { id: 5981, code: "OKR", name: "Yorke Island Airport[1]" },
  { id: 5982, code: "OKS", name: "Garden County Airport" },
  { id: 5983, code: "OKT", name: "Oktyabrsky Airport" },
  { id: 5984, code: "OKU", name: "Mokuti Lodge Airport[1]" },
  { id: 5985, code: "OKV", name: "Okao Airport[1]" },
  { id: 5986, code: "OKY", name: "Oakey Army Aviation Centre[1]" },
  { id: 5988, code: "OLA", name: "Ørland Airport[1]" },
  { id: 5989, code: "OLB", name: "Olbia Costa Smeralda Airport" },
  { id: 5990, code: "OLC", name: "Senadora Eunice Michiles Airport[1]" },
  { id: 5991, code: "OLD", name: "Old Town Municipal Airport and Seaplane Base (Dewitt Field)" },
  { id: 5992, code: "OLE", name: "Cattaraugus County-Olean Airport" },
  { id: 5993, code: "OLF", name: "L. M. Clayton Airport" },
  { id: 5994, code: "OLH", name: "Old Harbor Airport (FAA: 6R7)" },
  { id: 5995, code: "OLI", name: "Rif Airport[1]" },
  { id: 5996, code: "OLJ", name: "Olpoi Airport[1] (North West Santo Airport)" },
  { id: 5997, code: "OLK", name: "Fuerte Olimpo Airport" },
  { id: 5998, code: "OLL", name: "Oyo Ollombo Airport" },
  { id: 5999, code: "OLM", name: "Olympia Regional Airport" },
  { id: 6000, code: "OLN", name: "Lago Musters Airport[1]" },
  { id: 6001, code: "OLO", name: "Olomouc Airport (Neředín Airport)" },
  { id: 6002, code: "OLP", name: "Olympic Dam Airport[1]" },
  { id: 6003, code: "OLQ", name: "Olsobip Airport[1]" },
  { id: 6004, code: "OLR", name: "Forward Operating Base Salerno" },
  { id: 6005, code: "OLS", name: "Nogales International Airport" },
  { id: 6006, code: "OLU", name: "Columbus Municipal Airport" },
  { id: 6007, code: "OLV", name: "Olive Branch Airport" },
  { id: 6008, code: "OLX", name: "Olkiombo Airstrip[1]" },
  { id: 6009, code: "OLY", name: "Olney-Noble Airport" },
  { id: 6010, code: "OLZ", name: "Olyokminsk Airport" },
  { id: 6012, code: "OMA", name: "Eppley Airfield" },
  { id: 6013, code: "OMB", name: "Omboué Hospital Airport[1]" },
  { id: 6014, code: "OMC", name: "Ormoc Airport" },
  { id: 6015, code: "OMD", name: "Oranjemund Airport[1]" },
  { id: 6016, code: "OME", name: "Nome Airport" },
  { id: 6017, code: "OMF", name: "King Hussein Air Base" },
  { id: 6018, code: "OMG", name: "Omega Airport[1]" },
  { id: 6019, code: "OMH", name: "Urmia Airport[1]" },
  { id: 6020, code: "OMI", name: "Omidiyeh Air Base" },
  { id: 6021, code: "OMJ", name: "Ōmura Airport[1]" },
  { id: 6022, code: "OMK", name: "Omak Airport" },
  { id: 6023, code: "OML", name: "Omkalai Airport[1]" },
  { id: 6024, code: "OMM", name: "Marmul Airport[1]" },
  { id: 6025, code: "OMN", name: "Zomin Airport[1]" },
  { id: 6026, code: "OMO", name: "Mostar Airport" },
  { id: 6027, code: "OMR", name: "Oradea International Airport" },
  { id: 6028, code: "OMS", name: "Omsk Tsentralny Airport" },
  { id: 6029, code: "OMY", name: "Thbeng Meanchey Airport[1] (Preah Vinhear Airport)" },
  { id: 6031, code: "ONA", name: "Winona Municipal Airport (Max Conrad Field)" },
  { id: 6032, code: "ONB", name: "Ononge Airport[1]" },
  { id: 6033, code: "OND", name: "Ondangwa Airport[1]" },
  { id: 6034, code: "ONE", name: "Onepusu Airport[1]" },
  { id: 6035, code: "ONG", name: "Mornington Island Airport[1]" },
  { id: 6036, code: "ONH", name: "Oneonta Municipal Airport (FAA: N66)" },
  { id: 6037, code: "ONI", name: "Moanamani Airport[1]" },
  { id: 6038, code: "ONJ", name: "Odate–Noshiro Airport" },
  { id: 6039, code: "ONK", name: "Olenyok Airport" },
  { id: 6040, code: "ONL", name: "O'Neill Municipal Airport (John L. Baker Field)" },
  { id: 6041, code: "ONM", name: "Socorro Municipal Airport" },
  { id: 6042, code: "ONO", name: "Ontario Municipal Airport" },
  { id: 6043, code: "ONP", name: "Newport Municipal Airport" },
  { id: 6044, code: "ONQ", name: "Zonguldak Airport" },
  { id: 6045, code: "ONR", name: "Monkira Airport[1]" },
  { id: 6046, code: "ONS", name: "Onslow Airport[1]" },
  { id: 6047, code: "ONT", name: "Ontario International Airport" },
  { id: 6048, code: "ONU", name: "Ono-i-Lau Airport[1]" },
  { id: 6049, code: "ONX", name: "Enrique Adolfo Jiménez Airport" },
  { id: 6050, code: "ONY", name: "Olney Municipal Airport" },
  { id: 6052, code: "OOA", name: "Oskaloosa Municipal Airport" },
  { id: 6053, code: "OOK", name: "Toksook Bay Airport" },
  { id: 6054, code: "OOL", name: "Gold Coast Airport (Coolangatta Airport)" },
  { id: 6055, code: "OOM", name: "Cooma–Snowy Mountains Airport[1]" },
  { id: 6056, code: "OOR", name: "Mooraberree Airport[1]" },
  { id: 6057, code: "OOT", name: "Onotoa Airport[1]" },
  { id: 6059, code: "OPA", name: "Kópasker Airport[1]" },
  { id: 6060, code: "OPB", name: "Open Bay Airport[1]" },
  { id: 6061, code: "OPF", name: "Miami-Opa Locka Executive Airport" },
  { id: 6062, code: "OPI", name: "Oenpelli Airport[1]" },
  { id: 6063, code: "OPL", name: "St. Landry Parish Airport (Ahart Field)" },
  { id: 6064, code: "OPO", name: "Francisco de Sá Carneiro Airport" },
  { id: 6065, code: "OPS", name: "Presidente João Figueiredo Airport" },
  { id: 6066, code: "OPU", name: "Balimo Airport[1]" },
  { id: 6067, code: "OPW", name: "Opuwa Airport[1]" },
  { id: 6069, code: "ORA", name: "Orán Airport" },
  { id: 6070, code: "ORB", name: "Örebro Airport" },
  { id: 6071, code: "ORC", name: "Orocue Airport[1]" },
  { id: 6072, code: "ORD", name: "O'Hare International Airport" },
  { id: 6073, code: "ORE", name: "Orléans – Saint-Denis-de-l'Hôtel Airport[1]" },
  { id: 6074, code: "ORF", name: "Norfolk International Airport" },
  { id: 6075, code: "ORG", name: "Zorg en Hoop Airport" },
  { id: 6076, code: "ORH", name: "Worcester Regional Airport" },
  { id: 6077, code: "ORI", name: "Port Lions Airport" },
  { id: 6078, code: "ORJ", name: "Orinduik Airport" },
  { id: 6079, code: "ORK", name: "Cork Airport" },
  { id: 6080, code: "ORL", name: "Orlando Executive Airport" },
  { id: 6081, code: "ORM", name: "Sywell Aerodrome" },
  { id: 6082, code: "ORN", name: "Oran Es Sénia Airport" },
  { id: 6083, code: "ORO", name: "Yoro Airport[1]" },
  { id: 6084, code: "ORP", name: "Orapa Airport[1]" },
  { id: 6085, code: "ORR", name: "Yorketown Airport" },
  { id: 6086, code: "ORS", name: "Orpheus Island Resort Waterport" },
  { id: 6087, code: "ORT", name: "Northway Airport" },
  { id: 6088, code: "ORU", name: "Juan Mendoza Airport" },
  { id: 6089, code: "ORV", name: "Robert (Bob) Curtis Memorial Airport (FAA: D76)" },
  { id: 6090, code: "ORW", name: "Ormara Airport[1]" },
  { id: 6091, code: "ORX", name: "Oriximiná Airport[1]" },
  { id: 6092, code: "ORY", name: "Orly Airport" },
  { id: 6093, code: "ORZ", name: "Orange Walk Airport[1]" },
  { id: 6095, code: "OSA[1]", name: "metropolitan area1" },
  { id: 6096, code: "OSB", name: "Grand Glaize-Osage Beach Airport (FAA: K15)" },
  { id: 6097, code: "OSC", name: "Oscoda–Wurtsmith Airport" },
  { id: 6098, code: "OSD", name: "Åre Östersund Airport" },
  { id: 6099, code: "OSE", name: "Omora Airport[1]" },
  { id: 6100, code: "OSF", name: "Ostafyevo International Airport" },
  { id: 6101, code: "OSG", name: "Ossima Airport[1]" },
  { id: 6102, code: "OSH", name: "Wittman Regional Airport" },
  { id: 6103, code: "OSI", name: "Osijek Airport" },
  { id: 6104, code: "OSK", name: "Oskarshamn Airport" },
  { id: 6105, code: "OSL", name: "Oslo Airport, Gardermoen" },
  { id: 6106, code: "OSM", name: "Mosul International Airport[1]" },
  { id: 6107, code: "OSN", name: "Osan Air Base[1]" },
  { id: 6108, code: "OSO", name: "Osborne Mine Airport[1]" },
  { id: 6109, code: "OSR", name: "Leoš Janáček Airport Ostrava" },
  { id: 6110, code: "OSS", name: "Osh Airport" },
  { id: 6111, code: "OST", name: "Ostend–Bruges International Airport" },
  { id: 6112, code: "OSU", name: "Ohio State University Airport" },
  { id: 6113, code: "OSW", name: "Orsk Airport" },
  { id: 6114, code: "OSX", name: "Kosciusko-Attala County Airport" },
  { id: 6115, code: "OSY", name: "Namsos Airport, Høknesøra" },
  { id: 6116, code: "OSZ", name: "Koszalin-Zegrze Pomorskie Airport[1]" },
  { id: 6118, code: "OTA", name: "Mota Airport[1]" },
  { id: 6119, code: "OTC", name: "Bol-Bérim Airport" },
  { id: 6120, code: "OTD", name: "Contadora Airport" },
  { id: 6121, code: "OTG", name: "Worthington Municipal Airport" },
  { id: 6122, code: "OTH", name: "Southwest Oregon Regional Airport" },
  { id: 6123, code: "OTI", name: "Pitu Airport[1]" },
  { id: 6124, code: "OTJ", name: "Otjiwarongo Airport[1]" },
  { id: 6125, code: "OTK", name: "Tillamook Airport[1] (FAA: TMK)" },
  { id: 6126, code: "OTL", name: "Boutilimit Airport" },
  { id: 6127, code: "OTM", name: "Ottumwa Regional Airport" },
  { id: 6128, code: "OTN", name: "Ed-Air Airport (FAA: 2IG4)" },
  { id: 6129, code: "OTP", name: "Henri Coandă International Airport" },
  { id: 6130, code: "OTR", name: "Coto 47 Airport" },
  { id: 6131, code: "OTS", name: "Anacortes Airport (FAA: 74S)" },
  { id: 6132, code: "OTT", name: "Andre Maggi Airport[1]" },
  { id: 6133, code: "OTU", name: "Otú Airport[1]" },
  { id: 6134, code: "OTV", name: "Ontong Java Airport[1]" },
  { id: 6135, code: "OTY", name: "Oria Airport[1]" },
  { id: 6136, code: "OTZ", name: "Ralph Wien Memorial Airport" },
  { id: 6138, code: "OUA", name: "Ouagadougou Airport" },
  { id: 6139, code: "OUD", name: "Angads Airport" },
  { id: 6140, code: "OUE", name: "Ouésso Airport[1]" },
  { id: 6141, code: "OUG", name: "Ouahigouya Airport" },
  { id: 6142, code: "OUH", name: "Oudtshoorn Airport[1]" },
  { id: 6143, code: "OUK", name: "Out Skerries Airport[1]" },
  { id: 6144, code: "OUL", name: "Oulu Airport" },
  { id: 6145, code: "OUM", name: "Oum Hadjer Airport" },
  { id: 6146, code: "OUN", name: "University of Oklahoma Westheimer Airport (Max Westheimer Airport)" },
  { id: 6147, code: "OUR", name: "Batouri Airport" },
  { id: 6148, code: "OUS", name: "Jornalista Benedito Pimentel–Ourinhos State Airport[1]" },
  { id: 6149, code: "OUT", name: "Bousso Airport" },
  { id: 6150, code: "OUU", name: "Ouanga Airport[1]" },
  { id: 6151, code: "OUZ", name: "Tazadit Airport" },
  { id: 6153, code: "OVA", name: "Bekily Airport[1]" },
  { id: 6154, code: "OVB", name: "Tolmachevo Airport" },
  { id: 6155, code: "OVD", name: "Asturias Airport (Oviedo Airport)" },
  { id: 6156, code: "OVE", name: "Oroville Municipal Airport" },
  { id: 6157, code: "OVG", name: "Air Force Base Overberg[1]" },
  { id: 6158, code: "OVL", name: "El Tuqui Airport[1]" },
  { id: 6159, code: "OVR", name: "Olavarría Airport" },
  { id: 6160, code: "OVS", name: "Sovetsky Airport" },
  { id: 6162, code: "OWA", name: "Owatonna Degner Regional Airport" },
  { id: 6163, code: "OWB", name: "Owensboro–Daviess County Airport" },
  { id: 6164, code: "OWD", name: "Norwood Memorial Airport" },
  { id: 6165, code: "OWK", name: "Central Maine Airport of Norridgewock" },
  { id: 6167, code: "OXB", name: "Osvaldo Vieira International Airport" },
  { id: 6168, code: "OXC", name: "Waterbury–Oxford Airport" },
  { id: 6169, code: "OXD", name: "Miami University Airport" },
  { id: 6170, code: "OXF", name: "Oxford Airport (London Oxford Airport)" },
  { id: 6171, code: "OXO", name: "Orientos Airport[1]" },
  { id: 6172, code: "OXR", name: "Oxnard Airport" },
  { id: 6173, code: "OXY", name: "Morney Airport[1]" },
  { id: 6175, code: "OYA", name: "Goya Airport[1]" },
  { id: 6176, code: "OYE", name: "Oyem Airport[1]" },
  { id: 6177, code: "OYG", name: "Moyo Airport[1]" },
  { id: 6178, code: "OYK", name: "Oiapoque Airport" },
  { id: 6179, code: "OYL", name: "Moyale Airport[1]" },
  { id: 6180, code: "OYN", name: "Ouyen Airport[1]" },
  { id: 6181, code: "OYO", name: "Tres Arroyos Airport" },
  { id: 6182, code: "OYP", name: "Saint-Georges-de-l'Oyapock Airport[1]" },
  { id: 6184, code: "OZA", name: "Ozona Municipal Airport" },
  { id: 6185, code: "OZC", name: "Labo Airport" },
  { id: 6186, code: "OZG", name: "Zagora Airport[1]" },
  { id: 6187, code: "OZH", name: "Zaporizhzhia International Airport" },
  { id: 6188, code: "OZP", name: "Morón Air Base[1]" },
  { id: 6189, code: "OZR", name: "Cairns Army Airfield" },
  { id: 6190, code: "OZZ", name: "Ouarzazate Airport" },
  { id: 6192, code: "PAA", name: "Hpa-An Airport[1]" },
  { id: 6193, code: "PAB", name: "Bilaspur Airport" },
  { id: 6194, code: "PAC", name: "Albrook Marcos A. Gelabert International Airport" },
  { id: 6195, code: "PAD", name: "Paderborn Lippstadt Airport" },
  { id: 6196, code: "PAE", name: "Paine Field (Snohomish County Airport)" },
  { id: 6197, code: "PAF", name: "Pakuba Airfield" },
  { id: 6198, code: "PAG", name: "Pagadian Airport" },
  { id: 6199, code: "PAH", name: "Barkley Regional Airport" },
  { id: 6200, code: "PAJ", name: "Parachinar Airport[1]" },
  { id: 6201, code: "PAK", name: "Port Allen Airport" },
  { id: 6202, code: "PAL", name: "Captain Germán Olano Moreno Air Base[1]" },
  { id: 6203, code: "PAM", name: "Tyndall Air Force Base" },
  { id: 6204, code: "PAN", name: "Pattani Airport" },
  { id: 6205, code: "PAO", name: "Palo Alto Airport (Santa Clara County Airport)" },
  { id: 6206, code: "PAP", name: "Toussaint L'Ouverture International Airport" },
  { id: 6207, code: "PAQ", name: "Palmer Municipal Airport" },
  { id: 6208, code: "PAR[1]", name: "metropolitan area1" },
  { id: 6209, code: "PAS", name: "Paros National Airport" },
  { id: 6210, code: "PAT", name: "Lok Nayak Jayaprakash Airport" },
  { id: 6211, code: "PAU", name: "Pauk Airport[1]" },
  { id: 6212, code: "PAV", name: "Paulo Afonso Airport[1]" },
  { id: 6213, code: "PAW", name: "Pambwa Airport[1]" },
  { id: 6214, code: "PAX", name: "Port-de-Paix Airport[1]" },
  { id: 6215, code: "PAY", name: "Pamol Airport[1]" },
  { id: 6216, code: "PAZ", name: "El Tajín National Airport" },
  { id: 6218, code: "PBB", name: "Paranaíba Airport[1]" },
  { id: 6219, code: "PBC", name: "Hermanos Serdán International Airport" },
  { id: 6220, code: "PBD", name: "Porbandar Airport[1]" },
  { id: 6221, code: "PBE", name: "Morela Airport[1] (Puerto Berrío Airport)" },
  { id: 6222, code: "PBF", name: "Grider Field" },
  { id: 6223, code: "PBG", name: "Plattsburgh International Airport" },
  { id: 6224, code: "PBH", name: "Paro International Airport" },
  { id: 6225, code: "PBI", name: "Palm Beach International Airport" },
  { id: 6226, code: "PBJ", name: "Paama Airport[1]" },
  { id: 6227, code: "PBL", name: "Bartolomé Salom Airport[1]" },
  { id: 6228, code: "PBM", name: "Johan Adolf Pengel International Airport" },
  { id: 6229, code: "PBN", name: "Porto Amboim Airport[1]" },
  { id: 6230, code: "PBO", name: "Paraburdoo Airport" },
  { id: 6231, code: "PBP", name: "Punta Islita Airport" },
  { id: 6232, code: "PBQ", name: "Pimenta Bueno Airport[1]" },
  { id: 6233, code: "PBR", name: "Puerto Barrios Airport[1]" },
  { id: 6234, code: "PBT", name: "Puerto Leda Airport[1]" },
  { id: 6235, code: "PBU", name: "Putao Airport[1]" },
  { id: 6236, code: "PBV", name: "Porto dos Gaúchos Airport" },
  { id: 6237, code: "PBX", name: "Fazenda Piraguassu Airport" },
  { id: 6238, code: "PBZ", name: "Plettenberg Bay Airport[1]" },
  { id: 6240, code: "PCA", name: "Portage Creek Airport (FAA: A14)" },
  { id: 6241, code: "PCB", name: "Pondok Cabe Airport[1]" },
  { id: 6242, code: "PCC", name: "Puerto Rico Airport[1]" },
  { id: 6243, code: "PCD", name: "Prairie du Chien Municipal Airport (FAA: PDC)" },
  { id: 6244, code: "PCF", name: "Potchefstroom Airport[1]" },
  { id: 6245, code: "PCH", name: "Palacios Airport[1]" },
  { id: 6246, code: "PCJ", name: "Puerto La Victoria Airport[1]" },
  { id: 6247, code: "PCL", name: "FAP Captain David Abensur Rengifo International Airport" },
  { id: 6248, code: "PCM", name: "Playa del Carmen Airport" },
  { id: 6249, code: "PCN", name: "Picton Aerodrome" },
  { id: 6250, code: "PCO", name: "Punta Colorada Airstrip[1]" },
  { id: 6251, code: "PCP", name: "Príncipe Airport[1]" },
  { id: 6252, code: "PCQ", name: "Boun Neua Airport[1]" },
  { id: 6253, code: "PCR", name: "Germán Olano Airport" },
  { id: 6254, code: "PCS", name: "Picos Airport[1]" },
  { id: 6255, code: "PCT", name: "Princeton Airport (FAA: 39N)" },
  { id: 6256, code: "PCU", name: "Poplarville-Pearl River County Airport[1] (FAA: M13)" },
  { id: 6257, code: "PCV", name: "Punta Chivato Airstrip[1]" },
  { id: 6259, code: "PDA", name: "Obando Airport" },
  { id: 6260, code: "PDB", name: "Pedro Bay Airport (FAA: 4K0)" },
  { id: 6261, code: "PDC", name: "Mueo/Nickel Airport" },
  { id: 6262, code: "PDD", name: "Ponta do Ouro Airport[1]" },
  { id: 6263, code: "PDE", name: "Pandie Pandie Airport[1]" },
  { id: 6264, code: "PDF", name: "Faz Taua Airport[1]" },
  { id: 6265, code: "PDG", name: "Minangkabau International Airport" },
  { id: 6266, code: "PDI", name: "Pindiu Airport[1]" },
  { id: 6267, code: "PDK", name: "DeKalb–Peachtree Airport" },
  { id: 6268, code: "PDL", name: "João Paulo II Airport" },
  { id: 6269, code: "PDM", name: "Pedasí Airport[1] (Capt. J. Montenegro Airport)" },
  { id: 6270, code: "PDN", name: "Parndana Airport[1]" },
  { id: 6271, code: "PDO", name: "Pendopo Airport[1]" },
  { id: 6272, code: "PDP", name: "Capitán de Corbeta Carlos A. Curbelo International Airport" },
  { id: 6273, code: "PDR", name: "Presidente Dutra Airport[1]" },
  { id: 6274, code: "PDS", name: "Piedras Negras International Airport" },
  { id: 6275, code: "PDT", name: "Eastern Oregon Regional Airport" },
  { id: 6276, code: "PDU", name: "Tydeo Larre Borges International Airport" },
  { id: 6277, code: "PDV", name: "Plovdiv Airport" },
  { id: 6278, code: "PDX", name: "Portland International Airport" },
  { id: 6279, code: "PDZ", name: "Pedernales Airport[1]" },
  { id: 6281, code: "PEA", name: "Penneshaw Airport[1]" },
  { id: 6282, code: "PEB", name: "Pebane Airport[1]" },
  { id: 6283, code: "PEC", name: "Pelican Seaplane Base[1]" },
  { id: 6284, code: "PED", name: "Pardubice Airport" },
  { id: 6285, code: "PEE", name: "Perm International Airport (Bolshoye Savino Airport)" },
  { id: 6286, code: "PEF", name: "Peenemünde Airfield[1]" },
  { id: 6287, code: "PEG", name: "Perugia San Francesco d'Assisi – Umbria International Airport" },
  { id: 6288, code: "PEH", name: "Comodoro Pedro Zanni Airport" },
  { id: 6289, code: "PEI", name: "Matecaña International Airport" },
  { id: 6290, code: "PEK", name: "Beijing Capital International Airport" },
  { id: 6291, code: "PEL", name: "Pelaneng Airport[1]" },
  { id: 6292, code: "PEM", name: "Padre Aldamiz International Airport" },
  { id: 6293, code: "PEN", name: "Penang International Airport" },
  { id: 6294, code: "PEP", name: "Peppimenarti Airport[1]" },
  { id: 6295, code: "PEQ", name: "Pecos Municipal Airport" },
  { id: 6296, code: "PER", name: "Perth Airport" },
  { id: 6297, code: "PES", name: "Petrozavodsk Airport (Besovets Airport)" },
  { id: 6298, code: "PET", name: "João Simões Lopes Neto International Airport" },
  { id: 6299, code: "PEU", name: "Puerto Lempira Airport[1]" },
  { id: 6300, code: "PEV", name: "Pécs-Pogány International Airport[1]" },
  { id: 6301, code: "PEW", name: "Bacha Khan International Airport" },
  { id: 6302, code: "PEX", name: "Pechora Airport" },
  { id: 6303, code: "PEY", name: "Penong Airport[1]" },
  { id: 6304, code: "PEZ", name: "Penza Airport (Ternovka Airport)" },
  { id: 6306, code: "PFB", name: "Lauro Kurtz Airport" },
  { id: 6307, code: "PFC", name: "Pacific City State Airport" },
  { id: 6308, code: "PFJ", name: "Patreksfjörður Airport" },
  { id: 6309, code: "PFM", name: "Primrose Aerodrome" },
  { id: 6310, code: "PFO", name: "Paphos International Airport" },
  { id: 6311, code: "PFQ", name: "Parsabad-Moghan Airport[1]" },
  { id: 6312, code: "PFR", name: "Ilebo Airport[1]" },
  { id: 6314, code: "PGA", name: "Page Municipal Airport" },
  { id: 6315, code: "PGB", name: "Pangoa Airport[1]" },
  { id: 6316, code: "PGC", name: "Grant County Airport (FAA: W99)" },
  { id: 6317, code: "PGD", name: "Punta Gorda Airport" },
  { id: 6318, code: "PGE", name: "Yegepa Airport" },
  { id: 6319, code: "PGF", name: "Perpignan–Rivesaltes Airport" },
  { id: 6320, code: "PGH", name: "Pantnagar Airport[1]" },
  { id: 6321, code: "PGI", name: "Chitato Airport[1]" },
  { id: 6322, code: "PGK", name: "Depati Amir Airport[1]" },
  { id: 6323, code: "PGL", name: "Trent Lott International Airport (FAA: PQL)" },
  { id: 6324, code: "PGM", name: "Port Graham Airport" },
  { id: 6325, code: "PGN", name: "Pangia Airport[1]" },
  { id: 6326, code: "PGO", name: "Stevens Field (FAA: PSO)" },
  { id: 6327, code: "PGQ", name: "Buli Airport" },
  { id: 6328, code: "PGR", name: "Kirk Field" },
  { id: 6329, code: "PGS", name: "Grand Canyon Caverns Airport (FAA: L37)" },
  { id: 6330, code: "PGU", name: "Persian Gulf Airport[1]" },
  { id: 6331, code: "PGV", name: "Pitt–Greenville Airport" },
  { id: 6332, code: "PGX", name: "Périgueux Bassillac Airport" },
  { id: 6333, code: "PGZ", name: "Comte. Antonio Amilton Beraldo Airport[1]" },
  { id: 6335, code: "PHA", name: "Phan Rang Air Base[1]" },
  { id: 6336, code: "PHB", name: "Parnaíba-Prefeito Dr. João Silva Filho International Airport" },
  { id: 6337, code: "PHC", name: "Port Harcourt International Airport" },
  { id: 6338, code: "PHD", name: "Harry Clever Field" },
  { id: 6339, code: "PHE", name: "Port Hedland International Airport" },
  { id: 6340, code: "PHF", name: "Newport News/Williamsburg International Airport" },
  { id: 6341, code: "PHG", name: "Port Harcourt City Airport[1]" },
  { id: 6342, code: "PHI", name: "Pinheiro Airport[1]" },
  { id: 6343, code: "PHK", name: "Palm Beach County Glades Airport" },
  { id: 6344, code: "PHL", name: "Philadelphia International Airport" },
  { id: 6345, code: "PHN", name: "St. Clair County International Airport" },
  { id: 6346, code: "PHO", name: "Point Hope Airport" },
  { id: 6347, code: "PHP", name: "Philip Airport" },
  { id: 6348, code: "PHQ", name: "The Monument Airport[1]" },
  { id: 6349, code: "PHR", name: "Pacific Harbour Airport[1]" },
  { id: 6350, code: "PHS", name: "Phitsanulok Airport" },
  { id: 6351, code: "PHT", name: "Henry County Airport" },
  { id: 6352, code: "PHW", name: "Hendrik Van Eck Airport" },
  { id: 6353, code: "PHX", name: "Phoenix Sky Harbor International Airport" },
  { id: 6354, code: "PHY", name: "Phetchabun Airport" },
  { id: 6356, code: "PIA", name: "General Wayne A. Downing Peoria International Airport" },
  { id: 6357, code: "PIB", name: "Hattiesburg–Laurel Regional Airport" },
  { id: 6358, code: "PIC", name: "Pine Cay Airport[1]" },
  { id: 6359, code: "PIE", name: "St. Pete–Clearwater International Airport" },
  { id: 6360, code: "PIF", name: "Pingtung South Airport[1]" },
  { id: 6361, code: "PIH", name: "Pocatello Regional Airport" },
  { id: 6362, code: "PIK", name: "Glasgow Prestwick Airport" },
  { id: 6363, code: "PIL", name: "Carlos Miguel Jiménez Airport" },
  { id: 6364, code: "PIM", name: "Harris County Airport" },
  { id: 6365, code: "PIN", name: "Júlio Belém Airport" },
  { id: 6366, code: "PIO", name: "Capitán FAP Renán Elías Olivera Airport" },
  { id: 6367, code: "PIP", name: "Pilot Point Airport (FAA: PNP)" },
  { id: 6368, code: "PIQ", name: "Pipillipai Airport[1]" },
  { id: 6369, code: "PIR", name: "Pierre Regional Airport" },
  { id: 6370, code: "PIS", name: "Poitiers–Biard Airport" },
  { id: 6371, code: "PIT", name: "Pittsburgh International Airport" },
  { id: 6372, code: "PIU", name: "FAP Captain Guillermo Concha Iberico International Airport" },
  { id: 6373, code: "PIV", name: "Pirapora Airport[1]" },
  { id: 6374, code: "PIW", name: "Pikwitonei Airport[1]" },
  { id: 6375, code: "PIX", name: "Pico Airport" },
  { id: 6376, code: "PIZ", name: "Point Lay LRRS Airport" },
  { id: 6378, code: "PJA", name: "Pajala Airport" },
  { id: 6379, code: "PJB", name: "Payson Airport (FAA: PAN)" },
  { id: 6380, code: "PJC", name: "Dr. Augusto Roberto Fuster International Airport" },
  { id: 6381, code: "PJG", name: "Panjgur Airport" },
  { id: 6382, code: "PJM", name: "Puerto Jiménez Airport" },
  { id: 6384, code: "PKA", name: "Napaskiak Airport" },
  { id: 6385, code: "PKB", name: "Mid-Ohio Valley Regional Airport" },
  { id: 6386, code: "PKC", name: "Petropavlovsk-Kamchatsky Airport (Yelizovo Airport)" },
  { id: 6387, code: "PKD", name: "Park Rapids Municipal Airport (Konshok Field)" },
  { id: 6388, code: "PKE", name: "Parkes Airport[1]" },
  { id: 6389, code: "PKF", name: "Park Falls Municipal Airport" },
  { id: 6390, code: "PKG", name: "Pangkor Airport[1]" },
  { id: 6391, code: "PKH", name: "Porto Cheli Airport" },
  { id: 6392, code: "PKJ", name: "Playa Grande Airport[1]" },
  { id: 6393, code: "PKK", name: "Pakokku Airport[1]" },
  { id: 6394, code: "PKM", name: "Port Kaituma Airport[1]" },
  { id: 6395, code: "PKN", name: "Iskandar Airport[1]" },
  { id: 6396, code: "PKO", name: "Parakou Airport" },
  { id: 6397, code: "PKP", name: "Puka-Puka Airport[1]" },
  { id: 6398, code: "PKR", name: "Pokhara Airport" },
  { id: 6399, code: "PKT", name: "Port Keats Airfield" },
  { id: 6400, code: "PKU", name: "Sultan Syarif Kasim II International Airport" },
  { id: 6401, code: "PKV", name: "Pskov Airport" },
  { id: 6402, code: "PKW", name: "Selebi-Phikwe Airport" },
  { id: 6403, code: "PKX", name: "Beijing Daxing International Airport" },
  { id: 6404, code: "PKY", name: "Tjilik Riwut Airport[1]" },
  { id: 6405, code: "PKZ", name: "Pakse International Airport" },
  { id: 6407, code: "PLA", name: "Planadas Airport[1]" },
  { id: 6408, code: "PLC", name: "Planeta Rica Airport[1]" },
  { id: 6409, code: "PLD", name: "Carrillo Airport[1] (Playa Samara/Carrillo Airport)" },
  { id: 6410, code: "PLE", name: "Paiela Airport" },
  { id: 6411, code: "PLF", name: "Pala Airport[1]" },
  { id: 6412, code: "PLH", name: "Plymouth City Airport" },
  { id: 6413, code: "PLI", name: "Palm Island Airport[1]" },
  { id: 6414, code: "PLJ", name: "Placencia Airport" },
  { id: 6415, code: "PLK", name: "M. Graham Clark Downtown Airport" },
  { id: 6416, code: "PLL", name: "Manaus Air Force Base" },
  { id: 6417, code: "PLM", name: "Sultan Mahmud Badaruddin II International Airport" },
  { id: 6418, code: "PLN", name: "Pellston Regional Airport (Emmet County)" },
  { id: 6419, code: "PLO", name: "Port Lincoln Airport" },
  { id: 6420, code: "PLP", name: "Captain Ramon Xatruch Airport[1]" },
  { id: 6421, code: "PLQ", name: "Palanga International Airport" },
  { id: 6422, code: "PLR", name: "St. Clair County Airport" },
  { id: 6423, code: "PLS", name: "Providenciales International Airport" },
  { id: 6425, code: "PLT", name: "Plato Airport[1]" },
  { id: 6426, code: "PLU", name: "Belo Horizonte/Pampulha – Carlos Drummond de Andrade Airport" },
  { id: 6427, code: "PLV", name: "Poltava Airport[1]" },
  { id: 6428, code: "PLW", name: "Mutiara Airport[1]" },
  { id: 6429, code: "PLX", name: "Semey Airport" },
  { id: 6430, code: "PLY", name: "Plymouth Municipal Airport (FAA: C65)" },
  { id: 6431, code: "PLZ", name: "Port Elizabeth Airport" },
  { id: 6433, code: "PMA", name: "Pemba Airport[1]" },
  { id: 6434, code: "PMB", name: "Pembina Municipal Airport" },
  { id: 6435, code: "PMC", name: "El Tepual Airport" },
  { id: 6436, code: "PMD", name: "Palmdale Regional Airport" },
  { id: 6437, code: "PMF", name: "Parma Airport (Giuseppe Verdi Airport)" },
  { id: 6438, code: "PMG", name: "Ponta Porã International Airport" },
  { id: 6439, code: "PMH", name: "Greater Portsmouth Regional Airport" },
  { id: 6440, code: "PMI", name: "Palma de Mallorca Airport" },
  { id: 6441, code: "PMK", name: "Palm Island Airport[1]" },
  { id: 6442, code: "PML", name: "Port Moller Airport (FAA: 1AK3)" },
  { id: 6443, code: "PMN", name: "Pumani Airport[1]" },
  { id: 6444, code: "PMO", name: "Falcone–Borsellino Airport (Punta Raisi Airport)" },
  { id: 6445, code: "PMP", name: "Pimaga Airport" },
  { id: 6446, code: "PMQ", name: "Perito Moreno Airport" },
  { id: 6447, code: "PMR", name: "Palmerston North Airport" },
  { id: 6448, code: "PMS", name: "Palmyra Airport" },
  { id: 6449, code: "PMT", name: "Paramakatoi Airport[1]" },
  { id: 6450, code: "PMV", name: "Santiago Mariño Caribbean International Airport" },
  { id: 6451, code: "PMW", name: "Palmas–Brigadeiro Lysias Rodrigues Airport" },
  { id: 6452, code: "PMX", name: "Metropolitan Airport[1] (FAA: 13MA)" },
  { id: 6453, code: "PMY", name: "El Tehuelche Airport" },
  { id: 6454, code: "PMZ", name: "Palmar Sur Airport" },
  { id: 6456, code: "PNA", name: "Pamplona Airport" },
  { id: 6457, code: "PNB", name: "Porto Nacional Airport[1]" },
  { id: 6458, code: "PNC", name: "Ponca City Regional Airport" },
  { id: 6459, code: "PND", name: "Punta Gorda Airport[1]" },
  { id: 6460, code: "PNE", name: "Northeast Philadelphia Airport" },
  { id: 6461, code: "PNG", name: "Santos Dumont Airport[1]" },
  { id: 6462, code: "PNH", name: "Phnom Penh International Airport" },
  { id: 6463, code: "PNI", name: "Pohnpei International Airport" },
  { id: 6464, code: "PNJ", name: "Penglai Shahekou Airport[1]" },
  { id: 6465, code: "PNK", name: "Supadio Airport" },
  { id: 6466, code: "PNL", name: "Pantelleria Airport[1]" },
  { id: 6467, code: "PNN", name: "Princeton Municipal Airport" },
  { id: 6468, code: "PNP", name: "Girua Airport[1]" },
  { id: 6469, code: "PNQ", name: "Pune Airport" },
  { id: 6470, code: "PNR", name: "Pointe Noire Airport" },
  { id: 6471, code: "PNS", name: "Pensacola International Airport" },
  { id: 6472, code: "PNT", name: "Teniente Julio Gallardo Airport" },
  { id: 6473, code: "PNU", name: "Panguitch Municipal Airport (FAA: U55)" },
  { id: 6474, code: "PNV", name: "Panevėžys Air Base[1] (Pajuostis Airport)" },
  { id: 6475, code: "PNX", name: "North Texas Regional Airport (FAA: GYI)" },
  { id: 6476, code: "PNY", name: "Puducherry Airport" },
  { id: 6477, code: "PNZ", name: "Senador Nilo Coelho Airport" },
  { id: 6479, code: "POA", name: "Salgado Filho International Airport" },
  { id: 6480, code: "POB", name: "Pope Field (Pope AFB)" },
  { id: 6481, code: "POC", name: "Brackett Field" },
  { id: 6482, code: "POD", name: "Podor Airport" },
  { id: 6483, code: "POE", name: "Maks Army Airfield[3]" },
  { id: 6484, code: "POF", name: "Poplar Bluff Municipal Airport" },
  { id: 6485, code: "POG", name: "Port-Gentil International Airport" },
  { id: 6486, code: "POH", name: "Pocahontas Municipal Airport" },
  { id: 6487, code: "POI", name: "Captain Nicolas Rojas Airport[1]" },
  { id: 6488, code: "POJ", name: "Pedro Pereira dos Santos Airport" },
  { id: 6489, code: "POL", name: "Pemba Airport" },
  { id: 6490, code: "POM", name: "Jacksons International Airport" },
  { id: 6491, code: "PON", name: "Poptún Airport[1]" },
  { id: 6492, code: "POO", name: "Poços de Caldas Airport[1]" },
  { id: 6493, code: "POP", name: "Gregorio Luperón International Airport" },
  { id: 6494, code: "POR", name: "Pori Airport" },
  { id: 6495, code: "POS", name: "Piarco International Airport" },
  { id: 6496, code: "POT", name: "Ken Jones Aerodrome" },
  { id: 6497, code: "POU", name: "Dutchess County Airport" },
  { id: 6498, code: "POV", name: "Prešov Air Base[1]" },
  { id: 6499, code: "POW", name: "Portorož Airport" },
  { id: 6500, code: "POX", name: "Pontoise – Cormeilles Aerodrome" },
  { id: 6501, code: "POY", name: "Powell Municipal Airport" },
  { id: 6502, code: "POZ", name: "Poznań–Ławica Airport" },
  { id: 6504, code: "PPA", name: "Perry Lefors Field" },
  { id: 6505, code: "PPB", name: "Presidente Prudente Airport" },
  { id: 6506, code: "PPC", name: "Prospect Creek Airport" },
  { id: 6507, code: "PPE", name: "Puerto Peñasco International Airport" },
  { id: 6508, code: "PPF", name: "Tri-City Airport" },
  { id: 6509, code: "PPG", name: "Pago Pago International Airport" },
  { id: 6510, code: "PPH", name: "Parai-tepuí Airport[1]" },
  { id: 6511, code: "PPI", name: "Port Pirie Airport" },
  { id: 6512, code: "PPJ", name: "Panjang Island Airport[1]" },
  { id: 6513, code: "PPK", name: "Petropavl Airport" },
  { id: 6514, code: "PPL", name: "Phaplu Airport" },
  { id: 6515, code: "PPM", name: "Pompano Beach Airpark (FAA: PMP)" },
  { id: 6516, code: "PPN", name: "Guillermo León Valencia Airport" },
  { id: 6517, code: "PPP", name: "Whitsunday Coast Airport" },
  { id: 6518, code: "PPQ", name: "Kapiti Coast Airport" },
  { id: 6519, code: "PPR", name: "Tuanku Tambusai Airport[1]" },
  { id: 6520, code: "PPS", name: "Puerto Princesa International Airport" },
  { id: 6521, code: "PPT", name: "Fa'a'ā International Airport" },
  { id: 6522, code: "PPU", name: "Papun Airport[1]" },
  { id: 6523, code: "PPV", name: "Port Protection Seaplane Base (FAA: 19P)" },
  { id: 6524, code: "PPW", name: "Papa Westray Airport" },
  { id: 6525, code: "PPX", name: "Param Airport[1]" },
  { id: 6526, code: "PPY", name: "Pouso Alegre Airport[1]" },
  { id: 6527, code: "PPZ", name: "Puerto Páez Airport[1]" },
  { id: 6529, code: "PQC", name: "Phu Quoc International Airport" },
  { id: 6530, code: "PQD", name: "Batticaloa Seaplane Base[1]" },
  { id: 6531, code: "PQI", name: "Northern Maine Regional Airport at Presque Isle" },
  { id: 6532, code: "PQM", name: "Palenque International Airport[1]" },
  { id: 6533, code: "PQQ", name: "Port Macquarie Airport" },
  { id: 6534, code: "PQS", name: "Pilot Station Airport (FAA: 0AK)" },
  { id: 6536, code: "PRA", name: "General Justo José de Urquiza Airport" },
  { id: 6537, code: "PRB", name: "Paso Robles Municipal Airport" },
  { id: 6538, code: "PRC", name: "Ernest A. Love Field" },
  { id: 6539, code: "PRD", name: "Pardoo Airport[1]" },
  { id: 6540, code: "PRE", name: "Pore Airport[1]" },
  { id: 6541, code: "PRG", name: "Václav Havel Airport Prague" },
  { id: 6542, code: "PRH", name: "Phrae Airport" },
  { id: 6543, code: "PRI", name: "Praslin Island Airport" },
  { id: 6544, code: "PRK", name: "Prieska Airport[1]" },
  { id: 6545, code: "PRM", name: "Portimão Airport" },
  { id: 6546, code: "PRN", name: "Pristina International Airport Adem Jashari" },
  { id: 6547, code: "PRO", name: "Perry Municipal Airport" },
  { id: 6548, code: "PRP", name: "Propriano Airport" },
  { id: 6549, code: "PRQ", name: "Presidencia Roque Sáenz Peña Airport" },
  { id: 6550, code: "PRR", name: "Paruima Airport" },
  { id: 6551, code: "PRS", name: "Parasi Airport[1]" },
  { id: 6552, code: "PRU", name: "Pyay Airport[1]" },
  { id: 6553, code: "PRV", name: "Přerov Airport[1]" },
  { id: 6554, code: "PRW", name: "Prentice Airport (FAA: 5N2)" },
  { id: 6555, code: "PRX", name: "Cox Field" },
  { id: 6556, code: "PRY", name: "Wonderboom Airport" },
  { id: 6557, code: "PRZ", name: "Prineville Airport (FAA: S39)" },
  { id: 6559, code: "PSA", name: "Pisa International Airport (Galileo Galilei Airport)" },
  { id: 6560, code: "PSB", name: "Mid-State Regional Airport" },
  { id: 6561, code: "PSC", name: "Tri-Cities Airport" },
  { id: 6562, code: "PSD", name: "Port Said Airport[1]" },
  { id: 6563, code: "PSE", name: "Mercedita Airport" },
  { id: 6564, code: "PSF", name: "Pittsfield Municipal Airport" },
  { id: 6565, code: "PSG", name: "Petersburg James A. Johnson Airport" },
  { id: 6566, code: "PSH", name: "Sankt Peter-Ording Airport[1]" },
  { id: 6567, code: "PSI", name: "Pasni Airport[1]" },
  { id: 6568, code: "PSJ", name: "Kasiguncu Airport[1]" },
  { id: 6569, code: "PSK", name: "New River Valley Airport" },
  { id: 6570, code: "PSL", name: "Perth Airport (Scone Airport)" },
  { id: 6571, code: "PSM", name: "Portsmouth International Airport at Pease" },
  { id: 6572, code: "PSN", name: "Palestine Municipal Airport" },
  { id: 6573, code: "PSO", name: "Antonio Nariño Airport" },
  { id: 6574, code: "PSP", name: "Palm Springs International Airport" },
  { id: 6575, code: "PSQ", name: "Philadelphia Seaplane Base (FAA: 9N2)" },
  { id: 6576, code: "PSR", name: "Abruzzo Airport" },
  { id: 6577, code: "PSS", name: "Libertador General José de San Martín Airport" },
  { id: 6578, code: "PSU", name: "Pangsuma Airport[1]" },
  { id: 6579, code: "PSV", name: "Papa Stour Airstrip[1]" },
  { id: 6580, code: "PSW", name: "Passos Airport[1]" },
  { id: 6581, code: "PSX", name: "Palacios Municipal Airport" },
  { id: 6582, code: "PSY", name: "Port Stanley Airport" },
  { id: 6583, code: "PSZ", name: "Puerto Suárez International Airport" },
  { id: 6585, code: "PTA", name: "Port Alsworth Airport (FAA: TPO)" },
  { id: 6586, code: "PTB", name: "Dinwiddie County Airport" },
  { id: 6587, code: "PTC", name: "Port Alice Seaplane Base (FAA: 16K)" },
  { id: 6588, code: "PTD", name: "Port Alexander Seaplane Base (FAA: AHP)" },
  { id: 6589, code: "PTF", name: "Malolo Lailai Airport[1]" },
  { id: 6590, code: "PTG", name: "Polokwane International Airport" },
  { id: 6591, code: "PTH", name: "Port Heiden Airport" },
  { id: 6592, code: "PTJ", name: "Portland Airport" },
  { id: 6593, code: "PTK", name: "Oakland County International Airport" },
  { id: 6594, code: "PTM", name: "Palmarito Airport[1]" },
  { id: 6595, code: "PTN", name: "Harry P. Williams Memorial Airport" },
  { id: 6596, code: "PTO", name: "Juvenal Loureiro Cardoso Airport[1]" },
  { id: 6597, code: "PTP", name: "Pointe-à-Pitre International Airport (Le Raizet Airport)" },
  { id: 6598, code: "PTQ", name: "Porto de Moz Airport[1]" },
  { id: 6599, code: "PTS", name: "Atkinson Municipal Airport" },
  { id: 6600, code: "PTT", name: "Pratt Regional Airport" },
  { id: 6601, code: "PTU", name: "Platinum Airport" },
  { id: 6602, code: "PTV", name: "Porterville Municipal Airport" },
  { id: 6603, code: "PTW", name: "Heritage Field" },
  { id: 6604, code: "PTX", name: "Contador Airport[1]" },
  { id: 6605, code: "PTY", name: "Tocumen International Airport" },
  { id: 6606, code: "PTZ", name: "Río Amazonas Airport" },
  { id: 6608, code: "PUA", name: "Puas Airport[1]" },
  { id: 6609, code: "PUB", name: "Pueblo Memorial Airport" },
  { id: 6610, code: "PUC", name: "Carbon County Regional Airport" },
  { id: 6611, code: "PUD", name: "Puerto Deseado Airport" },
  { id: 6612, code: "PUE", name: "Puerto Obaldia Airport[1]" },
  { id: 6613, code: "PUF", name: "Pau Pyrénées Airport" },
  { id: 6614, code: "PUG", name: "Port Augusta Airport[1]" },
  { id: 6615, code: "PUI", name: "Pureni Airport" },
  { id: 6616, code: "PUJ", name: "Punta Cana International Airport" },
  { id: 6617, code: "PUK", name: "Pukarua Airport" },
  { id: 6618, code: "PUL", name: "Port of Poulsbo Marina Moorage Seaplane Base (FAA: 83Q)" },
  { id: 6619, code: "PUN", name: "Punia Airport[1]" },
  { id: 6620, code: "PUP", name: "Pô Airport" },
  { id: 6621, code: "PUQ", name: "Presidente Carlos Ibáñez del Campo International Airport" },
  { id: 6622, code: "PUR", name: "Puerto Rico Airport[1]" },
  { id: 6623, code: "PUS", name: "Gimhae International Airport" },
  { id: 6624, code: "PUT", name: "Sri Sathya Sai Airport[1]" },
  { id: 6625, code: "PUU", name: "Tres de Mayo Airport" },
  { id: 6626, code: "PUV", name: "Malabou Airport[1]" },
  { id: 6627, code: "PUW", name: "Pullman–Moscow Regional Airport" },
  { id: 6628, code: "PUX", name: "El Mirador Airport[1]" },
  { id: 6629, code: "PUY", name: "Pula Airport" },
  { id: 6630, code: "PUZ", name: "Puerto Cabezas Airport" },
  { id: 6632, code: "PVA", name: "El Embrujo Airport" },
  { id: 6633, code: "PVC", name: "Provincetown Municipal Airport" },
  { id: 6634, code: "PVD", name: "Theodore Francis Green State Airport" },
  { id: 6635, code: "PVE", name: "El Porvenir Airport[1]" },
  { id: 6636, code: "PVF", name: "Placerville Airport" },
  { id: 6637, code: "PVG", name: "Shanghai Pudong International Airport" },
  { id: 6638, code: "PVH", name: "Governador Jorge Teixeira de Oliveira International Airport" },
  { id: 6639, code: "PVI", name: "Edu Chaves Airport[1]" },
  { id: 6640, code: "PVK", name: "Aktion National Airport" },
  { id: 6641, code: "PVL", name: "Pike County Airport[1] (FAA: PBX)" },
  { id: 6642, code: "PVO", name: "Reales Tamarindos Airport" },
  { id: 6643, code: "PVR", name: "Licenciado Gustavo Díaz Ordaz International Airport" },
  { id: 6644, code: "PVS", name: "Provideniya Bay Airport" },
  { id: 6645, code: "PVU", name: "Provo Municipal Airport" },
  { id: 6646, code: "PVW", name: "Hale County Airport" },
  { id: 6648, code: "PWA", name: "Wiley Post Airport" },
  { id: 6649, code: "PWD", name: "Sher-Wood Airport" },
  { id: 6650, code: "PWE", name: "Pevek Airport" },
  { id: 6651, code: "PWI", name: "Beles Airport[1]" },
  { id: 6652, code: "PWK", name: "Chicago Executive Airport" },
  { id: 6653, code: "PWL", name: "Wirasaba Airport" },
  { id: 6654, code: "PWM", name: "Portland International Jetport" },
  { id: 6655, code: "PWN", name: "Pitts Town Airport[1]" },
  { id: 6656, code: "PWO", name: "Pweto Airport[1]" },
  { id: 6657, code: "PWQ", name: "Pavlodar Airport" },
  { id: 6658, code: "PWR", name: "Port Walter Seaplane Base[1]" },
  { id: 6659, code: "PWT", name: "Bremerton National Airport" },
  { id: 6660, code: "PWY", name: "Ralph Wenz Field (FAA: PNA)" },
  { id: 6662, code: "PXA", name: "Atung Bungsu Airport[1]" },
  { id: 6663, code: "PXH", name: "Prominent Hill Airport[1]" },
  { id: 6664, code: "PXL", name: "Polacca Airport (FAA: P10)" },
  { id: 6665, code: "PXM", name: "Puerto Escondido International Airport" },
  { id: 6666, code: "PXO", name: "Porto Santo Airport" },
  { id: 6667, code: "PXR", name: "Surin Airport[1]" },
  { id: 6668, code: "PXU", name: "Pleiku Airport" },
  { id: 6670, code: "PYA", name: "Velasquez Airport[1]" },
  { id: 6671, code: "PYB", name: "Jeypore Airport[1]" },
  { id: 6672, code: "PYC", name: "Playón Chico Airport" },
  { id: 6673, code: "PYE", name: "Tongareva Airport[1]" },
  { id: 6674, code: "PYG", name: "Pakyong Airport" },
  { id: 6675, code: "PYH", name: "Cacique Aramare Airport" },
  { id: 6676, code: "PYJ", name: "Polyarny Airport" },
  { id: 6677, code: "PYK", name: "Payam International Airport[1]" },
  { id: 6678, code: "PYL", name: "Perry Island Seaplane Base[1]" },
  { id: 6679, code: "PYM", name: "Plymouth Municipal Airport" },
  { id: 6680, code: "PYN", name: "Payán Airport[1]" },
  { id: 6681, code: "PYO", name: "Putumayo Airport[1]" },
  { id: 6682, code: "PYR", name: "Andravida Air Base[1]" },
  { id: 6683, code: "PYS", name: "Paradise Skypark[1] (FAA: CA92)" },
  { id: 6684, code: "PYV", name: "Yaviza Airport[1]" },
  { id: 6685, code: "PYY", name: "Pai Airport" },
  { id: 6687, code: "PZA", name: "Paz de Ariporo Airport[1]" },
  { id: 6688, code: "PZB", name: "Pietermaritzburg Airport" },
  { id: 6689, code: "PZH", name: "Zhob Airport" },
  { id: 6690, code: "PZI", name: "Panzhihua Bao'anying Airport[1]" },
  { id: 6691, code: "PZK", name: "Pukapuka Island Airport[1]" },
  { id: 6692, code: "PZL", name: "Zulu Inyala Airport[1]" },
  { id: 6693, code: "PZO", name: "Manuel Carlos Piar Guayana Airport" },
  { id: 6694, code: "PZS", name: "Maquehue Airport[1]" },
  { id: 6695, code: "PZU", name: "Port Sudan New International Airport" },
  { id: 6696, code: "PZY", name: "Piešťany Airport" },
  { id: 6698, code: "QAQ", name: "L'Aquila–Preturo Airport[1]" },
  { id: 6700, code: "QBC", name: "Bella Coola Airport" },
  { id: 6701, code: "QBH", name: "Mount Holland Airport" },
  { id: 6703, code: "QCY", name: "RAF Coningsby" },
  { id: 6705, code: "QHU", name: "Husum Schwesing Airport[1]" },
  { id: 6707, code: "QLR", name: "Monte Real Air Base" },
  { id: 6709, code: "QOW", name: "Sam Mbakwe Airport" },
  { id: 6711, code: "QPG", name: "Paya Lebar Air Base" },
  { id: 6713, code: "QRA", name: "Rand Airport" },
  { id: 6714, code: "QRC", name: "Rancagua de la Independencia Airport" },
  { id: 6715, code: "QRO", name: "Querétaro Intercontinental Airport" },
  { id: 6716, code: "QRW", name: "Warri Airport (Osubi Airport)" },
  { id: 6718, code: "QSC", name: "Mário Pereira Lopes Airport" },
  { id: 6719, code: "QSF", name: "Ain Arnat Airport" },
  { id: 6720, code: "QSR", name: "Salerno Costa d'Amalfi Airport (Pontecagnano Airport)" },
  { id: 6721, code: "QSZ", name: "Shache Airport" },
  { id: 6723, code: "QUB", name: "Ubari Airport[1]" },
  { id: 6724, code: "QUG", name: "Chichester/Goodwood Airport" },
  { id: 6725, code: "QUO", name: "Akwa Ibom International Airport" },
  { id: 6726, code: "QUY", name: "RAF Wyton[1]" },
  { id: 6728, code: "QWG", name: "Wilgrove Air Park (FAA: 8A6) (closed June 2020)" },
  { id: 6730, code: "RAA", name: "Rakanda Airport[1]" },
  { id: 6731, code: "RAB", name: "Rabaul Airport (Tokua Airport)" },
  { id: 6732, code: "RAC", name: "John H. Batten Airport" },
  { id: 6733, code: "RAD", name: "Road Town Seaplane Base[1]" },
  { id: 6734, code: "RAE", name: "Arar Domestic Airport" },
  { id: 6735, code: "RAF", name: "Rafaela Airport[1]" },
  { id: 6736, code: "RAG", name: "Raglan Aerodrome[1]" },
  { id: 6737, code: "RAH", name: "Rafha Domestic Airport[1]" },
  { id: 6738, code: "RAI", name: "Nelson Mandela International Airport" },
  { id: 6739, code: "RAJ", name: "Rajkot Airport" },
  { id: 6740, code: "RAK", name: "Marrakesh Menara Airport" },
  { id: 6741, code: "RAL", name: "Riverside Municipal Airport" },
  { id: 6742, code: "RAM", name: "Ramingining Airport[1]" },
  { id: 6743, code: "RAN", name: "Ravenna Airport[1]" },
  { id: 6744, code: "RAO", name: "Leite Lopes Airport" },
  { id: 6745, code: "RAP", name: "Rapid City Regional Airport" },
  { id: 6746, code: "RAQ", name: "Sugimanuru Airport[1]" },
  { id: 6747, code: "RAR", name: "Rarotonga International Airport" },
  { id: 6748, code: "RAS", name: "Rasht Airport[1]" },
  { id: 6749, code: "RAT", name: "Raduzhny Airport" },
  { id: 6750, code: "RAV", name: "Cravo Norte Airport[1]" },
  { id: 6751, code: "RAW", name: "Arawa Airport[1]" },
  { id: 6752, code: "RAX", name: "Oram Airport[1]" },
  { id: 6753, code: "RAZ", name: "Rawalakot Airport[1]" },
  { id: 6755, code: "RBA", name: "Rabat–Salé Airport" },
  { id: 6756, code: "RBB", name: "Borba Airport" },
  { id: 6757, code: "RBC", name: "Robinvale Airport" },
  { id: 6758, code: "RBD", name: "Dallas Executive Airport" },
  { id: 6759, code: "RBE", name: "Ratanakiri Airport" },
  { id: 6760, code: "RBF", name: "Big Bear City Airport[1] (FAA: L35)" },
  { id: 6761, code: "RBG", name: "Roseburg Regional Airport" },
  { id: 6762, code: "RBI", name: "Rabi Airport[1]" },
  { id: 6763, code: "RBJ", name: "Rebun Airport[1]" },
  { id: 6764, code: "RBK", name: "French Valley Airport[1] (FAA: F70)" },
  { id: 6765, code: "RBL", name: "Red Bluff Municipal Airport" },
  { id: 6766, code: "RBM", name: "Straubing Wallmühle Airport" },
  { id: 6767, code: "RBO", name: "Roboré Airport[1]" },
  { id: 6768, code: "RBP", name: "Rabaraba Airport[1]" },
  { id: 6769, code: "RBQ", name: "Rurrenabaque Airport" },
  { id: 6770, code: "RBR", name: "Plácido de Castro International Airport" },
  { id: 6771, code: "RBS", name: "Orbost Airport[1]" },
  { id: 6772, code: "RBT", name: "Marsabit Airport[1]" },
  { id: 6773, code: "RBU", name: "Roebourne Airport[1]" },
  { id: 6774, code: "RBV", name: "Ramata Airport[1]" },
  { id: 6775, code: "RBW", name: "Lowcountry Regional Airport" },
  { id: 6776, code: "RBX", name: "Rumbek Airport[1]" },
  { id: 6777, code: "RBY", name: "Ruby Airport" },
  { id: 6779, code: "RCA", name: "Ellsworth Air Force Base" },
  { id: 6780, code: "RCB", name: "Richards Bay Airport" },
  { id: 6781, code: "RCE", name: "Roche Harbor Seaplane Base" },
  { id: 6782, code: "RCH", name: "Almirante Padilla Airport" },
  { id: 6783, code: "RCK", name: "H. H. Coffield Regional Airport" },
  { id: 6784, code: "RCL", name: "Redcliffe Airport[1]" },
  { id: 6785, code: "RCM", name: "Richmond Airport" },
  { id: 6786, code: "RCN", name: "American River Airport[1]" },
  { id: 6787, code: "RCO", name: "Rochefort – Saint-Agnant Airport[1]" },
  { id: 6788, code: "RCQ", name: "Reconquista Airport" },
  { id: 6789, code: "RCR", name: "Fulton County Airport" },
  { id: 6790, code: "RCS", name: "Rochester Airport" },
  { id: 6791, code: "RCT", name: "Nartron Field" },
  { id: 6792, code: "RCU", name: "Las Higueras Airport" },
  { id: 6793, code: "RCY", name: "Port Nelson Airport[1]" },
  { id: 6795, code: "RDA", name: "Rockhampton Downs Airport" },
  { id: 6796, code: "RDB", name: "Red Dog Airport" },
  { id: 6797, code: "RDC", name: "Redenção Airport[1]" },
  { id: 6798, code: "RDD", name: "Redding Municipal Airport" },
  { id: 6799, code: "RDE", name: "Merdey Airport[1] (Jahabra Airport)" },
  { id: 6800, code: "RDG", name: "Reading Regional Airport (Carl A. Spaatz Field)" },
  { id: 6801, code: "RDM", name: "Roberts Field" },
  { id: 6802, code: "RDN", name: "Redang Airport[1]" },
  { id: 6803, code: "RDO", name: "Radom Airport[1]" },
  { id: 6804, code: "RDP", name: "Kazi Nazrul Islam Airport" },
  { id: 6805, code: "RDR", name: "Grand Forks Air Force Base" },
  { id: 6806, code: "RDS", name: "Rincón de los Sauces Airport[1]" },
  { id: 6807, code: "RDT", name: "Richard Toll Airport" },
  { id: 6808, code: "RDU", name: "Raleigh–Durham International Airport" },
  { id: 6809, code: "RDV", name: "Red Devil Airport" },
  { id: 6810, code: "RDZ", name: "Rodez–Marcillac Airport" },
  { id: 6812, code: "REA", name: "Reao Airport[1]" },
  { id: 6813, code: "REB", name: "Rechlin–Lärz Airfield[1]" },
  { id: 6814, code: "REC", name: "Recife/Guararapes–Gilberto Freyre International Airport" },
  { id: 6815, code: "RED", name: "Mifflin County Airport (FAA: RVL)" },
  { id: 6816, code: "REE", name: "Reese Airpark[1] (FAA: 8XS8)" },
  { id: 6817, code: "REG", name: "Reggio di Calabria Airport" },
  { id: 6818, code: "REI", name: "Régina Airport[1]" },
  { id: 6819, code: "REK[1]", name: "metropolitan area1" },
  { id: 6820, code: "REL", name: "Almirante Marcos A. Zar Airport" },
  { id: 6821, code: "REN", name: "Orenburg Tsentralny Airport" },
  { id: 6822, code: "REO", name: "Rome State Airport" },
  { id: 6823, code: "REP", name: "Siem Reap International Airport (Angkor Int'l)" },
  { id: 6824, code: "REQ", name: "Reko Diq Airport[1]" },
  { id: 6825, code: "RER", name: "Retalhuleu Airport" },
  { id: 6826, code: "RES", name: "Resistencia International Airport" },
  { id: 6827, code: "RET", name: "Røst Airport" },
  { id: 6828, code: "REU", name: "Reus Airport" },
  { id: 6829, code: "REW", name: "Churhata Airport[1]" },
  { id: 6830, code: "REX", name: "General Lucio Blanco International Airport" },
  { id: 6831, code: "REY", name: "Reyes Airport[1]" },
  { id: 6832, code: "REZ", name: "Resende Airport[1]" },
  { id: 6834, code: "RFA", name: "Rafaï Airport[1]" },
  { id: 6835, code: "RFD", name: "Chicago Rockford International Airport (Greater Rockford Airport)" },
  { id: 6836, code: "RFG", name: "Rooke Field" },
  { id: 6837, code: "RFK", name: "Rollang Field[1] (FAA: 5MS1)" },
  { id: 6838, code: "RFN", name: "Raufarhöfn Airport[1]" },
  { id: 6839, code: "RFP", name: "Raiatea Airport[1] (Uturoa Airport)" },
  { id: 6840, code: "RFR", name: "Río Frío Airport[1]" },
  { id: 6841, code: "RFS", name: "Rosita Airport[1]" },
  { id: 6843, code: "RGA", name: "Hermes Quijada International Airport" },
  { id: 6844, code: "RGE", name: "Porgera Airport[1]" },
  { id: 6845, code: "RGH", name: "Balurghat Airport[1]" },
  { id: 6846, code: "RGI", name: "Rangiroa Airport[1]" },
  { id: 6847, code: "RGK", name: "Gorno-Altaysk Airport[1]" },
  { id: 6848, code: "RGL", name: "Piloto Civil Norberto Fernández International Airport" },
  { id: 6849, code: "RGN", name: "Yangon International Airport" },
  { id: 6850, code: "RGO", name: "Chongjin Airport" },
  { id: 6851, code: "RGR", name: "Ranger Municipal Airport[1] (FAA: F23)" },
  { id: 6852, code: "RGS", name: "Burgos Airport" },
  { id: 6853, code: "RGT", name: "Japura Airport[1]" },
  { id: 6855, code: "RHA", name: "Reykhólar Airport[1]" },
  { id: 6856, code: "RHD", name: "Termas de Río Hondo Airport[1]" },
  { id: 6857, code: "RHE", name: "Reims – Champagne Air Base" },
  { id: 6858, code: "RHG", name: "Ruhengeri Airport[1]" },
  { id: 6859, code: "RHI", name: "Rhinelander–Oneida County Airport" },
  { id: 6860, code: "RHL", name: "Roy Hill Station Airport[1]" },
  { id: 6861, code: "RHN", name: "Skorpion Mine Airport[1]" },
  { id: 6862, code: "RHO", name: "Rhodes International Airport" },
  { id: 6863, code: "RHP", name: "Ramechhap Airport" },
  { id: 6864, code: "RHR", name: "Al Hamra Seaplane Base[1]" },
  { id: 6865, code: "RHT", name: "Alxa Right Banner Badanjilin Airport" },
  { id: 6866, code: "RHV", name: "Reid–Hillview Airport of Santa Clara County" },
  { id: 6868, code: "RIA", name: "Santa Maria Airport" },
  { id: 6869, code: "RIB", name: "Riberalta Airport" },
  { id: 6870, code: "RIC", name: "Richmond International Airport" },
  { id: 6871, code: "RID", name: "Richmond Municipal Airport" },
  { id: 6872, code: "RIE", name: "Rice Lake Regional Airport (Carl's Field) (FAA: RPD)" },
  { id: 6873, code: "RIF", name: "Richfield Municipal Airport" },
  { id: 6874, code: "RIG", name: "Rio Grande Regional Airport" },
  { id: 6875, code: "RIH", name: "Scarlett Martinez International Airport" },
  { id: 6876, code: "RIJ", name: "Juan Simons Vela Airport[1]" },
  { id: 6877, code: "RIL", name: "Garfield County Regional Airport" },
  { id: 6878, code: "RIM", name: "San Nicolas Airport[1]" },
  { id: 6879, code: "RIN", name: "Ringgi Cove Airport[1]" },
  { id: 6880, code: "RIO[1]", name: "metropolitan area2" },
  { id: 6881, code: "RIR", name: "Flabob Airport" },
  { id: 6882, code: "RIS", name: "Rishiri Airport[1]" },
  { id: 6883, code: "RIV", name: "March Air Reserve Base" },
  { id: 6884, code: "RIW", name: "Central Wyoming Regional Airport" },
  { id: 6885, code: "RIX", name: "Riga International Airport" },
  { id: 6886, code: "RIY", name: "Riyan Airport[1]" },
  { id: 6887, code: "RIZ", name: "Rizhao Shanzihe Airport" },
  { id: 6889, code: "RJA", name: "Rajahmundry Airport" },
  { id: 6890, code: "RJB", name: "Rajbiraj Airport[1]" },
  { id: 6891, code: "RJH", name: "Shah Makhdum Airport" },
  { id: 6892, code: "RJI", name: "Rajouri Airport[1]" },
  { id: 6893, code: "RJK", name: "Rijeka Airport" },
  { id: 6894, code: "RJL", name: "Logroño–Agoncillo Airport" },
  { id: 6895, code: "RJM", name: "Marinda Airport[1]" },
  { id: 6896, code: "RJN", name: "Rafsanjan Airport[1]" },
  { id: 6898, code: "RKA", name: "Aratika-Nord Airport[1]" },
  { id: 6899, code: "RKD", name: "Knox County Regional Airport" },
  { id: 6900, code: "RKE", name: "Roskilde Airport" },
  { id: 6901, code: "RKH", name: "Rock Hill/York County Airport[1] (FAA: UZA)" },
  { id: 6902, code: "RKI", name: "Rokot Airport" },
  { id: 6903, code: "RKP", name: "Aransas County Airport" },
  { id: 6904, code: "RKR", name: "Robert S. Kerr Airport" },
  { id: 6905, code: "RKS", name: "Rock Springs–Sweetwater County Airport" },
  { id: 6906, code: "RKT", name: "Ras Al Khaimah International Airport" },
  { id: 6907, code: "RKU", name: "Kairuku Airport[1]" },
  { id: 6908, code: "RKV", name: "Reykjavík Airport" },
  { id: 6909, code: "RKW", name: "Rockwood Municipal Airport" },
  { id: 6910, code: "RKY", name: "Rokeby Airport[1]" },
  { id: 6911, code: "RKZ", name: "Shigatse Peace Airport" },
  { id: 6913, code: "RLD", name: "Richland Airport" },
  { id: 6914, code: "RLG", name: "Rostock–Laage Airport" },
  { id: 6915, code: "RLK", name: "Bayannur Tianjitai Airport[1]" },
  { id: 6916, code: "RLO", name: "Valle del Conlara Airport[1]" },
  { id: 6917, code: "RLP", name: "Rosella Plains Airport[1]" },
  { id: 6918, code: "RLR", name: "Relais de la Reine Airport[1]" },
  { id: 6919, code: "RLT", name: "Arlit Airport" },
  { id: 6921, code: "RMA", name: "Roma Airport" },
  { id: 6922, code: "RMB", name: "Buraimi Airport[1]" },
  { id: 6923, code: "RMD", name: "Ramagundam Airport (Basanth Nagar Airport)" },
  { id: 6924, code: "RME", name: "Griffiss International Airport" },
  { id: 6925, code: "RMF", name: "Marsa Alam International Airport" },
  { id: 6926, code: "RMG", name: "Richard B. Russell Airport" },
  { id: 6927, code: "RMI", name: "Federico Fellini International Airport" },
  { id: 6928, code: "RMK", name: "Renmark Airport" },
  { id: 6929, code: "RML", name: "Colombo International Airport, Ratmalana" },
  { id: 6930, code: "RMN", name: "Rumginae Airport" },
  { id: 6931, code: "RMO", name: "Chișinău International Airport" },
  { id: 6932, code: "RMP", name: "Rampart Airport" },
  { id: 6933, code: "RMQ", name: "Taichung Airport (Taichung Ching Chuan Kang Airport)" },
  { id: 6934, code: "RMS", name: "Ramstein Air Base" },
  { id: 6935, code: "RMT", name: "Rimatara Airport[1]" },
  { id: 6936, code: "RMU", name: "Región de Murcia International Airport[1]" },
  { id: 6937, code: "RMY", name: "Mariposa-Yosemite Airport[1] (FAA: MPI)" },
  { id: 6939, code: "RNA", name: "Ulawa Airport" },
  { id: 6940, code: "RNB", name: "Ronneby Airport" },
  { id: 6941, code: "RNC", name: "Warren County Memorial Airport" },
  { id: 6942, code: "RND", name: "Randolph Air Force Base" },
  { id: 6943, code: "RNE", name: "Roanne Renaison Airport" },
  { id: 6944, code: "RNG", name: "Rangely Airport[1] (FAA: 4V0)" },
  { id: 6945, code: "RNH", name: "New Richmond Regional Airport" },
  { id: 6946, code: "RNI", name: "Corn Island Airport" },
  { id: 6947, code: "RNJ", name: "Yoron Airport[1]" },
  { id: 6948, code: "RNL", name: "Rennell/Tingoa Airport[1]" },
  { id: 6949, code: "RNM", name: "Qarn Alam Airport[1]" },
  { id: 6950, code: "RNN", name: "Bornholm Airport" },
  { id: 6951, code: "RNO", name: "Reno–Tahoe International Airport" },
  { id: 6952, code: "RNP", name: "Rongelap Airport" },
  { id: 6953, code: "RNR", name: "Robinson River Airport[1]" },
  { id: 6954, code: "RNS", name: "Rennes–Saint-Jacques Airport" },
  { id: 6955, code: "RNT", name: "Renton Municipal Airport" },
  { id: 6956, code: "RNU", name: "Ranau Airport[1]" },
  { id: 6957, code: "RNZ", name: "Jasper County Airport (FAA: RZL)" },
  { id: 6959, code: "ROA", name: "Roanoke–Blacksburg Regional Airport (Woodrum Field)" },
  { id: 6960, code: "ROB", name: "Roberts International Airport" },
  { id: 6961, code: "ROC", name: "Greater Rochester International Airport" },
  { id: 6962, code: "ROD", name: "Robertson Airfield[1]" },
  { id: 6963, code: "ROF", name: "Montague Airport[1] (Yreka Rohrer Field) (FAA: 1O5)" },
  { id: 6964, code: "ROG", name: "Rogers Municipal Airport (Carter Field)" },
  { id: 6965, code: "ROH", name: "Robinhood Airport[1]" },
  { id: 6966, code: "ROI", name: "Roi Et Airport" },
  { id: 6967, code: "ROK", name: "Rockhampton Airport" },
  { id: 6968, code: "ROL", name: "Roosevelt Municipal Airport" },
  { id: 6969, code: "ROM[1]", name: "metropolitan area3" },
  { id: 6970, code: "RON", name: "Juan José Rondón Airport[1]" },
  { id: 6971, code: "ROO", name: "Maestro Marinho Franco Airport" },
  { id: 6972, code: "ROP", name: "Rota International Airport (FAA: GRO)" },
  { id: 6973, code: "ROR", name: "Roman Tmetuchl International Airport" },
  { id: 6974, code: "ROS", name: "Rosario – Islas Malvinas International Airport" },
  { id: 6975, code: "ROT", name: "Rotorua Regional Airport" },
  { id: 6976, code: "ROU", name: "Ruse Airport" },
  { id: 6977, code: "ROV", name: "Platov International Airport" },
  { id: 6978, code: "ROW", name: "Roswell International Air Center" },
  { id: 6979, code: "ROX", name: "Roseau Municipal Airport (Rudy Billberg Field)" },
  { id: 6980, code: "ROY", name: "Río Mayo Airport[1]" },
  { id: 6981, code: "ROZ", name: "US Naval Station Rota[1]" },
  { id: 6983, code: "RPA", name: "Rolpa Airport[1]" },
  { id: 6984, code: "RPB", name: "Roper Bar Airport" },
  { id: 6985, code: "RPI", name: "Rampi Airport" },
  { id: 6986, code: "RPM", name: "Ngukurr Airport[1]" },
  { id: 6987, code: "RPN", name: "Rosh Pina Airport" },
  { id: 6988, code: "RPR", name: "Swami Vivekananda Airport" },
  { id: 6989, code: "RPV", name: "Roper Valley Airport[1]" },
  { id: 6990, code: "RPX", name: "Roundup Airport" },
  { id: 6992, code: "RQA", name: "Ruoqiang Loulan Airport" },
  { id: 6993, code: "RQW", name: "Qayyarah Airfield West[1]" },
  { id: 6995, code: "RRE", name: "Marree Airport[1]" },
  { id: 6996, code: "RRG", name: "Sir Gaëtan Duval Airport" },
  { id: 6997, code: "RRI", name: "Barora Airport[1]" },
  { id: 6998, code: "RRJ", name: "Jacarepaguá Airport[1]" },
  { id: 6999, code: "RRK", name: "Rourkela Airport" },
  { id: 7000, code: "RRL", name: "Merrill Municipal Airport" },
  { id: 7001, code: "RRM", name: "Marromeu Airport[1]" },
  { id: 7002, code: "RRR", name: "Raroia Airport" },
  { id: 7003, code: "RRS", name: "Røros Airport" },
  { id: 7004, code: "RRT", name: "Warroad International Memorial Airport (Swede Carlson Field)" },
  { id: 7005, code: "RRV", name: "Robinson River Airport[1]" },
  { id: 7007, code: "RSA", name: "Santa Rosa Airport" },
  { id: 7008, code: "RSB", name: "Roseberth Airport[1]" },
  { id: 7009, code: "RSD", name: "Rock Sound International Airport[1]" },
  { id: 7010, code: "RSE", name: "Rose Bay Water Airport[1]" },
  { id: 7011, code: "RSH", name: "Russian Mission Airport" },
  { id: 7012, code: "RSI", name: "Red Sea International Airport" },
  { id: 7013, code: "RSJ", name: "Rosario Seaplane Base (FAA: W49)" },
  { id: 7014, code: "RSK", name: "Abresso Airport[1]" },
  { id: 7015, code: "RSL", name: "Russell Municipal Airport" },
  { id: 7016, code: "RSN", name: "Ruston Regional Airport" },
  { id: 7017, code: "RSS", name: "Damazin Airport[1]" },
  { id: 7018, code: "RST", name: "Rochester International Airport" },
  { id: 7019, code: "RSU", name: "Yeosu/Suncheon Airport[1]" },
  { id: 7020, code: "RSW", name: "Southwest Florida International Airport" },
  { id: 7021, code: "RSX", name: "Rouses Point Seaplane Base[1] (FAA: K21)" },
  { id: 7023, code: "RTA", name: "Rotuma Airport[1]" },
  { id: 7024, code: "RTB", name: "Juan Manuel Gálvez International Airport" },
  { id: 7025, code: "RTC", name: "Ratnagiri Airport" },
  { id: 7026, code: "RTG", name: "Frans Sales Lega Airport[1]" },
  { id: 7027, code: "RTI", name: "David Constantijn Saudale Airport[1]" },
  { id: 7028, code: "RTL", name: "Spirit Lake Municipal Airport[1] (FAA: 0F3)" },
  { id: 7029, code: "RTM", name: "Rotterdam The Hague Airport" },
  { id: 7030, code: "RTN", name: "Raton Municipal Airport (Crews Field)" },
  { id: 7031, code: "RTP", name: "Rutland Plains Airport[1]" },
  { id: 7032, code: "RTS", name: "Rottnest Island Airport" },
  { id: 7033, code: "RTW", name: "Saratov Tsentralny Airport" },
  { id: 7034, code: "RTY", name: "Merty Merty Airport[1]" },
  { id: 7036, code: "RUA", name: "Arua Airport" },
  { id: 7037, code: "RUD", name: "Shahroud Airport[1]" },
  { id: 7038, code: "RUE", name: "Butembo Airport[1]" },
  { id: 7039, code: "RUF", name: "Yuruf Airport[1]" },
  { id: 7040, code: "RUG", name: "Rugao Air Base" },
  { id: 7041, code: "RUH", name: "King Khalid International Airport" },
  { id: 7042, code: "RUI", name: "Sierra Blanca Regional Airport[1] (FAA: SRR)" },
  { id: 7043, code: "RUK", name: "Chaurjahari Airport" },
  { id: 7044, code: "RUL", name: "Maavarulu Airport[1]" },
  { id: 7045, code: "RUM", name: "Rumjatar Airport" },
  { id: 7046, code: "RUN", name: "Roland Garros Airport" },
  { id: 7047, code: "RUP", name: "Rupsi Airport" },
  { id: 7048, code: "RUR", name: "Rurutu Airport" },
  { id: 7049, code: "RUS", name: "Marau Airport" },
  { id: 7050, code: "RUT", name: "Rutland – Southern Vermont Regional Airport" },
  { id: 7051, code: "RUU", name: "Ruti Airport[1]" },
  { id: 7052, code: "RUV", name: "Rubelsanto Airport[1]" },
  { id: 7053, code: "RUY", name: "Copán Ruinas Airport[1]" },
  { id: 7055, code: "RVA", name: "Farafangana Airport[1]" },
  { id: 7056, code: "RVC", name: "River Cess Airport[1]" },
  { id: 7057, code: "RVD", name: "General Leite de Castro Airport[1]" },
  { id: 7058, code: "RVE", name: "Los Colonizadores Airport" },
  { id: 7059, code: "RVH", name: "Rzhevka Airport" },
  { id: 7060, code: "RVI", name: "Rostov-on-Don Airport" },
  { id: 7061, code: "RVK", name: "Rørvik Airport, Ryum" },
  { id: 7062, code: "RVN", name: "Rovaniemi Airport" },
  { id: 7063, code: "RVO", name: "Reivilo Airport[1]" },
  { id: 7064, code: "RVR", name: "Green River Municipal Airport[1] (FAA: U34)" },
  { id: 7065, code: "RVS", name: "Richard Lloyd Jones Jr. Airport" },
  { id: 7066, code: "RVT", name: "Ravensthorpe Airport[1]" },
  { id: 7067, code: "RVV", name: "Raivavae Airport" },
  { id: 7068, code: "RVY", name: "Pres. Gral. Óscar D. Gestido International Airport" },
  { id: 7070, code: "RWF", name: "Redwood Falls Municipal Airport" },
  { id: 7071, code: "RWI", name: "Rocky Mount–Wilson Regional Airport" },
  { id: 7072, code: "RWL", name: "Rawlins Municipal Airport (Harvey Field)" },
  { id: 7073, code: "RWN", name: "Rivne International Airport" },
  { id: 7075, code: "RXA", name: "Ar Rawdah Airport[1]" },
  { id: 7076, code: "RXE", name: "Rexburg–Madison County Airport" },
  { id: 7077, code: "RXS", name: "Roxas Airport" },
  { id: 7079, code: "RYB", name: "Staroselye Airport" },
  { id: 7080, code: "RYG", name: "Moss Airport, Rygge / Rygge Air Station" },
  { id: 7081, code: "RYK", name: "Shaikh Zayed International Airport[1]" },
  { id: 7082, code: "RYL", name: "Royal Airstrip[1]" },
  { id: 7083, code: "RYN", name: "Royan – Médis Aerodrome" },
  { id: 7084, code: "RYO", name: "Rio Turbio Airport[1]" },
  { id: 7086, code: "RZA", name: "Santa Cruz Airport[1]" },
  { id: 7087, code: "RZE", name: "Rzeszów–Jasionka Airport" },
  { id: 7088, code: "RZN", name: "Turlatovo Airport" },
  { id: 7089, code: "RZP", name: "Cesar Lim Rodriguez Airport" },
  { id: 7090, code: "RZR", name: "Ramsar International Airport[1]" },
  { id: 7091, code: "RZS", name: "Sawan Airport[1]" },
  { id: 7092, code: "RZV", name: "Rize–Artvin Airport" },
  { id: 7093, code: "RZZ", name: "Halifax County Airport" },
  { id: 7095, code: "SAA", name: "Shively Field" },
  { id: 7096, code: "SAB", name: "Juancho E. Yrausquin Airport" },
  { id: 7097, code: "SAC", name: "Sacramento Executive Airport" },
  { id: 7098, code: "SAD", name: "Safford Regional Airport" },
  { id: 7099, code: "SAF", name: "Santa Fe Municipal Airport" },
  { id: 7100, code: "SAG", name: "Shirdi Airport" },
  { id: 7101, code: "SAH", name: "Sana'a International Airport (El Rahaba Airport)" },
  { id: 7102, code: "SAI", name: "Siem Reap–Angkor International Airport" },
  { id: 7103, code: "SAK", name: "Sauðárkrókur Airport" },
  { id: 7104, code: "SAL", name: "Monseñor Óscar Arnulfo Romero International Airport" },
  { id: 7105, code: "SAM", name: "Salamo Airport[1]" },
  { id: 7106, code: "SAN", name: "San Diego International Airport" },
  { id: 7107, code: "SAO[1]", name: "metropolitan area1" },
  { id: 7108, code: "SAP", name: "Ramón Villeda Morales International Airport" },
  { id: 7109, code: "SAQ", name: "San Andros Airport[1]" },
  { id: 7110, code: "SAR", name: "Sparta Community Airport (Hunter Field)" },
  { id: 7111, code: "SAS", name: "Salton Sea Airport" },
  { id: 7112, code: "SAT", name: "San Antonio International Airport" },
  { id: 7113, code: "SAU", name: "Tardamu Airport" },
  { id: 7114, code: "SAV", name: "Savannah/Hilton Head International Airport" },
  { id: 7115, code: "SAW", name: "Sabiha Gökçen International Airport" },
  { id: 7116, code: "SAX", name: "Sambú Airport[1]" },
  { id: 7117, code: "SAY", name: "Siena–Ampugnano Airport" },
  { id: 7118, code: "SAZ", name: "Sasstown Airport" },
  { id: 7120, code: "SBA", name: "Santa Barbara Municipal Airport" },
  { id: 7121, code: "SBB", name: "Santa Bárbara de Barinas Airport[1]" },
  { id: 7122, code: "SBC", name: "Selbang Airport[1]" },
  { id: 7123, code: "SBD", name: "San Bernardino International Airport" },
  { id: 7124, code: "SBE", name: "Suabi Airport[1]" },
  { id: 7125, code: "SBF", name: "Sardeh Band Airport" },
  { id: 7126, code: "SBG", name: "Maimun Saleh Airport[1]" },
  { id: 7127, code: "SBH", name: "Gustaf III Airport" },
  { id: 7128, code: "SBI", name: "Sambailo Airport" },
  { id: 7129, code: "SBJ", name: "São Mateus Airport[1]" },
  { id: 7130, code: "SBK", name: "Saint-Brieuc – Armor Airport" },
  { id: 7131, code: "SBL", name: "Santa Ana del Yacuma Airport" },
  { id: 7132, code: "SBM", name: "Sheboygan County Memorial Airport" },
  { id: 7133, code: "SBN", name: "South Bend International Airport" },
  { id: 7134, code: "SBO", name: "Salina-Gunnison Airport[1] (FAA: 44U)" },
  { id: 7135, code: "SBP", name: "San Luis Obispo County Regional Airport (McChesney Field)" },
  { id: 7136, code: "SBQ", name: "Sibi Airport[1]" },
  { id: 7137, code: "SBR", name: "Saibai Island Airport[1]" },
  { id: 7138, code: "SBS", name: "Steamboat Springs Airport (Bob Adams Field)" },
  { id: 7139, code: "SBT", name: "Sabetta International Airport[1]" },
  { id: 7140, code: "SBU", name: "Springbok Airport" },
  { id: 7141, code: "SBV", name: "Sabah Airport[1]" },
  { id: 7142, code: "SBW", name: "Sibu Airport" },
  { id: 7143, code: "SBX", name: "Shelby Airport" },
  { id: 7144, code: "SBY", name: "Salisbury–Ocean City–Wicomico Regional Airport" },
  { id: 7145, code: "SBZ", name: "Sibiu International Airport" },
  { id: 7147, code: "SCA", name: "Santa Catalina Airport[1]" },
  { id: 7148, code: "SCB", name: "Scribner State Airport" },
  { id: 7149, code: "SCC", name: "Deadhorse Airport" },
  { id: 7150, code: "SCD", name: "Sulaco Airport" },
  { id: 7151, code: "SCE", name: "State College Regional Airport (FAA: UNV)" },
  { id: 7152, code: "SCF", name: "Scottsdale Airport (FAA: SDL)" },
  { id: 7153, code: "SCG", name: "Spring Creek Airport[1]" },
  { id: 7154, code: "SCH", name: "Schenectady County Airport" },
  { id: 7155, code: "SCI", name: "Paramillo Airport[1]" },
  { id: 7156, code: "SCK", name: "Stockton Metropolitan Airport" },
  { id: 7157, code: "SCL", name: "Arturo Merino Benítez International Airport" },
  { id: 7158, code: "SCM", name: "Scammon Bay Airport" },
  { id: 7159, code: "SCN", name: "Saarbrücken Airport" },
  { id: 7160, code: "SCO", name: "Aktau Airport" },
  { id: 7161, code: "SCP", name: "Mont-Dauphin - Saint-Crépin Airport[1]" },
  { id: 7162, code: "SCQ", name: "Santiago de Compostela Airport" },
  { id: 7163, code: "SCR", name: "Scandinavian Mountains Airport" },
  { id: 7164, code: "SCS", name: "Scatsta Airport" },
  { id: 7165, code: "SCT", name: "Socotra Airport[1]" },
  { id: 7166, code: "SCU", name: "Antonio Maceo International Airport" },
  { id: 7167, code: "SCV", name: "Suceava International Airport (Ștefan cel Mare Int'l)" },
  { id: 7168, code: "SCW", name: "Syktyvkar Airport" },
  { id: 7169, code: "SCX", name: "Salina Cruz Airport" },
  { id: 7170, code: "SCY", name: "San Cristóbal Airport" },
  { id: 7171, code: "SCZ", name: "Santa Cruz/Graciosa Bay/Luova Airport[1]" },
  { id: 7173, code: "SDB", name: "Air Force Base Langebaanweg[1]" },
  { id: 7174, code: "SDC", name: "Sand Creek Airport" },
  { id: 7175, code: "SDD", name: "Lubango Mukanka Airport" },
  { id: 7176, code: "SDE", name: "Vicecomodoro Ángel de la Paz Aragonés Airport" },
  { id: 7177, code: "SDF", name: "Louisville International Airport (Standiford Field)" },
  { id: 7178, code: "SDG", name: "Sanandaj Airport[1]" },
  { id: 7179, code: "SDH", name: "Santa Rosa de Copán Airport[1]" },
  { id: 7180, code: "SDI", name: "Saidor Airport[1]" },
  { id: 7181, code: "SDJ", name: "Sendai Airport" },
  { id: 7182, code: "SDK", name: "Sandakan Airport" },
  { id: 7183, code: "SDL", name: "Sundsvall-Timrå Airport (Midlanda Airport)" },
  { id: 7184, code: "SDM", name: "Brown Field Municipal Airport" },
  { id: 7185, code: "SDN", name: "Sandane Airport, Anda" },
  { id: 7186, code: "SDP", name: "Sand Point Airport" },
  { id: 7187, code: "SDQ", name: "Las Américas International Airport" },
  { id: 7188, code: "SDR", name: "Santander Airport" },
  { id: 7189, code: "SDS", name: "Sado Airport[1]" },
  { id: 7190, code: "SDT", name: "Saidu Sharif Airport[1]" },
  { id: 7191, code: "SDU", name: "Santos Dumont Airport" },
  { id: 7192, code: "SDV", name: "Sde Dov Airport" },
  { id: 7193, code: "SDX", name: "Sedona Airport (FAA: SEZ)" },
  { id: 7194, code: "SDY", name: "Sidney–Richland Municipal Airport" },
  { id: 7195, code: "SDZ[1]", name: "metropolitan area2" },
  { id: 7197, code: "SEA", name: "Seattle–Tacoma International Airport" },
  { id: 7198, code: "SEB", name: "Sabha Airport[1]" },
  { id: 7199, code: "SED", name: "Sdom Airfield[1] (Hashnayim Airfield)" },
  { id: 7200, code: "SEE", name: "Gillespie Field" },
  { id: 7201, code: "SEF", name: "Sebring Regional Airport" },
  { id: 7202, code: "SEG", name: "Penn Valley Airport" },
  { id: 7203, code: "SEH", name: "Senggeh Airport" },
  { id: 7204, code: "SEK", name: "Srednekolymsk Airport" },
  { id: 7205, code: "SEL[1]", name: "metropolitan area3" },
  { id: 7206, code: "SEM", name: "Craig Field" },
  { id: 7207, code: "SEN", name: "London Southend Airport" },
  { id: 7208, code: "SEO", name: "Séguéla Airport[1]" },
  { id: 7209, code: "SEP", name: "Stephenville Clark Regional Airport" },
  { id: 7210, code: "SEQ", name: "Sei Pakning Airport" },
  { id: 7211, code: "SER", name: "Freeman Municipal Airport" },
  { id: 7212, code: "SEU", name: "Seronera Airstrip[1]" },
  { id: 7213, code: "SEV", name: "Severodonetsk Airport[1]" },
  { id: 7214, code: "SEW", name: "Siwa Oasis North Airport[1]" },
  { id: 7215, code: "SEY", name: "Sélibaby Airport" },
  { id: 7216, code: "SEZ", name: "Seychelles International Airport" },
  { id: 7218, code: "SFA", name: "Sfax–Thyna International Airport" },
  { id: 7219, code: "SFB", name: "Orlando Sanford International Airport" },
  { id: 7220, code: "SFC", name: "Saint-François Airport[1]" },
  { id: 7221, code: "SFD", name: "Las Flecheras Airport" },
  { id: 7222, code: "SFE", name: "San Fernando Airport" },
  { id: 7223, code: "SFF", name: "Felts Field" },
  { id: 7224, code: "SFG", name: "L'Espérance Airport[1] (Grand Case Airport)" },
  { id: 7225, code: "SFH", name: "San Felipe International Airport" },
  { id: 7226, code: "SFI", name: "Safi Airport" },
  { id: 7227, code: "SFJ", name: "Kangerlussuaq Airport" },
  { id: 7228, code: "SFK", name: "Soure Airport[1]" },
  { id: 7229, code: "SFL", name: "São Filipe Airport" },
  { id: 7230, code: "SFM", name: "Sanford Seacoast Regional Airport" },
  { id: 7231, code: "SFN", name: "Sauce Viejo Airport[1]" },
  { id: 7232, code: "SFO", name: "San Francisco International Airport" },
  { id: 7233, code: "SFQ", name: "Şanlıurfa Airport" },
  { id: 7234, code: "SFS", name: "Subic Bay International Airport" },
  { id: 7235, code: "SFT", name: "Skellefteå Airport" },
  { id: 7236, code: "SFU", name: "Safia Airport[1]" },
  { id: 7237, code: "SFV", name: "Santa Fé do Sul Airport[1]" },
  { id: 7238, code: "SFX", name: "Macagua Airport[1]" },
  { id: 7239, code: "SFY[1]", name: "metropolitan area4" },
  { id: 7240, code: "SFZ", name: "North Central State Airport" },
  { id: 7242, code: "SGA", name: "Sheghnan Airport" },
  { id: 7243, code: "SGB", name: "Singaua Airport[1]" },
  { id: 7244, code: "SGC", name: "Surgut International Airport" },
  { id: 7245, code: "SGD", name: "Sønderborg Airport" },
  { id: 7246, code: "SGE", name: "Siegerland Airport" },
  { id: 7247, code: "SGF", name: "Springfield–Branson National Airport" },
  { id: 7248, code: "SGG", name: "Simanggang Airport" },
  { id: 7249, code: "SGH", name: "Springfield–Beckley Municipal Airport" },
  { id: 7250, code: "SGI[1]", name: "metropolitan area1" },
  { id: 7251, code: "SGJ", name: "Sagarai Airport[1]" },
  { id: 7252, code: "SGK", name: "Sangapi Airport" },
  { id: 7253, code: "SGL", name: "Sangley Point Airport" },
  { id: 7254, code: "SGM", name: "San Ignacio Airfield[1]" },
  { id: 7255, code: "SGN", name: "Tan Son Nhat International Airport" },
  { id: 7256, code: "SGO", name: "St George Airport[1]" },
  { id: 7257, code: "SGP", name: "Shay Gap Airport[1]" },
  { id: 7258, code: "SGQ", name: "Sangkimah Airport[1]" },
  { id: 7259, code: "SGR", name: "Sugar Land Regional Airport" },
  { id: 7260, code: "SGT", name: "Stuttgart Municipal Airport" },
  { id: 7261, code: "SGU", name: "St. George Regional Airport" },
  { id: 7262, code: "SGV", name: "Sierra Grande Airport[1]" },
  { id: 7263, code: "SGW", name: "Saginaw Seaplane Base[1] (FAA: A23)" },
  { id: 7264, code: "SGX", name: "Songea Airport[1]" },
  { id: 7265, code: "SGY", name: "Skagway Airport" },
  { id: 7266, code: "SGZ", name: "Songkhla Airport[1]" },
  { id: 7268, code: "SHA", name: "Shanghai Hongqiao International Airport" },
  { id: 7269, code: "SHB", name: "Nakashibetsu Airport" },
  { id: 7270, code: "SHC", name: "Shire Airport[1]" },
  { id: 7271, code: "SHD", name: "Shenandoah Valley Regional Airport" },
  { id: 7272, code: "SHE", name: "Shenyang Taoxian International Airport" },
  { id: 7273, code: "SHF", name: "Shihezi Huayuan Airport" },
  { id: 7274, code: "SHG", name: "Shungnak Airport" },
  { id: 7275, code: "SHH", name: "Shishmaref Airport" },
  { id: 7276, code: "SHI", name: "Shimojishima Airport" },
  { id: 7277, code: "SHJ", name: "Sharjah International Airport" },
  { id: 7278, code: "SHK", name: "Sehonghong Airport[1]" },
  { id: 7279, code: "SHL", name: "Shillong Airport (Barapani Airport)" },
  { id: 7280, code: "SHM", name: "Nanki–Shirahama Airport" },
  { id: 7281, code: "SHN", name: "Sanderson Field" },
  { id: 7282, code: "SHO", name: "King Mswati III International Airport[1] (Sikhuphe Int'l)" },
  { id: 7283, code: "SHQ", name: "Southport Airport[1]" },
  { id: 7284, code: "SHR", name: "Sheridan County Airport" },
  { id: 7285, code: "SHS", name: "Shashi Airport" },
  { id: 7286, code: "SHT", name: "Shepparton Airport" },
  { id: 7287, code: "SHU", name: "Smith Point Airport[1]" },
  { id: 7288, code: "SHV", name: "Shreveport Regional Airport" },
  { id: 7289, code: "SHW", name: "Sharurah Domestic Airport" },
  { id: 7290, code: "SHX", name: "Shageluk Airport" },
  { id: 7291, code: "SHY", name: "Shinyanga Airport[1]" },
  { id: 7292, code: "SHZ", name: "Seshutes Airport[1]" },
  { id: 7294, code: "SIA", name: "Xi'an Xiguan Airport" },
  { id: 7295, code: "SIB", name: "Sibiti Airport[1]" },
  { id: 7296, code: "SIC", name: "San José Airport[1]" },
  { id: 7297, code: "SID", name: "Amílcar Cabral International Airport" },
  { id: 7298, code: "SIE", name: "Sines Airport[1]" },
  { id: 7299, code: "SIF", name: "Simara Airport[1]" },
  { id: 7300, code: "SIG", name: "Fernando Luis Ribas Dominicci Airport" },
  { id: 7301, code: "SIH", name: "Silgadhi Airport[1]" },
  { id: 7302, code: "SII", name: "Sidi Ifni Airport (Sania Ramel Airport)" },
  { id: 7303, code: "SIJ", name: "Siglufjörður Airport" },
  { id: 7304, code: "SIK", name: "Sikeston Memorial Municipal Airport" },
  { id: 7305, code: "SIL", name: "Sila Airport[1]" },
  { id: 7306, code: "SIM", name: "Simbai Airport[1]" },
  { id: 7307, code: "SIN", name: "Singapore Changi Airport" },
  { id: 7308, code: "SIO", name: "Smithton Airport" },
  { id: 7309, code: "SIP", name: "Simferopol International Airport" },
  { id: 7310, code: "SIQ", name: "Dabo Singkep Airport[1]" },
  { id: 7311, code: "SIR", name: "Sion Airport" },
  { id: 7312, code: "SIS", name: "Sishen Airport" },
  { id: 7313, code: "SIT", name: "Sitka Rocky Gutierrez Airport" },
  { id: 7314, code: "SIU", name: "Siuna Airport" },
  { id: 7315, code: "SIV", name: "Sullivan County Airport" },
  { id: 7316, code: "SIW", name: "Sibisa Airport[1]" },
  { id: 7317, code: "SIX", name: "Singleton Airport[1]" },
  { id: 7318, code: "SIY", name: "Siskiyou County Airport" },
  { id: 7319, code: "SIZ", name: "Sissano Airport[1]" },
  { id: 7321, code: "SJA", name: "San Juan de Marcona Airport[1]" },
  { id: 7322, code: "SJB", name: "San Joaquín Airport[1]" },
  { id: 7323, code: "SJC", name: "San Jose International Airport" },
  { id: 7324, code: "SJD", name: "Los Cabos International Airport" },
  { id: 7325, code: "SJE", name: "Jorge Enrique González Torres Airport" },
  { id: 7326, code: "SJF", name: "Cruz Bay Seaplane Base[1]" },
  { id: 7327, code: "SJG", name: "San Pedro de Jagua Airport[1]" },
  { id: 7328, code: "SJH", name: "San Juan del Cesar Airport[1]" },
  { id: 7329, code: "SJI", name: "San Jose Airport" },
  { id: 7330, code: "SJJ", name: "Sarajevo International Airport" },
  { id: 7331, code: "SJK", name: "Professor Urbano Ernesto Stumpf Airport" },
  { id: 7332, code: "SJL", name: "São Gabriel da Cachoeira Airport[1]" },
  { id: 7333, code: "SJM", name: "San Juan de la Maguana Airport" },
  { id: 7334, code: "SJN", name: "St. Johns Industrial Air Park" },
  { id: 7335, code: "SJO", name: "Juan Santamaría International Airport" },
  { id: 7336, code: "SJP", name: "Prof. Eribelto Manoel Reino State Airport" },
  { id: 7337, code: "SJQ", name: "Sesheke Airport[1]" },
  { id: 7338, code: "SJR", name: "San Juan de Urabá Airport[1]" },
  { id: 7339, code: "SJS", name: "San José de Chiquitos Airport[1]" },
  { id: 7340, code: "SJT", name: "San Angelo Regional Airport (Mathis Field)" },
  { id: 7341, code: "SJU", name: "Luis Muñoz Marín International Airport" },
  { id: 7342, code: "SJV", name: "San Javier Airport[1]" },
  { id: 7343, code: "SJW", name: "Shijiazhuang Zhengding International Airport" },
  { id: 7344, code: "SJX", name: "Sarteneja Airport" },
  { id: 7345, code: "SJY", name: "Seinäjoki Airport" },
  { id: 7346, code: "SJZ", name: "São Jorge Airport" },
  { id: 7348, code: "SKA", name: "Fairchild Air Force Base" },
  { id: 7349, code: "SKB", name: "Robert L. Bradshaw International Airport" },
  { id: 7350, code: "SKC", name: "Suki Airport[1]" },
  { id: 7351, code: "SKD", name: "Samarkand International Airport[1]" },
  { id: 7352, code: "SKE", name: "Skien Airport, Geiteryggen" },
  { id: 7353, code: "SKF", name: "Kelly Field Annex / Lackland Air Force Base" },
  { id: 7354, code: "SKG", name: "Thessaloniki Airport Macedonia" },
  { id: 7355, code: "SKH", name: "Surkhet Airport[1]" },
  { id: 7356, code: "SKI", name: "Skikda Airport" },
  { id: 7357, code: "SKK", name: "Shaktoolik Airport (FAA: 2C7)" },
  { id: 7358, code: "SKL", name: "Broadford Airfield[1]" },
  { id: 7359, code: "SKM", name: "Skeldon Airport[1]" },
  { id: 7360, code: "SKN", name: "Stokmarknes Airport, Skagen" },
  { id: 7361, code: "SKO", name: "Sadiq Abubakar III International Airport[1]" },
  { id: 7362, code: "SKP", name: "Skopje Alexander the Great Airport" },
  { id: 7363, code: "SKQ", name: "Sekake Airport[1]" },
  { id: 7364, code: "SKR", name: "Shakiso Airport[1]" },
  { id: 7365, code: "SKS", name: "Vojens Airport (Skrydstrup Airport)" },
  { id: 7366, code: "SKT", name: "Sialkot International Airport" },
  { id: 7367, code: "SKU", name: "Skyros Island National Airport" },
  { id: 7368, code: "SKV", name: "St. Catherine International Airport" },
  { id: 7369, code: "SKW", name: "Skwentna Airport" },
  { id: 7370, code: "SKX", name: "Saransk Airport" },
  { id: 7371, code: "SKY", name: "Griffing Sandusky Airport" },
  { id: 7372, code: "SKZ", name: "Sukkur Airport" },
  { id: 7374, code: "SLA", name: "Martín Miguel de Güemes International Airport" },
  { id: 7375, code: "SLB", name: "Storm Lake Municipal Airport" },
  { id: 7376, code: "SLC", name: "Salt Lake City International Airport" },
  { id: 7377, code: "SLD", name: "Sliač Airport" },
  { id: 7378, code: "SLE", name: "McNary Field" },
  { id: 7379, code: "SLF", name: "Sulayel Airport[1]" },
  { id: 7380, code: "SLG", name: "Smith Field" },
  { id: 7381, code: "SLH", name: "Vanua Lava Airport" },
  { id: 7382, code: "SLI", name: "Solwezi Airport" },
  { id: 7383, code: "SLJ", name: "Solomon Airport" },
  { id: 7384, code: "SLK", name: "Adirondack Regional Airport" },
  { id: 7385, code: "SLL", name: "Salalah International Airport" },
  { id: 7386, code: "SLM", name: "Salamanca Airport" },
  { id: 7387, code: "SLN", name: "Salina Regional Airport" },
  { id: 7388, code: "SLO", name: "Salem–Leckrone Airport" },
  { id: 7389, code: "SLP", name: "Ponciano Arriaga International Airport" },
  { id: 7390, code: "SLQ", name: "Sleetmute Airport" },
  { id: 7391, code: "SLR", name: "Sulphur Springs Municipal Airport" },
  { id: 7392, code: "SLS", name: "Silistra Airfield" },
  { id: 7393, code: "SLT", name: "Harriet Alexander Field (FAA: ANK)" },
  { id: 7394, code: "SLU", name: "George F. L. Charles Airport" },
  { id: 7395, code: "SLV", name: "Shimla Airport" },
  { id: 7396, code: "SLW", name: "Plan de Guadalupe International Airport" },
  { id: 7397, code: "SLX", name: "Salt Cay Airport[1]" },
  { id: 7398, code: "SLY", name: "Salekhard Airport" },
  { id: 7399, code: "SLZ", name: "Marechal Cunha Machado International Airport" },
  { id: 7401, code: "SMA", name: "Santa Maria Airport" },
  { id: 7402, code: "SMB", name: "Franco Bianco Airport[1]" },
  { id: 7403, code: "SMC", name: "Santa María Airport[1]" },
  { id: 7404, code: "SMD", name: "Smith Field" },
  { id: 7405, code: "SME", name: "Lake Cumberland Regional Airport" },
  { id: 7406, code: "SMF", name: "Sacramento International Airport" },
  { id: 7407, code: "SMG", name: "Santa María Airport[1]" },
  { id: 7408, code: "SMH", name: "Sapmanga Airport" },
  { id: 7409, code: "SMI", name: "Samos International Airport Aristarchos of Samos" },
  { id: 7410, code: "SMJ", name: "Sim Airport[1]" },
  { id: 7411, code: "SMK", name: "St. Michael Airport" },
  { id: 7412, code: "SML", name: "Stella Maris Airport[1]" },
  { id: 7413, code: "SMM", name: "Semporna Airport" },
  { id: 7414, code: "SMN", name: "Lemhi County Airport" },
  { id: 7415, code: "SMO", name: "Santa Monica Municipal Airport" },
  { id: 7416, code: "SMP", name: "Stockholm Airport[1]" },
  { id: 7417, code: "SMQ", name: "H. Asan Airport" },
  { id: 7418, code: "SMR", name: "Simón Bolívar International Airport" },
  { id: 7419, code: "SMS", name: "Sainte Marie Airport" },
  { id: 7420, code: "SMU", name: "Sheep Mountain Airport" },
  { id: 7421, code: "SMV", name: "Samedan Airport (Engadin Airport)" },
  { id: 7422, code: "SMW", name: "Smara Airport[1]" },
  { id: 7423, code: "SMX", name: "Santa Maria Public Airport (Capt. G. Allan Hancock Field)" },
  { id: 7424, code: "SMY", name: "Simenti Airport" },
  { id: 7425, code: "SMZ", name: "Stoelmans Eiland Airstrip" },
  { id: 7427, code: "SNA", name: "John Wayne Airport (Orange County Airport)" },
  { id: 7428, code: "SNB", name: "Snake Bay Airport" },
  { id: 7429, code: "SNC", name: "General Ulpiano Paez Airport" },
  { id: 7430, code: "SNE", name: "Preguiça Airport" },
  { id: 7431, code: "SNF", name: "Sub Teniente Nestor Arias Airport[1]" },
  { id: 7432, code: "SNG", name: "Capitán Av. Juan Cochamanidis Airport[1]" },
  { id: 7433, code: "SNH", name: "Stanthorpe Airport" },
  { id: 7434, code: "SNI", name: "Greenville/Sinoe Airport (R.E. Murray Airport)" },
  { id: 7435, code: "SNJ", name: "San Julián Air Base[1]" },
  { id: 7436, code: "SNK", name: "Winston Field Airport" },
  { id: 7437, code: "SNL", name: "Shawnee Regional Airport" },
  { id: 7438, code: "SNM", name: "San Ignacio de Moxos Airport[1]" },
  { id: 7439, code: "SNN", name: "Shannon Airport" },
  { id: 7440, code: "SNO", name: "Sakon Nakhon Airport[1]" },
  { id: 7441, code: "SNP", name: "St. Paul Island Airport" },
  { id: 7442, code: "SNQ", name: "San Quintín Military Airstrip[1]" },
  { id: 7443, code: "SNR", name: "Saint-Nazaire Montoir Airport" },
  { id: 7444, code: "SNS", name: "Salinas Municipal Airport" },
  { id: 7445, code: "SNT", name: "Las Cruces Airport[1]" },
  { id: 7446, code: "SNU", name: "Abel Santamaría Airport" },
  { id: 7447, code: "SNV", name: "Santa Elena de Uairén Airport[1]" },
  { id: 7448, code: "SNW", name: "Thandwe Airport[1]" },
  { id: 7449, code: "SNX", name: "Semnan Municipal Airport[1]" },
  { id: 7450, code: "SNY", name: "Sidney Municipal Airport (Lloyd W. Carr Field)" },
  { id: 7451, code: "SNZ", name: "Santa Cruz Air Force Base" },
  { id: 7453, code: "SOA", name: "Sóc Trăng Airfield[1]" },
  { id: 7454, code: "SOB", name: "Hévíz–Balaton Airport" },
  { id: 7455, code: "SOC", name: "Adisumarmo International Airport" },
  { id: 7456, code: "SOD", name: "Bertram Luiz Leupolz–Sorocaba Airport" },
  { id: 7457, code: "SOE", name: "Souanké Airport[1]" },
  { id: 7458, code: "SOF", name: "Sofia Airport" },
  { id: 7459, code: "SOG", name: "Sogndal Airport, Haukåsen" },
  { id: 7460, code: "SOJ", name: "Sørkjosen Airport" },
  { id: 7461, code: "SOK", name: "Semonkong Airport" },
  { id: 7462, code: "SOL", name: "Solomon State Field Airport[1] (FAA: AK26)" },
  { id: 7463, code: "SOM", name: "San Tomé Airport" },
  { id: 7464, code: "SON", name: "Santo-Pekoa International Airport" },
  { id: 7465, code: "SOO", name: "Söderhamn Airport[1] (Helsinge Airport)" },
  { id: 7466, code: "SOP", name: "Moore County Airport" },
  { id: 7467, code: "SOQ", name: "Dominique Edward Osok Airport[1]" },
  { id: 7468, code: "SOT", name: "Sodankylä Airfield[1]" },
  { id: 7469, code: "SOU", name: "Southampton Airport" },
  { id: 7470, code: "SOV", name: "Seldovia Airport" },
  { id: 7471, code: "SOW", name: "Show Low Regional Airport" },
  { id: 7472, code: "SOX", name: "Alberto Lleras Camargo Airport[1]" },
  { id: 7473, code: "SOY", name: "Stronsay Airport" },
  { id: 7474, code: "SOZ", name: "Solenzara Air Base[1]" },
  { id: 7476, code: "SPA", name: "Spartanburg Downtown Memorial Airport" },
  { id: 7477, code: "SPB", name: "Charlotte Amalie Harbor Seaplane Base (St. Thomas Seaplane Base) (FAA: VI22)" },
  { id: 7478, code: "SPC", name: "La Palma Airport" },
  { id: 7479, code: "SPD", name: "Saidpur Airport" },
  { id: 7480, code: "SPE", name: "Sepulot Airport[1]" },
  { id: 7481, code: "SPF", name: "Black Hills Airport (Clyde Ice Field)" },
  { id: 7482, code: "SPG", name: "Albert Whitted Airport" },
  { id: 7483, code: "SPH", name: "Sopu Airport" },
  { id: 7484, code: "SPI", name: "Abraham Lincoln Capital Airport" },
  { id: 7485, code: "SPJ", name: "Sparti Airport" },
  { id: 7486, code: "SPK[1]", name: "metropolitan area5" },
  { id: 7487, code: "SPM", name: "Spangdahlem Air Base" },
  { id: 7488, code: "SPN", name: "Saipan International Airport (Francisco C. Ada Int'l) (FAA: GSN)" },
  { id: 7489, code: "SPP", name: "Menongue Airport[1]" },
  { id: 7490, code: "SPR", name: "John Greif II Airport" },
  { id: 7491, code: "SPS", name: "Wichita Falls Municipal Airport" },
  { id: 7492, code: "SPT", name: "Sipitang Airstrip[1]" },
  { id: 7493, code: "SPU", name: "Split Airport" },
  { id: 7494, code: "SPV", name: "Sepik Plains Airport[1]" },
  { id: 7495, code: "SPW", name: "Spencer Municipal Airport" },
  { id: 7496, code: "SPY", name: "San Pédro Airport[1]" },
  { id: 7497, code: "SPX", name: "Sphinx International Airport[1]" },
  { id: 7498, code: "SPZ", name: "Springdale Municipal Airport (FAA: ASG)" },
  { id: 7500, code: "SQA", name: "Santa Ynez Airport (FAA: IZA)" },
  { id: 7501, code: "SQB", name: "Santa Ana Airport[1]" },
  { id: 7502, code: "SQC", name: "Southern Cross Airport[1]" },
  { id: 7503, code: "SQD", name: "Shangrao Sanqingshan Airport[1]" },
  { id: 7504, code: "SQE", name: "San Luis de Palenque Airport[1]" },
  { id: 7505, code: "SQG", name: "Tebelian Airport[1] (Susilo Airport)" },
  { id: 7506, code: "SQH", name: "Nà Sản Airport[1]" },
  { id: 7507, code: "SQI", name: "Whiteside County Airport (Jos. H. Bittorf Field)" },
  { id: 7508, code: "SQJ", name: "Sanming Shaxian Airport[1]" },
  { id: 7509, code: "SQK", name: "Sidi Barrani Airport[1]" },
  { id: 7510, code: "SQL", name: "San Carlos Airport" },
  { id: 7511, code: "SQM", name: "São Miguel do Araguaia Airport[1]" },
  { id: 7512, code: "SQN", name: "Sanana Airport[1]" },
  { id: 7513, code: "SQO", name: "Storuman Airport[1]" },
  { id: 7514, code: "SQQ", name: "Šiauliai International Airport" },
  { id: 7515, code: "SQR", name: "Soroako Airport" },
  { id: 7516, code: "SQS", name: "Matthew Spain Airport[1]" },
  { id: 7517, code: "SQT", name: "China Strait Airstrip[1]" },
  { id: 7518, code: "SQU", name: "Saposoa Airport[1]" },
  { id: 7519, code: "SQV", name: "Sequim Valley Airport (FAA: W28)" },
  { id: 7520, code: "SQW", name: "Skive Airport" },
  { id: 7521, code: "SQX", name: "Hélio Wasum Airport" },
  { id: 7522, code: "SQY", name: "São Lourenço do Sul Airport[1]" },
  { id: 7523, code: "SQZ", name: "RAF Scampton[1]" },
  { id: 7525, code: "SRA", name: "Santa Rosa Airport[1]" },
  { id: 7526, code: "SRB", name: "Santa Rosa Airport[1]" },
  { id: 7527, code: "SRC", name: "Searcy Municipal Airport" },
  { id: 7528, code: "SRD", name: "San Ramón Airport[1]" },
  { id: 7529, code: "SRE", name: "Alcantarí Airport" },
  { id: 7530, code: "SRF", name: "San Rafael Airport (Hamilton Field)" },
  { id: 7531, code: "SRG", name: "Achmad Yani International Airport" },
  { id: 7532, code: "SRH", name: "Sarh Airport" },
  { id: 7533, code: "SRI", name: "Temindung Airport" },
  { id: 7534, code: "SRJ", name: "Capitán Germán Quiroga Guardia Airport" },
  { id: 7535, code: "SRL", name: "Palo Verde Airport[1]" },
  { id: 7536, code: "SRM", name: "Sandringham Station Airport[1]" },
  { id: 7537, code: "SRN", name: "Strahan Airport[1]" },
  { id: 7538, code: "SRO", name: "Santana Ramos Airport[1]" },
  { id: 7539, code: "SRP", name: "Stord Airport, Sørstokken" },
  { id: 7540, code: "SRQ", name: "Sarasota–Bradenton International Airport" },
  { id: 7541, code: "SRR", name: "Dunwich Airport[1]" },
  { id: 7542, code: "SRS", name: "San Marcos Airport[1]" },
  { id: 7543, code: "SRT", name: "Soroti Airport" },
  { id: 7544, code: "SRV", name: "Stony River Airport" },
  { id: 7545, code: "SRW", name: "Rowan County Airport (FAA: RUQ)" },
  { id: 7546, code: "SRX", name: "Gardabya Airport" },
  { id: 7547, code: "SRY", name: "Dasht-e Naz Airport" },
  { id: 7548, code: "SRZ", name: "El Trompillo Airport" },
  { id: 7550, code: "SSA", name: "Deputado Luís Eduardo Magalhães International Airport" },
  { id: 7551, code: "SSB", name: "Christiansted Harbor Seaplane Base (St. Croix Seaplane Base) (FAA: VI32)" },
  { id: 7552, code: "SSC", name: "Shaw Air Force Base" },
  { id: 7553, code: "SSD", name: "San Felipe Airport" },
  { id: 7554, code: "SSE", name: "Solapur Airport" },
  { id: 7555, code: "SSF", name: "Stinson Municipal Airport" },
  { id: 7556, code: "SSG", name: "Malabo International Airport (Saint Isabel Airport)" },
  { id: 7557, code: "SSH", name: "Sharm el-Sheikh International Airport" },
  { id: 7558, code: "SSI", name: "Malcolm McKinnon Airport" },
  { id: 7559, code: "SSJ", name: "Sandnessjøen Airport, Stokka" },
  { id: 7560, code: "SSK", name: "Sturt Creek Airport[1]" },
  { id: 7561, code: "SSL", name: "Santa Rosalía Airport[1]" },
  { id: 7562, code: "SSN", name: "Seoul Air Base" },
  { id: 7563, code: "SSO", name: "São Lourenço Airport[1]" },
  { id: 7564, code: "SSP", name: "Silver Plains Airport[1]" },
  { id: 7565, code: "SSQ", name: "La Sarre Airport (TC: CSR8)" },
  { id: 7566, code: "SSR", name: "Sara Airport" },
  { id: 7567, code: "SSS", name: "Siassi Airport[1]" },
  { id: 7568, code: "SST", name: "Santa Teresita Airport[1]" },
  { id: 7569, code: "SSV", name: "Siasi Airport" },
  { id: 7570, code: "SSW", name: "Stuart Island Airpark[1] (FAA: 7WA5)" },
  { id: 7571, code: "SSY", name: "Mbanza Congo Airport[1]" },
  { id: 7572, code: "SSZ", name: "Santos Air Force Base" },
  { id: 7574, code: "STA", name: "Stauning Vestjylland Airport" },
  { id: 7575, code: "STB", name: "Miguel Urdaneta Fernández Airport" },
  { id: 7576, code: "STC", name: "St. Cloud Regional Airport" },
  { id: 7577, code: "STD", name: "Mayor Buenaventura Vivas Airport" },
  { id: 7578, code: "STE", name: "Stevens Point Municipal Airport" },
  { id: 7579, code: "STF", name: "Stephens Island Airport" },
  { id: 7580, code: "STG", name: "St. George Airport (FAA: PBV)" },
  { id: 7581, code: "STH", name: "Strathmore Airport[1]" },
  { id: 7582, code: "STI", name: "Cibao International Airport" },
  { id: 7583, code: "STJ", name: "Rosecrans Memorial Airport" },
  { id: 7584, code: "STK", name: "Sterling Municipal Airport" },
  { id: 7585, code: "STL", name: "Lambert–St. Louis International Airport" },
  { id: 7586, code: "STM", name: "Santarém-Maestro Wilson Fonseca Airport" },
  { id: 7587, code: "STN", name: "London Stansted Airport" },
  { id: 7588, code: "STO[1]", name: "metropolitan area6" },
  { id: 7589, code: "STP", name: "St. Paul Downtown Airport (Holman Field)" },
  { id: 7590, code: "STQ", name: "St. Marys Municipal Airport (FAA: OYM)" },
  { id: 7591, code: "STR", name: "Stuttgart Airport" },
  { id: 7592, code: "STS", name: "Charles M. Schulz–Sonoma County Airport" },
  { id: 7593, code: "STT", name: "Cyril E. King Airport" },
  { id: 7594, code: "STV", name: "Surat Airport" },
  { id: 7595, code: "STW", name: "Stavropol Shpakovskoye Airport" },
  { id: 7596, code: "STX", name: "Henry E. Rohlsen Airport" },
  { id: 7597, code: "STY", name: "Nueva Hespérides International Airport" },
  { id: 7598, code: "STZ", name: "Santa Terezinha Airport[1]" },
  { id: 7600, code: "SUA", name: "Witham Field" },
  { id: 7601, code: "SUB", name: "Juanda International Airport" },
  { id: 7602, code: "SUD", name: "Stroud Municipal Airport" },
  { id: 7603, code: "SUE", name: "Door County Cherryland Airport" },
  { id: 7604, code: "SUF", name: "Lamezia Terme International Airport" },
  { id: 7605, code: "SUG", name: "Surigao Airport" },
  { id: 7606, code: "SUH", name: "Sur Airport[1]" },
  { id: 7607, code: "SUI", name: "Sukhumi Babushara Airport (Dranda Airport)" },
  { id: 7608, code: "SUJ", name: "Satu Mare International Airport" },
  { id: 7609, code: "SUK", name: "Sakkyryr Airport" },
  { id: 7610, code: "SUL", name: "Sui Airport[1]" },
  { id: 7611, code: "SUM", name: "Sumter Airport (FAA: SMS)" },
  { id: 7612, code: "SUN", name: "Friedman Memorial Airport" },
  { id: 7613, code: "SUO", name: "Sunriver Airport (FAA: S21)" },
  { id: 7614, code: "SUP", name: "Trunojoyo Airport[1]" },
  { id: 7615, code: "SUQ", name: "Sucúa Airport[1]" },
  { id: 7616, code: "SUR", name: "Summer Beaver Airport[1] (TC: CJV7)" },
  { id: 7617, code: "SUS", name: "Spirit of St. Louis Airport" },
  { id: 7618, code: "SUT", name: "Sumbawanga Airport" },
  { id: 7619, code: "SUU", name: "Travis Air Force Base" },
  { id: 7620, code: "SUV", name: "Nausori International Airport" },
  { id: 7621, code: "SUW", name: "Richard I. Bong Airport" },
  { id: 7622, code: "SUX", name: "Sioux Gateway Airport (Colonel Bud Day Field)" },
  { id: 7623, code: "SUY", name: "Suntar Airport[1]" },
  { id: 7624, code: "SUZ", name: "Suria Airport[1]" },
  { id: 7626, code: "SVA", name: "Savoonga Airport" },
  { id: 7627, code: "SVB", name: "Sambava Airport[1]" },
  { id: 7628, code: "SVC", name: "Grant County Airport" },
  { id: 7629, code: "SVD", name: "Argyle International Airport" },
  { id: 7630, code: "SVE", name: "Susanville Municipal Airport" },
  { id: 7631, code: "SVF", name: "Savé Airport" },
  { id: 7632, code: "SVG", name: "Stavanger Airport, Sola" },
  { id: 7633, code: "SVH", name: "Statesville Regional Airport" },
  { id: 7634, code: "SVI", name: "Eduardo Falla Solano Airport[1]" },
  { id: 7635, code: "SVJ", name: "Svolvær Airport, Helle" },
  { id: 7636, code: "SVK", name: "Silver Creek Airport[1]" },
  { id: 7637, code: "SVL", name: "Savonlinna Airport[1]" },
  { id: 7638, code: "SVM", name: "St Pauls Airport[1]" },
  { id: 7639, code: "SVN", name: "Hunter Army Airfield" },
  { id: 7640, code: "SVO", name: "Sheremetyevo International Airport" },
  { id: 7641, code: "SVP", name: "Kuito Airport[1]" },
  { id: 7642, code: "SVQ", name: "Seville Airport" },
  { id: 7643, code: "SVS", name: "Stevens Village Airport" },
  { id: 7644, code: "SVT", name: "Savuti Airport[1]" },
  { id: 7645, code: "SVU", name: "Savusavu Airport" },
  { id: 7646, code: "SVW", name: "Sparrevohn LRRS Airport" },
  { id: 7647, code: "SVX", name: "Koltsovo International Airport" },
  { id: 7648, code: "SVY", name: "Savo Airport[1]" },
  { id: 7649, code: "SVZ", name: "Juan Vicente Gómez International Airport" },
  { id: 7651, code: "SWA", name: "Jieyang Chaoshan International Airport" },
  { id: 7652, code: "SWB", name: "Shaw River Airport[1]" },
  { id: 7653, code: "SWC", name: "Stawell Airport[1]" },
  { id: 7654, code: "SWD", name: "Seward Airport" },
  { id: 7655, code: "SWE", name: "Siwea Airport[1]" },
  { id: 7656, code: "SWF", name: "Stewart International Airport" },
  { id: 7657, code: "SWG", name: "Satwag Airport[1]" },
  { id: 7658, code: "SWH", name: "Swan Hill Airport[1]" },
  { id: 7659, code: "SWJ", name: "South West Bay Airport[1]" },
  { id: 7660, code: "SWL", name: "San Vicente Airport" },
  { id: 7661, code: "SWM", name: "Suia-Missu Airport[1]" },
  { id: 7662, code: "SWN", name: "Sahiwal Airport" },
  { id: 7663, code: "SWO", name: "Stillwater Regional Airport" },
  { id: 7664, code: "SWP", name: "Swakopmund Airport[1]" },
  { id: 7665, code: "SWQ", name: "Sultan Muhammad Kaharuddin III Airport[1] (Brangbiji Airport)" },
  { id: 7666, code: "SWR", name: "Silur Airport[1]" },
  { id: 7667, code: "SWS", name: "Swansea Airport" },
  { id: 7668, code: "SWT", name: "Strezhevoy Airport" },
  { id: 7669, code: "SWU", name: "Suwon Air Base[1]" },
  { id: 7670, code: "SWV", name: "Severo-Evensk Airport[1]" },
  { id: 7671, code: "SWW", name: "Avenger Field" },
  { id: 7672, code: "SWX", name: "Shakawe Airport[1]" },
  { id: 7673, code: "SWY", name: "Sitiawan Airport" },
  { id: 7675, code: "SXA", name: "Sialum Airport[1]" },
  { id: 7676, code: "SXB", name: "Strasbourg Airport" },
  { id: 7677, code: "SXE", name: "West Sale Airport[1]" },
  { id: 7678, code: "SXG", name: "Senanga Airport[1]" },
  { id: 7679, code: "SXH", name: "Sehulea Airport[1]" },
  { id: 7680, code: "SXI", name: "Sirri Island Airport[1]" },
  { id: 7681, code: "SXJ", name: "Shanshan Airport[1]" },
  { id: 7682, code: "SXK", name: "Saumlaki Airport[1] (Olilit Airport)" },
  { id: 7683, code: "SXL", name: "Sligo Airport" },
  { id: 7684, code: "SXM", name: "Princess Juliana International Airport" },
  { id: 7685, code: "SXN", name: "Sua Pan Airport[1]" },
  { id: 7686, code: "SXO", name: "São Félix do Araguaia Airport[1]" },
  { id: 7687, code: "SXP", name: "Sheldon Point Airport" },
  { id: 7688, code: "SXQ", name: "Soldotna Airport" },
  { id: 7689, code: "SXR", name: "Sheikh ul-Alam International Airport[1]" },
  { id: 7690, code: "SXS", name: "Sahabat Airport[1]" },
  { id: 7691, code: "SXT", name: "Sungai Tiang Airport[1]" },
  { id: 7692, code: "SXU", name: "Soddu Airport[1]" },
  { id: 7693, code: "SXV", name: "Salem Airport" },
  { id: 7694, code: "SXW", name: "Sauren Airport[1]" },
  { id: 7695, code: "SXX", name: "São Félix do Xingu Airport[1]" },
  { id: 7696, code: "SXY", name: "Sidney Municipal Airport (FAA: N23)" },
  { id: 7697, code: "SXZ", name: "Siirt Airport" },
  { id: 7699, code: "SYA", name: "Eareckson Air Station" },
  { id: 7700, code: "SYB", name: "Seal Bay Seaplane Base[1]" },
  { id: 7701, code: "SYC", name: "Shiringayoc Airport[1]" },
  { id: 7702, code: "SYD", name: "Sydney Airport (Kingsford Smith Airport)" },
  { id: 7703, code: "SYE", name: "Saadah Airport[1]" },
  { id: 7704, code: "SYF", name: "Silva Bay Seaplane Base" },
  { id: 7705, code: "SYI", name: "Shelbyville Municipal Airport (Bomar Field)" },
  { id: 7706, code: "SYJ", name: "Sirjan Airport" },
  { id: 7707, code: "SYK", name: "Stykkishólmur Airport" },
  { id: 7708, code: "SYM", name: "Pu'er Simao Airport[1]" },
  { id: 7709, code: "SYN", name: "Stanton Airfield" },
  { id: 7710, code: "SYO", name: "Shonai Airport" },
  { id: 7711, code: "SYP", name: "Ruben Cantu Airport" },
  { id: 7712, code: "SYQ", name: "Tobías Bolaños International Airport" },
  { id: 7713, code: "SYR", name: "Syracuse Hancock International Airport" },
  { id: 7714, code: "SYS", name: "Saskylakh Airport[1]" },
  { id: 7715, code: "SYT", name: "Saint-Yan Airport[1] (Charolais Bourgogne Sud Airport)" },
  { id: 7716, code: "SYU", name: "Warraber Island Airport[1]" },
  { id: 7717, code: "SYV", name: "Sylvester Airport" },
  { id: 7718, code: "SYW", name: "Sehwan Sharif Airport[1]" },
  { id: 7719, code: "SYX", name: "Sanya Phoenix International Airport" },
  { id: 7720, code: "SYY", name: "Stornoway Airport" },
  { id: 7721, code: "SYZ", name: "Shiraz International Airport (Shahid Dastghaib Int'l)" },
  { id: 7723, code: "SZA", name: "Soyo Airport[1]" },
  { id: 7724, code: "SZB", name: "Sultan Abdul Aziz Shah Airport" },
  { id: 7725, code: "SZE", name: "Semera Airport[1]" },
  { id: 7726, code: "SZF", name: "Samsun-Çarşamba Airport" },
  { id: 7727, code: "SZG", name: "Salzburg Airport" },
  { id: 7728, code: "SZI", name: "Zaysan Airport" },
  { id: 7729, code: "SZJ", name: "Siguanea Airport[1]" },
  { id: 7730, code: "SZK", name: "Skukuza Airport[1]" },
  { id: 7731, code: "SZL", name: "Whiteman Air Force Base" },
  { id: 7732, code: "SZM", name: "Sesriem Airport[1]" },
  { id: 7733, code: "SZN", name: "Santa Cruz Island Airport" },
  { id: 7734, code: "SZP", name: "Santa Paula Airport" },
  { id: 7735, code: "SZR", name: "Stara Zagora Airport" },
  { id: 7736, code: "SZS", name: "Ryan's Creek Aerodrome" },
  { id: 7737, code: "SZU", name: "Ségou Airport[1]" },
  { id: 7738, code: "SZV", name: "Suzhou Guangfu Airport" },
  { id: 7739, code: "SZW", name: "Schwerin-Parchim International Airport" },
  { id: 7740, code: "SZX", name: "Shenzhen Bao'an International Airport" },
  { id: 7741, code: "SZY", name: "Olsztyn-Mazury Regional Airport" },
  { id: 7742, code: "SZZ", name: "Solidarity Szczecin–Goleniów Airport" },
  { id: 7744, code: "TAA", name: "Tarapaina Airport[1]" },
  { id: 7745, code: "TAB", name: "Arthur Napoleon Raymond Robinson International Airport" },
  { id: 7746, code: "TAC", name: "Daniel Z. Romualdez Airport" },
  { id: 7747, code: "TAD", name: "Perry Stokes Airport" },
  { id: 7748, code: "TAE", name: "Daegu International Airport" },
  { id: 7749, code: "TAF", name: "Oran Tafaraoui Airport" },
  { id: 7750, code: "TAG", name: "Bohol–Panglao International Airport" },
  { id: 7751, code: "TAH", name: "Whitegrass Airport" },
  { id: 7752, code: "TAI", name: "Taiz International Airport" },
  { id: 7753, code: "TAJ", name: "Tadji Airport" },
  { id: 7754, code: "TAK", name: "Takamatsu Airport" },
  { id: 7755, code: "TAL", name: "Ralph M. Calhoun Memorial Airport" },
  { id: 7756, code: "TAM", name: "General Francisco Javier Mina International Airport" },
  { id: 7757, code: "TAN", name: "Tangalooma Airport" },
  { id: 7758, code: "TAO", name: "Qingdao Jiaodong International Airport" },
  { id: 7759, code: "TAP", name: "Tapachula International Airport" },
  { id: 7760, code: "TAQ", name: "Tarcoola Airport[1]" },
  { id: 7761, code: "TAR", name: "Taranto-Grottaglie Airport" },
  { id: 7762, code: "TAS", name: "Tashkent International Airport" },
  { id: 7763, code: "TAT", name: "Poprad–Tatry Airport" },
  { id: 7764, code: "TAU", name: "Tauramena Airport[1]" },
  { id: 7765, code: "TAV", name: "Tau Airport (FAA: HI36)" },
  { id: 7766, code: "TAW", name: "Tacuarembó Airport" },
  { id: 7767, code: "TAX", name: "Taliabu Airport" },
  { id: 7768, code: "TAY", name: "Tartu Airport" },
  { id: 7769, code: "TAZ", name: "Daşoguz Airport" },
  { id: 7771, code: "TBA", name: "Tabibuga Airport[1]" },
  { id: 7772, code: "TBB", name: "Dong Tac Airport[1]" },
  { id: 7773, code: "TBC", name: "Tuba City Airport[1] (FAA: T03)" },
  { id: 7774, code: "TBD", name: "Timbiquí Airport[1]" },
  { id: 7775, code: "TBE", name: "Timbunke Airport[1]" },
  { id: 7776, code: "TBF", name: "Tabiteuea North Airport[1]" },
  { id: 7777, code: "TBG", name: "Tabubil Airport[1]" },
  { id: 7778, code: "TBH", name: "Tugdan Airport" },
  { id: 7779, code: "TBI", name: "New Bight Airport" },
  { id: 7780, code: "TBJ", name: "Tabarka–Aïn Draham International Airport" },
  { id: 7781, code: "TBK", name: "Timber Creek Airport[1]" },
  { id: 7782, code: "TBL", name: "Tableland Homestead Airport[1]" },
  { id: 7783, code: "TBM", name: "Tumbang Samba Airport[1]" },
  { id: 7784, code: "TBN", name: "Waynesville-St. Robert Regional Airport (Forney Field)" },
  { id: 7785, code: "TBO", name: "Tabora Airport[1]" },
  { id: 7786, code: "TBP", name: "Cap. FAP Pedro Canga Rodríguez Airport" },
  { id: 7787, code: "TBQ", name: "Tarabo Airport[1]" },
  { id: 7788, code: "TBR", name: "Statesboro–Bulloch County Airport" },
  { id: 7789, code: "TBS", name: "Tbilisi International Airport" },
  { id: 7790, code: "TBT", name: "Tabatinga International Airport" },
  { id: 7791, code: "TBU", name: "Fuaʻamotu International Airport" },
  { id: 7792, code: "TBV", name: "Tabal Airport[1]" },
  { id: 7793, code: "TBW", name: "Tambov Donskoye Airport" },
  { id: 7794, code: "TBY", name: "Tshabong Airport[1]" },
  { id: 7795, code: "TBZ", name: "Tabriz International Airport" },
  { id: 7797, code: "TCA", name: "Tennant Creek Airport" },
  { id: 7798, code: "TCB", name: "Treasure Cay Airport" },
  { id: 7799, code: "TCC", name: "Tucumcari Municipal Airport" },
  { id: 7800, code: "TCD", name: "Tarapacá Airport[1]" },
  { id: 7801, code: "TCE", name: "Tulcea Danube Delta Airport[1]" },
  { id: 7802, code: "TCF", name: "Tocoa Airport[1]" },
  { id: 7803, code: "TCG", name: "Tacheng Airport[1]" },
  { id: 7804, code: "TCH", name: "Tchibanga Airport[1]" },
  { id: 7805, code: "TCI[1]", name: "metropolitan area1" },
  { id: 7806, code: "TCJ", name: "Torembi Airport[1]" },
  { id: 7807, code: "TCK", name: "Tinboli Airport[1]" },
  { id: 7808, code: "TCL", name: "Tuscaloosa Regional Airport" },
  { id: 7809, code: "TCM", name: "McChord Field" },
  { id: 7810, code: "TCN", name: "Tehuacán Airport" },
  { id: 7811, code: "TCO", name: "La Florida Airport[1]" },
  { id: 7812, code: "TCP", name: "Taba International Airport" },
  { id: 7813, code: "TCQ", name: "Coronel FAP Carlos Ciriani Santa Rosa International Airport[1]" },
  { id: 7814, code: "TCR", name: "Tuticorin Airport[1]" },
  { id: 7815, code: "TCS", name: "Truth or Consequences Municipal Airport" },
  { id: 7816, code: "TCT", name: "Takotna Airport" },
  { id: 7817, code: "TCU", name: "Thaba Nchu Airport[1]" },
  { id: 7818, code: "TCV", name: "Torch Cay Airport" },
  { id: 7819, code: "TCW", name: "Tocumwal Airport[1]" },
  { id: 7820, code: "TCX", name: "Tabas Airport" },
  { id: 7821, code: "TCY", name: "Terrace Bay Airport[1]" },
  { id: 7822, code: "TCZ", name: "Tengchong Tuofeng Airport" },
  { id: 7824, code: "TDA", name: "Trinidad Airport[1]" },
  { id: 7825, code: "TDB", name: "Tetebedi Airport[1]" },
  { id: 7826, code: "TDD", name: "Teniente Jorge Henrich Arauz Airport" },
  { id: 7827, code: "TDG", name: "Tandag Airport" },
  { id: 7828, code: "TDJ", name: "Tadjoura Airport[1]" },
  { id: 7829, code: "TDK", name: "Taldykorgan Airport" },
  { id: 7830, code: "TDL", name: "Tandil Airport" },
  { id: 7831, code: "TDN", name: "Theda Station Airport[1]" },
  { id: 7832, code: "TDO", name: "South Lewis County Airport (Ed Carlson Memorial Field)" },
  { id: 7833, code: "TDP", name: "Trompeteros Airport[1]" },
  { id: 7834, code: "TDR", name: "Theodore Airport" },
  { id: 7835, code: "TDS", name: "Sasereme Airport" },
  { id: 7836, code: "TDT", name: "Tanda Tula Airport[1]" },
  { id: 7837, code: "TDV", name: "Samangoky Airport" },
  { id: 7838, code: "TDW", name: "Tradewind Airport" },
  { id: 7839, code: "TDX", name: "Trat Airport" },
  { id: 7840, code: "TDZ", name: "Toledo Executive Airport" },
  { id: 7842, code: "TEA", name: "Tela Airport[1]" },
  { id: 7843, code: "TEB", name: "Teterboro Airport" },
  { id: 7844, code: "TEC", name: "Telêmaco Borba Airport[1]" },
  { id: 7845, code: "TED", name: "Thisted Airport" },
  { id: 7846, code: "TEE", name: "Cheikh Larbi Tébessi Airport[1]" },
  { id: 7847, code: "TEF", name: "Telfer Airport[1]" },
  { id: 7848, code: "TEG", name: "Tenkodogo Airport" },
  { id: 7849, code: "TEH", name: "Tetlin Airport[1] (FAA: 3T4)" },
  { id: 7850, code: "TEI", name: "Tezu Airport" },
  { id: 7851, code: "TEK", name: "Tatitlek Airport (FAA: 7KA)" },
  { id: 7852, code: "TEL", name: "Telupid Airport[1]" },
  { id: 7853, code: "TEM", name: "Temora Airport[1]" },
  { id: 7854, code: "TEN", name: "Tongren Fenghuang Airport" },
  { id: 7855, code: "TEO", name: "Terapo Airport[1]" },
  { id: 7856, code: "TEP", name: "Teptep Airport[1]" },
  { id: 7857, code: "TEQ", name: "Tekirdağ Çorlu Airport" },
  { id: 7858, code: "TER", name: "Lajes Airport" },
  { id: 7859, code: "TES", name: "Teseney Airport[1]" },
  { id: 7860, code: "TET", name: "Chingozi Airport" },
  { id: 7861, code: "TEU", name: "Te Anau Airport[1] (Manapouri Airport)" },
  { id: 7862, code: "TEV", name: "Teruel Airport[1]" },
  { id: 7863, code: "TEX", name: "Telluride Regional Airport" },
  { id: 7864, code: "TEY", name: "Thingeyri Airport[1]" },
  { id: 7865, code: "TEZ", name: "Tezpur Airport" },
  { id: 7867, code: "TFB", name: "Tifalmin Airport[1]" },
  { id: 7868, code: "TFF", name: "Tefé Airport" },
  { id: 7869, code: "TFI", name: "Tufi Airport[1]" },
  { id: 7870, code: "TFL", name: "Teófilo Otoni Airport[1] (Juscelino Kubitscheck Airport)" },
  { id: 7871, code: "TFM", name: "Telefomin Airport[1]" },
  { id: 7872, code: "TFN", name: "Tenerife–North Airport (Los Rodeos Airport)" },
  { id: 7873, code: "TFR", name: "Wadi al Jandali Airport[1]" },
  { id: 7874, code: "TFS", name: "Tenerife–South Airport (Reina Sofia Airport)" },
  { id: 7875, code: "TFT", name: "Taftan Airport[1]" },
  { id: 7876, code: "TFU", name: "Chengdu Tianfu International Airport" },
  { id: 7878, code: "TGA", name: "Tengah Air Base" },
  { id: 7879, code: "TGB", name: "Tagbita Airport" },
  { id: 7880, code: "TGC", name: "Tanjung Manis Airport[1]" },
  { id: 7881, code: "TGD", name: "Podgorica Airport" },
  { id: 7882, code: "TGE", name: "Sharpe Field (FAA: AL73)" },
  { id: 7883, code: "TGG", name: "Sultan Mahmud Airport" },
  { id: 7884, code: "TGH", name: "Tongoa Airport" },
  { id: 7885, code: "TGI", name: "Tingo María Airport" },
  { id: 7886, code: "TGJ", name: "Tiga Airport[1]" },
  { id: 7887, code: "TGK", name: "Taganrog Airport[1]" },
  { id: 7888, code: "TGL", name: "Tagula Airport[1]" },
  { id: 7889, code: "TGM", name: "Târgu Mureș International Airport" },
  { id: 7890, code: "TGN", name: "Latrobe Regional Airport[1]" },
  { id: 7891, code: "TGO", name: "Tongliao Airport[1]" },
  { id: 7892, code: "TGP", name: "Podkamennaya Tunguska Airport" },
  { id: 7893, code: "TGQ", name: "Tangará da Serra Airport[1]" },
  { id: 7894, code: "TGR", name: "Sidi Mahdi Airport[1]" },
  { id: 7895, code: "TGS", name: "Chokwe Airport[1]" },
  { id: 7896, code: "TGT", name: "Tanga Airport[1]" },
  { id: 7897, code: "TGU", name: "Toncontín International Airport" },
  { id: 7898, code: "TGV", name: "Targovishte Airport[1] (Buhovtsi Airfield)" },
  { id: 7899, code: "TGZ", name: "Ángel Albino Corzo International Airport" },
  { id: 7901, code: "THA", name: "Tullahoma Regional Airport (William Northern Field)" },
  { id: 7902, code: "THB", name: "Thaba Tseka Airport[1]" },
  { id: 7903, code: "THC", name: "Tchien Airport" },
  { id: 7904, code: "THD", name: "Tho Xuan Airport" },
  { id: 7905, code: "THE", name: "Teresina–Senador Petrônio Portella Airport" },
  { id: 7906, code: "THG", name: "Thangool Airport[1]" },
  { id: 7907, code: "THH", name: "Taharoa Aerodrome[1]" },
  { id: 7908, code: "THI", name: "Tichitt Airport" },
  { id: 7909, code: "THK", name: "Thakhek Airport[1]" },
  { id: 7910, code: "THL", name: "Tachilek Airport" },
  { id: 7911, code: "THM", name: "Thompson Falls Airport[1]" },
  { id: 7912, code: "THN", name: "Trollhättan–Vänersborg Airport" },
  { id: 7913, code: "THO", name: "Thorshofn Airport" },
  { id: 7914, code: "THP", name: "Hot Springs County–Thermopolis Municipal Airport" },
  { id: 7915, code: "THQ", name: "Tianshui Maijishan Airport[1]" },
  { id: 7916, code: "THR", name: "Mehrabad International Airport" },
  { id: 7917, code: "THS", name: "Sukhothai Airport" },
  { id: 7918, code: "THT", name: "Tamchakett Airport" },
  { id: 7919, code: "THU", name: "Pituffik Space Base" },
  { id: 7920, code: "THV", name: "York Airport" },
  { id: 7921, code: "THW", name: "Trincomalee Harbour Seaplane Base[1]" },
  { id: 7922, code: "THX", name: "Turukhansk Airport" },
  { id: 7923, code: "THY", name: "P.R. Mphephu Airport[1]" },
  { id: 7924, code: "THZ", name: "Tahoua Airport" },
  { id: 7926, code: "TIA", name: "Tirana International Airport Nënë Tereza" },
  { id: 7927, code: "TIB", name: "Tibú Airport[1]" },
  { id: 7928, code: "TIC", name: "Tinak Airport (FAA: N18)" },
  { id: 7929, code: "TID", name: "Abdelhafid Boussouf Bou Chekif Airport[1]" },
  { id: 7930, code: "TIE", name: "Tippi Airport[1]" },
  { id: 7931, code: "TIF", name: "Ta'if Regional Airport" },
  { id: 7932, code: "TIG", name: "Tingwon Airport[1]" },
  { id: 7933, code: "TIH", name: "Tikehau Airport[1]" },
  { id: 7934, code: "TII", name: "Tarinkot Airport" },
  { id: 7935, code: "TIJ", name: "Tijuana International Airport" },
  { id: 7936, code: "TIK", name: "Tinker Air Force Base" },
  { id: 7937, code: "TIL", name: "Cheadle Airport[1] (TC: CFQ4)" },
  { id: 7938, code: "TIM", name: "Mozes Kilangin Airport" },
  { id: 7939, code: "TIN", name: "Tindouf Airport[1]" },
  { id: 7940, code: "TIO", name: "Tilin Airport[1]" },
  { id: 7941, code: "TIP", name: "Tripoli International Airport" },
  { id: 7942, code: "TIQ", name: "Tinian International Airport (West Tinian Airport) (FAA: TNI)" },
  { id: 7943, code: "TIR", name: "Tirupati Airport" },
  { id: 7944, code: "TIS", name: "Thursday Island Airport" },
  { id: 7945, code: "TIU", name: "Richard Pearse Airport" },
  { id: 7946, code: "TIV", name: "Tivat Airport" },
  { id: 7947, code: "TIW", name: "Tacoma Narrows Airport" },
  { id: 7948, code: "TIX", name: "Space Coast Regional Airport" },
  { id: 7949, code: "TIY", name: "Tidjikja Airport" },
  { id: 7950, code: "TIZ", name: "Tari Airport[1]" },
  { id: 7952, code: "TJA", name: "Capitán Oriel Lea Plaza Airport" },
  { id: 7953, code: "TJB", name: "Sei Bati Airport[1]" },
  { id: 7954, code: "TJC", name: "Ticantiquí Airport[1]" },
  { id: 7955, code: "TJG", name: "Warukin Airport[1]" },
  { id: 7956, code: "TJH", name: "Tajima Airport[1]" },
  { id: 7957, code: "TJI", name: "Trujillo Airport[1] (Capiro Airport)" },
  { id: 7958, code: "TJK", name: "Tokat Airport" },
  { id: 7959, code: "TJL", name: "Plínio Alarcom Airport" },
  { id: 7960, code: "TJM", name: "Roshchino International Airport" },
  { id: 7961, code: "TJN", name: "Takume Airport[1]" },
  { id: 7962, code: "TJQ", name: "H.A.S. Hanandjoeddin Airport (Buluh Tumbang Airport)" },
  { id: 7963, code: "TJS", name: "Tanjung Harapan Airport[1]" },
  { id: 7964, code: "TJU", name: "Kulob Airport[1]" },
  { id: 7965, code: "TJV", name: "Thanjavur Air Force Station[1]" },
  { id: 7967, code: "TKA", name: "Talkeetna Airport" },
  { id: 7968, code: "TKB", name: "Tekadu Airport[1]" },
  { id: 7969, code: "TKC", name: "Tiko Airport[1]" },
  { id: 7970, code: "TKD", name: "Takoradi Airport" },
  { id: 7971, code: "TKE", name: "Tenakee Seaplane Base[1]" },
  { id: 7972, code: "TKF", name: "Truckee Tahoe Airport (FAA: TRK)" },
  { id: 7973, code: "TKG", name: "Radin Inten II Airport" },
  { id: 7974, code: "TKH", name: "Takhli Royal Thai Air Force Base[1]" },
  { id: 7975, code: "TKI", name: "Tokeen Seaplane Base (FAA: 57A)" },
  { id: 7976, code: "TKJ", name: "Tok Junction Airport[1] (FAA: 6K8)" },
  { id: 7977, code: "TKK", name: "Chuuk International Airport" },
  { id: 7978, code: "TKL", name: "Taku Lodge Seaplane Base[1]" },
  { id: 7979, code: "TKN", name: "Tokunoshima Airport[1]" },
  { id: 7980, code: "TKO", name: "Tlokoeng Airport[1]" },
  { id: 7981, code: "TKP", name: "Takapoto Airport[1]" },
  { id: 7982, code: "TKQ", name: "Kigoma Airport" },
  { id: 7983, code: "TKR", name: "Thakurgaon Airport[1]" },
  { id: 7984, code: "TKS", name: "Tokushima Airport[1]" },
  { id: 7985, code: "TKT", name: "Tak Airport" },
  { id: 7986, code: "TKU", name: "Turku Airport" },
  { id: 7987, code: "TKV", name: "Tatakoto Airport[1]" },
  { id: 7988, code: "TKW", name: "Tekin Airport[1]" },
  { id: 7989, code: "TKX", name: "Takaroa Airport[1]" },
  { id: 7990, code: "TKY", name: "Turkey Creek Airport[1]" },
  { id: 7991, code: "TKZ", name: "Tokoroa Aerodrome[1]" },
  { id: 7993, code: "TLA", name: "Teller Airport (FAA: TER)" },
  { id: 7994, code: "TLB", name: "Tarbela Dam Airport[1]" },
  { id: 7995, code: "TLC", name: "Licenciado Adolfo López Mateos International Airport" },
  { id: 7996, code: "TLD", name: "Tuli Lodge Airport[1]" },
  { id: 7997, code: "TLE", name: "Toliara Airport[1]" },
  { id: 7998, code: "TLF", name: "Telida Airport (FAA: 2K5)" },
  { id: 7999, code: "TLG", name: "Tulaghi Heliport[1]" },
  { id: 8000, code: "TLH", name: "Tallahassee International Airport" },
  { id: 8001, code: "TLI", name: "Sultan Bantilan Airport[1] (Lalos Airport)" },
  { id: 8002, code: "TLJ", name: "Tatalina LRRS Airport" },
  { id: 8003, code: "TLK", name: "Talakan Airport" },
  { id: 8004, code: "TLL", name: "Tallinn Airport (Lennart Meri Tallinn Airport)" },
  { id: 8005, code: "TLM", name: "Zenata – Messali El Hadj Airport[1]" },
  { id: 8006, code: "TLN", name: "Toulon–Hyères Airport (Hyères Le Palyvestre Airport)" },
  { id: 8007, code: "TLO", name: "Tol Airport[1]" },
  { id: 8008, code: "TLP", name: "Tumolbil Airport[1]" },
  { id: 8009, code: "TLQ", name: "Turpan Jiaohe Airport" },
  { id: 8010, code: "TLR", name: "Mefford Field Airport" },
  { id: 8011, code: "TLS", name: "Toulouse–Blagnac Airport" },
  { id: 8012, code: "TLT", name: "Tuluksak Airport" },
  { id: 8013, code: "TLU", name: "Golfo de Morrosquillo Airport[1]" },
  { id: 8014, code: "TLV", name: "Ben Gurion Airport" },
  { id: 8015, code: "TLW", name: "Talasea Airport[1]" },
  { id: 8016, code: "TLX", name: "Panguilemo Airport[1]" },
  { id: 8017, code: "TLY", name: "Plastun Airport[1]" },
  { id: 8018, code: "TLZ", name: "Catalão Airport[1]" },
  { id: 8020, code: "TMA", name: "Henry Tift Myers Airport" },
  { id: 8021, code: "TMB", name: "Miami Executive Airport" },
  { id: 8022, code: "TMC", name: "Tambolaka Airport[1] (Waikabubak Airport)" },
  { id: 8023, code: "TMD", name: "Timbedra Airport" },
  { id: 8024, code: "TME", name: "Gabriel Vargas Santos Airport" },
  { id: 8025, code: "TMF", name: "Thimarafushi Airport" },
  { id: 8026, code: "TMG", name: "Tommanggong Airport[1]" },
  { id: 8027, code: "TMH", name: "Tanah Merah Airport[1]" },
  { id: 8028, code: "TMI", name: "Tumlingtar Airport[1]" },
  { id: 8029, code: "TMJ", name: "Termez Airport" },
  { id: 8030, code: "TMK", name: "Tam Kỳ Airport[1]" },
  { id: 8031, code: "TML", name: "Tamale Airport" },
  { id: 8032, code: "TMM", name: "Toamasina Airport" },
  { id: 8033, code: "TMN", name: "Tamana Airport[1]" },
  { id: 8034, code: "TMO", name: "Tumeremo Airport[1]" },
  { id: 8035, code: "TMP", name: "Tampere–Pirkkala Airport" },
  { id: 8036, code: "TMQ", name: "Tambao Airport" },
  { id: 8037, code: "TMR", name: "Aguenar – Hadj Bey Akhamok Airport" },
  { id: 8038, code: "TMS", name: "São Tomé International Airport" },
  { id: 8039, code: "TMT", name: "Porto Trombetas Airport" },
  { id: 8040, code: "TMU", name: "Tambor Airport" },
  { id: 8041, code: "TMW", name: "Tamworth Airport" },
  { id: 8042, code: "TMX", name: "Timimoun Airport[1]" },
  { id: 8043, code: "TMY", name: "Tiom Airport[1]" },
  { id: 8044, code: "TMZ", name: "Thames Aerodrome" },
  { id: 8046, code: "TNA", name: "Jinan Yaoqiang International Airport" },
  { id: 8047, code: "TNB", name: "Tanah Grogot Airport[1]" },
  { id: 8048, code: "TNC", name: "Tin City LRRS Airport" },
  { id: 8049, code: "TND", name: "Alberto Delgado Airport[1]" },
  { id: 8050, code: "TNE", name: "New Tanegashima Airport[1]" },
  { id: 8051, code: "TNF", name: "Toussus-le-Noble Airport" },
  { id: 8052, code: "TNG", name: "Tangier Ibn Battouta Airport" },
  { id: 8053, code: "TNH", name: "Tonghua Sanyuanpu Airport" },
  { id: 8054, code: "TNI", name: "Satna Airport" },
  { id: 8055, code: "TNJ", name: "Raja Haji Fisabilillah Airport" },
  { id: 8056, code: "TNK", name: "Tununak Airport (FAA: 4KA)" },
  { id: 8057, code: "TNL", name: "Ternopil International Airport" },
  { id: 8058, code: "TNM", name: "Teniente R. Marsh Airport" },
  { id: 8059, code: "TNN", name: "Tainan Airport" },
  { id: 8060, code: "TNO", name: "Tamarindo Airport" },
  { id: 8061, code: "TNP", name: "Twentynine Palms Airport" },
  { id: 8062, code: "TNQ", name: "Teraina Airport" },
  { id: 8063, code: "TNR", name: "Ivato International Airport" },
  { id: 8064, code: "TNS", name: "Tungsten (Cantung) Airport[1] (TC: CBX5)" },
  { id: 8065, code: "TNT", name: "Dade-Collier Training and Transition Airport" },
  { id: 8066, code: "TNU", name: "Newton Municipal Airport" },
  { id: 8067, code: "TNV", name: "Tabuaeran Island Airport[1]" },
  { id: 8068, code: "TNW", name: "Jumandy Airport[1]" },
  { id: 8069, code: "TNX", name: "Steung Treng Airport[1]" },
  { id: 8070, code: "TNZ", name: "Tosontsengel Airport[1]" },
  { id: 8072, code: "TOA", name: "Zamperini Field" },
  { id: 8073, code: "TOB", name: "Tobruk Airport" },
  { id: 8074, code: "TOC", name: "Toccoa Airport (R.G. LeTourneau Field)" },
  { id: 8075, code: "TOD", name: "Tioman Airport" },
  { id: 8076, code: "TOE", name: "Tozeur–Nefta International Airport" },
  { id: 8077, code: "TOF", name: "Bogashevo Airport" },
  { id: 8078, code: "TOG", name: "Togiak Airport" },
  { id: 8079, code: "TOH", name: "Torres Airport[1]" },
  { id: 8080, code: "TOI", name: "Troy Municipal Airport" },
  { id: 8081, code: "TOJ", name: "Madrid–Torrejón Airport" },
  { id: 8082, code: "TOK", name: "Torokina Airport[1]" },
  { id: 8083, code: "TOL", name: "Toledo Express Airport" },
  { id: 8084, code: "TOM", name: "Timbuktu Airport" },
  { id: 8085, code: "TON", name: "Tonu Airport[1]" },
  { id: 8086, code: "TOO", name: "San Vito de Java Airport[1]" },
  { id: 8087, code: "TOP", name: "Philip Billard Municipal Airport" },
  { id: 8088, code: "TOQ", name: "Barriles Airport[1]" },
  { id: 8089, code: "TOR", name: "Torrington Municipal Airport" },
  { id: 8090, code: "TOS", name: "Tromsø Airport, Langnes" },
  { id: 8091, code: "TOT", name: "Totness Airstrip" },
  { id: 8092, code: "TOU", name: "Touho Airport[1]" },
  { id: 8093, code: "TOV", name: "West End Seaplane Base[1]" },
  { id: 8094, code: "TOW", name: "Luiz dal Canalle Filho Airport[1]" },
  { id: 8095, code: "TOX", name: "Tobolsk Airport[1]" },
  { id: 8096, code: "TOY", name: "Toyama Airport" },
  { id: 8097, code: "TOZ", name: "Mahana Airport[1]" },
  { id: 8099, code: "TPA", name: "Tampa International Airport" },
  { id: 8100, code: "TPC", name: "Tarapoa Airport[1]" },
  { id: 8101, code: "TPE", name: "Taiwan Taoyuan International Airport" },
  { id: 8102, code: "TPF", name: "Peter O. Knight Airport" },
  { id: 8103, code: "TPG", name: "Taiping Airport[1]" },
  { id: 8104, code: "TPH", name: "Tonopah Airport" },
  { id: 8105, code: "TPI", name: "Tapini Airport[1]" },
  { id: 8106, code: "TPJ", name: "Taplejung Airport[1]" },
  { id: 8107, code: "TPK", name: "Teuku Cut Ali Airport[1]" },
  { id: 8108, code: "TPL", name: "Draughon–Miller Central Texas Regional Airport" },
  { id: 8109, code: "TPN", name: "Tiputini Airport[1]" },
  { id: 8110, code: "TPP", name: "Cad. FAP Guillermo del Castillo Paredes Airport[1]" },
  { id: 8111, code: "TPQ", name: "Amado Nervo International Airport" },
  { id: 8112, code: "TPR", name: "Tom Price Airport" },
  { id: 8113, code: "TPS", name: "Vincenzo Florio Airport Trapani–Birgi" },
  { id: 8114, code: "TPT", name: "Tapeta Airport[1]" },
  { id: 8115, code: "TPU", name: "Tikapur Airport[1]" },
  { id: 8116, code: "TPX", name: "Tupai Airport[1]" },
  { id: 8118, code: "TQD", name: "Al-Taqaddum Air Base[1]" },
  { id: 8119, code: "TQL", name: "Tarko-Sale Airport[1]" },
  { id: 8120, code: "TQN", name: "Taloqan Airport" },
  { id: 8121, code: "TQO", name: "Tulum International Airport" },
  { id: 8122, code: "TQP", name: "Trepell Airport" },
  { id: 8123, code: "TQQ", name: "Maranggo Airport[1]" },
  { id: 8124, code: "TQS", name: "Captain Ernesto Esguerra Cubides Air Base[1]" },
  { id: 8126, code: "TRA", name: "Tarama Airport[1]" },
  { id: 8127, code: "TRB", name: "Gonzalo Mejía Airport[1]" },
  { id: 8128, code: "TRC", name: "Francisco Sarabia International Airport (Torreón Int'l)" },
  { id: 8129, code: "TRD", name: "Trondheim Airport, Værnes" },
  { id: 8130, code: "TRE", name: "Tiree Airport" },
  { id: 8131, code: "TRF", name: "Sandefjord Airport, Torp" },
  { id: 8132, code: "TRG", name: "Tauranga Airport" },
  { id: 8133, code: "TRH", name: "Trona Airport (FAA: L72)" },
  { id: 8134, code: "TRI", name: "Tri-Cities Regional Airport" },
  { id: 8135, code: "TRJ", name: "Tarakbits Airport[1]" },
  { id: 8136, code: "TRK", name: "Juwata International Airport" },
  { id: 8137, code: "TRL", name: "Terrell Municipal Airport" },
  { id: 8138, code: "TRM", name: "Jacqueline Cochran Regional Airport" },
  { id: 8139, code: "TRN", name: "Turin Airport (Caselle Airport)" },
  { id: 8140, code: "TRO", name: "Taree Airport[1]" },
  { id: 8141, code: "TRQ", name: "José Galera dos Santos Airport[1]" },
  { id: 8142, code: "TRR", name: "China Bay Airport" },
  { id: 8143, code: "TRS", name: "Trieste Airport (Ronchi dei Legionari Airport)" },
  { id: 8144, code: "TRU", name: "FAP Captain Carlos Martínez de Pinillos International Airport" },
  { id: 8145, code: "TRV", name: "Trivandrum International Airport" },
  { id: 8146, code: "TRW", name: "Bonriki International Airport" },
  { id: 8147, code: "TRX", name: "Trenton Municipal Airport" },
  { id: 8148, code: "TRY", name: "Tororo Airport[1]" },
  { id: 8149, code: "TRZ", name: "Tiruchirappalli International Airport" },
  { id: 8151, code: "TSA", name: "Taipei Songshan Airport" },
  { id: 8152, code: "TSB", name: "Tsumeb Airport[1]" },
  { id: 8153, code: "TSC", name: "Taisha Airport[1]" },
  { id: 8154, code: "TSD", name: "Tshipise Airport[1]" },
  { id: 8155, code: "TSF", name: "Treviso-Sant'Angelo Airport" },
  { id: 8156, code: "TSG", name: "Tanacross Airport" },
  { id: 8157, code: "TSH", name: "Tshikapa Airport[1]" },
  { id: 8158, code: "TSI", name: "Tsile Tsile Airport[1]" },
  { id: 8159, code: "TSJ", name: "Tsushima Airport" },
  { id: 8160, code: "TSK", name: "Taskul Airport[1]" },
  { id: 8161, code: "TSL", name: "Tamuín National Airport" },
  { id: 8162, code: "TSM", name: "Taos Regional Airport (FAA: SKX)" },
  { id: 8163, code: "TSN", name: "Tianjin Binhai International Airport" },
  { id: 8164, code: "TSP", name: "Tehachapi Municipal Airport" },
  { id: 8165, code: "TSQ", name: "Torres Airport[1]" },
  { id: 8166, code: "TSR", name: "Timișoara Traian Vuia International Airport" },
  { id: 8167, code: "TST", name: "Trang Airport" },
  { id: 8168, code: "TSU", name: "Tabiteuea South Airport[1]" },
  { id: 8169, code: "TSV", name: "Townsville Airport" },
  { id: 8170, code: "TSW", name: "Tsewi Airport[1]" },
  { id: 8171, code: "TSY", name: "Tasikmalaya Airport[1] (Wiriadinata Airport)" },
  { id: 8172, code: "TSX", name: "Tanjung Santan Airport[1]" },
  { id: 8173, code: "TSZ", name: "Tsetserleg Airport" },
  { id: 8175, code: "TTA", name: "Tan Tan Airport (Plage Blanche Airport)" },
  { id: 8176, code: "TTB", name: "Tortolì Airport (Arbatax Airport)" },
  { id: 8177, code: "TTC", name: "Las Breas Airport[1]" },
  { id: 8178, code: "TTD", name: "Portland–Troutdale Airport" },
  { id: 8179, code: "TTE", name: "Sultan Babullah Airport[1]" },
  { id: 8180, code: "TTG", name: "Tartagal General Enrique Mosconi Airport" },
  { id: 8181, code: "TTH", name: "RAFO Thumrait[1]" },
  { id: 8182, code: "TTI", name: "Tetiaroa Airport[1]" },
  { id: 8183, code: "TTJ", name: "Tottori Airport[1]" },
  { id: 8184, code: "TTL", name: "Turtle Island Seaplane Base[1]" },
  { id: 8185, code: "TTM", name: "Tablón de Tamará Airport" },
  { id: 8186, code: "TTN", name: "Trenton–Mercer Airport" },
  { id: 8187, code: "TTO", name: "Britton Municipal Airport (FAA: BTN)" },
  { id: 8188, code: "TTQ", name: "Tortuguero Airport (Barra de Tortuguero Airport)" },
  { id: 8189, code: "TTR", name: "Pongtiku Airport[1]" },
  { id: 8190, code: "TTS", name: "Tsaratanana Airport" },
  { id: 8191, code: "TTT", name: "Taitung Airport (Taitung Fongnian Airport)" },
  { id: 8192, code: "TTU", name: "Sania Ramel Airport" },
  { id: 8193, code: "TTW", name: "Tissa Tank Waterdrome[1]" },
  { id: 8194, code: "TTX", name: "Truscott-Mungalalu Airport[1]" },
  { id: 8196, code: "TUA", name: "Teniente Coronel Luis a Mantilla International Airport" },
  { id: 8197, code: "TUB", name: "Tubuai – Mataura Airport[1]" },
  { id: 8198, code: "TUC", name: "Teniente General Benjamín Matienzo International Airport" },
  { id: 8199, code: "TUD", name: "Tambacounda Airport" },
  { id: 8200, code: "TUF", name: "Tours Val de Loire Airport" },
  { id: 8201, code: "TUG", name: "Tuguegarao Airport" },
  { id: 8202, code: "TUI", name: "Turaif Domestic Airport[1]" },
  { id: 8203, code: "TUJ", name: "Tum Airport[1]" },
  { id: 8204, code: "TUK", name: "Turbat International Airport" },
  { id: 8205, code: "TUL", name: "Tulsa International Airport" },
  { id: 8206, code: "TUM", name: "Tumut Airport[1]" },
  { id: 8207, code: "TUN", name: "Tunis–Carthage International Airport" },
  { id: 8208, code: "TUO", name: "Taupō Airport" },
  { id: 8209, code: "TUP", name: "Tupelo Regional Airport" },
  { id: 8210, code: "TUQ", name: "Tougan Airport" },
  { id: 8211, code: "TUR", name: "Tucuruí Airport[1]" },
  { id: 8212, code: "TUS", name: "Tucson International Airport" },
  { id: 8213, code: "TUT", name: "Tauta Airport[1]" },
  { id: 8214, code: "TUU", name: "Tabuk Regional Airport" },
  { id: 8215, code: "TUV", name: "San Rafael Airport[1]" },
  { id: 8216, code: "TUW", name: "Tubala Airport[1]" },
  { id: 8217, code: "TUX", name: "Tumbler Ridge Airport[1] (TC: CBX7)" },
  { id: 8218, code: "TUY", name: "Tulum Airport" },
  { id: 8219, code: "TUZ", name: "Tucumã Airport[1]" },
  { id: 8221, code: "TVA", name: "Morafenobe Airport[1]" },
  { id: 8222, code: "TVC", name: "Cherry Capital Airport" },
  { id: 8223, code: "TVF", name: "Thief River Falls Regional Airport" },
  { id: 8224, code: "TVI", name: "Thomasville Regional Airport" },
  { id: 8225, code: "TVL", name: "Lake Tahoe Airport" },
  { id: 8226, code: "TVS", name: "Tangshan Sannühe Airport" },
  { id: 8227, code: "TVU", name: "Matei Airport" },
  { id: 8228, code: "TVY", name: "Dawei Airport" },
  { id: 8230, code: "TWA", name: "Twin Hills Airport (FAA: A63)" },
  { id: 8231, code: "TWB", name: "Toowoomba City Aerodrome[1]" },
  { id: 8232, code: "TWC", name: "Tumxuk Tangwangcheng Airport[1]" },
  { id: 8233, code: "TWD", name: "Jefferson County International Airport (FAA: 0S9)" },
  { id: 8234, code: "TWE", name: "Taylor Airport (FAA: AK49)" },
  { id: 8235, code: "TWF", name: "Magic Valley Regional Airport (Joslin Field)" },
  { id: 8236, code: "TWN", name: "Tewantin Airport[1]" },
  { id: 8237, code: "TWP", name: "Torwood Airport[1]" },
  { id: 8238, code: "TWT", name: "Sanga-Sanga Airport" },
  { id: 8239, code: "TWU", name: "Tawau Airport" },
  { id: 8240, code: "TWY", name: "Tawa Airport[1]" },
  { id: 8241, code: "TWZ", name: "Pukaki Airport[1] (Twizel Airport)" },
  { id: 8243, code: "TXE", name: "Rembele Airport[1]" },
  { id: 8244, code: "TXF", name: "Teixeira de Freitas Airport[1] (9 de maio Airport)" },
  { id: 8245, code: "TXK", name: "Texarkana Regional Airport (Webb Field)" },
  { id: 8246, code: "TXM", name: "Teminabuan Airport[1]" },
  { id: 8247, code: "TXN", name: "Huangshan Tunxi International Airport[1]" },
  { id: 8248, code: "TXR", name: "Tanbar Airport[1]" },
  { id: 8249, code: "TXU", name: "Tabou Airport[1]" },
  { id: 8251, code: "TYA", name: "Klokovo Airport[1]" },
  { id: 8252, code: "TYB", name: "Tibooburra Airport[1]" },
  { id: 8253, code: "TYD", name: "Tynda Airport" },
  { id: 8254, code: "TYE", name: "Tyonek Airport" },
  { id: 8255, code: "TYF", name: "Torsby Airport[1]" },
  { id: 8256, code: "TYG", name: "Thylungra Airport[1]" },
  { id: 8257, code: "TYL", name: "Capitán FAP Víctor Montes Arias International Airport" },
  { id: 8258, code: "TYM", name: "Staniel Cay Airport[1]" },
  { id: 8259, code: "TYN", name: "Taiyuan Wusu International Airport" },
  { id: 8260, code: "TYO[1]", name: "metropolitan area2" },
  { id: 8261, code: "TYP", name: "Tobermorey Airport[1]" },
  { id: 8262, code: "TYR", name: "Tyler Pounds Regional Airport" },
  { id: 8263, code: "TYS", name: "McGhee Tyson Airport" },
  { id: 8264, code: "TYT", name: "Treinta y Tres Airport" },
  { id: 8265, code: "TYZ", name: "Taylor Airport (FAA: TYL)" },
  { id: 8267, code: "TZA", name: "Belize City Municipal Airport" },
  { id: 8268, code: "TZC", name: "Tuscola Area Airport[1] (FAA: CFS)" },
  { id: 8269, code: "TZL", name: "Tuzla International Airport" },
  { id: 8270, code: "TZM", name: "Cupul National Airport" },
  { id: 8271, code: "TZN", name: "South Andros Airport (Congo Town Airport)" },
  { id: 8272, code: "TZO", name: "Tsimiroro Airport[1]" },
  { id: 8273, code: "TZX", name: "Trabzon Airport" },
  { id: 8275, code: "UAB", name: "Incirlik Air Base[1]" },
  { id: 8276, code: "UAC", name: "San Luis Río Colorado Airport[1]" },
  { id: 8277, code: "UAE", name: "Mount Aue Airport[1]" },
  { id: 8278, code: "UAH", name: "Ua Huka Airport[1]" },
  { id: 8279, code: "UAI", name: "Suai Airport[1]" },
  { id: 8280, code: "UAK", name: "Narsarsuaq Airport" },
  { id: 8281, code: "UAL", name: "Luau Airport" },
  { id: 8282, code: "UAM", name: "Andersen Air Force Base" },
  { id: 8283, code: "UAP", name: "Ua Pou Airport[1]" },
  { id: 8284, code: "UAQ", name: "Domingo Faustino Sarmiento Airport" },
  { id: 8285, code: "UAR", name: "Bouarfa Airport[1]" },
  { id: 8286, code: "UAS", name: "Samburu Airport[1] (Buffalo Spring Airport)" },
  { id: 8287, code: "UAX", name: "Uaxactun Airport[1]" },
  { id: 8289, code: "UBA", name: "Mário de Almeida Franco Airport" },
  { id: 8290, code: "UBB", name: "Mabuiag Island Airport[1]" },
  { id: 8291, code: "UBI", name: "Buin Airport[1]" },
  { id: 8292, code: "UBJ", name: "Yamaguchi Ube Airport" },
  { id: 8293, code: "UBN", name: "Chinggis Khaan International Airport" },
  { id: 8294, code: "UBP", name: "Ubon Ratchathani Airport" },
  { id: 8295, code: "UBR", name: "Ubrub Airport[1]" },
  { id: 8296, code: "UBS", name: "Columbus-Lowndes County Airport" },
  { id: 8297, code: "UBT", name: "Ubatuba Airport[1] (Gastão Madeira Airport)" },
  { id: 8298, code: "UBU", name: "Kalumburu Airport[1]" },
  { id: 8300, code: "UCB", name: "Ulanqab Airport[1]" },
  { id: 8301, code: "UCC", name: "Yucca Airstrip (FAA: NV11)" },
  { id: 8302, code: "UCE", name: "Eunice Airport (FAA: 4R7)" },
  { id: 8303, code: "UCK", name: "Lutsk Airport[1]" },
  { id: 8304, code: "UCN", name: "Buchanan Airport" },
  { id: 8305, code: "UCT", name: "Ukhta Airport" },
  { id: 8306, code: "UCY", name: "Everett–Stewart Regional Airport" },
  { id: 8308, code: "UDA", name: "Undara Airport[1]" },
  { id: 8309, code: "UDD", name: "Bermuda Dunes Airport" },
  { id: 8310, code: "UDE", name: "Volkel Air Base" },
  { id: 8311, code: "UDI", name: "Ten. Cel. Av. César Bombonato Airport" },
  { id: 8312, code: "UDJ", name: "Uzhhorod International Airport[1]" },
  { id: 8313, code: "UDN", name: "Campoformido Airport[1]" },
  { id: 8314, code: "UDR", name: "Maharana Pratap Airport" },
  { id: 8316, code: "UEE", name: "Queenstown Airport[1]" },
  { id: 8317, code: "UEL", name: "Quelimane Airport" },
  { id: 8318, code: "UEN", name: "Urengoy Airport[1]" },
  { id: 8319, code: "UEO", name: "Kumejima Airport[1]" },
  { id: 8320, code: "UES", name: "Waukesha County Airport (Crites Field)" },
  { id: 8321, code: "UET", name: "Quetta International Airport" },
  { id: 8323, code: "UFA", name: "Ufa International Airport" },
  { id: 8325, code: "UGA", name: "Bulgan Airport" },
  { id: 8326, code: "UGB", name: "Ugashik Bay Airport" },
  { id: 8327, code: "UGC", name: "Urgench International Airport" },
  { id: 8328, code: "UGI", name: "San Juan (Uganik) Seaplane Base (FAA: WSJ)" },
  { id: 8329, code: "UGL", name: "Union Glacier Blue-Ice Runway" },
  { id: 8330, code: "UGN", name: "Waukegan National Airport" },
  { id: 8331, code: "UGO", name: "Uíge Airport[1]" },
  { id: 8332, code: "UGS", name: "Ugashik Airport (FAA: 9A8)" },
  { id: 8333, code: "UGT", name: "Bulagtai Airport[1]" },
  { id: 8334, code: "UGU", name: "Bilogai Airport[1]" },
  { id: 8336, code: "UHE", name: "Kunovice Airport" },
  { id: 8338, code: "UIB", name: "El Caraño Airport" },
  { id: 8339, code: "UIH", name: "Phu Cat Airport" },
  { id: 8340, code: "UII", name: "Útila Airport" },
  { id: 8341, code: "UIK", name: "Ust-Ilimsk Airport" },
  { id: 8342, code: "UIL", name: "Quillayute Airport" },
  { id: 8343, code: "UIN", name: "Quincy Regional Airport (Baldwin Field)" },
  { id: 8344, code: "UIO", name: "Mariscal Sucre International Airport" },
  { id: 8345, code: "UIP", name: "Quimper–Cornouaille Airport (Pluguffan)" },
  { id: 8346, code: "UIQ", name: "Quoin Hill Airfield" },
  { id: 8347, code: "UIR", name: "Quirindi Airport[1]" },
  { id: 8348, code: "UIT", name: "Jaluit Airport (FAA: N55)" },
  { id: 8350, code: "UJE", name: "Ujae Airport" },
  { id: 8351, code: "UJN", name: "Uljin Airport[1]" },
  { id: 8352, code: "UJU", name: "Uiju Airfield[1]" },
  { id: 8354, code: "UKA", name: "Ukunda Airport[1] (Diani Airport)" },
  { id: 8355, code: "UKB", name: "Kobe Airport" },
  { id: 8356, code: "UKE", name: "Utkela Airport" },
  { id: 8357, code: "UKG", name: "Ust-Kuyga Airport" },
  { id: 8358, code: "UKH", name: "Mukhaizna Airport[1]" },
  { id: 8359, code: "UKI", name: "Ukiah Municipal Airport" },
  { id: 8360, code: "UKK", name: "Oskemen Airport (Ust-Kamenogorsk Airport)" },
  { id: 8361, code: "UKN", name: "Waukon Municipal Airport (FAA: Y01)" },
  { id: 8362, code: "UKR", name: "Mukeiras Airport[1]" },
  { id: 8363, code: "UKS", name: "Sevastopol International Airport[1]" },
  { id: 8364, code: "UKT", name: "Quakertown Airport" },
  { id: 8365, code: "UKU", name: "Nuku Airport[1]" },
  { id: 8366, code: "UKX", name: "Ust-Kut Airport" },
  { id: 8368, code: "ULA", name: "Capitán José Daniel Vazquez Airport[1]" },
  { id: 8369, code: "ULB", name: "Ulei Airport[1]" },
  { id: 8370, code: "ULD", name: "Ulundi Airport[1]" },
  { id: 8371, code: "ULE", name: "Sule Airport[1]" },
  { id: 8372, code: "ULG", name: "Ölgii Airport[1]" },
  { id: 8373, code: "ULH", name: "Prince Abdul Majeed bin Abdulaziz Domestic Airport[1]" },
  { id: 8374, code: "ULI", name: "Ulithi Airport (FAA: TT02)" },
  { id: 8375, code: "ULK", name: "Lensk Airport[1]" },
  { id: 8376, code: "ULL", name: "Glenforsa Airfield[1]" },
  { id: 8377, code: "ULM", name: "New Ulm Municipal Airport" },
  { id: 8378, code: "ULN", name: "Buyant-Ukhaa International Airport" },
  { id: 8379, code: "ULO", name: "Ulaangom Airport" },
  { id: 8380, code: "ULP", name: "Quilpie Airport[1]" },
  { id: 8381, code: "ULQ", name: "Heriberto Gíl Martínez Airport[1]" },
  { id: 8382, code: "ULS", name: "Mulatos Airport" },
  { id: 8383, code: "ULU", name: "Gulu Airport[1]" },
  { id: 8384, code: "ULV", name: "Ulyanovsk Baratayevka Airport" },
  { id: 8385, code: "ULX", name: "Ulusaba Airstrip[1]" },
  { id: 8386, code: "ULY", name: "Ulyanovsk Vostochny Airport" },
  { id: 8387, code: "ULZ", name: "Donoi Airport[1]" },
  { id: 8389, code: "UMA", name: "Punta de Maisí Airport" },
  { id: 8390, code: "UMC", name: "Umba Airport[1]" },
  { id: 8391, code: "UME", name: "Umeå Airport" },
  { id: 8392, code: "UMI", name: "Quince Mil Airport[1]" },
  { id: 8393, code: "UMM", name: "Summit Airport" },
  { id: 8394, code: "UMR", name: "RAAF Woomera Airfield[1]" },
  { id: 8395, code: "UMS", name: "Ust-Maya Airport" },
  { id: 8396, code: "UMT", name: "Umiat Airport" },
  { id: 8397, code: "UMU", name: "Orlando de Carvalho Airport[1]" },
  { id: 8398, code: "UMY", name: "Sumy Airport[1]" },
  { id: 8399, code: "UMZ", name: "Mena Intermountain Municipal Airport" },
  { id: 8401, code: "UNA", name: "Una-Comandatuba Airport[1]" },
  { id: 8402, code: "UNC", name: "Unguía Airport" },
  { id: 8403, code: "UND", name: "Kunduz Airport" },
  { id: 8404, code: "UNE", name: "Qacha's Nek Airport[1]" },
  { id: 8405, code: "UNG", name: "Kiunga Airport[1]" },
  { id: 8406, code: "UNI", name: "Union Island Airport" },
  { id: 8407, code: "UNK", name: "Unalakleet Airport" },
  { id: 8408, code: "UNN", name: "Ranong Airport" },
  { id: 8409, code: "UNR", name: "Öndörkhaan Airport" },
  { id: 8410, code: "UNT", name: "Unst Airport[1]" },
  { id: 8411, code: "UNU", name: "Dodge County Airport" },
  { id: 8413, code: "UOA", name: "Mururoa Airport[1]" },
  { id: 8414, code: "UOL", name: "Pogogul Airport" },
  { id: 8415, code: "UOS", name: "Franklin County Airport" },
  { id: 8416, code: "UOX", name: "University-Oxford Airport" },
  { id: 8418, code: "UPB", name: "Playa Baracoa Airport[1]" },
  { id: 8419, code: "UPG", name: "Sultan Hasanuddin International Airport" },
  { id: 8420, code: "UPL", name: "Upala Airport" },
  { id: 8421, code: "UPN", name: "Ignacio López Rayón International Airport" },
  { id: 8422, code: "UPP", name: "Upolu Airport" },
  { id: 8423, code: "UPR", name: "Upiara Airport[1]" },
  { id: 8424, code: "UPV", name: "RAF Upavon[1]" },
  { id: 8426, code: "URA", name: "Oral Ak Zhol Airport" },
  { id: 8427, code: "URB", name: "Castilho Airport[1] (Urubupunga Airport)" },
  { id: 8428, code: "URC", name: "Ürümqi Diwopu International Airport" },
  { id: 8429, code: "URD", name: "Burg Feuerstein Airport[1]" },
  { id: 8430, code: "URE", name: "Kuressaare Airport" },
  { id: 8431, code: "URG", name: "Rubem Berta International Airport" },
  { id: 8432, code: "URI", name: "Uribe Airport" },
  { id: 8433, code: "URJ", name: "Uray Airport" },
  { id: 8434, code: "URM", name: "Uriman Airport[1]" },
  { id: 8435, code: "URN", name: "Urgun Airport" },
  { id: 8436, code: "URO", name: "Rouen Airport (Vallée de Seine Airport)" },
  { id: 8437, code: "URR", name: "Urrao Airport[1]" },
  { id: 8438, code: "URS", name: "Kursk Vostochny Airport" },
  { id: 8439, code: "URT", name: "Surat Thani Airport" },
  { id: 8440, code: "URU", name: "Uroubi Airport[1]" },
  { id: 8441, code: "URY", name: "Gurayat Domestic Airport[1]" },
  { id: 8442, code: "URZ", name: "Uruzgan Airport" },
  { id: 8444, code: "USA", name: "Concord Regional Airport (FAA: JQF)" },
  { id: 8445, code: "USC", name: "Union County Airport/Troy Shelton Field (FAA: 35A)" },
  { id: 8446, code: "USH", name: "Ushuaia – Malvinas Argentinas International Airport" },
  { id: 8447, code: "USI", name: "Mabaruma Airport" },
  { id: 8448, code: "USJ", name: "Usharal Airport" },
  { id: 8449, code: "USK", name: "Usinsk Airport[1]" },
  { id: 8450, code: "USL", name: "Useless Loop Airport[1]" },
  { id: 8451, code: "USM", name: "Samui Airport" },
  { id: 8452, code: "USN", name: "Ulsan Airport[1]" },
  { id: 8453, code: "USO", name: "Usino Airport[1]" },
  { id: 8454, code: "USQ", name: "Uşak Airport" },
  { id: 8455, code: "USR", name: "Ust-Nera Airport" },
  { id: 8456, code: "USS", name: "Sancti Spíritus Airport[1]" },
  { id: 8457, code: "UST", name: "Northeast Florida Regional Airport (FAA: SGJ)" },
  { id: 8458, code: "USU", name: "Francisco B. Reyes Airport" },
  { id: 8460, code: "UTA", name: "Mutare Airport" },
  { id: 8461, code: "UTB", name: "Muttaburra Airport[1]" },
  { id: 8462, code: "UTC", name: "Soesterberg Air Base" },
  { id: 8463, code: "UTD", name: "Nutwood Downs Airport[1]" },
  { id: 8464, code: "UTG", name: "Quthing Airport[1]" },
  { id: 8465, code: "UTH", name: "Udon Thani International Airport" },
  { id: 8466, code: "UTI", name: "Utti Airport" },
  { id: 8467, code: "UTK", name: "Utirik Airport (FAA: 03N)" },
  { id: 8468, code: "UTM", name: "Tunica Municipal Airport (FAA: UTA)" },
  { id: 8469, code: "UTN", name: "Upington Airport" },
  { id: 8470, code: "UTO", name: "Indian Mountain LRRS Airport" },
  { id: 8471, code: "UTP", name: "U-Tapao International Airport" },
  { id: 8472, code: "UTS", name: "Ust-Tsilma Airport[1]" },
  { id: 8473, code: "UTT", name: "Mthatha Airport" },
  { id: 8474, code: "UTU", name: "Ustupo Airport[1]" },
  { id: 8475, code: "UTW", name: "Queenstown Airport[1]" },
  { id: 8477, code: "UUA", name: "Bugulma Airport" },
  { id: 8478, code: "UUD", name: "Baikal International Airport" },
  { id: 8479, code: "UUK", name: "Ugnu-Kuparuk Airport (FAA: UBW)" },
  { id: 8480, code: "UUN", name: "Baruun-Urt Airport[1]" },
  { id: 8481, code: "UUS", name: "Yuzhno-Sakhalinsk Airport (Khomutovo Airport)" },
  { id: 8482, code: "UUU", name: "Manumu Airport" },
  { id: 8484, code: "UVA", name: "Garner Field" },
  { id: 8485, code: "UVE", name: "Ouvéa Airport[1] (Ouloup Airport)" },
  { id: 8486, code: "UVF", name: "Hewanorra International Airport" },
  { id: 8487, code: "UVI", name: "União da Vitória Airport[1]" },
  { id: 8488, code: "UVL", name: "El Kharga Airport[1]" },
  { id: 8489, code: "UVO", name: "Uvol Airport[1]" },
  { id: 8491, code: "UYL", name: "Nyala Airport" },
  { id: 8492, code: "UYN", name: "Yulin Yuyang Airport" },
  { id: 8493, code: "UYU", name: "Uyuni Airport (Joya Andina Airport)" },
  { id: 8495, code: "UZC", name: "Užice-Ponikve Airport" },
  { id: 8496, code: "UZM", name: "Hope Bay Aerodrome[1] (TC: CHB3)" },
  { id: 8497, code: "UZR", name: "Urzhar Airport" },
  { id: 8498, code: "UZU", name: "Curuzú Cuatiá Airport" },
  { id: 8500, code: "VAA", name: "Vaasa Airport" },
  { id: 8501, code: "VAB", name: "Yavarate Airport[1]" },
  { id: 8502, code: "VAC", name: "Varrelbusch Airport[1]" },
  { id: 8503, code: "VAD", name: "Moody Air Force Base" },
  { id: 8504, code: "VAF", name: "Valence-Chabeuil Airport" },
  { id: 8505, code: "VAG", name: "Major Brigadeiro Trompowsky Airport" },
  { id: 8506, code: "VAH", name: "Cap. Av. Vidal Villagomez Toledo Airport[1]" },
  { id: 8507, code: "VAI", name: "Vanimo Airport[1]" },
  { id: 8508, code: "VAK", name: "Chevak Airport" },
  { id: 8509, code: "VAL", name: "Valença Airport[1]" },
  { id: 8510, code: "VAM", name: "Villa International Airport Maamigili" },
  { id: 8511, code: "VAN", name: "Van Ferit Melen Airport" },
  { id: 8512, code: "VAO", name: "Suavanao Airport[1]" },
  { id: 8513, code: "VAP", name: "Rodelillo Airfield[1]" },
  { id: 8514, code: "VAR", name: "Varna Airport" },
  { id: 8515, code: "VAS", name: "Sivas Airport" },
  { id: 8516, code: "VAT", name: "Vatomandry Airport[1]" },
  { id: 8517, code: "VAU", name: "Vatukoula Airport[1]" },
  { id: 8518, code: "VAV", name: "Vavaʻu International Airport[1]" },
  { id: 8519, code: "VAW", name: "Vardø Airport, Svartnes" },
  { id: 8521, code: "VBA", name: "Ann Airport[1]" },
  { id: 8522, code: "VBC", name: "Mandalay Chanmyathazi Airport[1]" },
  { id: 8523, code: "VBG", name: "Vandenberg Air Force Base" },
  { id: 8524, code: "VBP", name: "Bokpyin Airport[1]" },
  { id: 8525, code: "VBS", name: "Brescia Airport (Gabriele D'Annunzio Airport)" },
  { id: 8526, code: "VBV", name: "Vanuabalavu Airport[1]" },
  { id: 8527, code: "VBY", name: "Visby Airport" },
  { id: 8529, code: "VCA", name: "Can Tho International Airport" },
  { id: 8530, code: "VCD", name: "Victoria River Downs Airport[1]" },
  { id: 8531, code: "VCE", name: "Venice Marco Polo Airport" },
  { id: 8532, code: "VCF", name: "Valcheta Airport[1]" },
  { id: 8533, code: "VCH", name: "Vichadero Airport" },
  { id: 8534, code: "VCL", name: "Chu Lai International Airport" },
  { id: 8535, code: "VCP", name: "Viracopos/Campinas International Airport" },
  { id: 8536, code: "VCR", name: "Carora Airport[1]" },
  { id: 8537, code: "VCS", name: "Con Dao Airport (Cỏ Ống Airport)" },
  { id: 8538, code: "VCT", name: "Victoria Regional Airport" },
  { id: 8539, code: "VCV", name: "Southern California Logistics Airport" },
  { id: 8541, code: "VDA", name: "Ovda Airport" },
  { id: 8542, code: "VDB", name: "Fagernes Airport, Leirin" },
  { id: 8543, code: "VDC", name: "Glauber Rocha Airport" },
  { id: 8544, code: "VDE", name: "El Hierro Airport[1]" },
  { id: 8545, code: "VDH", name: "Dong Hoi Airport[1]" },
  { id: 8546, code: "VDI", name: "Vidalia Regional Airport" },
  { id: 8547, code: "VDM", name: "Gobernador Edgardo Castello Airport" },
  { id: 8548, code: "VDO", name: "Van Don International Airport" },
  { id: 8549, code: "VDP", name: "Valle de la Pascua Airport" },
  { id: 8550, code: "VDR", name: "Villa Dolores Airport" },
  { id: 8551, code: "VDS", name: "Vadsø Airport" },
  { id: 8552, code: "VDY", name: "Vidyanagar Airport[1] (Jindal Airport)" },
  { id: 8553, code: "VDZ", name: "Valdez Airport (Pioneer Field)" },
  { id: 8555, code: "VEE", name: "Venetie Airport" },
  { id: 8556, code: "VEG", name: "Maikwak Airport[1]" },
  { id: 8557, code: "VEL", name: "Vernal Regional Airport" },
  { id: 8558, code: "VER", name: "Veracruz International Airport" },
  { id: 8559, code: "VEV", name: "Barakoma Airport[1]" },
  { id: 8560, code: "VEX", name: "Tioga Municipal Airport (FAA: D60)" },
  { id: 8561, code: "VEY", name: "Vestmannaeyjar Airport" },
  { id: 8563, code: "VFA", name: "Victoria Falls Airport" },
  { id: 8565, code: "VGA", name: "NTR Amaravati International Airport" },
  { id: 8566, code: "VGD", name: "Vologda Airport" },
  { id: 8567, code: "VGO", name: "Vigo–Peinador Airport" },
  { id: 8568, code: "VGS", name: "General Villegas Airport[1]" },
  { id: 8569, code: "VGT", name: "North Las Vegas Airport" },
  { id: 8570, code: "VGZ", name: "Villa Garzón Airport" },
  { id: 8572, code: "VHC", name: "Henrique de Carvalho Airport[1]" },
  { id: 8573, code: "VHM", name: "Vilhelmina Airport" },
  { id: 8574, code: "VHN", name: "Culberson County Airport" },
  { id: 8575, code: "VHV", name: "Verkhnevilyuysk Airport" },
  { id: 8576, code: "VHY", name: "Vichy — Charmeil Airport[1]" },
  { id: 8577, code: "VHZ", name: "Vahitahi Airport[1]" },
  { id: 8579, code: "VIA", name: "Ângelo Ponzoni Municipal Airport" },
  { id: 8580, code: "VIB", name: "Villa Constitución Airport[1]" },
  { id: 8581, code: "VIC", name: "Vicenza Airport" },
  { id: 8582, code: "VIE", name: "Vienna International Airport" },
  { id: 8583, code: "VIG", name: "Juan Pablo Pérez Alfonzo Airport" },
  { id: 8584, code: "VIH", name: "Rolla National Airport" },
  { id: 8585, code: "VII", name: "Vinh International Airport" },
  { id: 8586, code: "VIJ", name: "Virgin Gorda Airport" },
  { id: 8587, code: "VIL", name: "Dakhla Airport" },
  { id: 8588, code: "VIN", name: "Havryshivka Vinnytsia International Airport" },
  { id: 8589, code: "VIQ", name: "Viqueque Airport" },
  { id: 8590, code: "VIR", name: "Virginia Airport[1]" },
  { id: 8591, code: "VIS", name: "Visalia Municipal Airport" },
  { id: 8592, code: "VIT", name: "Vitoria Airport" },
  { id: 8593, code: "VIU", name: "Viru Harbour Airport[1]" },
  { id: 8594, code: "VIV", name: "Vivigani Airfield" },
  { id: 8595, code: "VIX", name: "Eurico de Aguiar Salles Airport" },
  { id: 8596, code: "VIY", name: "Vélizy – Villacoublay Air Base[1]" },
  { id: 8598, code: "VJB", name: "Xai-Xai Airport" },
  { id: 8599, code: "VJI", name: "Virginia Highlands Airport" },
  { id: 8600, code: "VJQ", name: "Gurúé Airport[1]" },
  { id: 8602, code: "VKG", name: "Rach Gia Airport" },
  { id: 8603, code: "VKO", name: "Vnukovo International Airport" },
  { id: 8604, code: "VKS", name: "Vicksburg Municipal Airport" },
  { id: 8605, code: "VKT", name: "Vorkuta Airport" },
  { id: 8607, code: "VLA", name: "Vandalia Municipal Airport" },
  { id: 8608, code: "VLC", name: "Valencia Airport" },
  { id: 8609, code: "VLD", name: "Valdosta Regional Airport" },
  { id: 8610, code: "VLE", name: "Valle Airport (FAA: 40G)" },
  { id: 8611, code: "VLG", name: "Villa Gesell Airport" },
  { id: 8612, code: "VLI", name: "Bauerfield International Airport" },
  { id: 8613, code: "VLK", name: "Volgodonsk Airport[1]" },
  { id: 8614, code: "VLL", name: "Valladolid Airport" },
  { id: 8615, code: "VLM", name: "Lieutenant Colonel Rafael Pabón Airport[1]" },
  { id: 8616, code: "VLN", name: "Arturo Michelena International Airport" },
  { id: 8617, code: "VLP", name: "Vila Rica Municipal Airport[1]" },
  { id: 8618, code: "VLR", name: "Vallenar Airport[1]" },
  { id: 8619, code: "VLS", name: "Valesdir Airport[1]" },
  { id: 8620, code: "VLU", name: "Velikiye Luki Airport" },
  { id: 8621, code: "VLV", name: "Dr. Antonio Nicolás Briceño Airport" },
  { id: 8622, code: "VLY", name: "Anglesey Airport / RAF Valley" },
  { id: 8624, code: "VME", name: "Villa Reynolds Airport" },
  { id: 8625, code: "VMI", name: "Dr. Juan Plate Airport[1]" },
  { id: 8626, code: "VMU", name: "Baimuru Airport" },
  { id: 8628, code: "VNA", name: "Salavan Airport[1]" },
  { id: 8629, code: "VNC", name: "Venice Municipal Airport" },
  { id: 8630, code: "VND", name: "Vangaindrano Airport[1]" },
  { id: 8631, code: "VNE", name: "Meucon Airport" },
  { id: 8632, code: "VNO", name: "Vilnius Airport" },
  { id: 8633, code: "VNR", name: "Vanrook Airport[1]" },
  { id: 8634, code: "VNS", name: "Lal Bahadur Shastri Airport" },
  { id: 8635, code: "VNT", name: "Ventspils International Airport" },
  { id: 8636, code: "VNX", name: "Vilankulo Airport" },
  { id: 8637, code: "VNY", name: "Van Nuys Airport" },
  { id: 8639, code: "VOD", name: "Vodochody Airport" },
  { id: 8640, code: "VOG", name: "Volgograd International Airport" },
  { id: 8641, code: "VOH", name: "Vohemar Airport[1]" },
  { id: 8642, code: "VOI", name: "Voinjama Airport (Tenebu Airport)" },
  { id: 8643, code: "VOK", name: "Volk Field Air National Guard Base" },
  { id: 8644, code: "VOL", name: "Nea Anchialos National Airport" },
  { id: 8645, code: "VOT", name: "Votuporanga Airport[1] (Domingos Pignatari Airport)" },
  { id: 8646, code: "VOZ", name: "Voronezh International Airport (Chertovitskoye Airport)" },
  { id: 8648, code: "VPE", name: "Ondjiva Pereira Airport[1]" },
  { id: 8649, code: "VPG", name: "Vipingo Airport[1]" },
  { id: 8650, code: "VPN", name: "Vopnafjörður Airport" },
  { id: 8651, code: "VPS", name: "Destin–Fort Walton Beach Airport / Eglin Air Force Base" },
  { id: 8652, code: "VPY", name: "Chimoio Airport" },
  { id: 8653, code: "VPZ", name: "Porter County Regional Airport" },
  { id: 8655, code: "VQQ", name: "Cecil Airport[1]" },
  { id: 8656, code: "VQS", name: "Antonio Rivera Rodríguez Airport" },
  { id: 8658, code: "VRA", name: "Juan Gualberto Gómez Airport" },
  { id: 8659, code: "VRB", name: "Vero Beach Regional Airport" },
  { id: 8660, code: "VRC", name: "Virac Airport" },
  { id: 8661, code: "VRE", name: "Vredendal Airport[1]" },
  { id: 8662, code: "VRI", name: "Varandey Airport" },
  { id: 8663, code: "VRK", name: "Varkaus Airport" },
  { id: 8664, code: "VRL", name: "Vila Real Airport" },
  { id: 8665, code: "VRN", name: "Verona Villafranca Airport" },
  { id: 8666, code: "VRO", name: "Kawama Airport" },
  { id: 8667, code: "VRS", name: "Roy Otten Memorial Airfield (FAA: 3VS)" },
  { id: 8668, code: "VRU", name: "Vryburg Airport[1]" },
  { id: 8670, code: "VSA", name: "Villahermosa International Airport" },
  { id: 8671, code: "VSE", name: "Viseu Airport[1]" },
  { id: 8672, code: "VSF", name: "Hartness State Airport" },
  { id: 8673, code: "VSG", name: "Luhansk International Airport" },
  { id: 8674, code: "VST", name: "Stockholm Västerås Airport" },
  { id: 8676, code: "VTB", name: "Vitebsk Vostochny Airport[1]" },
  { id: 8677, code: "VTE", name: "Wattay International Airport" },
  { id: 8678, code: "VTF", name: "Vatulele Airport[1]" },
  { id: 8679, code: "VTG", name: "Vung Tau Airport" },
  { id: 8680, code: "VTL", name: "Vittel - Champ-de-Courses Airport[1]" },
  { id: 8681, code: "VTM", name: "Nevatim Airbase[1]" },
  { id: 8682, code: "VTN", name: "Miller Field" },
  { id: 8683, code: "VTU", name: "Hermanos Ameijeiras Airport[1]" },
  { id: 8684, code: "VTZ", name: "Visakhapatnam Airport" },
  { id: 8686, code: "VUP", name: "Alfonso López Pumarejo Airport" },
  { id: 8687, code: "VUS", name: "Veliky Ustyug Airport" },
  { id: 8688, code: "VUU", name: "Mvuu Camp Airport[1]" },
  { id: 8690, code: "VVB", name: "Mahanoro Airport[1]" },
  { id: 8691, code: "VVC", name: "La Vanguardia Airport[1]" },
  { id: 8692, code: "VVI", name: "Viru Viru International Airport" },
  { id: 8693, code: "VVK", name: "Västervik Airport[1]" },
  { id: 8694, code: "VVN", name: "Las Malvinas Airport[1]" },
  { id: 8695, code: "VVO", name: "Vladivostok International Airport" },
  { id: 8696, code: "VVZ", name: "Takhamalt Airport" },
  { id: 8698, code: "VXC", name: "Lichinga Airport" },
  { id: 8699, code: "VXE", name: "Cesária Évora Airport (São Pedro Airport)" },
  { id: 8700, code: "VXO", name: "Växjö/Kronoberg Airport" },
  { id: 8702, code: "VYD", name: "Vryheid Airport" },
  { id: 8703, code: "VYI", name: "Vilyuysk Airport" },
  { id: 8704, code: "VYS", name: "Illinois Valley Regional Airport (Walter A. Duncan Field)" },
  { id: 8707, code: "WAA", name: "Wales Airport[1]" },
  { id: 8708, code: "WAC", name: "Wacca Airport[1]" },
  { id: 8709, code: "WAD", name: "Andriamena Airport" },
  { id: 8710, code: "WAE", name: "Wadi al-Dawasir Domestic Airport[1]" },
  { id: 8711, code: "WAF", name: "Wana Airport[1]" },
  { id: 8712, code: "WAG", name: "Whanganui Airport" },
  { id: 8713, code: "WAH", name: "Harry Stern Airport (FAA: BWP)" },
  { id: 8714, code: "WAI", name: "Ambalabe Airport[1]" },
  { id: 8715, code: "WAJ", name: "Wawoi Falls Airport[1]" },
  { id: 8716, code: "WAK", name: "Ankazoabo Airport[1]" },
  { id: 8717, code: "WAL", name: "Wallops Flight Facility" },
  { id: 8718, code: "WAM", name: "Ambatondrazaka Airport[1]" },
  { id: 8719, code: "WAO", name: "Wabo Airport[1]" },
  { id: 8720, code: "WAP", name: "Alto Palena Airfield[1]" },
  { id: 8721, code: "WAQ", name: "Antsalova Airport[1]" },
  { id: 8722, code: "WAR", name: "Waris Airport[1]" },
  { id: 8723, code: "WAS[1]", name: "metropolitan area1" },
  { id: 8724, code: "WAT", name: "Waterford Airport" },
  { id: 8725, code: "WAU", name: "Wauchope Airport[1]" },
  { id: 8726, code: "WAV", name: "Wave Hill Airport[1]" },
  { id: 8727, code: "WAW", name: "Warsaw Chopin Airport" },
  { id: 8728, code: "WAX", name: "Zuwarah Airport[1]" },
  { id: 8729, code: "WAY", name: "Greene County Airport" },
  { id: 8730, code: "WAZ", name: "Warwick Airport[1]" },
  { id: 8732, code: "WBA", name: "Wahai Airport[1]" },
  { id: 8733, code: "WBB", name: "Stebbins Airport" },
  { id: 8734, code: "WBC", name: "Wapolu Airport[1]" },
  { id: 8735, code: "WBD", name: "Befandriana Airport[1]" },
  { id: 8736, code: "WBE", name: "Ankaizina Airport[1]" },
  { id: 8737, code: "WBG", name: "Schleswig Air Base" },
  { id: 8738, code: "WBK", name: "West Branch Community Airport[1] (FAA: Y31)" },
  { id: 8739, code: "WBM", name: "Wapenamanda Airport[1]" },
  { id: 8740, code: "WBO", name: "Antsoa Airport[1]" },
  { id: 8741, code: "WBQ", name: "Beaver Airport" },
  { id: 8742, code: "WBR", name: "Roben–Hood Airport (FAA: RQB)" },
  { id: 8743, code: "WBU", name: "Boulder Municipal Airport (FAA: BDU)" },
  { id: 8744, code: "WBW", name: "Wilkes-Barre Wyoming Valley Airport" },
  { id: 8746, code: "WCA", name: "Gamboa Airport" },
  { id: 8747, code: "WCH", name: "Nuevo Chaitén Airport" },
  { id: 8748, code: "WCR", name: "Chandalar Lake Airport" },
  { id: 8750, code: "WDA", name: "Wadi Ain Airport" },
  { id: 8751, code: "WDG", name: "Enid Woodring Regional Airport" },
  { id: 8752, code: "WDH", name: "Hosea Kutako International Airport" },
  { id: 8753, code: "WDI", name: "Wondai Airport[1]" },
  { id: 8754, code: "WDN", name: "Waldronaire Airport[1] (FAA: 90WA)" },
  { id: 8755, code: "WDR", name: "Barrow County Airport" },
  { id: 8756, code: "WDS", name: "Shiyan Wudangshan Airport" },
  { id: 8758, code: "WEA", name: "Parker County Airport" },
  { id: 8759, code: "WED", name: "Wedau Airport[1]" },
  { id: 8760, code: "WEF", name: "Weifang Airport" },
  { id: 8761, code: "WEH", name: "Weihai Dashuibo Airport" },
  { id: 8762, code: "WEI", name: "Weipa Airport" },
  { id: 8763, code: "WEL", name: "Welkom Airport[1]" },
  { id: 8764, code: "WEP", name: "Weam Airport[1]" },
  { id: 8765, code: "WET", name: "Waghete Airport[1]" },
  { id: 8766, code: "WEW", name: "Wee Waa Airport[1]" },
  { id: 8768, code: "WFB", name: "Ketchikan Harbor Seaplane Base (FAA: 5KE)" },
  { id: 8769, code: "WFD", name: "Woodford Aerodrome[1]" },
  { id: 8770, code: "WFI", name: "Fianarantsoa Airport" },
  { id: 8771, code: "WFK", name: "Northern Aroostook Regional Airport (FAA: FVE)" },
  { id: 8773, code: "WGA", name: "Wagga Wagga Airport" },
  { id: 8774, code: "WGC", name: "Warangal Airport[1]" },
  { id: 8775, code: "WGE", name: "Walgett Airport[1]" },
  { id: 8776, code: "WGN", name: "Shaoyang Wugang Airport" },
  { id: 8777, code: "WGO", name: "Winchester Regional Airport (FAA: OKV)" },
  { id: 8778, code: "WGP", name: "Mau Hau Airport (Umbu Mehang Kunda Airport)" },
  { id: 8779, code: "WGT", name: "Wangaratta Airport" },
  { id: 8780, code: "WGU", name: "Wagau Airport[1]" },
  { id: 8781, code: "WGY", name: "Wagny Airport[1]" },
  { id: 8783, code: "WHA", name: "Wuhu Xuanzhou Airport" },
  { id: 8784, code: "WHD", name: "Hyder Seaplane Base (FAA: 4Z7)" },
  { id: 8785, code: "WHF", name: "Wadi Halfa Airport" },
  { id: 8786, code: "WHK", name: "Whakatane Airport" },
  { id: 8787, code: "WHL", name: "Welshpool Airport[1]" },
  { id: 8788, code: "WHO", name: "Franz Josef Glacier Aerodrome[1]" },
  { id: 8789, code: "WHP", name: "Whiteman Airport" },
  { id: 8790, code: "WHS", name: "Whalsay Airstrip[1]" },
  { id: 8791, code: "WHT", name: "Wharton Regional Airport (FAA: ARM)" },
  { id: 8793, code: "WIB", name: "Wilbarger County Airport[1] (FAA: F05)" },
  { id: 8794, code: "WIC", name: "Wick Airport" },
  { id: 8795, code: "WIE", name: "Wiesbaden Army Airfield" },
  { id: 8796, code: "WIK", name: "Waiheke Island Aerodrome[1]" },
  { id: 8797, code: "WIL", name: "Wilson Airport" },
  { id: 8798, code: "WIN", name: "Winton Airport[1]" },
  { id: 8799, code: "WIO", name: "Wilcannia Airport[1]" },
  { id: 8800, code: "WIR", name: "Wairoa Aerodrome[1]" },
  { id: 8801, code: "WIT", name: "Wittenoom Airport[1]" },
  { id: 8802, code: "WIU", name: "Witu Airport[1]" },
  { id: 8804, code: "WJA", name: "Woja Airport" },
  { id: 8805, code: "WJF", name: "General William J. Fox Airfield" },
  { id: 8806, code: "WJR", name: "Wajir Airport[1]" },
  { id: 8807, code: "WJU", name: "Wonju Airport" },
  { id: 8809, code: "WKA", name: "Wānaka Airport" },
  { id: 8810, code: "WKB", name: "Warracknabeal Airport[1]" },
  { id: 8811, code: "WKF", name: "Air Force Base Waterkloof[1]" },
  { id: 8812, code: "WKI", name: "Hwange Town Airport[1]" },
  { id: 8813, code: "WKJ", name: "Wakkanai Airport" },
  { id: 8814, code: "WKK", name: "Aleknagik Airport (FAA: 5A8)" },
  { id: 8815, code: "WKN", name: "Wakunai Airport" },
  { id: 8816, code: "WKR", name: "Walker's Cay Airport[1]" },
  { id: 8818, code: "WLA", name: "Wallal Airport[1]" },
  { id: 8819, code: "WLC", name: "Walcha Airport[1]" },
  { id: 8820, code: "WLD", name: "Strother Field" },
  { id: 8821, code: "WLE", name: "Miles Airport" },
  { id: 8822, code: "WLG", name: "Wellington International Airport" },
  { id: 8823, code: "WLH", name: "Walaha Airport[1]" },
  { id: 8824, code: "WLK", name: "Selawik Airport" },
  { id: 8825, code: "WLL", name: "Wollogorang Airport" },
  { id: 8826, code: "WLO", name: "Waterloo Airport" },
  { id: 8827, code: "WLP", name: "West Angelas Airport[1]" },
  { id: 8828, code: "WLR", name: "Loring Seaplane Base (FAA: 13Z)" },
  { id: 8829, code: "WLS", name: "Hihifo Airport" },
  { id: 8830, code: "WLW", name: "Willows-Glenn County Airport" },
  { id: 8832, code: "WMA", name: "Mandritsara Airport" },
  { id: 8833, code: "WMB", name: "Warrnambool Airport" },
  { id: 8834, code: "WMC", name: "Winnemucca Municipal Airport" },
  { id: 8835, code: "WMD", name: "Mandabe Airport[1]" },
  { id: 8836, code: "WME", name: "Mount Keith Airport" },
  { id: 8837, code: "WMH", name: "Ozark Regional Airport (FAA: BPK)" },
  { id: 8838, code: "WMI", name: "Warsaw Modlin Airport" },
  { id: 8839, code: "WMK", name: "Meyers Chuck Seaplane Base (FAA: 84K)" },
  { id: 8840, code: "WML", name: "Malaimbandy Airport" },
  { id: 8841, code: "WMN", name: "Maroantsetra Airport[1]" },
  { id: 8842, code: "WMO", name: "White Mountain Airport" },
  { id: 8843, code: "WMP", name: "Mampikony Airport[1]" },
  { id: 8844, code: "WMR", name: "Mananara Nord Airport[1]" },
  { id: 8845, code: "WMT", name: "Zunyi Maotai Airport[1]" },
  { id: 8846, code: "WMV", name: "Madirovalo Airport[1]" },
  { id: 8847, code: "WMX", name: "Wamena Airport[1]" },
  { id: 8849, code: "WNA", name: "Napakiak Airport" },
  { id: 8850, code: "WND", name: "Windarra Airport[1]" },
  { id: 8851, code: "WNE", name: "Wora na Yeno Airport[1]" },
  { id: 8852, code: "WNH", name: "Wenshan Puzhehei Airport" },
  { id: 8853, code: "WNI", name: "Matahora Airport" },
  { id: 8854, code: "WNN", name: "Wunnummin Lake Airport[1] (TC: CKL3)" },
  { id: 8855, code: "WNP", name: "Naga Airport" },
  { id: 8856, code: "WNR", name: "Windorah Airport[1]" },
  { id: 8857, code: "WNS", name: "Nawabshah Airport[1]" },
  { id: 8858, code: "WNU", name: "Wanuma Airport[1]" },
  { id: 8859, code: "WNZ", name: "Wenzhou Longwan International Airport" },
  { id: 8861, code: "WOA", name: "Wonenara Airport[1]" },
  { id: 8862, code: "WOE", name: "Woensdrecht Air Base" },
  { id: 8863, code: "WOK", name: "Uonquén Airport[1]" },
  { id: 8864, code: "WOL", name: "Shellharbour Airport" },
  { id: 8865, code: "WON", name: "Wondoola Airport[1]" },
  { id: 8866, code: "WOR", name: "Moramba Airport[1]" },
  { id: 8867, code: "WOS", name: "Wonsan Kalma International Airport[1]" },
  { id: 8868, code: "WOT", name: "Wang-an Airport" },
  { id: 8869, code: "WOW", name: "Willow Airport (FAA: UUO)" },
  { id: 8871, code: "WPA", name: "Cabo Juan Román Airfield" },
  { id: 8872, code: "WPB", name: "Port Bergé Airport" },
  { id: 8873, code: "WPC", name: "Pincher Creek Airport" },
  { id: 8874, code: "WPK", name: "Wrotham Park Airport[1]" },
  { id: 8875, code: "WPL", name: "Powell Lake Water Aerodrome[1] (TC: CAQ8)" },
  { id: 8876, code: "WPM", name: "Wipim Airport[1]" },
  { id: 8877, code: "WPO", name: "North Fork Valley Airport (FAA: 7V2)" },
  { id: 8878, code: "WPR", name: "Capitán Fuentes Martínez Airport[1]" },
  { id: 8879, code: "WPU", name: "Guardiamarina Zañartu Airport[1]" },
  { id: 8881, code: "WRA", name: "Warder Airport[1]" },
  { id: 8882, code: "WRB", name: "Robins Air Force Base" },
  { id: 8883, code: "WRE", name: "Whangarei Airport" },
  { id: 8884, code: "WRG", name: "Wrangell Airport" },
  { id: 8885, code: "WRI", name: "McGuire Air Force Base" },
  { id: 8886, code: "WRL", name: "Worland Municipal Airport" },
  { id: 8887, code: "WRN", name: "Windarling Airport" },
  { id: 8888, code: "WRO", name: "Wrocław Airport" },
  { id: 8889, code: "WRT", name: "Warton Aerodrome" },
  { id: 8890, code: "WRW", name: "Warrawagine Airport[1]" },
  { id: 8891, code: "WRY", name: "Westray Airport[1]" },
  { id: 8892, code: "WRZ", name: "Weerawila Airport" },
  { id: 8894, code: "WSA", name: "Wasua Airport[1]" },
  { id: 8895, code: "WSB", name: "Steamboat Bay Seaplane Base[1]" },
  { id: 8896, code: "WSD", name: "Condron Army Airfield" },
  { id: 8897, code: "WSF", name: "Cape Sarichef Airport[1] (FAA: 26AK)" },
  { id: 8898, code: "WSG", name: "Washington County Airport (FAA: AFJ)" },
  { id: 8899, code: "WSH", name: "Brookhaven Airport (FAA: HWV)" },
  { id: 8900, code: "WSI", name: "Western Sydney Airport (Nancy-Bird Walton Airport)" },
  { id: 8901, code: "WSK", name: "Chongqing Wushan Airport" },
  { id: 8902, code: "WSM", name: "Wiseman Airport" },
  { id: 8903, code: "WSN", name: "South Naknek Airport" },
  { id: 8904, code: "WSO", name: "Washabo Airport" },
  { id: 8905, code: "WSP", name: "Waspam Airport" },
  { id: 8906, code: "WSR", name: "Wasior Airport[1]" },
  { id: 8907, code: "WST", name: "Westerly State Airport" },
  { id: 8908, code: "WSU", name: "Wasu Airport[1]" },
  { id: 8909, code: "WSX", name: "Westsound Seaplane Base[1] (FAA: WA83)" },
  { id: 8910, code: "WSY", name: "Whitsunday Airport" },
  { id: 8911, code: "WSZ", name: "Westport Airport" },
  { id: 8913, code: "WTA", name: "Tambohorano Airport" },
  { id: 8914, code: "WTB", name: "Toowoomba Wellcamp Airport" },
  { id: 8915, code: "WTD", name: "West End Airport" },
  { id: 8916, code: "WTE", name: "Wotje Airport (FAA: N36)" },
  { id: 8917, code: "WTK", name: "Noatak Airport" },
  { id: 8918, code: "WTL", name: "Tuntutuliak Airport (FAA: A61)" },
  { id: 8919, code: "WTN", name: "RAF Waddington[1]" },
  { id: 8920, code: "WTO", name: "Wotho Airport" },
  { id: 8921, code: "WTP", name: "Woitape Airport[1]" },
  { id: 8922, code: "WTR", name: "Whiteriver Airport (FAA: E24)" },
  { id: 8923, code: "WTS", name: "Tsiroanomandidy Airport" },
  { id: 8924, code: "WTT", name: "Wantoat Airport[1]" },
  { id: 8925, code: "WTZ", name: "Whitianga Aerodrome[1]" },
  { id: 8927, code: "WUA", name: "Wuhai Airport" },
  { id: 8928, code: "WUD", name: "Wudinna Airport[1]" },
  { id: 8929, code: "WUG", name: "Wau Airport[1]" },
  { id: 8930, code: "WUH", name: "Wuhan Tianhe International Airport" },
  { id: 8931, code: "WUI", name: "Murrin Murrin Airport" },
  { id: 8932, code: "WUM", name: "Wasum Airport[1]" },
  { id: 8933, code: "WUN", name: "Wiluna Airport[1]" },
  { id: 8934, code: "WUS", name: "Wuyishan Airport" },
  { id: 8935, code: "WUT", name: "Xinzhou Wutaishan Airport[1]" },
  { id: 8936, code: "WUU", name: "Wau Airport" },
  { id: 8937, code: "WUV", name: "Wuvulu Island Airport[1]" },
  { id: 8938, code: "WUX", name: "Sunan Shuofang International Airport" },
  { id: 8939, code: "WUZ", name: "Wuzhou Xijiang Airport" },
  { id: 8941, code: "WVB", name: "Walvis Bay Airport" },
  { id: 8942, code: "WVI", name: "Watsonville Municipal Airport" },
  { id: 8943, code: "WVK", name: "Manakara Airport[1]" },
  { id: 8944, code: "WVL", name: "Waterville Robert LaFleur Airport" },
  { id: 8945, code: "WVN", name: "JadeWeserAirport" },
  { id: 8947, code: "WWA", name: "Wasilla Airport (FAA: IYS)" },
  { id: 8948, code: "WWD", name: "Cape May Airport" },
  { id: 8949, code: "WWI", name: "Woodie Woodie Airport[1]" },
  { id: 8950, code: "WWK", name: "Wewak Airport[1]" },
  { id: 8951, code: "WWP", name: "North Whale Seaplane Base (FAA: 96Z)" },
  { id: 8952, code: "WWR", name: "West Woodward Airport" },
  { id: 8953, code: "WWT", name: "Newtok Airport (FAA: EWU)" },
  { id: 8954, code: "WWY", name: "West Wyalong Airport" },
  { id: 8956, code: "WXN", name: "Wanzhou Wuqiao Airport" },
  { id: 8958, code: "WYA", name: "Whyalla Airport" },
  { id: 8959, code: "WYB", name: "Yes Bay Lodge Seaplane Base (FAA: 78K)" },
  { id: 8960, code: "WYE", name: "Yengema Airport" },
  { id: 8961, code: "WYN", name: "Wyndham Airport[1]" },
  { id: 8962, code: "WYS", name: "Yellowstone Airport" },
  { id: 8964, code: "WZA", name: "Wa Airport" },
  { id: 8965, code: "WZQ", name: "Urad Middle Banner Airport[1]" },
  { id: 8967, code: "XAI", name: "Xinyang Minggang Airport" },
  { id: 8968, code: "XAL", name: "Álamos Airport" },
  { id: 8969, code: "XAP", name: "Serafin Enoss Bertaso Airport" },
  { id: 8970, code: "XAR", name: "Aribinda Airport" },
  { id: 8971, code: "XAU", name: "Saül Airport" },
  { id: 8973, code: "XBB", name: "Blubber Bay Seaplane Base" },
  { id: 8974, code: "XBE", name: "Bearskin Lake Airport (TC: CNE3)" },
  { id: 8975, code: "XBG", name: "Bogande Airport" },
  { id: 8976, code: "XBJ", name: "Birjand International Airport" },
  { id: 8977, code: "XBL", name: "Bedele Airport (Buno Bedele Airport)" },
  { id: 8978, code: "XBN", name: "Biniguni Airport" },
  { id: 8979, code: "XBO", name: "Boulsa Airport" },
  { id: 8980, code: "XBR", name: "Brockville Regional Tackaberry Airport (TC: CNL3)" },
  { id: 8982, code: "XCH", name: "Christmas Island Airport" },
  { id: 8983, code: "XCL", name: "Cluff Lake Airport (TC: CJS3)" },
  { id: 8984, code: "XCM", name: "Chatham-Kent Airport" },
  { id: 8985, code: "XCN", name: "Coron Airport" },
  { id: 8986, code: "XCO", name: "Colac Airport" },
  { id: 8987, code: "XCR", name: "Châlons Vatry Airport" },
  { id: 8989, code: "XDE", name: "Diébougou Airport" },
  { id: 8990, code: "XDJ", name: "Djibo Airport" },
  { id: 8992, code: "XEN", name: "Xingcheng Airport" },
  { id: 8993, code: "XES", name: "Grand Geneva Resort Airport (FAA: C02)" },
  { id: 8995, code: "XFN", name: "Xiangyang Liuji Airport" },
  { id: 8996, code: "XFW", name: "Hamburg Finkenwerder Airport" },
  { id: 8998, code: "XGA", name: "Gaoua Airport" },
  { id: 8999, code: "XGG", name: "Gorom Gorom Airport" },
  { id: 9000, code: "XGN", name: "Xangongo Airport" },
  { id: 9001, code: "XGR", name: "Kangiqsualujjuaq (Georges River) Airport" },
  { id: 9003, code: "XIC", name: "Xichang Qingshan Airport" },
  { id: 9004, code: "XIE", name: "Xienglom Airport[1]" },
  { id: 9005, code: "XIG", name: "Xinguara Municipal Airport" },
  { id: 9006, code: "XIJ", name: "Ahmad al-Jaber Air Base[1]" },
  { id: 9007, code: "XIL", name: "Xilinhot Airport" },
  { id: 9008, code: "XIN", name: "Xingning Air Base" },
  { id: 9009, code: "XIY", name: "Xi'an Xianyang International Airport" },
  { id: 9011, code: "XJD", name: "Al Udeid Air Base[1]" },
  { id: 9012, code: "XJM", name: "Mangla Airport[1]" },
  { id: 9014, code: "XKA", name: "Kantchari Airport" },
  { id: 9015, code: "XKH", name: "Xieng Khouang Airport" },
  { id: 9016, code: "XKS", name: "Kasabonika Airport" },
  { id: 9017, code: "XKY", name: "Kaya Airport" },
  { id: 9019, code: "XLB", name: "Lac Brochet Airport" },
  { id: 9020, code: "XLO", name: "Long Xuyen Airport" },
  { id: 9021, code: "XLS", name: "Saint-Louis Airport" },
  { id: 9022, code: "XLU", name: "Leo Airport" },
  { id: 9023, code: "XLW", name: "Lemwerder Airport" },
  { id: 9025, code: "XMA", name: "Maramag Airport" },
  { id: 9026, code: "XMC", name: "Mallacoota Airport[1]" },
  { id: 9027, code: "XMD", name: "Madison Municipal Airport (FAA: MDS)" },
  { id: 9028, code: "XMG", name: "Mahendranagar Airport" },
  { id: 9029, code: "XMH", name: "Manihi Airport" },
  { id: 9030, code: "XMI", name: "Masasi Airport" },
  { id: 9031, code: "XML", name: "Minlaton Airport" },
  { id: 9032, code: "XMN", name: "Xiamen Gaoqi International Airport" },
  { id: 9033, code: "XMP", name: "Macmillan Pass Airport[1] (TC: CFC4)" },
  { id: 9034, code: "XMS", name: "Edmundo Carvajal Airport" },
  { id: 9035, code: "XMY", name: "Yam Island Airport" },
  { id: 9037, code: "XNA", name: "Northwest Arkansas Regional Airport" },
  { id: 9038, code: "XNG", name: "Quang Ngai Airport[1]" },
  { id: 9039, code: "XNH", name: "Ali Air Base[1]" },
  { id: 9040, code: "XNN", name: "Xining Caojiabao Airport" },
  { id: 9041, code: "XNT", name: "Xingtai Dalian Airport" },
  { id: 9042, code: "XNU", name: "Nouna Airport" },
  { id: 9044, code: "XPA", name: "Pama Airport" },
  { id: 9045, code: "XPK", name: "Pukatawagan Airport" },
  { id: 9046, code: "XPL", name: "Soto Cano Air Base" },
  { id: 9047, code: "XPP", name: "Poplar River Airport" },
  { id: 9048, code: "XPR", name: "Pine Ridge Airport (FAA: IEN)" },
  { id: 9050, code: "XQP", name: "Quepos La Managua Airport" },
  { id: 9051, code: "XQU", name: "Qualicum Beach Airport (TC: CAT4)" },
  { id: 9053, code: "XRH", name: "RAAF Base Richmond[1]" },
  { id: 9054, code: "XRQ", name: "Xinbarag Youqi Baogede Airport" },
  { id: 9055, code: "XRR", name: "Ross River Airport" },
  { id: 9056, code: "XRY", name: "Jerez Airport (La Parra Airport)" },
  { id: 9058, code: "XSB", name: "Sir Bani Yas Airport[1]" },
  { id: 9059, code: "XSC", name: "South Caicos Airport" },
  { id: 9060, code: "XSD", name: "Tonopah Test Range Airport (FAA: TNX)" },
  { id: 9061, code: "XSE", name: "Sebba Airport" },
  { id: 9062, code: "XSI", name: "South Indian Lake Airport" },
  { id: 9063, code: "XSO", name: "Siocon Airport" },
  { id: 9064, code: "XSP", name: "Seletar Airport" },
  { id: 9066, code: "XTA", name: "Homey Airport" },
  { id: 9067, code: "XTG", name: "Thargomindah Airport" },
  { id: 9068, code: "XTL", name: "Tadoule Lake Airport" },
  { id: 9069, code: "XTO", name: "Taroom Airport" },
  { id: 9070, code: "XTR", name: "Tara Airport" },
  { id: 9072, code: "XUZ", name: "Xuzhou Guanyin Airport" },
  { id: 9074, code: "XVL", name: "Vinh Long Airport" },
  { id: 9076, code: "XWA", name: "Williston Basin International Airport" },
  { id: 9078, code: "XYA", name: "Yandina Airport" },
  { id: 9079, code: "XYE", name: "Ye Airport" },
  { id: 9080, code: "XYR", name: "Edwaki Airport[1]" },
  { id: 9082, code: "XZA", name: "Zabré Airport" },
  { id: 9084, code: "YAA", name: "Anahim Lake Airport (TC: CAJ4)" },
  { id: 9085, code: "YAB", name: "Arctic Bay Airport (TC: CJX7)" },
  { id: 9086, code: "YAC", name: "Cat Lake Airport" },
  { id: 9087, code: "YAD", name: "Moose Lake Airport (TC: CJB4)" },
  { id: 9088, code: "YAG", name: "Fort Frances Municipal Airport" },
  { id: 9089, code: "YAH", name: "La Grande-4 Airport" },
  { id: 9090, code: "YAI", name: "General Bernardo O'Higgins Airport" },
  { id: 9091, code: "YAJ", name: "Lyall Harbour Seaplane Base" },
  { id: 9092, code: "YAK", name: "Yakutat Airport" },
  { id: 9093, code: "YAL", name: "Alert Bay Airport" },
  { id: 9094, code: "YAM", name: "Sault Ste. Marie Airport" },
  { id: 9095, code: "YAN", name: "Yangambi Airport" },
  { id: 9096, code: "YAO", name: "Yaoundé Airport" },
  { id: 9097, code: "YAP", name: "Yap International Airport (FAA: T11)" },
  { id: 9098, code: "YAQ", name: "Maple Bay Seaplane Base" },
  { id: 9099, code: "YAR", name: "La Grande-3 Airport" },
  { id: 9100, code: "YAS", name: "Yasawa Island Airport" },
  { id: 9101, code: "YAT", name: "Attawapiskat Airport" },
  { id: 9102, code: "YAU", name: "Kattiniq/Donaldson Airport (TC: CTP9)" },
  { id: 9103, code: "YAV", name: "Mayne Island Water Aerodrome (Miner's Bay Seaplane Base) (TC: CAW7)" },
  { id: 9104, code: "YAX", name: "Angling Lake/Wapekeka Airport[1] (TC: CKB6)" },
  { id: 9105, code: "YAY", name: "St. Anthony Airport" },
  { id: 9106, code: "YAZ", name: "Tofino-Long Beach Airport" },
  { id: 9108, code: "YBA", name: "Banff Airport" },
  { id: 9109, code: "YBB", name: "Kugaaruk Airport" },
  { id: 9110, code: "YBC", name: "Baie-Comeau Airport" },
  { id: 9111, code: "YBE", name: "Uranium City Airport" },
  { id: 9112, code: "YBF", name: "Bamfield Water Aerodrome (TC: CAE9)" },
  { id: 9113, code: "YBG", name: "Canadian Forces Base Bagotville" },
  { id: 9114, code: "YBH", name: "Bull Harbour Waterdrome" },
  { id: 9115, code: "YBI", name: "Black Tickle Airport (TC: CCE4)" },
  { id: 9116, code: "YBJ", name: "Baie-Johan-Beetz Seaplane Base" },
  { id: 9117, code: "YBK", name: "Baker Lake Airport" },
  { id: 9118, code: "YBL", name: "Campbell River Airport" },
  { id: 9119, code: "YBO", name: "Bob Quinn Lake Airport (TC: CBW4)" },
  { id: 9120, code: "YBP", name: "Yibin Wuliangye Airport" },
  { id: 9121, code: "YBQ", name: "Telegraph Harbour Seaplane Base" },
  { id: 9122, code: "YBR", name: "Brandon Municipal Airport (McGill Field)" },
  { id: 9123, code: "YBS", name: "Opapimiskan Lake Airport[1] (TC: CKM8)" },
  { id: 9124, code: "YBT", name: "Brochet Airport" },
  { id: 9125, code: "YBV", name: "Berens River Airport" },
  { id: 9126, code: "YBW", name: "Bedwell Harbour Water Aerodrome (TC: CAB3)" },
  { id: 9127, code: "YBX", name: "Lourdes-de-Blanc-Sablon Airport" },
  { id: 9128, code: "YBY", name: "Bonnyville Airport" },
  { id: 9130, code: "YCA", name: "Courtenay Airpark (TC: CAH3)" },
  { id: 9131, code: "YCB", name: "Cambridge Bay Airport" },
  { id: 9132, code: "YCC", name: "Cornwall Regional Airport" },
  { id: 9133, code: "YCD", name: "Nanaimo Airport" },
  { id: 9134, code: "YCE", name: "Centralia/James T. Field Memorial Aerodrome" },
  { id: 9135, code: "YCF", name: "Cortes Island Aerodrome (TC: CCI9)" },
  { id: 9136, code: "YCG", name: "West Kootenay Regional Airport (Castlegar Airport)" },
  { id: 9137, code: "YCH", name: "Miramichi Airport" },
  { id: 9138, code: "YCK", name: "Colville Lake/Tommy Kochon Aerodrome" },
  { id: 9139, code: "YCL", name: "Charlo Airport" },
  { id: 9140, code: "YCM", name: "St. Catharines/Niagara District Airport" },
  { id: 9141, code: "YCN", name: "Cochrane Aerodrome" },
  { id: 9142, code: "YCO", name: "Kugluktuk Airport" },
  { id: 9143, code: "YCQ", name: "Chetwynd Airport" },
  { id: 9144, code: "YCR", name: "Cross Lake (Charlie Sinclair Memorial) Airport" },
  { id: 9145, code: "YCS", name: "Chesterfield Inlet Airport" },
  { id: 9146, code: "YCT", name: "Coronation Airport" },
  { id: 9147, code: "YCU", name: "Yuncheng Guangong Airport" },
  { id: 9148, code: "YCW", name: "Chilliwack Airport" },
  { id: 9149, code: "YCY", name: "Clyde River Airport" },
  { id: 9150, code: "YCZ", name: "Fairmont Hot Springs Airport" },
  { id: 9152, code: "YDA", name: "Dawson City Airport" },
  { id: 9153, code: "YDB", name: "Burwash Airport" },
  { id: 9154, code: "YDC", name: "Drayton Valley Industrial Airport (TC: CER3)" },
  { id: 9155, code: "YDE", name: "Paradise River Airport (TC: CDF4)" },
  { id: 9156, code: "YDF", name: "Deer Lake Regional Airport" },
  { id: 9157, code: "YDG", name: "Digby/Annapolis Regional Airport" },
  { id: 9158, code: "YDJ", name: "Hatchet Lake Airport[1] (TC: CJL2)" },
  { id: 9159, code: "YDL", name: "Dease Lake Airport" },
  { id: 9160, code: "YDN", name: "Lt. Col W.G. (Billy) Barker VC Airport" },
  { id: 9161, code: "YDO", name: "Dolbeau-Saint-Félicien Airport" },
  { id: 9162, code: "YDP", name: "Nain Airport" },
  { id: 9163, code: "YDQ", name: "Dawson Creek Airport" },
  { id: 9164, code: "YDT", name: "Boundary Bay Airport" },
  { id: 9165, code: "YDU", name: "Kasba Lake Airport[1] (TC: CJL8)" },
  { id: 9166, code: "YDV", name: "Bloodvein River Airport" },
  { id: 9167, code: "YDW", name: "Obre Lake/North of Sixty Airport (TC: CKV4)" },
  { id: 9169, code: "YEA[1]", name: "metropolitan area1" },
  { id: 9170, code: "YEB", name: "Bar River Airport[1] (TC: CPF2)" },
  { id: 9171, code: "YEC", name: "Yecheon Air Base" },
  { id: 9172, code: "YEG", name: "Edmonton International Airport" },
  { id: 9173, code: "YEI", name: "Yenişehir Airport" },
  { id: 9174, code: "YEK", name: "Arviat Airport" },
  { id: 9175, code: "YEL", name: "Elliot Lake Municipal Airport" },
  { id: 9176, code: "YEM", name: "Manitowaning/Manitoulin East Municipal Airport" },
  { id: 9177, code: "YEN", name: "Estevan Regional Aerodrome" },
  { id: 9178, code: "YEO", name: "Royal Naval Air Station Yeovilton" },
  { id: 9179, code: "YEQ", name: "Yankisa Airport" },
  { id: 9180, code: "YER", name: "Fort Severn Airport" },
  { id: 9181, code: "YES", name: "Yasuj Airport[1]" },
  { id: 9182, code: "YET", name: "Edson Airport" },
  { id: 9183, code: "YEU", name: "Eureka Aerodrome" },
  { id: 9184, code: "YEV", name: "Inuvik (Mike Zubko) Airport" },
  { id: 9185, code: "YEY", name: "Amos/Magny Airport" },
  { id: 9187, code: "YFA", name: "Fort Albany Airport" },
  { id: 9188, code: "YFB", name: "Iqaluit Airport" },
  { id: 9189, code: "YFC", name: "Fredericton International Airport" },
  { id: 9190, code: "YFE", name: "Forestville Airport" },
  { id: 9191, code: "YFG", name: "Fontanges Airport (TC: CTU2)" },
  { id: 9192, code: "YFH", name: "Fort Hope Airport" },
  { id: 9193, code: "YFI", name: "Fort MacKay/Firebag Aerodrome[1] (TC: CFG6)" },
  { id: 9194, code: "YFJ", name: "Wekweètì Airport[1] (Snare Lake Airport) (TC: CFJ7)" },
  { id: 9195, code: "YFL", name: "Fort Reliance Water Aerodrome (CJN8)" },
  { id: 9196, code: "YFO", name: "Flin Flon Airport" },
  { id: 9197, code: "YFR", name: "Fort Resolution Airport" },
  { id: 9198, code: "YFS", name: "Fort Simpson Airport" },
  { id: 9199, code: "YFT", name: "Taipa Ferry Terminal" },
  { id: 9200, code: "YFX", name: "St. Lewis (Fox Harbour) Airport (TC: CCK4)" },
  { id: 9202, code: "YGB", name: "Texada/Gillies Bay Airport" },
  { id: 9203, code: "YGC", name: "Grande Cache Airport (TC: CEQ5)" },
  { id: 9204, code: "YGE", name: "Gorge Harbour Water Aerodrome" },
  { id: 9205, code: "YGG", name: "Ganges Water Aerodrome (TC: CAX6)" },
  { id: 9206, code: "YGH", name: "Fort Good Hope Airport" },
  { id: 9207, code: "YGJ", name: "Miho–Yonago Airport" },
  { id: 9208, code: "YGK", name: "Kingston/Norman Rogers Airport" },
  { id: 9209, code: "YGL", name: "La Grande Rivière Airport" },
  { id: 9210, code: "YGM", name: "Gimli Industrial Park Airport" },
  { id: 9211, code: "YGN", name: "Greenway Sound Water Aerodrome" },
  { id: 9212, code: "YGO", name: "Gods Lake Narrows Airport" },
  { id: 9213, code: "YGP", name: "Michel-Pouliot Gaspé Airport" },
  { id: 9214, code: "YGQ", name: "Geraldton (Greenstone Regional) Airport" },
  { id: 9215, code: "YGR", name: "Îles-de-la-Madeleine Airport" },
  { id: 9216, code: "YGT", name: "Igloolik Airport" },
  { id: 9217, code: "YGV", name: "Havre Saint-Pierre Airport" },
  { id: 9218, code: "YGW", name: "Kuujjuarapik Airport" },
  { id: 9219, code: "YGX", name: "Gillam Airport" },
  { id: 9220, code: "YGZ", name: "Grise Fiord Airport" },
  { id: 9222, code: "YHA", name: "Port Hope Simpson Airport (TC: CCP4)" },
  { id: 9223, code: "YHB", name: "Hudson Bay Airport" },
  { id: 9224, code: "YHC", name: "Hakai Passage Water Aerodrome" },
  { id: 9225, code: "YHD", name: "Dryden Regional Airport" },
  { id: 9226, code: "YHE", name: "Hope Aerodrome" },
  { id: 9227, code: "YHF", name: "Hearst (René Fontaine) Municipal Airport" },
  { id: 9228, code: "YHG", name: "Charlottetown Airport (TC: CCH4)" },
  { id: 9229, code: "YHH", name: "Campbell River Water Aerodrome (TC: CAE3)" },
  { id: 9230, code: "YHI", name: "Ulukhaktok/Holman Airport" },
  { id: 9231, code: "YHK", name: "Gjoa Haven Airport" },
  { id: 9232, code: "YHM", name: "John C. Munro Hamilton International Airport" },
  { id: 9233, code: "YHN", name: "Hornepayne Municipal Airport" },
  { id: 9234, code: "YHO", name: "Hopedale Airport" },
  { id: 9235, code: "YHP", name: "Poplar Hill Airport" },
  { id: 9236, code: "YHR", name: "Chevery Airport" },
  { id: 9237, code: "YHS", name: "Sechelt Aerodrome (TC: CAP3)" },
  { id: 9238, code: "YHT", name: "Haines Junction Airport" },
  { id: 9239, code: "YHU", name: "Montréal/Saint-Hubert Airport" },
  { id: 9240, code: "YHY", name: "Hay River/Merlyn Carter Airport" },
  { id: 9241, code: "YHZ", name: "Halifax Stanfield International Airport" },
  { id: 9243, code: "YIA", name: "Yogyakarta International Airport" },
  { id: 9244, code: "YIB", name: "Atikokan Municipal Airport" },
  { id: 9245, code: "YIC", name: "Yichun Mingyueshan Airport" },
  { id: 9246, code: "YIE", name: "Arxan Yi'ershi Airport" },
  { id: 9247, code: "YIF", name: "Saint-Augustin Airport" },
  { id: 9248, code: "YIG", name: "Big Bay Water Aerodrome (TC: CAF6)" },
  { id: 9249, code: "YIH", name: "Yichang Sanxia Airport" },
  { id: 9250, code: "YIK", name: "Ivujivik Airport" },
  { id: 9251, code: "YIN", name: "Yining Airport" },
  { id: 9252, code: "YIO", name: "Pond Inlet Airport" },
  { id: 9253, code: "YIP", name: "Willow Run Airport" },
  { id: 9254, code: "YIV", name: "Island Lake Airport (Garden Hill Airport)" },
  { id: 9255, code: "YIW", name: "Yiwu Airport" },
  { id: 9257, code: "YJA", name: "Jasper Airport" },
  { id: 9258, code: "YJF", name: "Fort Liard Airport" },
  { id: 9259, code: "YJN", name: "Saint-Jean Airport" },
  { id: 9260, code: "YJP", name: "Hinton/Jasper-Hinton Airport (TC: CEC4)" },
  { id: 9261, code: "YJS", name: "Samjiyon Airport[1]" },
  { id: 9262, code: "YJT", name: "Stephenville International Airport" },
  { id: 9264, code: "YKA", name: "Kamloops Airport" },
  { id: 9265, code: "YKC", name: "Collins Bay Airport" },
  { id: 9266, code: "YKD", name: "Kincardine Municipal Airport" },
  { id: 9267, code: "YKE", name: "Knee Lake Airport (TC: CJT3)" },
  { id: 9268, code: "YKF", name: "Region of Waterloo International Airport" },
  { id: 9269, code: "YKG", name: "Kangirsuk Airport" },
  { id: 9270, code: "YKH", name: "Yingkou Lanqi Airport" },
  { id: 9271, code: "YKJ", name: "Key Lake Airport[1]" },
  { id: 9272, code: "YKK", name: "Kitkatla Water Aerodrome (TC: CAP7)" },
  { id: 9273, code: "YKL", name: "Schefferville Airport" },
  { id: 9274, code: "YKM", name: "Yakima Air Terminal (McAllister Field)" },
  { id: 9275, code: "YKN", name: "Chan Gurney Municipal Airport" },
  { id: 9276, code: "YKO", name: "Hakkari Yüksekova Airport[1]" },
  { id: 9277, code: "YKQ", name: "Waskaganish Airport" },
  { id: 9278, code: "YKS", name: "Yakutsk Airport" },
  { id: 9279, code: "YKT", name: "Klemtu Water Aerodrome" },
  { id: 9280, code: "YKU", name: "Chisasibi Airport (TC: CSU2)" },
  { id: 9281, code: "YKX", name: "Kirkland Lake Airport" },
  { id: 9282, code: "YKY", name: "Kindersley Regional Airport" },
  { id: 9283, code: "YKZ", name: "Buttonville Municipal Airport" },
  { id: 9285, code: "YLB", name: "Lac La Biche Airport" },
  { id: 9286, code: "YLC", name: "Kimmirut Airport" },
  { id: 9287, code: "YLD", name: "Chapleau Airport" },
  { id: 9288, code: "YLE", name: "Whatì Airport (TC: CEM3)" },
  { id: 9289, code: "YLG", name: "Yalgoo Airport" },
  { id: 9290, code: "YLH", name: "Lansdowne House Airport" },
  { id: 9291, code: "YLI", name: "Ylivieska Airfield" },
  { id: 9292, code: "YLJ", name: "Meadow Lake Airport" },
  { id: 9293, code: "YLK", name: "Lake Simcoe Regional Airport[1]" },
  { id: 9294, code: "YLL", name: "Lloydminster Airport" },
  { id: 9295, code: "YLM", name: "Clinton Creek Airport[1]" },
  { id: 9296, code: "YLN", name: "Yilan Airport" },
  { id: 9297, code: "YLP", name: "Mingan Airport" },
  { id: 9298, code: "YLQ", name: "La Tuque Airport" },
  { id: 9299, code: "YLR", name: "Leaf Rapids Airport" },
  { id: 9300, code: "YLS", name: "Lebel-sur-Quévillon Airport (TC: CSH4)" },
  { id: 9301, code: "YLT", name: "Alert Airport" },
  { id: 9302, code: "YLV", name: "Yevlakh Airport[1]" },
  { id: 9303, code: "YLW", name: "Kelowna International Airport" },
  { id: 9304, code: "YLX", name: "Yulin Fumian Airport" },
  { id: 9305, code: "YLY", name: "Langley Regional Airport[1]" },
  { id: 9307, code: "YMA", name: "Mayo Airport" },
  { id: 9308, code: "YMB", name: "Merritt Airport (TC: CAD5)" },
  { id: 9309, code: "YMD", name: "Mould Bay Airport" },
  { id: 9310, code: "YME", name: "Matane Airport" },
  { id: 9311, code: "YMF", name: "Montague Harbour Water Aerodrome" },
  { id: 9312, code: "YMG", name: "Manitouwadge Airport" },
  { id: 9313, code: "YMH", name: "Mary's Harbour Airport" },
  { id: 9314, code: "YMJ", name: "CFB Moose Jaw (C.M. McEwen Airport)" },
  { id: 9315, code: "YMK", name: "Mys-Kamenny Airport[1]" },
  { id: 9316, code: "YML", name: "Charlevoix Airport" },
  { id: 9317, code: "YMM", name: "Fort McMurray International Airport" },
  { id: 9318, code: "YMN", name: "Makkovik Airport" },
  { id: 9319, code: "YMO", name: "Moosonee Airport" },
  { id: 9320, code: "YMP", name: "Port McNeill Airport (TC: CAT5)" },
  { id: 9321, code: "YMQ[1]", name: "metropolitan area3" },
  { id: 9322, code: "YMS", name: "Moisés Benzaquén Rengifo Airport" },
  { id: 9323, code: "YMT", name: "Chibougamau/Chapais Airport" },
  { id: 9324, code: "YMU", name: "Mansons Landing Water Aerodrome[1] (TC: CAV7)" },
  { id: 9325, code: "YMV", name: "Mary River Aerodrome[1] (TC: CMR2)" },
  { id: 9326, code: "YMW", name: "Maniwaki Airport" },
  { id: 9327, code: "YMX", name: "Montréal–Mirabel International Airport" },
  { id: 9329, code: "YNA", name: "Natashquan Airport" },
  { id: 9330, code: "YNB", name: "Yanbu Airport (Yenbo Airport)" },
  { id: 9331, code: "YNC", name: "Wemindji Airport" },
  { id: 9332, code: "YND", name: "Gatineau-Ottawa Executive Airport" },
  { id: 9333, code: "YNE", name: "Norway House Airport" },
  { id: 9334, code: "YNG", name: "Youngstown–Warren Regional Airport" },
  { id: 9335, code: "YNH", name: "Hudson's Hope Airport" },
  { id: 9336, code: "YNJ", name: "Yanji Chaoyangchuan Airport" },
  { id: 9337, code: "YNL", name: "Points North Landing Airport" },
  { id: 9338, code: "YNM", name: "Matagami Airport" },
  { id: 9339, code: "YNN", name: "Yandicoogina Airport[1]" },
  { id: 9340, code: "YNO", name: "North Spirit Lake Airport (TC: CKQ3)" },
  { id: 9341, code: "YNP", name: "Natuashish Airport[1] (TC: CNH2)" },
  { id: 9342, code: "YNS", name: "Nemiscau Airport" },
  { id: 9343, code: "YNT", name: "Yantai Penglai International Airport" },
  { id: 9344, code: "YNX", name: "Snap Lake Airport[1] (TC: CSK6)" },
  { id: 9345, code: "YNY", name: "Yangyang International Airport[1]" },
  { id: 9346, code: "YNZ", name: "Yancheng Nanyang International Airport" },
  { id: 9348, code: "YOA", name: "Ekati Airport[1]" },
  { id: 9349, code: "YOC", name: "Old Crow Airport" },
  { id: 9350, code: "YOD", name: "CFB Cold Lake (R.W. McNair Airport)" },
  { id: 9351, code: "YOE", name: "Donnelly Airport (TC: CFM4)" },
  { id: 9352, code: "YOG", name: "Ogoki Post Airport" },
  { id: 9353, code: "YOH", name: "Oxford House Airport" },
  { id: 9354, code: "YOJ", name: "High Level Airport" },
  { id: 9355, code: "YOL", name: "Yola Airport" },
  { id: 9356, code: "YON", name: "Yongphulla Airport[1] (Yonphula Airport)" },
  { id: 9357, code: "YOO", name: "Oshawa Airport" },
  { id: 9358, code: "YOP", name: "Rainbow Lake Airport" },
  { id: 9359, code: "YOS", name: "Billy Bishop Regional Airport" },
  { id: 9360, code: "YOT", name: "Yotvata Airfield" },
  { id: 9361, code: "YOW", name: "Ottawa Macdonald–Cartier International Airport" },
  { id: 9363, code: "YPA", name: "Prince Albert (Glass Field) Airport" },
  { id: 9364, code: "YPB", name: "Alberni Valley Regional Airport (TC: CBS8)" },
  { id: 9365, code: "YPC", name: "Nora Aliqatchialuk Ruben Airport" },
  { id: 9366, code: "YPD", name: "Parry Sound Area Municipal Airport (TC: CNK4)" },
  { id: 9367, code: "YPE", name: "Peace River Airport" },
  { id: 9368, code: "YPG", name: "Portage la Prairie/Southport Airport" },
  { id: 9369, code: "YPH", name: "Inukjuak Airport" },
  { id: 9370, code: "YPI", name: "Port Simpson Water Aerodrome (TC: CAN8)" },
  { id: 9371, code: "YPJ", name: "Aupaluk Airport" },
  { id: 9372, code: "YPL", name: "Pickle Lake Airport" },
  { id: 9373, code: "YPM", name: "Pikangikum Airport" },
  { id: 9374, code: "YPN", name: "Port-Menier Airport" },
  { id: 9375, code: "YPO", name: "Peawanuck Airport" },
  { id: 9376, code: "YPQ", name: "Peterborough Airport" },
  { id: 9377, code: "YPR", name: "Prince Rupert Airport" },
  { id: 9378, code: "YPS", name: "Port Hawkesbury Airport" },
  { id: 9379, code: "YPT", name: "Pender Harbour Water Aerodrome (TC: CAG8)" },
  { id: 9380, code: "YPW", name: "Powell River Airport" },
  { id: 9381, code: "YPX", name: "Puvirnituq Airport" },
  { id: 9382, code: "YPY", name: "Fort Chipewyan Airport" },
  { id: 9383, code: "YPZ", name: "Burns Lake Airport" },
  { id: 9385, code: "YQA", name: "Muskoka Airport" },
  { id: 9386, code: "YQB", name: "Québec City Jean Lesage International Airport" },
  { id: 9387, code: "YQC", name: "Quaqtaq Airport" },
  { id: 9388, code: "YQD", name: "The Pas Airport" },
  { id: 9389, code: "YQF", name: "Red Deer Regional Airport" },
  { id: 9390, code: "YQG", name: "Windsor International Airport" },
  { id: 9391, code: "YQH", name: "Watson Lake Airport" },
  { id: 9392, code: "YQI", name: "Yarmouth Airport" },
  { id: 9393, code: "YQJ", name: "April Point Water Aerodrome[1]" },
  { id: 9394, code: "YQK", name: "Kenora Airport" },
  { id: 9395, code: "YQL", name: "Lethbridge Airport" },
  { id: 9396, code: "YQM", name: "Greater Moncton International Airport" },
  { id: 9397, code: "YQN", name: "Nakina Airport" },
  { id: 9398, code: "YQQ", name: "CFB Comox" },
  { id: 9399, code: "YQR", name: "Regina International Airport" },
  { id: 9400, code: "YQS", name: "St. Thomas Municipal Airport" },
  { id: 9401, code: "YQT", name: "Thunder Bay International Airport" },
  { id: 9402, code: "YQU", name: "Grande Prairie Airport" },
  { id: 9403, code: "YQV", name: "Yorkton Municipal Airport" },
  { id: 9404, code: "YQW", name: "North Battleford Airport (Cameron McIntosh Airport)" },
  { id: 9405, code: "YQX", name: "Gander International Airport / CFB Gander" },
  { id: 9406, code: "YQY", name: "Sydney/J.A. Douglas McCurdy Airport" },
  { id: 9407, code: "YQZ", name: "Quesnel Airport" },
  { id: 9409, code: "YRA", name: "Gamètì/Rae Lakes Airport" },
  { id: 9410, code: "YRB", name: "Resolute Bay Airport" },
  { id: 9411, code: "YRC", name: "Refuge Cove Water Aerodrome[1]" },
  { id: 9412, code: "YRD", name: "Dean River Airport" },
  { id: 9413, code: "YRF", name: "Cartwright Airport" },
  { id: 9414, code: "YRG", name: "Rigolet Airport (TC: CCZ2)" },
  { id: 9415, code: "YRI", name: "Rivière-du-Loup Airport" },
  { id: 9416, code: "YRJ", name: "Roberval Airport" },
  { id: 9417, code: "YRL", name: "Red Lake Airport" },
  { id: 9418, code: "YRM", name: "Rocky Mountain House Airport" },
  { id: 9419, code: "YRN", name: "Rivers Inlet Water Aerodrome (TC: CAU8)" },
  { id: 9420, code: "YRO", name: "Ottawa/Rockcliffe Airport" },
  { id: 9421, code: "YRQ", name: "Trois-Rivières Airport" },
  { id: 9422, code: "YRR", name: "Stuart Island Airstrip" },
  { id: 9423, code: "YRS", name: "Red Sucker Lake Airport" },
  { id: 9424, code: "YRT", name: "Rankin Inlet Airport" },
  { id: 9425, code: "YRV", name: "Revelstoke Airport" },
  { id: 9427, code: "YSA", name: "Sable Island Aerodrome" },
  { id: 9428, code: "YSB", name: "Sudbury Airport" },
  { id: 9429, code: "YSC", name: "Sherbrooke Airport" },
  { id: 9430, code: "YSE", name: "Squamish Airport" },
  { id: 9431, code: "YSF", name: "Stony Rapids Airport" },
  { id: 9432, code: "YSG", name: "Lutselk'e Airport" },
  { id: 9433, code: "YSH", name: "Smiths Falls-Montague Airport" },
  { id: 9434, code: "YSI", name: "Parry Sound/Frying Pan Island-Sans Souci Water Aerodrome (TC: CPS9)" },
  { id: 9435, code: "YSJ", name: "Saint John Airport" },
  { id: 9436, code: "YSK", name: "Sanikiluaq Airport" },
  { id: 9437, code: "YSL", name: "Saint-Léonard Aerodrome" },
  { id: 9438, code: "YSM", name: "Fort Smith Airport" },
  { id: 9439, code: "YSN", name: "Salmon Arm Airport" },
  { id: 9440, code: "YSO", name: "Postville Airport (TC: CCD4)" },
  { id: 9441, code: "YSP", name: "Marathon Aerodrome" },
  { id: 9442, code: "YSQ", name: "Songyuan Chaganhu Airport" },
  { id: 9443, code: "YST", name: "St. Theresa Point Airport" },
  { id: 9444, code: "YSU", name: "Summerside Airport" },
  { id: 9445, code: "YSX", name: "Bella Bella/Shearwater Water Aerodrome (TC: CAW8)" },
  { id: 9446, code: "YSY", name: "Sachs Harbour (David Nasogaluak Jr. Saaryuaq) Airport" },
  { id: 9448, code: "YTA", name: "Pembroke Airport" },
  { id: 9449, code: "YTB", name: "Hartley Bay Water Aerodrome (TC: CAY4)" },
  { id: 9450, code: "YTD", name: "Thicket Portage Airport" },
  { id: 9451, code: "YTE", name: "Kinngait Airport" },
  { id: 9452, code: "YTF", name: "Alma Airport" },
  { id: 9453, code: "YTG", name: "Sullivan Bay Water Aerodrome (TC: CAV5)" },
  { id: 9454, code: "YTH", name: "Thompson Airport" },
  { id: 9455, code: "YTL", name: "Big Trout Lake Airport" },
  { id: 9456, code: "YTM", name: "Mont Tremblant International Airport" },
  { id: 9457, code: "YTO[1]", name: "metropolitan area4" },
  { id: 9458, code: "YTP", name: "Tofino Harbour Water Aerodrome (TC: CAB4)" },
  { id: 9459, code: "YTQ", name: "Tasiujaq Airport" },
  { id: 9460, code: "YTR", name: "CFB Trenton" },
  { id: 9461, code: "YTS", name: "Timmins/Victor M. Power Airport" },
  { id: 9462, code: "YTT", name: "Tisdale Airport (TC: CJY3)" },
  { id: 9463, code: "YTU", name: "Tasu Water Aerodrome" },
  { id: 9464, code: "YTW", name: "Yutian Wanfang Airport" },
  { id: 9465, code: "YTX", name: "Telegraph Creek Airport (TC: CBM5)" },
  { id: 9466, code: "YTY", name: "Yangzhou Taizhou Airport" },
  { id: 9467, code: "YTZ", name: "Billy Bishop Toronto City Airport (Toronto Island Airport)" },
  { id: 9469, code: "YUA", name: "Yuanmou Air Base" },
  { id: 9470, code: "YUB", name: "Tuktoyaktuk/James Gruben Airport" },
  { id: 9471, code: "YUD", name: "Umiujaq Airport" },
  { id: 9472, code: "YUE", name: "Yuendumu Airport" },
  { id: 9473, code: "YUK", name: "Syunik Airport" },
  { id: 9474, code: "YUL", name: "Montréal–Trudeau International Airport" },
  { id: 9475, code: "YUM", name: "Yuma International Airport / MCAS Yuma (FAA: NYL)" },
  { id: 9476, code: "YUS", name: "Yushu Batang Airport" },
  { id: 9477, code: "YUT", name: "Repulse Bay Airport" },
  { id: 9478, code: "YUX", name: "Sanirajak Airport" },
  { id: 9479, code: "YUY", name: "Rouyn-Noranda Airport" },
  { id: 9481, code: "YVA", name: "Iconi Airport" },
  { id: 9482, code: "YVB", name: "Bonaventure Airport" },
  { id: 9483, code: "YVC", name: "La Ronge (Barber Field) Airport" },
  { id: 9484, code: "YVD", name: "Yeva Airport" },
  { id: 9485, code: "YVE", name: "Vernon Regional Airport" },
  { id: 9486, code: "YVG", name: "Vermilion Airport" },
  { id: 9487, code: "YVM", name: "Qikiqtarjuaq Airport" },
  { id: 9488, code: "YVN", name: "Cape Dyer Airport[1]" },
  { id: 9489, code: "YVO", name: "Val-d'Or Airport" },
  { id: 9490, code: "YVP", name: "Kuujjuaq Airport" },
  { id: 9491, code: "YVQ", name: "Norman Wells Airport" },
  { id: 9492, code: "YVR", name: "Vancouver International Airport" },
  { id: 9493, code: "YVT", name: "Buffalo Narrows Airport" },
  { id: 9494, code: "YVV", name: "Wiarton Airport" },
  { id: 9495, code: "YVZ", name: "Deer Lake Airport" },
  { id: 9497, code: "YWA", name: "Petawawa Airport" },
  { id: 9498, code: "YWB", name: "Kangiqsujuaq (Wakeham Bay) Airport" },
  { id: 9499, code: "YWG", name: "Winnipeg James Armstrong Richardson International Airport" },
  { id: 9500, code: "YWH", name: "Victoria Harbour Water Airport" },
  { id: 9501, code: "YWJ", name: "Déline Airport" },
  { id: 9502, code: "YWK", name: "Wabush Airport" },
  { id: 9503, code: "YWL", name: "Williams Lake Airport" },
  { id: 9504, code: "YWM", name: "Williams Harbour Airport (TC: CCA6)" },
  { id: 9505, code: "YWP", name: "Webequie Airport" },
  { id: 9506, code: "YWQ", name: "Chutes-des-Passes/Lac Margane Water Aerodrome[1] (TC: CTM3)" },
  { id: 9507, code: "YWR", name: "White River Water Aerodrome (TC: CNJ8)" },
  { id: 9508, code: "YWS", name: "Whistler/Green Lake Water Aerodrome (TC: CAE5)" },
  { id: 9509, code: "YWY", name: "Wrigley Airport" },
  { id: 9511, code: "YXC", name: "Cranbrook/Canadian Rockies International Airport" },
  { id: 9512, code: "YXD", name: "Edmonton City Centre (Blatchford Field) Airport[1]" },
  { id: 9513, code: "YXE", name: "Saskatoon John G. Diefenbaker International Airport" },
  { id: 9514, code: "YXH", name: "Medicine Hat Airport" },
  { id: 9515, code: "YXJ", name: "Fort St. John Airport (North Peace Airport)" },
  { id: 9516, code: "YXK", name: "Rimouski Airport" },
  { id: 9517, code: "YXL", name: "Sioux Lookout Airport" },
  { id: 9518, code: "YXN", name: "Whale Cove Airport" },
  { id: 9519, code: "YXP", name: "Pangnirtung Airport" },
  { id: 9520, code: "YXQ", name: "Beaver Creek Airport" },
  { id: 9521, code: "YXR", name: "Earlton (Timiskaming Regional) Airport" },
  { id: 9522, code: "YXS", name: "Prince George Airport" },
  { id: 9523, code: "YXT", name: "Northwest Regional Airport" },
  { id: 9524, code: "YXU", name: "London International Airport" },
  { id: 9525, code: "YXX", name: "Abbotsford International Airport" },
  { id: 9526, code: "YXY", name: "Erik Nielsen Whitehorse International Airport" },
  { id: 9527, code: "YXZ", name: "Wawa Airport" },
  { id: 9529, code: "YYA", name: "Yueyang Sanhe Airport" },
  { id: 9530, code: "YYB", name: "North Bay/Jack Garland Airport" },
  { id: 9531, code: "YYC", name: "Calgary International Airport" },
  { id: 9532, code: "YYD", name: "Smithers Airport" },
  { id: 9533, code: "YYE", name: "Northern Rockies Regional Airport" },
  { id: 9534, code: "YYF", name: "Penticton Regional Airport" },
  { id: 9535, code: "YYG", name: "Charlottetown Airport" },
  { id: 9536, code: "YYH", name: "Taloyoak Airport" },
  { id: 9537, code: "YYI", name: "Rivers Airport" },
  { id: 9538, code: "YYJ", name: "Victoria International Airport" },
  { id: 9539, code: "YYL", name: "Lynn Lake Airport" },
  { id: 9540, code: "YYM", name: "Cowley Airport" },
  { id: 9541, code: "YYN", name: "Swift Current Airport" },
  { id: 9542, code: "YYQ", name: "Churchill Airport" },
  { id: 9543, code: "YYR", name: "CFB Goose Bay" },
  { id: 9544, code: "YYT", name: "St. John's International Airport" },
  { id: 9545, code: "YYU", name: "Kapuskasing Airport" },
  { id: 9546, code: "YYW", name: "Armstrong Airport" },
  { id: 9547, code: "YYY", name: "Mont-Joli Airport" },
  { id: 9548, code: "YYZ", name: "Toronto Pearson International Airport" },
  { id: 9550, code: "YZA", name: "Cache Creek Airport (Ashcroft Regional Airport)" },
  { id: 9551, code: "YZE", name: "Gore Bay-Manitoulin Airport" },
  { id: 9552, code: "YZF", name: "Yellowknife Airport" },
  { id: 9553, code: "YZG", name: "Salluit Airport" },
  { id: 9554, code: "YZH", name: "Slave Lake Airport" },
  { id: 9555, code: "YZP", name: "Sandspit Airport" },
  { id: 9556, code: "YZR", name: "Sarnia Chris Hadfield Airport" },
  { id: 9557, code: "YZS", name: "Coral Harbour Airport" },
  { id: 9558, code: "YZT", name: "Port Hardy Airport" },
  { id: 9559, code: "YZU", name: "Whitecourt Airport" },
  { id: 9560, code: "YZV", name: "Sept-Îles Airport" },
  { id: 9561, code: "YZW", name: "Teslin Airport" },
  { id: 9562, code: "YZX", name: "CFB Greenwood" },
  { id: 9563, code: "YZY", name: "Zhangye Ganzhou Airport" },
  { id: 9564, code: "YZZ", name: "Trail Airport[1] (TC: CAD4)" },
  { id: 9566, code: "ZAA", name: "Alice Arm/Silver City Water Aerodrome (TC: CAC3)" },
  { id: 9567, code: "ZAC", name: "York Landing Airport" },
  { id: 9568, code: "ZAD", name: "Zadar Airport" },
  { id: 9569, code: "ZAG", name: "Franjo Tuđman Airport" },
  { id: 9570, code: "ZAH", name: "Zahedan Airport" },
  { id: 9571, code: "ZAJ", name: "Zaranj Airport" },
  { id: 9572, code: "ZAL", name: "Pichoy Airport" },
  { id: 9573, code: "ZAM", name: "Zamboanga International Airport" },
  { id: 9574, code: "ZAO", name: "Cahors - Lalbenque Airport" },
  { id: 9575, code: "ZAR", name: "Zaria Airport" },
  { id: 9576, code: "ZAT", name: "Zhaotong Airport" },
  { id: 9577, code: "ZAZ", name: "Zaragoza Airport" },
  { id: 9579, code: "ZBE", name: "Zábřeh Airport" },
  { id: 9580, code: "ZBF", name: "Bathurst Airport" },
  { id: 9581, code: "ZBK", name: "Žabljak Airport" },
  { id: 9582, code: "ZBL", name: "Biloela Airport" },
  { id: 9583, code: "ZBM", name: "Roland-Désourdy Airport" },
  { id: 9584, code: "ZBO", name: "Bowen Airport" },
  { id: 9585, code: "ZBR", name: "Konarak Airport" },
  { id: 9586, code: "ZBY", name: "Sayaboury Airport" },
  { id: 9588, code: "ZCL", name: "General Leobardo C. Ruiz International Airport" },
  { id: 9589, code: "ZCO", name: "La Araucanía Airport" },
  { id: 9591, code: "ZDJ", name: "Bern Railway Station" },
  { id: 9592, code: "ZDY", name: "Dalma Airport" },
  { id: 9594, code: "ZEC", name: "Secunda Airport" },
  { id: 9595, code: "ZEG", name: "Senggo Airport" },
  { id: 9596, code: "ZEL", name: "Bella Bella (Campbell Island) Airport" },
  { id: 9597, code: "ZEM", name: "Eastmain River Airport" },
  { id: 9598, code: "ZEN", name: "Zenag Airport[1]" },
  { id: 9599, code: "ZER", name: "Zero Airport (Ziro Airport)" },
  { id: 9601, code: "ZFA", name: "Faro Airport" },
  { id: 9602, code: "ZFD", name: "Fond-du-Lac Airport" },
  { id: 9603, code: "ZFM", name: "Fort McPherson Airport" },
  { id: 9604, code: "ZFN", name: "Tulita Airport" },
  { id: 9605, code: "ZFW", name: "Fairview Airport (TC: CEB5)" },
  { id: 9607, code: "ZGF", name: "Grand Forks Airport" },
  { id: 9608, code: "ZGI", name: "Gods River Airport" },
  { id: 9609, code: "ZGL", name: "South Galway Airport" },
  { id: 9610, code: "ZGM", name: "Ngoma Airport" },
  { id: 9611, code: "ZGR", name: "Little Grand Rapids Airport" },
  { id: 9612, code: "ZGS", name: "La Romaine Airport (TC: CTT5)" },
  { id: 9613, code: "ZGU", name: "Gaua Airport" },
  { id: 9615, code: "ZHA", name: "Zhanjiang Wuchuan Airport" },
  { id: 9616, code: "ZHM", name: "Shamshernagar Airport" },
  { id: 9617, code: "ZHP", name: "High Prairie Airport" },
  { id: 9618, code: "ZHT", name: "Geneva Railway Station" },
  { id: 9619, code: "ZHY", name: "Zhongwei Shapotou Airport (Zhongwei Xiangshan Airport)" },
  { id: 9621, code: "ZIA", name: "Ramenskoye Airport[1] (Zhukovsky Airport)" },
  { id: 9622, code: "ZIC", name: "Victoria Airport" },
  { id: 9623, code: "ZIG", name: "Ziguinchor Airport" },
  { id: 9624, code: "ZIH", name: "Ixtapa-Zihuatanejo International Airport" },
  { id: 9625, code: "ZIS", name: "Alzintan Airport[1]" },
  { id: 9626, code: "ZIX", name: "Zhigansk Airport[1]" },
  { id: 9627, code: "ZIZ", name: "Zamzama Airport[1]" },
  { id: 9629, code: "ZJG", name: "Jenpeg Airport" },
  { id: 9630, code: "ZJN", name: "Swan River Airport" },
  { id: 9631, code: "ZJT", name: "Tanjung Pelepas Port Airport[1]" },
  { id: 9633, code: "ZKB", name: "Kasaba Bay Airport" },
  { id: 9634, code: "ZKE", name: "Kashechewan Airport" },
  { id: 9635, code: "ZKG", name: "Kegaska Airport (TC: CTK6)" },
  { id: 9636, code: "ZKP", name: "Zyryanka Airport" },
  { id: 9638, code: "ZLO", name: "Playa de Oro International Airport" },
  { id: 9639, code: "ZLT", name: "La Tabatière Airport (TC: CTU5)" },
  { id: 9640, code: "ZLW", name: "Pasir Gudang Port Airport[1]" },
  { id: 9641, code: "ZLX", name: "Zalingei Airport[1]" },
  { id: 9643, code: "ZMD", name: "Sena Madureira Airport" },
  { id: 9644, code: "ZMH", name: "South Cariboo Regional Airport" },
  { id: 9645, code: "ZMM", name: "Zamora National Airport" },
  { id: 9646, code: "ZMT", name: "Masset Airport" },
  { id: 9648, code: "ZNA", name: "Nanaimo Harbour Water Airport (TC: CAC8)" },
  { id: 9649, code: "ZNC", name: "Nyac Airport" },
  { id: 9650, code: "ZND", name: "Zinder Airport" },
  { id: 9651, code: "ZNE", name: "Newman Airport" },
  { id: 9652, code: "ZNU", name: "Namu Water Aerodrome" },
  { id: 9653, code: "ZNZ", name: "Abeid Amani Karume International Airport" },
  { id: 9655, code: "ZOF", name: "Ocean Falls Water Aerodrome (TC: CAH2)" },
  { id: 9656, code: "ZOS", name: "Cañal Bajo Carlos Hott Siebert Airport" },
  { id: 9658, code: "ZPB", name: "Sachigo Lake Airport" },
  { id: 9659, code: "ZPC", name: "Pucón Airport" },
  { id: 9660, code: "ZPH", name: "Zephyrhills Municipal Airport" },
  { id: 9661, code: "ZPO", name: "Pinehouse Lake Airport" },
  { id: 9663, code: "ZQN", name: "Queenstown Airport" },
  { id: 9664, code: "ZQS", name: "Queen Charlotte City Water Aerodrome (TC: CAQ6)" },
  { id: 9665, code: "ZQW", name: "Zweibrücken Airport" },
  { id: 9666, code: "ZQZ", name: "Zhangjiakou Ningyuan Airport" },
  { id: 9668, code: "ZRH", name: "Zurich Airport" },
  { id: 9669, code: "ZRI", name: "Serui Airport" },
  { id: 9670, code: "ZRJ", name: "Round Lake (Weagamow Lake) Airport" },
  { id: 9671, code: "ZRM", name: "Sarmi Orai Airport" },
  { id: 9673, code: "ZSA", name: "San Salvador Airport (Cockburn Town Airport)" },
  { id: 9674, code: "ZSE", name: "Pierrefonds Airport" },
  { id: 9675, code: "ZSJ", name: "Sandy Lake Airport" },
  { id: 9676, code: "ZSS", name: "Sassandra Airport" },
  { id: 9677, code: "ZST", name: "Stewart Aerodrome" },
  { id: 9678, code: "ZSW", name: "Prince Rupert/Seal Cove Water Airport" },
  { id: 9680, code: "ZTA", name: "Tureia Airport" },
  { id: 9681, code: "ZTB", name: "Tête-à-la-Baleine Airport (TC: CTB6)" },
  { id: 9682, code: "ZTH", name: "Zakynthos International Airport (Dionysios SolomosAirport)" },
  { id: 9683, code: "ZTM", name: "Shamattawa Airport" },
  { id: 9684, code: "ZTR", name: "Zhytomyr Airport" },
  { id: 9685, code: "ZTS", name: "Tahsis Water Aerodrome (TC: CAL9)" },
  { id: 9686, code: "ZTU", name: "Zaqatala International Airport" },
  { id: 9688, code: "ZUC", name: "Ignace Municipal Airport" },
  { id: 9689, code: "ZUD", name: "Pupelde Airfield" },
  { id: 9690, code: "ZUH", name: "Zhuhai Jinwan Airport (Zhuhai Sanzao Airport)" },
  { id: 9691, code: "ZUL", name: "Zilfi Airport" },
  { id: 9692, code: "ZUM", name: "Churchill Falls Airport" },
  { id: 9694, code: "ZVA", name: "Miandrivazo Airport" },
  { id: 9695, code: "ZVG", name: "Springvale Airport" },
  { id: 9696, code: "ZVK", name: "Savannakhet Airport" },
  { id: 9698, code: "ZWA", name: "Andapa Airport" },
  { id: 9699, code: "ZWL", name: "Wollaston Lake Airport" },
  { id: 9701, code: "ZXT", name: "Zabrat Airport[1]" },
  { id: 9703, code: "ZYI", name: "Zunyi Xinzhou Airport" },
  { id: 9704, code: "ZYL", name: "Osmani International Airport" },
  { id: 9706, code: "ZZA[2]", name: "Ko Mai Si Airport" },
  { id: 9707, code: "ZZE", name: "Zangilan International Airport" },
  { id: 9708, code: "ZZO", name: "Zonalnoye Airport" },
  { id: 9709, code: "ZZU", name: "Mzuzu Airport" },
  { id: 9710, code: "ZZV", name: "Zanesville Municipal Airport" },
  { id: 9711, code: "XNB", name: "Dubai, Travel Mall Dubai Etihad Bus Station" },
];

export default airportList;